import _construct from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/construct";
import _wrapNativeSuper from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/wrapNativeSuper";
import _regeneratorRuntime from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/regenerator";
import _toArray from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/toArray";
import _toConsumableArray from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _get from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/get";
import _possibleConstructorReturn from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _slicedToArray from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _createClass from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _classCallCheck from "C:\\Users\\michael.HOME\\projects\\mydsl\\packages\\app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";

var e = function e(_e2) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;

  _classCallCheck(this, e);

  this.ctor = _e2, this.staticArguments = t, this.supportsDelayedInstantiation = i;
};

var t;
!function (e) {
  e.serviceIds = new Map(), e.DI_TARGET = "$di$target", e.DI_DEPENDENCIES = "$di$dependencies", e.getServiceDependencies = function (t) {
    return t[e.DI_DEPENDENCIES] || [];
  };
}(t || (t = {}));
var i = n("instantiationService");

function o(e, i, o, n) {
  i[t.DI_TARGET] === i ? i[t.DI_DEPENDENCIES].push({
    id: e,
    index: o,
    optional: n
  }) : (i[t.DI_DEPENDENCIES] = [{
    id: e,
    index: o,
    optional: n
  }], i[t.DI_TARGET] = i);
}

function n(e) {
  if (t.serviceIds.has(e)) return t.serviceIds.get(e);

  var i = function i(e, t, n) {
    if (3 !== arguments.length) throw new Error("@IServiceName-decorator can only be used to decorate a parameter");
    o(i, e, n, !1);
  };

  return i.toString = function () {
    return e;
  }, t.serviceIds.set(e, i), i;
}

var s =
/*#__PURE__*/
function () {
  function s() {
    _classCallCheck(this, s);

    this._entries = new Map();

    for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
      e[_key] = arguments[_key];
    }

    for (var _i2 = 0, _e3 = e; _i2 < _e3.length; _i2++) {
      var _ref3 = _e3[_i2];

      var _ref2 = _slicedToArray(_ref3, 2);

      var _t2 = _ref2[0];
      var _i3 = _ref2[1];
      this.set(_t2, _i3);
    }
  }

  _createClass(s, [{
    key: "set",
    value: function set(e, t) {
      var i = this._entries.get(e);

      return this._entries.set(e, t), i;
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      this._entries.forEach(function (t, i) {
        return e(i, t);
      });
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._entries.has(e);
    }
  }, {
    key: "get",
    value: function get(e) {
      return this._entries.get(e);
    }
  }]);

  return s;
}();

function r(e, t, i, o) {
  var n,
      s = arguments.length,
      r = s < 3 ? t : null === o ? o = Object.getOwnPropertyDescriptor(t, i) : o;
  if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) r = Reflect.decorate(e, t, i, o);else for (var l = e.length - 1; l >= 0; l--) {
    (n = e[l]) && (r = (s < 3 ? n(r) : s > 3 ? n(t, i, r) : n(t, i)) || r);
  }
  return s > 3 && r && Object.defineProperty(t, i, r), r;
}

function l(e, t) {
  return function (i, o) {
    t(i, o, e);
  };
}

function a(e, t, i, o) {
  return new (i || (i = Promise))(function (n, s) {
    function r(e) {
      try {
        a(o.next(e));
      } catch (e) {
        s(e);
      }
    }

    function l(e) {
      try {
        a(o.throw(e));
      } catch (e) {
        s(e);
      }
    }

    function a(e) {
      e.done ? n(e.value) : new i(function (t) {
        t(e.value);
      }).then(r, l);
    }

    a((o = o.apply(e, t || [])).next());
  });
}

var A = new (
/*#__PURE__*/
function () {
  function _class() {
    _classCallCheck(this, _class);

    this.listeners = [], this.unexpectedErrorHandler = function (e) {
      setTimeout(function () {
        if (e.stack) throw new Error(e.message + "\n\n" + e.stack);
        throw e;
      }, 0);
    };
  }

  _createClass(_class, [{
    key: "addListener",
    value: function addListener(e) {
      var _this = this;

      return this.listeners.push(e), function () {
        _this._removeListener(e);
      };
    }
  }, {
    key: "emit",
    value: function emit(e) {
      this.listeners.forEach(function (t) {
        t(e);
      });
    }
  }, {
    key: "_removeListener",
    value: function _removeListener(e) {
      this.listeners.splice(this.listeners.indexOf(e), 1);
    }
  }, {
    key: "setUnexpectedErrorHandler",
    value: function setUnexpectedErrorHandler(e) {
      this.unexpectedErrorHandler = e;
    }
  }, {
    key: "getUnexpectedErrorHandler",
    value: function getUnexpectedErrorHandler() {
      return this.unexpectedErrorHandler;
    }
  }, {
    key: "onUnexpectedError",
    value: function onUnexpectedError(e) {
      this.unexpectedErrorHandler(e), this.emit(e);
    }
  }, {
    key: "onUnexpectedExternalError",
    value: function onUnexpectedExternalError(e) {
      this.unexpectedErrorHandler(e);
    }
  }]);

  return _class;
}())();

function h(e) {
  d(e) || A.onUnexpectedError(e);
}

var c = "Canceled";

function d(e) {
  return e instanceof Error && e.name === c && e.message === c;
}

function u() {
  var e = new Error(c);
  return e.name = e.message, e;
}

function g(e) {
  return e ? new Error("Illegal argument: ".concat(e)) : new Error("Illegal argument");
}

function C(e) {
  for (var _len2 = arguments.length, t = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    t[_key2 - 1] = arguments[_key2];
  }

  return Array.isArray(e) ? (e.forEach(function (e) {
    return e && e.dispose();
  }), []) : 0 === t.length ? e ? (e.dispose(), e) : void 0 : (C(e), C(t), []);
}

function p(e) {
  return {
    dispose: function dispose() {
      return C(e);
    }
  };
}

function m(e) {
  return {
    dispose: function dispose() {
      e();
    }
  };
}

var f =
/*#__PURE__*/
function () {
  function f() {
    _classCallCheck(this, f);

    this._toDispose = [], this._lifecycle_disposable_isDisposed = !1;
  }

  _createClass(f, [{
    key: "dispose",
    value: function dispose() {
      this._lifecycle_disposable_isDisposed = !0, this._toDispose = C(this._toDispose);
    }
  }, {
    key: "_register",
    value: function _register(e) {
      return this._lifecycle_disposable_isDisposed ? (console.warn("Registering disposable on object that has already been disposed."), e.dispose()) : this._toDispose.push(e), e;
    }
  }, {
    key: "toDispose",
    get: function get() {
      return this._toDispose;
    }
  }]);

  return f;
}();

f.None = Object.freeze({
  dispose: function dispose() {}
});
var D = {
  done: !0,
  value: void 0
};
var w, v;
!function (e) {
  var t = {
    next: function next() {
      return D;
    }
  };

  function i(e, t) {
    for (var _i4 = e.next(); !_i4.done; _i4 = e.next()) {
      t(_i4.value);
    }
  }

  e.empty = function () {
    return t;
  }, e.fromArray = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length;
    return {
      next: function next() {
        return t >= i ? D : {
          done: !1,
          value: e[t++]
        };
      }
    };
  }, e.from = function (t) {
    return t ? Array.isArray(t) ? e.fromArray(t) : t : e.empty();
  }, e.map = function (e, t) {
    return {
      next: function next() {
        var i = e.next();
        return i.done ? D : {
          done: !1,
          value: t(i.value)
        };
      }
    };
  }, e.filter = function (e, t) {
    return {
      next: function next() {
        for (;;) {
          var _i5 = e.next();

          if (_i5.done) return D;
          if (t(_i5.value)) return {
            done: !1,
            value: _i5.value
          };
        }
      }
    };
  }, e.forEach = i, e.collect = function (e) {
    var t = [];
    return i(e, function (e) {
      return t.push(e);
    }), t;
  };
}(w || (w = {}));

var E = function E(e) {
  _classCallCheck(this, E);

  this.element = e;
};

var y =
/*#__PURE__*/
function () {
  function y() {
    _classCallCheck(this, y);

    this._size = 0;
  }

  _createClass(y, [{
    key: "isEmpty",
    value: function isEmpty() {
      return !this._first;
    }
  }, {
    key: "clear",
    value: function clear() {
      this._first = void 0, this._last = void 0, this._size = 0;
    }
  }, {
    key: "unshift",
    value: function unshift(e) {
      return this._insert(e, !1);
    }
  }, {
    key: "push",
    value: function push(e) {
      return this._insert(e, !0);
    }
  }, {
    key: "_insert",
    value: function _insert(e, t) {
      var i = new E(e);
      if (this._first) {
        if (t) {
          var _e4 = this._last;
          this._last = i, i.prev = _e4, _e4.next = i;
        } else {
          var _e5 = this._first;
          this._first = i, i.next = _e5, _e5.prev = i;
        }
      } else this._first = i, this._last = i;
      return this._size += 1, this._remove.bind(this, i);
    }
  }, {
    key: "shift",
    value: function shift() {
      if (this._first) {
        var _e6 = this._first.element;
        return this._remove(this._first), _e6;
      }
    }
  }, {
    key: "pop",
    value: function pop() {
      if (this._last) {
        var _e7 = this._last.element;
        return this._remove(this._last), _e7;
      }
    }
  }, {
    key: "_remove",
    value: function _remove(e) {
      var t = this._first;

      for (; t instanceof E;) {
        if (t === e) {
          if (t.prev && t.next) {
            var _e8 = t.prev;
            _e8.next = t.next, t.next.prev = _e8;
          } else t.prev || t.next ? t.next ? t.prev || (this._first = this._first.next, this._first.prev = void 0) : (this._last = this._last.prev, this._last.next = void 0) : (this._first = void 0, this._last = void 0);

          this._size -= 1;
          break;
        }

        t = t.next;
      }
    }
  }, {
    key: "iterator",
    value: function iterator() {
      var e,
          t = this._first;
      return {
        next: function next() {
          return t ? (e ? e.value = t.element : e = {
            done: !1,
            value: t.element
          }, t = t.next, e) : D;
        }
      };
    }
  }, {
    key: "toArray",
    value: function toArray() {
      var e = [];

      for (var _t3 = this._first; _t3 instanceof E; _t3 = _t3.next) {
        e.push(_t3.element);
      }

      return e;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }]);

  return y;
}();

!function (e) {
  var t = {
    dispose: function dispose() {}
  };

  function i(e) {
    return function (t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var o = arguments.length > 2 ? arguments[2] : undefined;
      var n,
          s = !1;
      return n = e(function (e) {
        if (!s) return n ? n.dispose() : s = !0, t.call(i, e);
      }, null, o), s && n.dispose(), n;
    };
  }

  function o(e, t) {
    return l(function (i) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      return e(function (e) {
        return i.call(o, t(e));
      }, null, n);
    });
  }

  function n(e, t) {
    return l(function (i) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      return e(function (e) {
        t(e), i.call(o, e);
      }, null, n);
    });
  }

  function s(e, t) {
    return l(function (i) {
      var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var n = arguments.length > 2 ? arguments[2] : undefined;
      return e(function (e) {
        return t(e) && i.call(o, e);
      }, null, n);
    });
  }

  function r(e, t, i) {
    var n = i;
    return o(e, function (e) {
      return n = t(n, e);
    });
  }

  function l(e) {
    var t;
    var i = new b({
      onFirstListenerAdd: function onFirstListenerAdd() {
        t = e(i.fire, i);
      },
      onLastListenerRemove: function onLastListenerRemove() {
        t.dispose();
      }
    });
    return i.event;
  }

  function a(e) {
    var t,
        i = !0;
    return s(e, function (e) {
      var o = i || e !== t;
      return i = !1, t = e, o;
    });
  }

  e.None = function () {
    return t;
  }, e.once = i, e.map = o, e.forEach = n, e.filter = s, e.signal = function (e) {
    return e;
  }, e.any = function () {
    for (var _len3 = arguments.length, e = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      e[_key3] = arguments[_key3];
    }

    return function (t) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var o = arguments.length > 2 ? arguments[2] : undefined;
      return p(e.map(function (e) {
        return e(function (e) {
          return t.call(i, e);
        }, null, o);
      }));
    };
  }, e.reduce = r, e.snapshot = l, e.debounce = function (e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
    var n = arguments.length > 4 ? arguments[4] : undefined;
    var s,
        r = void 0,
        l = void 0,
        a = 0;
    var A = new b({
      leakWarningThreshold: n,
      onFirstListenerAdd: function onFirstListenerAdd() {
        s = e(function (e) {
          a++, r = t(r, e), o && !l && A.fire(r), clearTimeout(l), l = setTimeout(function () {
            var e = r;
            r = void 0, l = void 0, (!o || a > 1) && A.fire(e), a = 0;
          }, i);
        });
      },
      onLastListenerRemove: function onLastListenerRemove() {
        s.dispose();
      }
    });
    return A.event;
  }, e.stopwatch = function (e) {
    var t = new Date().getTime();
    return o(i(e), function (e) {
      return new Date().getTime() - t;
    });
  }, e.latch = a, e.buffer = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var o = i.slice(),
        n = e(function (e) {
      o ? o.push(e) : r.fire(e);
    });

    var s = function s() {
      o && o.forEach(function (e) {
        return r.fire(e);
      }), o = null;
    },
        r = new b({
      onFirstListenerAdd: function onFirstListenerAdd() {
        n || (n = e(function (e) {
          return r.fire(e);
        }));
      },
      onFirstListenerDidAdd: function onFirstListenerDidAdd() {
        o && (t ? setTimeout(s) : s());
      },
      onLastListenerRemove: function onLastListenerRemove() {
        n && n.dispose(), n = null;
      }
    });

    return r.event;
  }, e.echo = function (e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    i = i.slice(), e(function (e) {
      i.push(e), n.fire(e);
    });

    var o = function o(e, t) {
      return i.forEach(function (i) {
        return e.call(t, i);
      });
    },
        n = new b({
      onListenerDidAdd: function onListenerDidAdd(e, i, n) {
        t ? setTimeout(function () {
          return o(i, n);
        }) : o(i, n);
      }
    });

    return n.event;
  };

  var A =
  /*#__PURE__*/
  function () {
    function A(e) {
      _classCallCheck(this, A);

      this.event = e;
    }

    _createClass(A, [{
      key: "map",
      value: function map(e) {
        return new A(o(this.event, e));
      }
    }, {
      key: "forEach",
      value: function forEach(e) {
        return new A(n(this.event, e));
      }
    }, {
      key: "filter",
      value: function filter(e) {
        return new A(s(this.event, e));
      }
    }, {
      key: "reduce",
      value: function reduce(e, t) {
        return new A(r(this.event, e, t));
      }
    }, {
      key: "latch",
      value: function latch() {
        return new A(a(this.event));
      }
    }, {
      key: "on",
      value: function on(e, t, i) {
        return this.event(e, t, i);
      }
    }, {
      key: "once",
      value: function once(e, t, o) {
        return i(this.event)(e, t, o);
      }
    }]);

    return A;
  }();

  e.chain = function (e) {
    return new A(e);
  }, e.fromNodeEventEmitter = function (e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (e) {
      return e;
    };

    var o = function o() {
      return n.fire(i.apply(void 0, arguments));
    },
        n = new b({
      onFirstListenerAdd: function onFirstListenerAdd() {
        return e.on(t, o);
      },
      onLastListenerRemove: function onLastListenerRemove() {
        return e.removeListener(t, o);
      }
    });

    return n.event;
  }, e.fromPromise = function (e) {
    var t = new b();
    var i = !1;
    return e.then(void 0, function () {
      return null;
    }).then(function () {
      i ? t.fire(void 0) : setTimeout(function () {
        return t.fire(void 0);
      }, 0);
    }), i = !0, t.event;
  }, e.toPromise = function (e) {
    return new Promise(function (t) {
      return i(e)(t);
    });
  };
}(v || (v = {}));
var M = -1;

var B =
/*#__PURE__*/
function () {
  function B(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Math.random().toString(18).slice(2, 5);

    _classCallCheck(this, B);

    this.customThreshold = e, this.name = t, this._warnCountdown = 0;
  }

  _createClass(B, [{
    key: "dispose",
    value: function dispose() {
      this._stacks && this._stacks.clear();
    }
  }, {
    key: "check",
    value: function check(e) {
      var _this2 = this;

      var t = M;
      if ("number" == typeof this.customThreshold && (t = this.customThreshold), t <= 0 || e < t) return;
      this._stacks || (this._stacks = new Map());
      var i = new Error().stack.split("\n").slice(3).join("\n"),
          o = this._stacks.get(i) || 0;

      if (this._stacks.set(i, o + 1), this._warnCountdown -= 1, this._warnCountdown <= 0) {
        var _i6;

        this._warnCountdown = .5 * t;
        var _o2 = 0;
        this._stacks.forEach(function (e, t) {
          (!_i6 || _o2 < e) && (_i6 = t, _o2 = e);
        }), console.warn("[".concat(this.name, "] potential listener LEAK detected, having ").concat(e, " listeners already. MOST frequent listener (").concat(_o2, "):")), console.warn(_i6);
      }

      return function () {
        var e = _this2._stacks.get(i) || 0;

        _this2._stacks.set(i, e - 1);
      };
    }
  }]);

  return B;
}();

var b =
/*#__PURE__*/
function () {
  function b(e) {
    _classCallCheck(this, b);

    this._disposed = !1, this._options = e, this._leakageMon = M > 0 ? new B(this._options && this._options.leakWarningThreshold) : void 0;
  }

  _createClass(b, [{
    key: "fire",
    value: function fire(e) {
      if (this._listeners) {
        this._deliveryQueue || (this._deliveryQueue = []);

        for (var _t4 = this._listeners.iterator(), _i7 = _t4.next(); !_i7.done; _i7 = _t4.next()) {
          this._deliveryQueue.push([_i7.value, e]);
        }

        for (; this._deliveryQueue.length > 0;) {
          var _this$_deliveryQueue$ = this._deliveryQueue.shift(),
              _this$_deliveryQueue$2 = _slicedToArray(_this$_deliveryQueue$, 2),
              _e9 = _this$_deliveryQueue$2[0],
              _t5 = _this$_deliveryQueue$2[1];

          try {
            "function" == typeof _e9 ? _e9.call(void 0, _t5) : _e9[0].call(_e9[1], _t5);
          } catch (e) {
            h(e);
          }
        }
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._listeners && (this._listeners = void 0), this._deliveryQueue && (this._deliveryQueue.length = 0), this._leakageMon && this._leakageMon.dispose(), this._disposed = !0;
    }
  }, {
    key: "event",
    get: function get() {
      var _this3 = this;

      return this._event || (this._event = function (e, t, i) {
        _this3._listeners || (_this3._listeners = new y());

        var o = _this3._listeners.isEmpty();

        o && _this3._options && _this3._options.onFirstListenerAdd && _this3._options.onFirstListenerAdd(_this3);

        var n = _this3._listeners.push(t ? [e, t] : e);

        var s, r;
        return o && _this3._options && _this3._options.onFirstListenerDidAdd && _this3._options.onFirstListenerDidAdd(_this3), _this3._options && _this3._options.onListenerDidAdd && _this3._options.onListenerDidAdd(_this3, e, t), _this3._leakageMon && (s = _this3._leakageMon.check(_this3._listeners.size)), r = {
          dispose: function dispose() {
            if (s && s(), r.dispose = b._noop, !_this3._disposed && (n(), _this3._options && _this3._options.onLastListenerRemove)) {
              _this3._listeners && !_this3._listeners.isEmpty() || _this3._options.onLastListenerRemove(_this3);
            }
          }
        }, Array.isArray(i) && i.push(r), r;
      }), this._event;
    }
  }]);

  return b;
}();

b._noop = function () {};

var F =
/*#__PURE__*/
function () {
  function F() {
    _classCallCheck(this, F);

    this.buffers = [];
  }

  _createClass(F, [{
    key: "wrapEvent",
    value: function wrapEvent(e) {
      var _this4 = this;

      return function (t, i, o) {
        return e(function (e) {
          var o = _this4.buffers[_this4.buffers.length - 1];
          o ? o.push(function () {
            return t.call(i, e);
          }) : t.call(i, e);
        }, void 0, o);
      };
    }
  }, {
    key: "bufferEvents",
    value: function bufferEvents(e) {
      var t = [];
      this.buffers.push(t);
      var i = e();
      return this.buffers.pop(), t.forEach(function (e) {
        return e();
      }), i;
    }
  }]);

  return F;
}();

var H =
/*#__PURE__*/
function () {
  function H() {
    var _this5 = this;

    _classCallCheck(this, H);

    this.listening = !1, this.inputEvent = v.None, this.inputEventListener = f.None, this.emitter = new b({
      onFirstListenerDidAdd: function onFirstListenerDidAdd() {
        _this5.listening = !0, _this5.inputEventListener = _this5.inputEvent(_this5.emitter.fire, _this5.emitter);
      },
      onLastListenerRemove: function onLastListenerRemove() {
        _this5.listening = !1, _this5.inputEventListener.dispose();
      }
    }), this.event = this.emitter.event;
  }

  _createClass(H, [{
    key: "dispose",
    value: function dispose() {
      this.inputEventListener.dispose(), this.emitter.dispose();
    }
  }, {
    key: "input",
    set: function set(e) {
      this.inputEvent = e, this.listening && (this.inputEventListener.dispose(), this.inputEventListener = e(this.emitter.fire, this.emitter));
    }
  }]);

  return H;
}();

function S(e, t) {
  var i = Math.pow(10, t);
  return Math.round(e * i) / i;
}

var z =
/*#__PURE__*/
function () {
  function z(e, t, i) {
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, z);

    this.r = 0 | Math.min(255, Math.max(0, e)), this.g = 0 | Math.min(255, Math.max(0, t)), this.b = 0 | Math.min(255, Math.max(0, i)), this.a = S(Math.max(Math.min(1, o), 0), 3);
  }

  _createClass(z, null, [{
    key: "equals",
    value: function equals(e, t) {
      return e.r === t.r && e.g === t.g && e.b === t.b && e.a === t.a;
    }
  }]);

  return z;
}();

var x =
/*#__PURE__*/
function () {
  function x(e, t, i, o) {
    _classCallCheck(this, x);

    this.h = 0 | Math.max(Math.min(360, e), 0), this.s = S(Math.max(Math.min(1, t), 0), 3), this.l = S(Math.max(Math.min(1, i), 0), 3), this.a = S(Math.max(Math.min(1, o), 0), 3);
  }

  _createClass(x, null, [{
    key: "equals",
    value: function equals(e, t) {
      return e.h === t.h && e.s === t.s && e.l === t.l && e.a === t.a;
    }
  }, {
    key: "fromRGBA",
    value: function fromRGBA(e) {
      var t = e.r / 255,
          i = e.g / 255,
          o = e.b / 255,
          n = e.a,
          s = Math.max(t, i, o),
          r = Math.min(t, i, o);
      var l = 0,
          a = 0;
      var A = (r + s) / 2,
          h = s - r;

      if (h > 0) {
        switch (a = Math.min(A <= .5 ? h / (2 * A) : h / (2 - 2 * A), 1), s) {
          case t:
            l = (i - o) / h + (i < o ? 6 : 0);
            break;

          case i:
            l = (o - t) / h + 2;
            break;

          case o:
            l = (t - i) / h + 4;
        }

        l *= 60, l = Math.round(l);
      }

      return new x(l, a, A, n);
    }
  }, {
    key: "_hue2rgb",
    value: function _hue2rgb(e, t, i) {
      return i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6 ? e + 6 * (t - e) * i : i < .5 ? t : i < 2 / 3 ? e + (t - e) * (2 / 3 - i) * 6 : e;
    }
  }, {
    key: "toRGBA",
    value: function toRGBA(e) {
      var t = e.h / 360,
          i = e.s,
          o = e.l,
          n = e.a;
      var s, r, l;
      if (0 === i) s = r = l = o;else {
        var _e10 = o < .5 ? o * (1 + i) : o + i - o * i,
            _n2 = 2 * o - _e10;

        s = x._hue2rgb(_n2, _e10, t + 1 / 3), r = x._hue2rgb(_n2, _e10, t), l = x._hue2rgb(_n2, _e10, t - 1 / 3);
      }
      return new z(Math.round(255 * s), Math.round(255 * r), Math.round(255 * l), n);
    }
  }]);

  return x;
}();

var V =
/*#__PURE__*/
function () {
  function V(e, t, i, o) {
    _classCallCheck(this, V);

    this.h = 0 | Math.max(Math.min(360, e), 0), this.s = S(Math.max(Math.min(1, t), 0), 3), this.v = S(Math.max(Math.min(1, i), 0), 3), this.a = S(Math.max(Math.min(1, o), 0), 3);
  }

  _createClass(V, null, [{
    key: "equals",
    value: function equals(e, t) {
      return e.h === t.h && e.s === t.s && e.v === t.v && e.a === t.a;
    }
  }, {
    key: "fromRGBA",
    value: function fromRGBA(e) {
      var t = e.r / 255,
          i = e.g / 255,
          o = e.b / 255,
          n = Math.max(t, i, o),
          s = n - Math.min(t, i, o),
          r = 0 === n ? 0 : s / n;
      var l;
      return l = 0 === s ? 0 : n === t ? ((i - o) / s % 6 + 6) % 6 : n === i ? (o - t) / s + 2 : (t - i) / s + 4, new V(Math.round(60 * l), r, n, e.a);
    }
  }, {
    key: "toRGBA",
    value: function toRGBA(e) {
      var t = e.h,
          i = e.s,
          o = e.v,
          n = e.a,
          s = o * i,
          r = s * (1 - Math.abs(t / 60 % 2 - 1)),
          l = o - s;
      var a = 0,
          A = 0,
          h = 0;
      return t < 60 ? (a = s, A = r) : t < 120 ? (a = r, A = s) : t < 180 ? (A = s, h = r) : t < 240 ? (A = r, h = s) : t < 300 ? (a = r, h = s) : t < 360 && (a = s, h = r), a = Math.round(255 * (a + l)), A = Math.round(255 * (A + l)), h = Math.round(255 * (h + l)), new z(a, A, h, n);
    }
  }]);

  return V;
}();

var I =
/*#__PURE__*/
function () {
  function I(e) {
    _classCallCheck(this, I);

    if (!e) throw new Error("Color needs a value");
    if (e instanceof z) this.rgba = e;else if (e instanceof x) this._hsla = e, this.rgba = x.toRGBA(e);else {
      if (!(e instanceof V)) throw new Error("Invalid color ctor argument");
      this._hsva = e, this.rgba = V.toRGBA(e);
    }
  }

  _createClass(I, [{
    key: "equals",
    value: function equals(e) {
      return !!e && z.equals(this.rgba, e.rgba) && x.equals(this.hsla, e.hsla) && V.equals(this.hsva, e.hsva);
    }
  }, {
    key: "getRelativeLuminance",
    value: function getRelativeLuminance() {
      return S(.2126 * I._relativeLuminanceForComponent(this.rgba.r) + .7152 * I._relativeLuminanceForComponent(this.rgba.g) + .0722 * I._relativeLuminanceForComponent(this.rgba.b), 4);
    }
  }, {
    key: "getContrastRatio",
    value: function getContrastRatio(e) {
      var t = this.getRelativeLuminance(),
          i = e.getRelativeLuminance();
      return t > i ? (t + .05) / (i + .05) : (i + .05) / (t + .05);
    }
  }, {
    key: "isDarker",
    value: function isDarker() {
      return (299 * this.rgba.r + 587 * this.rgba.g + 114 * this.rgba.b) / 1e3 < 128;
    }
  }, {
    key: "isLighter",
    value: function isLighter() {
      return (299 * this.rgba.r + 587 * this.rgba.g + 114 * this.rgba.b) / 1e3 >= 128;
    }
  }, {
    key: "isLighterThan",
    value: function isLighterThan(e) {
      return this.getRelativeLuminance() > e.getRelativeLuminance();
    }
  }, {
    key: "isDarkerThan",
    value: function isDarkerThan(e) {
      return this.getRelativeLuminance() < e.getRelativeLuminance();
    }
  }, {
    key: "lighten",
    value: function lighten(e) {
      return new I(new x(this.hsla.h, this.hsla.s, this.hsla.l + this.hsla.l * e, this.hsla.a));
    }
  }, {
    key: "darken",
    value: function darken(e) {
      return new I(new x(this.hsla.h, this.hsla.s, this.hsla.l - this.hsla.l * e, this.hsla.a));
    }
  }, {
    key: "transparent",
    value: function transparent(e) {
      var _this$rgba = this.rgba,
          t = _this$rgba.r,
          i = _this$rgba.g,
          o = _this$rgba.b,
          n = _this$rgba.a;
      return new I(new z(t, i, o, n * e));
    }
  }, {
    key: "isTransparent",
    value: function isTransparent() {
      return 0 === this.rgba.a;
    }
  }, {
    key: "isOpaque",
    value: function isOpaque() {
      return 1 === this.rgba.a;
    }
  }, {
    key: "opposite",
    value: function opposite() {
      return new I(new z(255 - this.rgba.r, 255 - this.rgba.g, 255 - this.rgba.b, this.rgba.a));
    }
  }, {
    key: "blend",
    value: function blend(e) {
      var t = e.rgba,
          i = this.rgba.a,
          o = t.a;
      var n = i + o * (1 - i);
      if (n < 1e-6) return I.transparent;
      var s = this.rgba.r * i / n + t.r * o * (1 - i) / n,
          r = this.rgba.g * i / n + t.g * o * (1 - i) / n,
          l = this.rgba.b * i / n + t.b * o * (1 - i) / n;
      return new I(new z(s, r, l, n));
    }
  }, {
    key: "flatten",
    value: function flatten() {
      for (var _len4 = arguments.length, e = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        e[_key4] = arguments[_key4];
      }

      var t = e.reduceRight(function (e, t) {
        return I._flatten(t, e);
      });
      return I._flatten(this, t);
    }
  }, {
    key: "toString",
    value: function toString() {
      return "" + I.Format.CSS.format(this);
    }
  }, {
    key: "hsla",
    get: function get() {
      return this._hsla ? this._hsla : x.fromRGBA(this.rgba);
    }
  }, {
    key: "hsva",
    get: function get() {
      return this._hsva ? this._hsva : V.fromRGBA(this.rgba);
    }
  }], [{
    key: "fromHex",
    value: function fromHex(e) {
      return I.Format.CSS.parseHex(e) || I.red;
    }
  }, {
    key: "_relativeLuminanceForComponent",
    value: function _relativeLuminanceForComponent(e) {
      var t = e / 255;
      return t <= .03928 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
    }
  }, {
    key: "_flatten",
    value: function _flatten(e, t) {
      var i = 1 - e.rgba.a;
      return new I(new z(i * t.rgba.r + e.rgba.a * e.rgba.r, i * t.rgba.g + e.rgba.a * e.rgba.g, i * t.rgba.b + e.rgba.a * e.rgba.b));
    }
  }, {
    key: "getLighterColor",
    value: function getLighterColor(e, t, i) {
      if (e.isLighterThan(t)) return e;
      i = i || .5;
      var o = e.getRelativeLuminance(),
          n = t.getRelativeLuminance();
      return i = i * (n - o) / n, e.lighten(i);
    }
  }, {
    key: "getDarkerColor",
    value: function getDarkerColor(e, t, i) {
      if (e.isDarkerThan(t)) return e;
      i = i || .5;
      var o = e.getRelativeLuminance();
      return i = i * (o - t.getRelativeLuminance()) / o, e.darken(i);
    }
  }]);

  return I;
}();

I.white = new I(new z(255, 255, 255, 1)), I.black = new I(new z(0, 0, 0, 1)), I.red = new I(new z(255, 0, 0, 1)), I.blue = new I(new z(0, 0, 255, 1)), I.green = new I(new z(0, 255, 0, 1)), I.cyan = new I(new z(0, 255, 255, 1)), I.lightgrey = new I(new z(211, 211, 211, 1)), I.transparent = new I(new z(0, 0, 0, 0)), function (e) {
  var t;
  !function (t) {
    var i;
    !function (t) {
      function i(e) {
        var t = e.toString(16);
        return 2 !== t.length ? "0" + t : t;
      }

      function o(e) {
        switch (e) {
          case 48:
            return 0;

          case 49:
            return 1;

          case 50:
            return 2;

          case 51:
            return 3;

          case 52:
            return 4;

          case 53:
            return 5;

          case 54:
            return 6;

          case 55:
            return 7;

          case 56:
            return 8;

          case 57:
            return 9;

          case 97:
          case 65:
            return 10;

          case 98:
          case 66:
            return 11;

          case 99:
          case 67:
            return 12;

          case 100:
          case 68:
            return 13;

          case 101:
          case 69:
            return 14;

          case 102:
          case 70:
            return 15;
        }

        return 0;
      }

      t.formatRGB = function (t) {
        return 1 === t.rgba.a ? "rgb(".concat(t.rgba.r, ", ").concat(t.rgba.g, ", ").concat(t.rgba.b, ")") : e.Format.CSS.formatRGBA(t);
      }, t.formatRGBA = function (e) {
        return "rgba(".concat(e.rgba.r, ", ").concat(e.rgba.g, ", ").concat(e.rgba.b, ", ").concat(+e.rgba.a.toFixed(2), ")");
      }, t.formatHSL = function (t) {
        return 1 === t.hsla.a ? "hsl(".concat(t.hsla.h, ", ").concat((100 * t.hsla.s).toFixed(2), "%, ").concat((100 * t.hsla.l).toFixed(2), "%)") : e.Format.CSS.formatHSLA(t);
      }, t.formatHSLA = function (e) {
        return "hsla(".concat(e.hsla.h, ", ").concat((100 * e.hsla.s).toFixed(2), "%, ").concat((100 * e.hsla.l).toFixed(2), "%, ").concat(e.hsla.a.toFixed(2), ")");
      }, t.formatHex = function (e) {
        return "#".concat(i(e.rgba.r)).concat(i(e.rgba.g)).concat(i(e.rgba.b));
      }, t.formatHexA = function (t) {
        var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
        return o && 1 === t.rgba.a ? e.Format.CSS.formatHex(t) : "#".concat(i(t.rgba.r)).concat(i(t.rgba.g)).concat(i(t.rgba.b)).concat(i(Math.round(255 * t.rgba.a)));
      }, t.format = function (t) {
        return t ? t.isOpaque() ? e.Format.CSS.formatHex(t) : e.Format.CSS.formatRGBA(t) : null;
      }, t.parseHex = function (t) {
        if (!t) return null;
        var i = t.length;
        if (0 === i) return null;
        if (35 !== t.charCodeAt(0)) return null;

        if (7 === i) {
          var _i8 = 16 * o(t.charCodeAt(1)) + o(t.charCodeAt(2)),
              _n3 = 16 * o(t.charCodeAt(3)) + o(t.charCodeAt(4)),
              _s2 = 16 * o(t.charCodeAt(5)) + o(t.charCodeAt(6));

          return new e(new z(_i8, _n3, _s2, 1));
        }

        if (9 === i) {
          var _i9 = 16 * o(t.charCodeAt(1)) + o(t.charCodeAt(2)),
              _n4 = 16 * o(t.charCodeAt(3)) + o(t.charCodeAt(4)),
              _s3 = 16 * o(t.charCodeAt(5)) + o(t.charCodeAt(6)),
              _r = 16 * o(t.charCodeAt(7)) + o(t.charCodeAt(8));

          return new e(new z(_i9, _n4, _s3, _r / 255));
        }

        if (4 === i) {
          var _i10 = o(t.charCodeAt(1)),
              _n5 = o(t.charCodeAt(2)),
              _s4 = o(t.charCodeAt(3));

          return new e(new z(16 * _i10 + _i10, 16 * _n5 + _n5, 16 * _s4 + _s4));
        }

        if (5 === i) {
          var _i11 = o(t.charCodeAt(1)),
              _n6 = o(t.charCodeAt(2)),
              _s5 = o(t.charCodeAt(3)),
              _r2 = o(t.charCodeAt(4));

          return new e(new z(16 * _i11 + _i11, 16 * _n6 + _n6, 16 * _s5 + _s5, (16 * _r2 + _r2) / 255));
        }

        return null;
      };
    }(i = t.CSS || (t.CSS = {}));
  }(t = e.Format || (e.Format = {}));
}(I || (I = {}));

var _ = !1,
    N = !1,
    L = !1,
    P = void 0,
    Q = void 0;

var R = "undefined" != typeof process && void 0 !== process.versions && void 0 !== process.versions.electron && "renderer" === process.type;

if ("object" != typeof navigator || R) {
  if ("object" == typeof process) {
    _ = "win32" === process.platform, N = "darwin" === process.platform, L = "linux" === process.platform, P = "en";
    var _e11 = process.env.VSCODE_NLS_CONFIG;
    if (_e11) try {
      var _t6 = JSON.parse(_e11);

      _t6.availableLanguages["*"];
      P = _t6.locale, Q = _t6._translationsConfigFile;
    } catch (e) {}
  }
} else {
  var _e12 = navigator.userAgent;
  _ = _e12.indexOf("Windows") >= 0, N = _e12.indexOf("Macintosh") >= 0, L = _e12.indexOf("Linux") >= 0, P = navigator.language;
}

var T = _,
    k = N,
    Y = "object" == typeof self ? self : "object" == typeof global ? global : {};
var U = null;
var J = N ? 2 : _ ? 1 : 3,
    j = /^\w[\w\d+.-]*$/,
    G = /^\//,
    O = /^\/\//;
var K = !0;
var W = "",
    X = "/",
    Z = /^(([^:\/?#]+?):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?/;

var q =
/*#__PURE__*/
function () {
  _createClass(q, null, [{
    key: "isUri",
    value: function isUri(e) {
      return e instanceof q || !!e && "string" == typeof e.authority && "string" == typeof e.fragment && "string" == typeof e.path && "string" == typeof e.query && "string" == typeof e.scheme && "function" == typeof e.fsPath && "function" == typeof e.with && "function" == typeof e.toString;
    }
  }]);

  function q(e, t, i, o, n, s) {
    _classCallCheck(this, q);

    "object" == typeof e ? (this.scheme = e.scheme || W, this.authority = e.authority || W, this.path = e.path || W, this.query = e.query || W, this.fragment = e.fragment || W) : (this.scheme = e || W, this.authority = t || W, this.path = function (e, t) {
      switch (e) {
        case "https":
        case "http":
        case "file":
          t ? t[0] !== X && (t = X + t) : t = X;
      }

      return t;
    }(this.scheme, i || W), this.query = o || W, this.fragment = n || W, function (e, t) {
      if (!e.scheme) {
        if (t || K) throw new Error("[UriError]: Scheme is missing: {scheme: \"\", authority: \"".concat(e.authority, "\", path: \"").concat(e.path, "\", query: \"").concat(e.query, "\", fragment: \"").concat(e.fragment, "\"}"));
        console.warn("[UriError]: Scheme is missing: {scheme: \"\", authority: \"".concat(e.authority, "\", path: \"").concat(e.path, "\", query: \"").concat(e.query, "\", fragment: \"").concat(e.fragment, "\"}"));
      }

      if (e.scheme && !j.test(e.scheme)) throw new Error("[UriError]: Scheme contains illegal characters.");
      if (e.path) if (e.authority) {
        if (!G.test(e.path)) throw new Error('[UriError]: If a URI contains an authority component, then the path component must either be empty or begin with a slash ("/") character');
      } else if (O.test(e.path)) throw new Error('[UriError]: If a URI does not contain an authority component, then the path cannot begin with two slash characters ("//")');
    }(this, s));
  }

  _createClass(q, [{
    key: "with",
    value: function _with(e) {
      if (!e) return this;
      var t = e.scheme,
          i = e.authority,
          o = e.path,
          n = e.query,
          s = e.fragment;
      return void 0 === t ? t = this.scheme : null === t && (t = W), void 0 === i ? i = this.authority : null === i && (i = W), void 0 === o ? o = this.path : null === o && (o = W), void 0 === n ? n = this.query : null === n && (n = W), void 0 === s ? s = this.fragment : null === s && (s = W), t === this.scheme && i === this.authority && o === this.path && n === this.query && s === this.fragment ? this : new $(t, i, o, n, s);
    }
  }, {
    key: "toString",
    value: function toString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return ne(this, e);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this;
    }
  }, {
    key: "fsPath",
    get: function get() {
      return oe(this);
    }
  }], [{
    key: "parse",
    value: function parse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = Z.exec(e);
      return i ? new $(i[2] || W, decodeURIComponent(i[4] || W), decodeURIComponent(i[5] || W), decodeURIComponent(i[7] || W), decodeURIComponent(i[9] || W), t) : new $(W, W, W, W, W);
    }
  }, {
    key: "file",
    value: function file(e) {
      var t = W;

      if (T && (e = e.replace(/\\/g, X)), e[0] === X && e[1] === X) {
        var _i12 = e.indexOf(X, 2);

        -1 === _i12 ? (t = e.substring(2), e = X) : (t = e.substring(2, _i12), e = e.substring(_i12) || X);
      }

      return new $("file", t, e, W, W);
    }
  }, {
    key: "from",
    value: function from(e) {
      return new $(e.scheme, e.authority, e.path, e.query, e.fragment);
    }
  }, {
    key: "revive",
    value: function revive(e) {
      if (e) {
        if (e instanceof q) return e;
        {
          var _t7 = new $(e);

          return _t7._fsPath = e.fsPath, _t7._formatted = e.external, _t7;
        }
      }

      return e;
    }
  }]);

  return q;
}();

var $ =
/*#__PURE__*/
function (_q) {
  _inherits($, _q);

  function $() {
    var _this6;

    _classCallCheck(this, $);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf($).apply(this, arguments)), _this6._formatted = null, _this6._fsPath = null;
    return _this6;
  }

  _createClass($, [{
    key: "toString",
    value: function toString() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return e ? ne(this, !0) : (this._formatted || (this._formatted = ne(this, !1)), this._formatted);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = {
        $mid: 1
      };
      return this._fsPath && (e.fsPath = this._fsPath), this._formatted && (e.external = this._formatted), this.path && (e.path = this.path), this.scheme && (e.scheme = this.scheme), this.authority && (e.authority = this.authority), this.query && (e.query = this.query), this.fragment && (e.fragment = this.fragment), e;
    }
  }, {
    key: "fsPath",
    get: function get() {
      return this._fsPath || (this._fsPath = oe(this)), this._fsPath;
    }
  }]);

  return $;
}(q);

var ee = {
  58: "%3A",
  47: "%2F",
  63: "%3F",
  35: "%23",
  91: "%5B",
  93: "%5D",
  64: "%40",
  33: "%21",
  36: "%24",
  38: "%26",
  39: "%27",
  40: "%28",
  41: "%29",
  42: "%2A",
  43: "%2B",
  44: "%2C",
  59: "%3B",
  61: "%3D",
  32: "%20"
};

function te(e, t) {
  var i = void 0,
      o = -1;

  for (var _n7 = 0; _n7 < e.length; _n7++) {
    var _s6 = e.charCodeAt(_n7);

    if (_s6 >= 97 && _s6 <= 122 || _s6 >= 65 && _s6 <= 90 || _s6 >= 48 && _s6 <= 57 || 45 === _s6 || 46 === _s6 || 95 === _s6 || 126 === _s6 || t && 47 === _s6) -1 !== o && (i += encodeURIComponent(e.substring(o, _n7)), o = -1), void 0 !== i && (i += e.charAt(_n7));else {
      void 0 === i && (i = e.substr(0, _n7));
      var _t8 = ee[_s6];
      void 0 !== _t8 ? (-1 !== o && (i += encodeURIComponent(e.substring(o, _n7)), o = -1), i += _t8) : -1 === o && (o = _n7);
    }
  }

  return -1 !== o && (i += encodeURIComponent(e.substring(o))), void 0 !== i ? i : e;
}

function ie(e) {
  var t = void 0;

  for (var _i13 = 0; _i13 < e.length; _i13++) {
    var _o3 = e.charCodeAt(_i13);

    35 === _o3 || 63 === _o3 ? (void 0 === t && (t = e.substr(0, _i13)), t += ee[_o3]) : void 0 !== t && (t += e[_i13]);
  }

  return void 0 !== t ? t : e;
}

function oe(e) {
  var t;
  return t = e.authority && e.path.length > 1 && "file" === e.scheme ? "//".concat(e.authority).concat(e.path) : 47 === e.path.charCodeAt(0) && (e.path.charCodeAt(1) >= 65 && e.path.charCodeAt(1) <= 90 || e.path.charCodeAt(1) >= 97 && e.path.charCodeAt(1) <= 122) && 58 === e.path.charCodeAt(2) ? e.path[1].toLowerCase() + e.path.substr(2) : e.path, T && (t = t.replace(/\//g, "\\")), t;
}

function ne(e, t) {
  var i = t ? ie : te;
  var o = "",
      n = e.scheme,
      s = e.authority,
      r = e.path,
      l = e.query,
      a = e.fragment;

  if (n && (o += n, o += ":"), (s || "file" === n) && (o += X, o += X), s) {
    var _e13 = s.indexOf("@");

    if (-1 !== _e13) {
      var _t9 = s.substr(0, _e13);

      s = s.substr(_e13 + 1), -1 === (_e13 = _t9.indexOf(":")) ? o += i(_t9, !1) : (o += i(_t9.substr(0, _e13), !1), o += ":", o += i(_t9.substr(_e13 + 1), !1)), o += "@";
    }

    -1 === (_e13 = (s = s.toLowerCase()).indexOf(":")) ? o += i(s, !1) : (o += i(s.substr(0, _e13), !1), o += s.substr(_e13));
  }

  if (r) {
    if (r.length >= 3 && 47 === r.charCodeAt(0) && 58 === r.charCodeAt(2)) {
      var _e14 = r.charCodeAt(1);

      _e14 >= 65 && _e14 <= 90 && (r = "/".concat(String.fromCharCode(_e14 + 32), ":").concat(r.substr(3)));
    } else if (r.length >= 2 && 58 === r.charCodeAt(1)) {
      var _e15 = r.charCodeAt(0);

      _e15 >= 65 && _e15 <= 90 && (r = "".concat(String.fromCharCode(_e15 + 32), ":").concat(r.substr(2)));
    }

    o += i(r, !0);
  }

  return l && (o += "?", o += i(l, !1)), a && (o += "#", o += t ? a : te(a, !1)), o;
}

function se(e) {
  var t = [];
  return e.forEach(function (e) {
    return t.push(e);
  }), t;
}

function re(e) {
  var t = [];
  return e.forEach(function (e, i) {
    return t.push(i);
  }), t;
}

var le =
/*#__PURE__*/
function () {
  function le() {
    _classCallCheck(this, le);

    this.map = new Map(), this.ignoreCase = !1;
  }

  _createClass(le, [{
    key: "set",
    value: function set(e, t) {
      this.map.set(this.toKey(e), t);
    }
  }, {
    key: "get",
    value: function get(e) {
      return this.map.get(this.toKey(e));
    }
  }, {
    key: "has",
    value: function has(e) {
      return this.map.has(this.toKey(e));
    }
  }, {
    key: "clear",
    value: function clear() {
      this.map.clear();
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      return this.map.delete(this.toKey(e));
    }
  }, {
    key: "forEach",
    value: function forEach(e) {
      this.map.forEach(e);
    }
  }, {
    key: "values",
    value: function values() {
      return se(this.map);
    }
  }, {
    key: "toKey",
    value: function toKey(e) {
      var t = e.toString();
      return this.ignoreCase && (t = t.toLowerCase()), t;
    }
  }, {
    key: "keys",
    value: function keys() {
      return re(this.map).map(function (e) {
        return q.parse(e);
      });
    }
  }, {
    key: "clone",
    value: function clone() {
      var e = new le();
      return this.map.forEach(function (t, i) {
        return e.map.set(i, t);
      }), e;
    }
  }, {
    key: "size",
    get: function get() {
      return this.map.size;
    }
  }]);

  return le;
}();

var ae =
/*#__PURE__*/
function () {
  function ae() {
    _classCallCheck(this, ae);

    this._map = new Map(), this._head = void 0, this._tail = void 0, this._size = 0;
  }

  _createClass(ae, [{
    key: "clear",
    value: function clear() {
      this._map.clear(), this._head = void 0, this._tail = void 0, this._size = 0;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return !this._head && !this._tail;
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._map.has(e);
    }
  }, {
    key: "get",
    value: function get(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var i = this._map.get(e);

      if (i) return 0 !== t && this.touch(i, t), i.value;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var o = this._map.get(e);

      if (o) o.value = t, 0 !== i && this.touch(o, i);else {
        switch (o = {
          key: e,
          value: t,
          next: void 0,
          previous: void 0
        }, i) {
          case 0:
            this.addItemLast(o);
            break;

          case 1:
            this.addItemFirst(o);
            break;

          case 2:
          default:
            this.addItemLast(o);
        }

        this._map.set(e, o), this._size++;
      }
    }
  }, {
    key: "delete",
    value: function _delete(e) {
      return !!this.remove(e);
    }
  }, {
    key: "remove",
    value: function remove(e) {
      var t = this._map.get(e);

      if (t) return this._map.delete(e), this.removeItem(t), this._size--, t.value;
    }
  }, {
    key: "shift",
    value: function shift() {
      if (!this._head && !this._tail) return;
      if (!this._head || !this._tail) throw new Error("Invalid list");
      var e = this._head;
      return this._map.delete(e.key), this.removeItem(e), this._size--, e.value;
    }
  }, {
    key: "forEach",
    value: function forEach(e, t) {
      var i = this._head;

      for (; i;) {
        t ? e.bind(t)(i.value, i.key, this) : e(i.value, i.key, this), i = i.next;
      }
    }
  }, {
    key: "values",
    value: function values() {
      var e = [],
          t = this._head;

      for (; t;) {
        e.push(t.value), t = t.next;
      }

      return e;
    }
  }, {
    key: "keys",
    value: function keys() {
      var e = [],
          t = this._head;

      for (; t;) {
        e.push(t.key), t = t.next;
      }

      return e;
    }
  }, {
    key: "trimOld",
    value: function trimOld(e) {
      if (e >= this.size) return;
      if (0 === e) return void this.clear();
      var t = this._head,
          i = this.size;

      for (; t && i > e;) {
        this._map.delete(t.key), t = t.next, i--;
      }

      this._head = t, this._size = i, t && (t.previous = void 0);
    }
  }, {
    key: "addItemFirst",
    value: function addItemFirst(e) {
      if (this._head || this._tail) {
        if (!this._head) throw new Error("Invalid list");
        e.next = this._head, this._head.previous = e;
      } else this._tail = e;

      this._head = e;
    }
  }, {
    key: "addItemLast",
    value: function addItemLast(e) {
      if (this._head || this._tail) {
        if (!this._tail) throw new Error("Invalid list");
        e.previous = this._tail, this._tail.next = e;
      } else this._head = e;

      this._tail = e;
    }
  }, {
    key: "removeItem",
    value: function removeItem(e) {
      if (e === this._head && e === this._tail) this._head = void 0, this._tail = void 0;else if (e === this._head) {
        if (!e.next) throw new Error("Invalid list");
        e.next.previous = void 0, this._head = e.next;
      } else if (e === this._tail) {
        if (!e.previous) throw new Error("Invalid list");
        e.previous.next = void 0, this._tail = e.previous;
      } else {
        var _t10 = e.next,
            _i14 = e.previous;
        if (!_t10 || !_i14) throw new Error("Invalid list");
        _t10.previous = _i14, _i14.next = _t10;
      }
      e.next = void 0, e.previous = void 0;
    }
  }, {
    key: "touch",
    value: function touch(e, t) {
      if (!this._head || !this._tail) throw new Error("Invalid list");
      if (1 === t || 2 === t) if (1 === t) {
        if (e === this._head) return;
        var _t11 = e.next,
            _i15 = e.previous;
        e === this._tail ? (_i15.next = void 0, this._tail = _i15) : (_t11.previous = _i15, _i15.next = _t11), e.previous = void 0, e.next = this._head, this._head.previous = e, this._head = e;
      } else if (2 === t) {
        if (e === this._tail) return;
        var _t12 = e.next,
            _i16 = e.previous;
        e === this._head ? (_t12.previous = void 0, this._head = _t12) : (_t12.previous = _i16, _i16.next = _t12), e.next = void 0, e.previous = this._tail, this._tail.next = e, this._tail = e;
      }
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var e = [];
      return this.forEach(function (t, i) {
        e.push([i, t]);
      }), e;
    }
  }, {
    key: "fromJSON",
    value: function fromJSON(e) {
      this.clear();
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref6 = _step.value;

          var _ref5 = _slicedToArray(_ref6, 2);

          var _t13 = _ref5[0];
          var _i17 = _ref5[1];
          this.set(_t13, _i17);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }]);

  return ae;
}();

var Ae =
/*#__PURE__*/
function (_ae) {
  _inherits(Ae, _ae);

  function Ae(e) {
    var _this7;

    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

    _classCallCheck(this, Ae);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(Ae).call(this)), _this7._limit = e, _this7._ratio = Math.min(Math.max(0, t), 1);
    return _this7;
  }

  _createClass(Ae, [{
    key: "get",
    value: function get(e) {
      return _get(_getPrototypeOf(Ae.prototype), "get", this).call(this, e, 2);
    }
  }, {
    key: "peek",
    value: function peek(e) {
      return _get(_getPrototypeOf(Ae.prototype), "get", this).call(this, e, 0);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      _get(_getPrototypeOf(Ae.prototype), "set", this).call(this, e, t, 2), this.checkTrim();
    }
  }, {
    key: "checkTrim",
    value: function checkTrim() {
      this.size > this._limit && this.trimOld(Math.round(this._limit * this._ratio));
    }
  }, {
    key: "limit",
    get: function get() {
      return this._limit;
    },
    set: function set(e) {
      this._limit = e, this.checkTrim();
    }
  }, {
    key: "ratio",
    get: function get() {
      return this._ratio;
    },
    set: function set(e) {
      this._ratio = Math.min(Math.max(0, e), 1), this.checkTrim();
    }
  }]);

  return Ae;
}(ae);

function he(e) {
  return e.replace(/[<>&]/g, function (e) {
    switch (e) {
      case "<":
        return "&lt;";

      case ">":
        return "&gt;";

      case "&":
        return "&amp;";

      default:
        return e;
    }
  });
}

function ce(e) {
  return function (e) {
    return e >= 97 && e <= 122;
  }(e) || function (e) {
    return e >= 65 && e <= 90;
  }(e);
}

function de(e, t) {
  return (e ? e.length : 0) === (t ? t.length : 0) && ue(e, t);
}

function ue(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : e.length;
  if ("string" != typeof e || "string" != typeof t) return !1;

  for (var _o4 = 0; _o4 < i; _o4++) {
    var _i18 = e.charCodeAt(_o4),
        _n8 = t.charCodeAt(_o4);

    if (_i18 !== _n8) if (ce(_i18) && ce(_n8)) {
      var _e16 = Math.abs(_i18 - _n8);

      if (0 !== _e16 && 32 !== _e16) return !1;
    } else if (String.fromCharCode(_i18).toLowerCase() !== String.fromCharCode(_n8).toLowerCase()) return !1;
  }

  return !0;
}

Ce.bind(void 0, !1);
var ge = Ce.bind(void 0, !0);

function Ce(e, t, i) {
  if (!i || i.length < t.length) return null;
  var o;
  return (o = e ? function (e, t) {
    var i = t.length;
    return !(t.length > e.length) && ue(e, t, i);
  }(i, t) : 0 === i.indexOf(t)) ? t.length > 0 ? [{
    start: 0,
    end: t.length
  }] : [] : null;
}

new Ae(1e4);

function pe(e) {
  if (void 0 === e) return [];
  var t = e[1].toString(2),
      i = [];

  for (var _o5 = e[2]; _o5 < me; _o5++) {
    if ("1" === t[t.length - (_o5 + 1)]) {
      var _e17 = i[i.length - 1];
      _e17 && _e17.end === _o5 ? _e17.end = _o5 + 1 : i.push({
        start: _o5,
        end: _o5 + 1
      });
    }
  }

  return i;
}

var me = 53;
var fe;
!function (e) {
  e.Default = [-100, 0, 0], e.isDefault = function (e) {
    return !e || -100 === e[0] && 0 === e[1] && 0 === e[2];
  };
}(fe || (fe = {}));

var De =
/*#__PURE__*/
function () {
  function De() {
    _classCallCheck(this, De);
  }

  _createClass(De, [{
    key: "getHeight",
    value: function getHeight(e) {
      return De.ITEM_HEIGHT;
    }
  }, {
    key: "getTemplateId",
    value: function getTemplateId(e) {
      return ve.ID;
    }
  }]);

  return De;
}();

De.ITEM_HEIGHT = 22;

var we =
/*#__PURE__*/
function () {
  function we() {
    _classCallCheck(this, we);
  }

  _createClass(we, [{
    key: "getAriaLabel",
    value: function getAriaLabel(e) {
      return e.text;
    }
  }]);

  return we;
}();

var ve =
/*#__PURE__*/
function () {
  function ve(e, t, i) {
    _classCallCheck(this, ve);

    this.labels = e, this.updateWidth = t, this._treeViewService = i;
  }

  _createClass(ve, [{
    key: "renderTemplate",
    value: function renderTemplate(e) {
      return {
        elementDisposable: f.None,
        label: this.labels.create(e, {
          supportHighlights: !0
        }),
        container: e
      };
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i) {
      var _this8 = this;

      i.elementDisposable.dispose();
      var o = e.element;
      {
        i.label.element.style.display = "flex";
        var _t14 = ["explorer-item"];
        i.label.setResource({
          resource: void 0,
          name: this._treeViewService.getTextLabel(o),
          description: ""
        }, {
          extraClasses: _t14,
          matches: pe(e.filterData)
        }), i.elementDisposable = i.label.onDidRender(function () {
          _this8.updateWidth(o);
        });
      }
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(e, t, i) {
      i.elementDisposable.dispose();
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {
      e.elementDisposable.dispose(), e.label.dispose();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.configListener.dispose();
    }
  }, {
    key: "getHeight",
    value: function getHeight(e, t) {
      return ve.ITEM_HEIGHT;
    }
  }, {
    key: "templateId",
    get: function get() {
      return ve.ID;
    }
  }]);

  return ve;
}();

ve.ID = "file", ve.ITEM_HEIGHT = 22;
var Ee = {
  listFocusBackground: I.fromHex("#EEEEEE"),
  listActiveSelectionBackground: I.fromHex("#D1C4E9"),
  listActiveSelectionForeground: I.fromHex("#6200ee"),
  listFocusAndSelectionBackground: I.fromHex("#9575CD"),
  listFocusAndSelectionForeground: I.fromHex("#FFFFFF"),
  listInactiveSelectionBackground: I.fromHex("#E0E0E0"),
  listHoverBackground: I.fromHex("#F5F5F5"),
  listDropBackground: I.fromHex("#FAFAFA")
};

function ye(e, t) {
  void 0 === t && (t = {});
  var i = t.insertAt;

  if (e && "undefined" != typeof document) {
    var o = document.head || document.getElementsByTagName("head")[0],
        n = document.createElement("style");
    n.type = "text/css", "top" === i && o.firstChild ? o.insertBefore(n, o.firstChild) : o.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
  }
}

ye("/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n/* ---------- Icon label ---------- */\r\n\r\n.monaco-icon-label {\r\n\tdisplay: flex; /* required for icons support :before rule */\r\n\toverflow: hidden;\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.monaco-icon-label::before {\r\n\r\n\t/* svg icons rendered as background image */\r\n\tbackground-size: 16px;\r\n\tbackground-position: left center;\r\n\tbackground-repeat: no-repeat;\r\n\tpadding-right: 6px;\r\n\twidth: 16px;\r\n\theight: 22px;\r\n\tdisplay: inline-block;\r\n\r\n\t/* fonts icons */\r\n\t-webkit-font-smoothing: antialiased;\r\n\tvertical-align: top;\r\n\r\n\tflex-shrink: 0; /* fix for https://github.com/Microsoft/vscode/issues/13787 */\r\n}\r\n\r\n.monaco-icon-label > .monaco-icon-label-description-container {\r\n\toverflow: hidden; /* this causes the label/description to shrink first if decorations are enabled */\r\n\ttext-overflow: ellipsis;\r\n}\r\n\r\n.monaco-icon-label > .monaco-icon-label-description-container > .label-name {\r\n\tcolor: inherit;\r\n\twhite-space: pre; /* enable to show labels that include multiple whitespaces */\r\n}\r\n\r\n.monaco-icon-label > .monaco-icon-label-description-container > .label-description {\r\n\topacity: .7;\r\n\tmargin-left: 0.5em;\r\n\tfont-size: 0.9em;\r\n\twhite-space: pre; /* enable to show labels that include multiple whitespaces */\r\n}\r\n\r\n.monaco-icon-label.italic > .monaco-icon-label-description-container > .label-name,\r\n.monaco-icon-label.italic > .monaco-icon-label-description-container > .label-description {\r\n\tfont-style: italic;\r\n}\r\n\r\n.monaco-icon-label::after {\r\n\topacity: 0.75;\r\n\tfont-size: 90%;\r\n\tfont-weight: 600;\r\n\tpadding: 0 12px 0 5px;\r\n\tmargin-left: auto;\r\n\ttext-align: center;\r\n}\r\n\r\n/* make sure selection color wins when a label is being selected */\r\n.monaco-tree.focused .selected .monaco-icon-label, /* tree */\r\n.monaco-tree.focused .selected .monaco-icon-label::after,\r\n.monaco-list:focus .selected .monaco-icon-label, /* list */\r\n.monaco-list:focus .selected .monaco-icon-label::after\r\n{\r\n\tcolor: inherit !important;\r\n}\r\n\r\n.monaco-tree-row.focused.selected .label-description,\r\n.monaco-tree-row.selected .label-description,\r\n.monaco-list-row.focused.selected .label-description,\r\n.monaco-list-row.selected .label-description {\r\n\topacity: .8;\r\n}");

var Me =
/*#__PURE__*/
function () {
  function Me() {
    _classCallCheck(this, Me);

    this._zoomLevel = 0, this._lastZoomLevelChangeTime = 0, this._onDidChangeZoomLevel = new b(), this.onDidChangeZoomLevel = this._onDidChangeZoomLevel.event, this._zoomFactor = 0, this._onDidChangeFullscreen = new b(), this.onDidChangeFullscreen = this._onDidChangeFullscreen.event;
  }

  _createClass(Me, [{
    key: "getZoomLevel",
    value: function getZoomLevel() {
      return this._zoomLevel;
    }
  }, {
    key: "getTimeSinceLastZoomLevelChanged",
    value: function getTimeSinceLastZoomLevelChanged() {
      return Date.now() - this._lastZoomLevelChangeTime;
    }
  }, {
    key: "setZoomLevel",
    value: function setZoomLevel(e, t) {
      this._zoomLevel !== e && (this._zoomLevel = e, this._lastZoomLevelChangeTime = t ? 0 : Date.now(), this._onDidChangeZoomLevel.fire(this._zoomLevel));
    }
  }, {
    key: "getZoomFactor",
    value: function getZoomFactor() {
      return this._zoomFactor;
    }
  }, {
    key: "setZoomFactor",
    value: function setZoomFactor(e) {
      this._zoomFactor = e;
    }
  }, {
    key: "getPixelRatio",
    value: function getPixelRatio() {
      var e = document.createElement("canvas").getContext("2d");
      return (window.devicePixelRatio || 1) / (e.webkitBackingStorePixelRatio || e.mozBackingStorePixelRatio || e.msBackingStorePixelRatio || e.oBackingStorePixelRatio || e.backingStorePixelRatio || 1);
    }
  }, {
    key: "setFullscreen",
    value: function setFullscreen(e) {
      this._fullscreen !== e && (this._fullscreen = e, this._onDidChangeFullscreen.fire());
    }
  }, {
    key: "isFullscreen",
    value: function isFullscreen() {
      return this._fullscreen;
    }
  }]);

  return Me;
}();

Me.INSTANCE = new Me();
Me.INSTANCE.onDidChangeFullscreen;
var Be = navigator.userAgent,
    be = Be.indexOf("Trident") >= 0,
    Fe = Be.indexOf("Edge/") >= 0,
    He = (Be.indexOf("Opera"), Be.indexOf("Firefox") >= 0),
    Se = Be.indexOf("AppleWebKit") >= 0,
    ze = !(Be.indexOf("Chrome") >= 0) && Be.indexOf("Safari") >= 0,
    xe = (Be.indexOf("iPad"), Fe && Be.indexOf("WebView/"), function (e, t, i) {
  var o = function o(e) {
    return n.fire(e);
  },
      n = new b({
    onFirstListenerAdd: function onFirstListenerAdd() {
      e.addEventListener(t, o, i);
    },
    onLastListenerRemove: function onLastListenerRemove() {
      e.removeEventListener(t, o, i);
    }
  });

  return n.event;
});

var Ve =
/*#__PURE__*/
function () {
  function Ve() {
    _classCallCheck(this, Ve);

    this._keyCodeToStr = [], this._strToKeyCode = Object.create(null);
  }

  _createClass(Ve, [{
    key: "define",
    value: function define(e, t) {
      this._keyCodeToStr[e] = t, this._strToKeyCode[t.toLowerCase()] = e;
    }
  }, {
    key: "keyCodeToStr",
    value: function keyCodeToStr(e) {
      return this._keyCodeToStr[e];
    }
  }, {
    key: "strToKeyCode",
    value: function strToKeyCode(e) {
      return this._strToKeyCode[e.toLowerCase()] || 0;
    }
  }]);

  return Ve;
}();

var Ie = new Ve(),
    _e = new Ve(),
    Ne = new Ve();

var Le;

function Pe(e, t) {
  if (0 === e) return null;
  var i = (65535 & e) >>> 0,
      o = (4294901760 & e) >>> 16;
  return new Te(0 !== o ? [Qe(i, t), Qe(o, t)] : [Qe(i, t)]);
}

function Qe(e, t) {
  var i = !!(2048 & e),
      o = !!(256 & e);
  return new Re(2 === t ? o : i, !!(1024 & e), !!(512 & e), 2 === t ? i : o, 255 & e);
}

!function () {
  function e(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : i;
    Ie.define(e, t), _e.define(e, i), Ne.define(e, o);
  }

  e(0, "unknown"), e(1, "Backspace"), e(2, "Tab"), e(3, "Enter"), e(4, "Shift"), e(5, "Ctrl"), e(6, "Alt"), e(7, "PauseBreak"), e(8, "CapsLock"), e(9, "Escape"), e(10, "Space"), e(11, "PageUp"), e(12, "PageDown"), e(13, "End"), e(14, "Home"), e(15, "LeftArrow", "Left"), e(16, "UpArrow", "Up"), e(17, "RightArrow", "Right"), e(18, "DownArrow", "Down"), e(19, "Insert"), e(20, "Delete"), e(21, "0"), e(22, "1"), e(23, "2"), e(24, "3"), e(25, "4"), e(26, "5"), e(27, "6"), e(28, "7"), e(29, "8"), e(30, "9"), e(31, "A"), e(32, "B"), e(33, "C"), e(34, "D"), e(35, "E"), e(36, "F"), e(37, "G"), e(38, "H"), e(39, "I"), e(40, "J"), e(41, "K"), e(42, "L"), e(43, "M"), e(44, "N"), e(45, "O"), e(46, "P"), e(47, "Q"), e(48, "R"), e(49, "S"), e(50, "T"), e(51, "U"), e(52, "V"), e(53, "W"), e(54, "X"), e(55, "Y"), e(56, "Z"), e(57, "Meta"), e(58, "ContextMenu"), e(59, "F1"), e(60, "F2"), e(61, "F3"), e(62, "F4"), e(63, "F5"), e(64, "F6"), e(65, "F7"), e(66, "F8"), e(67, "F9"), e(68, "F10"), e(69, "F11"), e(70, "F12"), e(71, "F13"), e(72, "F14"), e(73, "F15"), e(74, "F16"), e(75, "F17"), e(76, "F18"), e(77, "F19"), e(78, "NumLock"), e(79, "ScrollLock"), e(80, ";", ";", "OEM_1"), e(81, "=", "=", "OEM_PLUS"), e(82, ",", ",", "OEM_COMMA"), e(83, "-", "-", "OEM_MINUS"), e(84, ".", ".", "OEM_PERIOD"), e(85, "/", "/", "OEM_2"), e(86, "`", "`", "OEM_3"), e(110, "ABNT_C1"), e(111, "ABNT_C2"), e(87, "[", "[", "OEM_4"), e(88, "\\", "\\", "OEM_5"), e(89, "]", "]", "OEM_6"), e(90, "'", "'", "OEM_7"), e(91, "OEM_8"), e(92, "OEM_102"), e(93, "NumPad0"), e(94, "NumPad1"), e(95, "NumPad2"), e(96, "NumPad3"), e(97, "NumPad4"), e(98, "NumPad5"), e(99, "NumPad6"), e(100, "NumPad7"), e(101, "NumPad8"), e(102, "NumPad9"), e(103, "NumPad_Multiply"), e(104, "NumPad_Add"), e(105, "NumPad_Separator"), e(106, "NumPad_Subtract"), e(107, "NumPad_Decimal"), e(108, "NumPad_Divide");
}(), function (e) {
  e.toString = function (e) {
    return Ie.keyCodeToStr(e);
  }, e.fromString = function (e) {
    return Ie.strToKeyCode(e);
  }, e.toUserSettingsUS = function (e) {
    return _e.keyCodeToStr(e);
  }, e.toUserSettingsGeneral = function (e) {
    return Ne.keyCodeToStr(e);
  }, e.fromUserSettings = function (e) {
    return _e.strToKeyCode(e) || Ne.strToKeyCode(e);
  };
}(Le || (Le = {}));

var Re =
/*#__PURE__*/
function () {
  function Re(e, t, i, o, n) {
    _classCallCheck(this, Re);

    this.ctrlKey = e, this.shiftKey = t, this.altKey = i, this.metaKey = o, this.keyCode = n;
  }

  _createClass(Re, [{
    key: "equals",
    value: function equals(e) {
      return this.ctrlKey === e.ctrlKey && this.shiftKey === e.shiftKey && this.altKey === e.altKey && this.metaKey === e.metaKey && this.keyCode === e.keyCode;
    }
  }, {
    key: "getHashCode",
    value: function getHashCode() {
      return "".concat(this.ctrlKey ? "1" : "0").concat(this.shiftKey ? "1" : "0").concat(this.altKey ? "1" : "0").concat(this.metaKey ? "1" : "0").concat(this.keyCode);
    }
  }, {
    key: "isModifierKey",
    value: function isModifierKey() {
      return 0 === this.keyCode || 5 === this.keyCode || 57 === this.keyCode || 6 === this.keyCode || 4 === this.keyCode;
    }
  }, {
    key: "toChord",
    value: function toChord() {
      return new Te([this]);
    }
  }, {
    key: "isDuplicateModifierCase",
    value: function isDuplicateModifierCase() {
      return this.ctrlKey && 5 === this.keyCode || this.shiftKey && 4 === this.keyCode || this.altKey && 6 === this.keyCode || this.metaKey && 57 === this.keyCode;
    }
  }]);

  return Re;
}();

var Te =
/*#__PURE__*/
function () {
  function Te(e) {
    _classCallCheck(this, Te);

    if (0 === e.length) throw g("parts");
    this.parts = e;
  }

  _createClass(Te, [{
    key: "getHashCode",
    value: function getHashCode() {
      var e = "";

      for (var _t15 = 0, _i19 = this.parts.length; _t15 < _i19; _t15++) {
        0 !== _t15 && (e += ";"), e += this.parts[_t15].getHashCode();
      }

      return e;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      if (null === e) return !1;
      if (this.parts.length !== e.parts.length) return !1;

      for (var _t16 = 0; _t16 < this.parts.length; _t16++) {
        if (!this.parts[_t16].equals(e.parts[_t16])) return !1;
      }

      return !0;
    }
  }]);

  return Te;
}();

var ke = function ke(e, t, i, o, n, s) {
  _classCallCheck(this, ke);

  this.ctrlKey = e, this.shiftKey = t, this.altKey = i, this.metaKey = o, this.keyLabel = n, this.keyAriaLabel = s;
};

var Ye = function Ye() {
  _classCallCheck(this, Ye);
};

var Ue = new Array(230),
    Je = new Array(112);
!function () {
  for (var _e18 = 0; _e18 < Je.length; _e18++) {
    Je[_e18] = -1;
  }

  function e(e, t) {
    Ue[e] = t, Je[t] = e;
  }

  e(3, 7), e(8, 1), e(9, 2), e(13, 3), e(16, 4), e(17, 5), e(18, 6), e(19, 7), e(20, 8), e(27, 9), e(32, 10), e(33, 11), e(34, 12), e(35, 13), e(36, 14), e(37, 15), e(38, 16), e(39, 17), e(40, 18), e(45, 19), e(46, 20), e(48, 21), e(49, 22), e(50, 23), e(51, 24), e(52, 25), e(53, 26), e(54, 27), e(55, 28), e(56, 29), e(57, 30), e(65, 31), e(66, 32), e(67, 33), e(68, 34), e(69, 35), e(70, 36), e(71, 37), e(72, 38), e(73, 39), e(74, 40), e(75, 41), e(76, 42), e(77, 43), e(78, 44), e(79, 45), e(80, 46), e(81, 47), e(82, 48), e(83, 49), e(84, 50), e(85, 51), e(86, 52), e(87, 53), e(88, 54), e(89, 55), e(90, 56), e(93, 58), e(96, 93), e(97, 94), e(98, 95), e(99, 96), e(100, 97), e(101, 98), e(102, 99), e(103, 100), e(104, 101), e(105, 102), e(106, 103), e(107, 104), e(108, 105), e(109, 106), e(110, 107), e(111, 108), e(112, 59), e(113, 60), e(114, 61), e(115, 62), e(116, 63), e(117, 64), e(118, 65), e(119, 66), e(120, 67), e(121, 68), e(122, 69), e(123, 70), e(124, 71), e(125, 72), e(126, 73), e(127, 74), e(128, 75), e(129, 76), e(130, 77), e(144, 78), e(145, 79), e(186, 80), e(187, 81), e(188, 82), e(189, 83), e(190, 84), e(191, 85), e(192, 86), e(193, 110), e(194, 111), e(219, 87), e(220, 88), e(221, 89), e(222, 90), e(223, 91), e(226, 92), e(229, 109), be ? e(91, 57) : He ? (e(59, 80), e(107, 81), e(109, 83), k && e(224, 57)) : Se && (e(91, 57), e(k ? 93 : 92, 57));
}();
var je = k ? 256 : 2048,
    Ge = 512,
    Oe = 1024,
    Ke = k ? 2048 : 256;

var We =
/*#__PURE__*/
function () {
  function We(e) {
    _classCallCheck(this, We);

    this._standardKeyboardEventBrand = !0;
    var t = e;
    this.browserEvent = t, this.target = t.target, this.ctrlKey = t.ctrlKey, this.shiftKey = t.shiftKey, this.altKey = t.altKey, this.metaKey = t.metaKey, this.keyCode = function (e) {
      if (e.charCode) {
        var _t17 = String.fromCharCode(e.charCode).toUpperCase();

        return Le.fromString(_t17);
      }

      return Ue[e.keyCode] || 0;
    }(t), this.code = t.code, this.ctrlKey = this.ctrlKey || 5 === this.keyCode, this.altKey = this.altKey || 6 === this.keyCode, this.shiftKey = this.shiftKey || 4 === this.keyCode, this.metaKey = this.metaKey || 57 === this.keyCode, this._asKeybinding = this._computeKeybinding(), this._asRuntimeKeybinding = this._computeRuntimeKeybinding();
  }

  _createClass(We, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
    }
  }, {
    key: "toKeybinding",
    value: function toKeybinding() {
      return this._asRuntimeKeybinding;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return this._asKeybinding === e;
    }
  }, {
    key: "_computeKeybinding",
    value: function _computeKeybinding() {
      var e = 0;
      5 !== this.keyCode && 4 !== this.keyCode && 6 !== this.keyCode && 57 !== this.keyCode && (e = this.keyCode);
      var t = 0;
      return this.ctrlKey && (t |= je), this.altKey && (t |= Ge), this.shiftKey && (t |= Oe), this.metaKey && (t |= Ke), t |= e;
    }
  }, {
    key: "_computeRuntimeKeybinding",
    value: function _computeRuntimeKeybinding() {
      var e = 0;
      return 5 !== this.keyCode && 4 !== this.keyCode && 6 !== this.keyCode && 57 !== this.keyCode && (e = this.keyCode), new Re(this.ctrlKey, this.shiftKey, this.altKey, this.metaKey, e);
    }
  }]);

  return We;
}();

var Xe = !1,
    Ze = null;

function qe(e) {
  if (!e.parent || e.parent === e) return null;

  try {
    var _t18 = e.location,
        _i20 = e.parent.location;
    if (_t18.protocol !== _i20.protocol || _t18.hostname !== _i20.hostname || _t18.port !== _i20.port) return Xe = !0, null;
  } catch (e) {
    return Xe = !0, null;
  }

  return e.parent;
}

function $e(e, t) {
  var i,
      o = e.document.getElementsByTagName("iframe");

  for (var _e19 = 0, _n9 = o.length; _e19 < _n9; _e19++) {
    if ((i = o[_e19]).contentWindow === t) return i;
  }

  return null;
}

var et =
/*#__PURE__*/
function () {
  function et() {
    _classCallCheck(this, et);
  }

  _createClass(et, null, [{
    key: "getSameOriginWindowChain",
    value: function getSameOriginWindowChain() {
      if (!Ze) {
        Ze = [];

        var _e20,
            _t19 = window;

        do {
          (_e20 = qe(_t19)) ? Ze.push({
            window: _t19,
            iframeElement: $e(_e20, _t19)
          }) : Ze.push({
            window: _t19,
            iframeElement: null
          }), _t19 = _e20;
        } while (_t19);
      }

      return Ze.slice(0);
    }
  }, {
    key: "hasDifferentOriginAncestor",
    value: function hasDifferentOriginAncestor() {
      return Ze || this.getSameOriginWindowChain(), Xe;
    }
  }, {
    key: "getPositionOfChildWindowRelativeToAncestorWindow",
    value: function getPositionOfChildWindowRelativeToAncestorWindow(e, t) {
      if (!t || e === t) return {
        top: 0,
        left: 0
      };
      var i = 0,
          o = 0,
          n = this.getSameOriginWindowChain();
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = n[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _e21 = _step2.value;
          if (_e21.window === t) break;
          if (!_e21.iframeElement) break;

          var _n10 = _e21.iframeElement.getBoundingClientRect();

          i += _n10.top, o += _n10.left;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return {
        top: i,
        left: o
      };
    }
  }]);

  return et;
}();

var tt =
/*#__PURE__*/
function () {
  function tt(e) {
    _classCallCheck(this, tt);

    this.timestamp = Date.now(), this.browserEvent = e, this.leftButton = 0 === e.button, this.middleButton = 1 === e.button, this.rightButton = 2 === e.button, this.target = e.target, this.detail = e.detail || 1, "dblclick" === e.type && (this.detail = 2), this.ctrlKey = e.ctrlKey, this.shiftKey = e.shiftKey, this.altKey = e.altKey, this.metaKey = e.metaKey, "number" == typeof e.pageX ? (this.posx = e.pageX, this.posy = e.pageY) : (this.posx = e.clientX + document.body.scrollLeft + document.documentElement.scrollLeft, this.posy = e.clientY + document.body.scrollTop + document.documentElement.scrollTop);
    var t = et.getPositionOfChildWindowRelativeToAncestorWindow(self, e.view);
    this.posx -= t.left, this.posy -= t.top;
  }

  _createClass(tt, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.browserEvent.preventDefault && this.browserEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
    }
  }]);

  return tt;
}();

var it =
/*#__PURE__*/
function () {
  function it(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

    _classCallCheck(this, it);

    if (this.browserEvent = e || null, this.target = e ? e.target || e.targetNode || e.srcElement : null, this.deltaY = i, this.deltaX = t, e) {
      var _t20 = e,
          _i21 = e;
      void 0 !== _t20.wheelDeltaY ? this.deltaY = _t20.wheelDeltaY / 120 : void 0 !== _i21.VERTICAL_AXIS && _i21.axis === _i21.VERTICAL_AXIS && (this.deltaY = -_i21.detail / 3), void 0 !== _t20.wheelDeltaX ? this.deltaX = ze && T ? -_t20.wheelDeltaX / 120 : _t20.wheelDeltaX / 120 : void 0 !== _i21.HORIZONTAL_AXIS && _i21.axis === _i21.HORIZONTAL_AXIS && (this.deltaX = -e.detail / 3), 0 === this.deltaY && 0 === this.deltaX && e.wheelDelta && (this.deltaY = e.wheelDelta / 120);
    }
  }

  _createClass(it, [{
    key: "preventDefault",
    value: function preventDefault() {
      this.browserEvent && this.browserEvent.preventDefault && this.browserEvent.preventDefault();
    }
  }, {
    key: "stopPropagation",
    value: function stopPropagation() {
      this.browserEvent && this.browserEvent.stopPropagation && this.browserEvent.stopPropagation();
    }
  }]);

  return it;
}();

var ot = Object.freeze(function (e, t) {
  var i = setTimeout(e.bind(t), 0);
  return {
    dispose: function dispose() {
      clearTimeout(i);
    }
  };
});
var nt;
!function (e) {
  e.isCancellationToken = function (t) {
    return t === e.None || t === e.Cancelled || t instanceof st || !(!t || "object" != typeof t) && "boolean" == typeof t.isCancellationRequested && "function" == typeof t.onCancellationRequested;
  }, e.None = Object.freeze({
    isCancellationRequested: !1,
    onCancellationRequested: v.None
  }), e.Cancelled = Object.freeze({
    isCancellationRequested: !0,
    onCancellationRequested: ot
  });
}(nt || (nt = {}));

var st =
/*#__PURE__*/
function () {
  function st() {
    _classCallCheck(this, st);

    this._isCancelled = !1, this._emitter = null;
  }

  _createClass(st, [{
    key: "cancel",
    value: function cancel() {
      this._isCancelled || (this._isCancelled = !0, this._emitter && (this._emitter.fire(void 0), this.dispose()));
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._emitter && (this._emitter.dispose(), this._emitter = null);
    }
  }, {
    key: "isCancellationRequested",
    get: function get() {
      return this._isCancelled;
    }
  }, {
    key: "onCancellationRequested",
    get: function get() {
      return this._isCancelled ? ot : (this._emitter || (this._emitter = new b()), this._emitter.event);
    }
  }]);

  return st;
}();

var rt =
/*#__PURE__*/
function () {
  function rt() {
    _classCallCheck(this, rt);
  }

  _createClass(rt, [{
    key: "cancel",
    value: function cancel() {
      this._token ? this._token instanceof st && this._token.cancel() : this._token = nt.Cancelled;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._token ? this._token instanceof st && this._token.dispose() : this._token = nt.None;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token || (this._token = new st()), this._token;
    }
  }]);

  return rt;
}();

function lt(e) {
  var t = new rt(),
      i = e(t.token),
      o = new Promise(function (e, o) {
    t.token.onCancellationRequested(function () {
      o(u());
    }), Promise.resolve(i).then(function (i) {
      t.dispose(), e(i);
    }, function (e) {
      t.dispose(), o(e);
    });
  });
  return new (
  /*#__PURE__*/
  function () {
    function _class2() {
      _classCallCheck(this, _class2);
    }

    _createClass(_class2, [{
      key: "cancel",
      value: function cancel() {
        t.cancel();
      }
    }, {
      key: "then",
      value: function then(e, t) {
        return o.then(e, t);
      }
    }, {
      key: "catch",
      value: function _catch(e) {
        return this.then(void 0, e);
      }
    }, {
      key: "finally",
      value: function _finally(e) {
        return o.finally(e);
      }
    }]);

    return _class2;
  }())();
}

var at =
/*#__PURE__*/
function () {
  function at(e) {
    _classCallCheck(this, at);

    this.defaultDelay = e, this.timeout = null, this.completionPromise = null, this.doResolve = null, this.task = null;
  }

  _createClass(at, [{
    key: "trigger",
    value: function trigger(e) {
      var _this9 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.defaultDelay;
      return this.task = e, this.cancelTimeout(), this.completionPromise || (this.completionPromise = new Promise(function (e, t) {
        _this9.doResolve = e, _this9.doReject = t;
      }).then(function () {
        _this9.completionPromise = null, _this9.doResolve = null;
        var e = _this9.task;
        return _this9.task = null, e();
      })), this.timeout = setTimeout(function () {
        _this9.timeout = null, _this9.doResolve(null);
      }, t), this.completionPromise;
    }
  }, {
    key: "isTriggered",
    value: function isTriggered() {
      return null !== this.timeout;
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.cancelTimeout(), this.completionPromise && (this.doReject(u()), this.completionPromise = null);
    }
  }, {
    key: "cancelTimeout",
    value: function cancelTimeout() {
      null !== this.timeout && (clearTimeout(this.timeout), this.timeout = null);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.cancelTimeout();
    }
  }]);

  return at;
}();

function At(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var i = setTimeout(e, t);
  return m(function () {
    return clearTimeout(i);
  });
}

var ht =
/*#__PURE__*/
function (_f) {
  _inherits(ht, _f);

  function ht(e, t) {
    var _this10;

    _classCallCheck(this, ht);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(ht).call(this)), _this10._token = -1, "function" == typeof e && "number" == typeof t && _this10.setIfNotSet(e, t);
    return _this10;
  }

  _createClass(ht, [{
    key: "dispose",
    value: function dispose() {
      this.cancel(), _get(_getPrototypeOf(ht.prototype), "dispose", this).call(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      -1 !== this._token && (clearTimeout(this._token), this._token = -1);
    }
  }, {
    key: "cancelAndSet",
    value: function cancelAndSet(e, t) {
      var _this11 = this;

      this.cancel(), this._token = setTimeout(function () {
        _this11._token = -1, e();
      }, t);
    }
  }, {
    key: "setIfNotSet",
    value: function setIfNotSet(e, t) {
      var _this12 = this;

      -1 === this._token && (this._token = setTimeout(function () {
        _this12._token = -1, e();
      }, t));
    }
  }]);

  return ht;
}(f);

var ct =
/*#__PURE__*/
function (_f2) {
  _inherits(ct, _f2);

  function ct() {
    var _this13;

    _classCallCheck(this, ct);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(ct).call(this)), _this13._token = -1;
    return _this13;
  }

  _createClass(ct, [{
    key: "dispose",
    value: function dispose() {
      this.cancel(), _get(_getPrototypeOf(ct.prototype), "dispose", this).call(this);
    }
  }, {
    key: "cancel",
    value: function cancel() {
      -1 !== this._token && (clearInterval(this._token), this._token = -1);
    }
  }, {
    key: "cancelAndSet",
    value: function cancelAndSet(e, t) {
      this.cancel(), this._token = setInterval(function () {
        e();
      }, t);
    }
  }]);

  return ct;
}(f);

function dt(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return e[e.length - (1 + t)];
}

function ut(e, t) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (e, t) {
    return e === t;
  };
  if (e === t) return !0;
  if (!e || !t) return !1;
  if (e.length !== t.length) return !1;

  for (var _o6 = 0, _n11 = e.length; _o6 < _n11; _o6++) {
    if (!i(e[_o6], t[_o6])) return !1;
  }

  return !0;
}

function gt(e) {
  return e ? e.filter(function (e) {
    return !!e;
  }) : e;
}

function Ct(e, t) {
  if (!t) return e.filter(function (t, i) {
    return e.indexOf(t) === i;
  });
  var i = Object.create(null);
  return e.filter(function (e) {
    var o = t(e);
    return !i[o] && (i[o] = !0, !0);
  });
}

function pt(e, t) {
  for (var _i22 = 0; _i22 < e.length; _i22++) {
    if (t(e[_i22])) return _i22;
  }

  return -1;
}

function mt(e, t) {
  var i = "number" == typeof t ? e : 0;
  "number" == typeof t ? i = e : (i = 0, t = e);
  var o = [];
  if (i <= t) for (var _e22 = i; _e22 < t; _e22++) {
    o.push(_e22);
  } else for (var _e23 = i; _e23 > t; _e23--) {
    o.push(_e23);
  }
  return o;
}

!function () {
  if ("function" != typeof requestIdleCallback || "function" != typeof cancelIdleCallback) {
    Object.freeze({
      didTimeout: !0,
      timeRemaining: function timeRemaining() {
        return 15;
      }
    });
  }
}();
var ft = new (
/*#__PURE__*/
function () {
  function _class3() {
    _classCallCheck(this, _class3);
  }

  _createClass(_class3, [{
    key: "_findClassName",
    value: function _findClassName(e, t) {
      var i = e.className;
      if (!i) return void (this._lastStart = -1);
      t = t.trim();
      var o = i.length,
          n = t.length;
      if (0 === n) return void (this._lastStart = -1);
      if (o < n) return void (this._lastStart = -1);
      if (i === t) return this._lastStart = 0, void (this._lastEnd = o);
      var s,
          r = -1;

      for (; (r = i.indexOf(t, r + 1)) >= 0;) {
        if (s = r + n, (0 === r || 32 === i.charCodeAt(r - 1)) && 32 === i.charCodeAt(s)) return this._lastStart = r, void (this._lastEnd = s + 1);
        if (r > 0 && 32 === i.charCodeAt(r - 1) && s === o) return this._lastStart = r - 1, void (this._lastEnd = s);
        if (0 === r && s === o) return this._lastStart = 0, void (this._lastEnd = s);
      }

      this._lastStart = -1;
    }
  }, {
    key: "hasClass",
    value: function hasClass(e, t) {
      return this._findClassName(e, t), -1 !== this._lastStart;
    }
  }, {
    key: "addClasses",
    value: function addClasses(e) {
      var _this14 = this;

      for (var _len5 = arguments.length, t = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        t[_key5 - 1] = arguments[_key5];
      }

      t.forEach(function (t) {
        return t.split(" ").forEach(function (t) {
          return _this14.addClass(e, t);
        });
      });
    }
  }, {
    key: "addClass",
    value: function addClass(e, t) {
      e.className ? (this._findClassName(e, t), -1 === this._lastStart && (e.className = e.className + " " + t)) : e.className = t;
    }
  }, {
    key: "removeClass",
    value: function removeClass(e, t) {
      this._findClassName(e, t), -1 !== this._lastStart && (e.className = e.className.substring(0, this._lastStart) + e.className.substring(this._lastEnd));
    }
  }, {
    key: "removeClasses",
    value: function removeClasses(e) {
      var _this15 = this;

      for (var _len6 = arguments.length, t = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        t[_key6 - 1] = arguments[_key6];
      }

      t.forEach(function (t) {
        return t.split(" ").forEach(function (t) {
          return _this15.removeClass(e, t);
        });
      });
    }
  }, {
    key: "toggleClass",
    value: function toggleClass(e, t, i) {
      this._findClassName(e, t), -1 === this._lastStart || void 0 !== i && i || this.removeClass(e, t), -1 !== this._lastStart || void 0 !== i && !i || this.addClass(e, t);
    }
  }]);

  return _class3;
}())(),
    Dt = new (
/*#__PURE__*/
function () {
  function _class4() {
    _classCallCheck(this, _class4);
  }

  _createClass(_class4, [{
    key: "hasClass",
    value: function hasClass(e, t) {
      return Boolean(t) && e.classList && e.classList.contains(t);
    }
  }, {
    key: "addClasses",
    value: function addClasses(e) {
      var _this16 = this;

      for (var _len7 = arguments.length, t = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        t[_key7 - 1] = arguments[_key7];
      }

      t.forEach(function (t) {
        return t.split(" ").forEach(function (t) {
          return _this16.addClass(e, t);
        });
      });
    }
  }, {
    key: "addClass",
    value: function addClass(e, t) {
      t && e.classList && e.classList.add(t);
    }
  }, {
    key: "removeClass",
    value: function removeClass(e, t) {
      t && e.classList && e.classList.remove(t);
    }
  }, {
    key: "removeClasses",
    value: function removeClasses(e) {
      var _this17 = this;

      for (var _len8 = arguments.length, t = new Array(_len8 > 1 ? _len8 - 1 : 0), _key8 = 1; _key8 < _len8; _key8++) {
        t[_key8 - 1] = arguments[_key8];
      }

      t.forEach(function (t) {
        return t.split(" ").forEach(function (t) {
          return _this17.removeClass(e, t);
        });
      });
    }
  }, {
    key: "toggleClass",
    value: function toggleClass(e, t, i) {
      e.classList && e.classList.toggle(t, i);
    }
  }]);

  return _class4;
}())(),
    wt = be ? ft : Dt,
    vt = wt.hasClass.bind(wt),
    Et = wt.addClass.bind(wt),
    yt = (wt.addClasses.bind(wt), wt.removeClass.bind(wt)),
    Mt = (wt.removeClasses.bind(wt), wt.toggleClass.bind(wt));

var Bt =
/*#__PURE__*/
function () {
  function Bt(e, t, i, o) {
    _classCallCheck(this, Bt);

    this._node = e, this._type = t, this._handler = i, this._useCapture = o || !1, this._node.addEventListener(this._type, this._handler, this._useCapture);
  }

  _createClass(Bt, [{
    key: "dispose",
    value: function dispose() {
      this._handler && (this._node.removeEventListener(this._type, this._handler, this._useCapture), this._node = null, this._handler = null);
    }
  }]);

  return Bt;
}();

function bt(e, t, i, o) {
  return new Bt(e, t, i, o);
}

var Ft,
    Ht = null;

var St =
/*#__PURE__*/
function () {
  function St(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    _classCallCheck(this, St);

    this._runner = e, this.priority = t, this._canceled = !1;
  }

  _createClass(St, [{
    key: "dispose",
    value: function dispose() {
      this._canceled = !0;
    }
  }, {
    key: "execute",
    value: function execute() {
      if (!this._canceled) try {
        this._runner();
      } catch (e) {
        h(e);
      }
    }
  }], [{
    key: "sort",
    value: function sort(e, t) {
      return t.priority - e.priority;
    }
  }]);

  return St;
}();

!function () {
  var e = [],
      t = null,
      i = !1,
      o = function o() {
    for (i = !1, t = e, e = []; t.length > 0;) {
      t.sort(St.sort), t.shift().execute();
    }
  };

  Ft = function Ft(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var s = new St(t, n);
    return e.push(s), i || (i = !0, function (e) {
      if (!Ht) {
        var _e24 = function _e24(e) {
          return setTimeout(function () {
            return e(new Date().getTime());
          }, 0);
        };

        Ht = self.requestAnimationFrame || self.msRequestAnimationFrame || self.webkitRequestAnimationFrame || self.mozRequestAnimationFrame || self.oRequestAnimationFrame || _e24;
      }

      Ht.call(self, e);
    }(o)), s;
  };
}();

var zt = 16,
    xt = function xt(e, t) {
  return t;
};

var Vt =
/*#__PURE__*/
function (_f3) {
  _inherits(Vt, _f3);

  function Vt(e, t, i) {
    var _this18;

    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : xt;
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : zt;

    _classCallCheck(this, Vt);

    _this18 = _possibleConstructorReturn(this, _getPrototypeOf(Vt).call(this));

    var s = null,
        r = 0,
        l = _this18._register(new ht()),
        a = function a() {
      r = new Date().getTime(), i(s), s = null;
    };

    _this18._register(bt(e, t, function (e) {
      s = o(s, e);
      var t = new Date().getTime() - r;
      t >= n ? (l.cancel(), a()) : l.setIfNotSet(a, n - t);
    }));

    return _this18;
  }

  return Vt;
}(f);

function It(e) {
  return document.defaultView.getComputedStyle(e, null);
}

var _t = function _t(e, t) {
  return parseFloat(t) || 0;
};

function Nt(e, t, i) {
  var o = It(e),
      n = "0";
  return o && (n = o.getPropertyValue ? o.getPropertyValue(t) : o.getAttribute(i)), _t(e, n);
}

var Lt = {
  getBorderLeftWidth: function getBorderLeftWidth(e) {
    return Nt(e, "border-left-width", "borderLeftWidth");
  },
  getBorderRightWidth: function getBorderRightWidth(e) {
    return Nt(e, "border-right-width", "borderRightWidth");
  },
  getBorderTopWidth: function getBorderTopWidth(e) {
    return Nt(e, "border-top-width", "borderTopWidth");
  },
  getBorderBottomWidth: function getBorderBottomWidth(e) {
    return Nt(e, "border-bottom-width", "borderBottomWidth");
  },
  getPaddingLeft: function getPaddingLeft(e) {
    return Nt(e, "padding-left", "paddingLeft");
  },
  getPaddingRight: function getPaddingRight(e) {
    return Nt(e, "padding-right", "paddingRight");
  },
  getPaddingTop: function getPaddingTop(e) {
    return Nt(e, "padding-top", "paddingTop");
  },
  getPaddingBottom: function getPaddingBottom(e) {
    return Nt(e, "padding-bottom", "paddingBottom");
  },
  getMarginLeft: function getMarginLeft(e) {
    return Nt(e, "margin-left", "marginLeft");
  },
  getMarginTop: function getMarginTop(e) {
    return Nt(e, "margin-top", "marginTop");
  },
  getMarginRight: function getMarginRight(e) {
    return Nt(e, "margin-right", "marginRight");
  },
  getMarginBottom: function getMarginBottom(e) {
    return Nt(e, "margin-bottom", "marginBottom");
  },
  __commaSentinel: !1
};
var Pt = new (
/*#__PURE__*/
function () {
  function _class5() {
    _classCallCheck(this, _class5);
  }

  _createClass(_class5, [{
    key: "scrollX",
    get: function get() {
      return "number" == typeof window.scrollX ? window.scrollX : document.body.scrollLeft + document.documentElement.scrollLeft;
    }
  }, {
    key: "scrollY",
    get: function get() {
      return "number" == typeof window.scrollY ? window.scrollY : document.body.scrollTop + document.documentElement.scrollTop;
    }
  }]);

  return _class5;
}())();

function Qt(e) {
  var t = Lt.getBorderLeftWidth(e) + Lt.getBorderRightWidth(e),
      i = Lt.getPaddingLeft(e) + Lt.getPaddingRight(e);
  return e.offsetWidth - t - i;
}

function Rt(e) {
  var t = Lt.getBorderTopWidth(e) + Lt.getBorderBottomWidth(e),
      i = Lt.getPaddingTop(e) + Lt.getPaddingBottom(e);
  return e.offsetHeight - t - i;
}

var Tt = {
  CLICK: "click",
  DBLCLICK: "dblclick",
  MOUSE_UP: "mouseup",
  MOUSE_DOWN: "mousedown",
  MOUSE_OVER: "mouseover",
  MOUSE_MOVE: "mousemove",
  MOUSE_OUT: "mouseout",
  MOUSE_ENTER: "mouseenter",
  MOUSE_LEAVE: "mouseleave",
  CONTEXT_MENU: "contextmenu",
  WHEEL: "wheel",
  KEY_DOWN: "keydown",
  KEY_PRESS: "keypress",
  KEY_UP: "keyup",
  LOAD: "load",
  UNLOAD: "unload",
  ABORT: "abort",
  ERROR: "error",
  RESIZE: "resize",
  SCROLL: "scroll",
  SELECT: "select",
  CHANGE: "change",
  SUBMIT: "submit",
  RESET: "reset",
  FOCUS: "focus",
  FOCUS_IN: "focusin",
  FOCUS_OUT: "focusout",
  BLUR: "blur",
  INPUT: "input",
  STORAGE: "storage",
  DRAG_START: "dragstart",
  DRAG: "drag",
  DRAG_ENTER: "dragenter",
  DRAG_LEAVE: "dragleave",
  DRAG_OVER: "dragover",
  DROP: "drop",
  DRAG_END: "dragend",
  ANIMATION_START: Se ? "webkitAnimationStart" : "animationstart",
  ANIMATION_END: Se ? "webkitAnimationEnd" : "animationend",
  ANIMATION_ITERATION: Se ? "webkitAnimationIteration" : "animationiteration"
};

function kt(e) {
  for (var _len9 = arguments.length, t = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
    t[_key9 - 1] = arguments[_key9];
  }

  return t.forEach(function (t) {
    return e.appendChild(t);
  }), t[t.length - 1];
}

var Yt = /([\w\-]+)?(#([\w\-]+))?((.([\w\-]+))*)/;

function Ut(e, t) {
  var o = Yt.exec(e);
  if (!o) throw new Error("Bad use of emmet");
  var n = document.createElement(o[1] || "div");

  for (var _len10 = arguments.length, i = new Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
    i[_key10 - 2] = arguments[_key10];
  }

  return o[3] && (n.id = o[3]), o[4] && (n.className = o[4].replace(/\./g, " ").trim()), t = t || {}, Object.keys(t).forEach(function (e) {
    var i = t[e];
    /^on\w+$/.test(e) ? n[e] = i : "selected" === e ? i && n.setAttribute(e, "true") : n.setAttribute(e, i);
  }), gt(i).forEach(function (e) {
    e instanceof Node ? n.appendChild(e) : n.appendChild(document.createTextNode(e));
  }), n;
}

var Jt = {
  number: "number",
  string: "string",
  undefined: "undefined",
  object: "object",
  function: "function"
};

function jt(e) {
  return typeof e === Jt.string || e instanceof String;
}

function Gt(e) {
  return !(typeof e !== Jt.object || null === e || Array.isArray(e) || e instanceof RegExp || e instanceof Date);
}

function Ot(e) {
  return typeof e === Jt.undefined;
}

function Kt(e) {
  return Ot(e) || null === e;
}

var Wt = Object.prototype.hasOwnProperty;

function Xt(e, t) {
  if (jt(t)) {
    if (typeof e !== t) throw new Error("argument does not match constraint: typeof ".concat(t));
  } else if (typeof t === Jt.function) {
    try {
      if (e instanceof t) return;
    } catch (e) {}

    if (!Kt(e) && e.constructor === t) return;
    if (1 === t.length && !0 === t.call(void 0, e)) return;
    throw new Error("argument does not match one of these constraints: arg instanceof constraint, arg.constructor === constraint, nor constraint(arg) === true");
  }
}

function Zt(e) {
  if (!e || "object" != typeof e) return e;
  if (e instanceof RegExp) return e;
  var t = Array.isArray(e) ? [] : {};
  return Object.keys(e).forEach(function (i) {
    e[i] && "object" == typeof e[i] ? t[i] = Zt(e[i]) : t[i] = e[i];
  }), t;
}

var qt = Object.prototype.hasOwnProperty;

function $t(e, t, i) {
  var o = t(e);
  return void 0 === o ? i : o;
}

ye('@font-face {\r\n    font-family: "octicons";\r\n    src: url("data:font/ttf;base64,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") format("truetype"),\r\nurl("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 standalone%3D%22no%22%3F%3E %0D%3C!DOCTYPE svg PUBLIC %22-%2F%2FW3C%2F%2FDTD SVG 1.1%2F%2FEN%22 %22http%3A%2F%2Fwww.w3.org%2FGraphics%2FSVG%2F1.1%2FDTD%2Fsvg11.dtd%22 %3E%0D%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cdefs%3E%0D  %3Cfont id%3D%22octicons%22 horiz-adv-x%3D%2245%22%3E%0D    %3Cfont-face font-family%3D%22octicons%22%0D      units-per-em%3D%221000%22 ascent%3D%22820%22%0D      descent%3D%22180%22 %2F%3E%0D    %3Cmissing-glyph horiz-adv-x%3D%220%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22alert%22%0D      unicode%3D%22%26%23xF02D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M555.8125 726.25C544.375 745.625 523.3125000000001 757.5 500.375 757.5S456.4375 745.625 445 726.25L8.625 -23.6875A61.25000000000001 61.25000000000001 0 0 1 8.625 -86.25C20.6875 -105.625 41.75 -117.5625 64 -117.5625H936.75C959.6875 -117.5625 980.75 -105.6875 991.5625 -86.3125A64.375 64.375 0 0 1 992.1875 -23.6874999999999L555.8125 726.25zM564.125 7.6875H436.6875V132.875H564.125V7.6875zM564.125 195.4375H436.6875V445.8125H564.125V195.4375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22archive%22%0D      unicode%3D%22%26%23xF101%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M250 382.5H625V320H250z M812.5 757.5H62.5C25 757.5 0 732.5 0 695V570C0 532.5 25 507.5 62.5 507.5V-55C62.5 -92.5 87.5 -117.5 125 -117.5H750C787.5 -117.5 812.5 -92.5 812.5 -55V507.5C850 507.5 875 532.5 875 570V695C875 732.5 850 757.5 812.5 757.5zM750 -55H125V507.5H750zM812.5 570H62.5V695H812.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-both%22%0D      unicode%3D%22%26%23xF102%3B%22%0D      horiz-adv-x%3D%221250%22 d%3D%22 M0 320L375 632.5V445H875V632.5L1250 320L875 7.5V195H375V7.5L0 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-down%22%0D      unicode%3D%22%26%23xF03F%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M437.5 382.5V632.5H187.5V382.5H0L312.5 7.5L625 382.5H437.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-left%22%0D      unicode%3D%22%26%23xF040%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M375 632.5L0 320L375 7.5V195H625V445H375V632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-right%22%0D      unicode%3D%22%26%23xF03E%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M625 320L250 632.5V445H0V195H250V7.5L625 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-small-down%22%0D      unicode%3D%22%26%23xF0A0%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M250 382.5V507.5H125V382.5H0L187.5 132.5L375 382.5H250z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-small-left%22%0D      unicode%3D%22%26%23xF0A1%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M250 382.5V507.5L0 320L250 132.5V257.5H375V382.5H250z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-small-right%22%0D      unicode%3D%22%26%23xF071%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M375 320L125 507.5V382.5H0V257.5H125V132.5L375 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-small-up%22%0D      unicode%3D%22%26%23xF09F%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M187.5 507.5L0 257.5H125V132.5H250V257.5H375L187.5 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22arrow-up%22%0D      unicode%3D%22%26%23xF03D%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M312.5 632.5L0 257.5H187.5V7.5H437.5V257.5H625L312.5 632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22beaker%22%0D      unicode%3D%22%26%23xF0DD%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M898.75 -91.875L687.5 382.5V632.5H750V695H187.5V632.5H250V382.5L39.375 -91.875A62.5 62.5 0 0 1 96.25 -180H842.5C887.5000000000001 -180 917.5 -133.125 899.375 -91.875H898.75zM234.375 195L312.5 382.5V632.5H625V382.5L703.125 195H234.375zM500 320H562.5V257.5H500V320zM437.5 382.5H375V445H437.5V382.5zM437.5 570H500V507.5H437.5V570zM437.5 757.5H375V820H437.5V757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22bell%22%0D      unicode%3D%22%26%23xF0DE%3B%22%0D      horiz-adv-x%3D%22937.5%22 d%3D%22 M875 70V7.5H0V70L45.625 106.25C93.75 154.375 96.25 265.6249999999999 120 382.5C168.125 618.125 375 695 375 695C375 729.375 403.125 757.5 437.5 757.5S500 729.375 500 695C500 695 711.875 618.125 760 382.5C783.7500000000001 265.0000000000001 786.25 153.75 834.375 106.25L875.625 70H875zM437.5 -180C506.8749999999999 -180 562.5 -124.375 562.5 -55H312.5C312.5 -124.375 368.125 -180 437.5 -180z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22bold%22%0D      unicode%3D%22%26%23xF282%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M62.5 695H301.875C456.8750000000001 695 570.6249999999999 648.125 570.6249999999999 510.625C570.6249999999999 439.375 531.2499999999999 371.25 466.2499999999999 347.5V343.75C549.375 325 609.9999999999999 266.875 609.9999999999999 165C609.9999999999999 15.6249999999999 486.8749999999999 -55 321.8749999999999 -55H62.5V695zM291.25 385.625C395.625 385.625 440 426.875 440 491.25C440 564.375 391.25 591.875 293.75 591.875H195.625V385.6250000000001H291.25zM308.125 48.75C418.75 48.75 480 88.75 480 172.5C480 251.875 420.625 285.6250000000001 308.125 285.6250000000001H195.625V48.1250000000001H308.125V48.7500000000001z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22book%22%0D      unicode%3D%22%26%23xF007%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M187.5 507.5H437.5V445H187.5V507.5zM187.5 320H437.5V382.5H187.5V320zM187.5 195H437.5V257.5H187.5V195zM875 507.5H625V445H875V507.5zM875 382.5H625V320H875V382.5zM875 257.5H625V195H875V257.5zM1000 632.5V70C1000 35.625 971.875 7.5 937.5 7.5H593.75L531.25 -55L468.75 7.5H125C90.625 7.5 62.5 35.625 62.5 70V632.5C62.5 666.875 90.625 695 125 695H468.75L531.25 632.5L593.75 695H937.5C971.875 695 1000 666.875 1000 632.5zM500 601.25L468.75 632.5H125V70H500V601.25zM937.5 632.5H593.75L562.5 601.25V70H937.5V632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22bookmark%22%0D      unicode%3D%22%26%23xF07B%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M562.5 820H62.5C16.875 820 0 803.125 0 757.5V-180L312.5 13.125L625 -180V757.5C625 803.125 608.125 820 562.5 820zM513.75 554.375L397.5 469.375L442.5 334.375C446.25 320.625 441.2500000000001 316.875 430 323.75L312.5 407.5L195 323.75C183.125 316.875 179.375 320.625 182.5 334.375L227.5 469.375L111.25 554.375C100.625 564.375 102.5 568.75 116.875 568.75L260.625 570.625L304.375 705.625H320L363.75 570.625L507.5000000000001 568.75C521.8750000000001 568.75 524.375 563.75 513.125 554.375H513.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22briefcase%22%0D      unicode%3D%22%26%23xF0D3%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M562.5 570V632.5C562.5 666.875 534.375 695 500 695H375C340.625 695 312.5 666.875 312.5 632.5V570H62.5C28.125 570 0 541.875 0 507.5V7.5C0 -26.875 28.125 -55 62.5 -55H812.5C846.875 -55 875 -26.875 875 7.5V507.5C875 541.875 846.875 570 812.5 570H562.5zM375 632.5H500V570H375V632.5zM812.5 257.5H500V195H375V257.5H62.5V507.5H125V320H750V507.5H812.5V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22broadcast%22%0D      unicode%3D%22%26%23xF048%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M562.5 257.5H500C534.375 257.5 562.5 285.625 562.5 320V382.5C562.5 416.875 534.375 445 500 445H437.5C403.125 445 375 416.875 375 382.5V320C375 285.625 403.125 257.5 437.5 257.5H375C340.625 257.5 312.5 229.375 312.5 195V70H375V-117.5C375 -151.875 403.125 -180 437.5 -180H500C534.375 -180 562.5 -151.875 562.5 -117.5V70H625V195C625 229.375 596.875 257.5 562.5 257.5zM437.5 382.5H500V320H437.5V382.5zM562.5 132.5H500V-117.5H437.5V132.5H375V195H562.5V132.5zM693.125 351.25C693.125 475 592.5 575.625 468.75 575.625A224.56249999999997 224.56249999999997 0 0 1 250 300.625V176.8749999999999C211.875 224.9999999999999 187.5 285 187.5 351.875C187.5 506.8749999999999 313.75 633.125 468.75 633.125S750 506.875 750 351.875C750 285.625 725.625 225 687.5 176.875V300.625C691.25 317.5 693.125 333.75 693.125 351.25zM937.5 351.25C937.5 171.2500000000001 835.6250000000001 15.0000000000001 687.5 -63.1249999999999V2.5000000000001A409.56250000000006 409.56250000000006 0 0 1 880.625 351.2500000000001A411.875 411.875 0 0 1 468.75 763.125A411.875 411.875 0 0 1 56.875 351.25C56.875 203.75 133.75 75 250 2.5V-63.125A468.56249999999994 468.56249999999994 0 0 0 468.75 820C727.5 820 937.5 610 937.5 351.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22browser%22%0D      unicode%3D%22%26%23xF0C5%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M312.5 632.5H375V570H312.5V632.5zM187.5 632.5H250V570H187.5V632.5zM62.5 632.5H125V570H62.5V632.5zM812.5 7.5H62.5V507.5H812.5V7.5zM812.5 570H437.5V632.5H812.5V570zM875 632.5C875 666.875 846.875 695 812.5 695H62.5C28.125 695 0 666.875 0 632.5V7.5C0 -26.875 28.125 -55 62.5 -55H812.5C846.875 -55 875 -26.875 875 7.5V632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22bug%22%0D      unicode%3D%22%26%23xF091%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M687.5 195H875V257.5H687.5V320L885.625 384.375L864.375 443.1250000000001L687.5 382.5V445C687.5 479.375 659.375 507.5 625 507.5V570C625 600 602.5 625 573.125 630.625L637.5 695H750V757.5H612.5L487.5000000000001 632.5H450.6250000000001L325 757.5H187.5V695H300L364.375 630.625C335 625 312.5 600.625 312.5 570V507.5C278.125 507.5 250 479.375 250 445V382.5L73.125 443.125L51.875 384.375L250 320V257.5H62.5V195H250V132.5L51.875 68.125L73.125 9.3750000000001L250 70V7.5C250 -26.875 278.125 -55 312.5 -55H375L437.5 7.5V445H500V7.5L562.5 -55H625C659.375 -55 687.5 -26.875 687.5 7.5V70L864.375 9.375L885.625 68.1249999999999L687.5 132.5V195zM562.5 507.5H375V570H562.5V507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22calendar%22%0D      unicode%3D%22%26%23xF068%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 695H750V601.25C750 583.75 736.25 570 718.75 570H593.75C576.25 570 562.5 583.75 562.5 601.25V695H375V601.25C375 583.75 361.25 570 343.75 570H218.75C201.25 570 187.5 583.75 187.5 601.25V695H125C90.625 695 62.5 666.875 62.5 632.5V-55C62.5 -89.375 90.625 -117.5 125 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V632.5C875 666.875 846.875 695 812.5 695zM812.5 -55H125V507.5H812.5V-55zM312.5 632.5H250V757.5H312.5V632.5zM687.5 632.5H625V757.5H687.5V632.5zM375 382.5H312.5V445H375V382.5zM500 382.5H437.5V445H500V382.5zM625 382.5H562.5V445H625V382.5zM750 382.5H687.5V445H750V382.5zM250 257.5H187.5V320H250V257.5zM375 257.5H312.5V320H375V257.5zM500 257.5H437.5V320H500V257.5zM625 257.5H562.5V320H625V257.5zM750 257.5H687.5V320H750V257.5zM250 132.5H187.5V195H250V132.5zM375 132.5H312.5V195H375V132.5zM500 132.5H437.5V195H500V132.5zM625 132.5H562.5V195H625V132.5zM750 132.5H687.5V195H750V132.5zM250 7.5H187.5V70H250V7.5zM375 7.5H312.5V70H375V7.5zM500 7.5H437.5V70H500V7.5zM625 7.5H562.5V70H625V7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22check%22%0D      unicode%3D%22%26%23xF03A%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M750 507.5L250 7.5L0 257.5L93.75 351.25L250 195L656.25 601.25L750 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22checklist%22%0D      unicode%3D%22%26%23xF076%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M1000 288.75L625 -86.25L437.5 101.25L531.25 195L625 101.25L906.25 382.5L1000 288.75zM356.25 57.5L406.25 7.5H125C90.625 7.5 62.5 35.625 62.5 70V632.5C62.5 666.875 90.625 695 125 695H562.5C596.875 695 625 666.875 625 632.5V226.25L575 276.25C550.6249999999999 300.6250000000001 510.625 300.6250000000001 486.2499999999999 276.25L356.25 145A62.25000000000001 62.25000000000001 0 0 1 356.25 56.875V57.4999999999999zM250 570H562.5V632.5H250V570zM250 445H562.5V507.5H250V445zM250 320H437.5V382.5H250V320zM187.5 257.5H125V195H187.5V257.5zM187.5 382.5H125V320H187.5V382.5zM187.5 507.5H125V445H187.5V507.5zM187.5 632.5H125V570H187.5V632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22chevron-down%22%0D      unicode%3D%22%26%23xF0A3%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M312.5 132.5L0 445L93.75 538.75L312.5 304.375L531.25 538.75L625 445L312.5 132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22chevron-left%22%0D      unicode%3D%22%26%23xF0A4%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M343.75 632.5L437.5 538.75L203.125 320L437.5 101.25L343.75 7.5L31.25 320L343.75 632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22chevron-right%22%0D      unicode%3D%22%26%23xF078%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M468.75 320L156.25 7.5L62.5 101.25L296.875 320L62.5 538.75L156.25 632.5L468.75 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22chevron-up%22%0D      unicode%3D%22%26%23xF0A2%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M625 195L531.25 101.25L312.5 335.625L93.75 101.25L0 195L312.5 507.5L625 195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22circle-slash%22%0D      unicode%3D%22%26%23xF084%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 757.5C196.25 757.5 0 561.25 0 320S196.25 -117.5 437.5 -117.5S875 78.75 875 320S678.75 757.5 437.5 757.5zM437.5 676.25C518.75 676.25 593.75 648.75 654.375 603.125L154.375 103.1250000000001A359.6875 359.6875 0 0 0 81.25 320C81.25 516.25 241.2500000000001 676.25 437.5 676.25zM437.5 -36.875C356.25 -36.875 281.25 -9.3750000000001 220.625 36.2499999999999L720.625 536.25C766.25 475.6249999999999 793.75 400.625 793.75 319.3749999999999C793.75 123.1249999999999 633.7499999999999 -36.875 437.5 -36.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22circuit-board%22%0D      unicode%3D%22%26%23xF0D6%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M187.5 507.5C187.5 541.875 215.625 570 250 570S312.5 541.875 312.5 507.5S284.375 445 250 445S187.5 473.125 187.5 507.5zM687.5 507.5C687.5 541.875 659.375 570 625 570S562.5 541.875 562.5 507.5S590.625 445 625 445S687.5 473.125 687.5 507.5zM687.5 132.5C687.5 166.875 659.375 195 625 195S562.5 166.875 562.5 132.5S590.625 70 625 70S687.5 98.125 687.5 132.5zM812.5 757.5H312.5V621.875C335 610 352.5 592.5 364.375 570H510.625C536.875 618.75 593.75 650 656.875 635.625C703.75 623.75 741.875 585.625 752.5 538.75C771.875 452.5 707.4999999999999 376.875 624.3749999999999 376.875C574.3749999999999 376.875 531.8749999999999 404.3750000000001 509.9999999999999 445H364.375C338.125 395 281.25 365 218.125 380.625C172.5 391.25 134.375 429.375 123.125 475.625C107.5 539.375 137.5 595.625 187.5 621.875V757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5L375 195H510.625C536.875 243.75 593.75 275 656.875 260.625C703.75 248.7500000000001 741.875 210.625 752.5 163.75C771.875 77.5000000000001 707.4999999999999 1.875 624.3749999999999 1.875C574.3749999999999 1.875 531.8749999999999 29.375 509.9999999999999 70H436.875L250 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V695C875 729.375 846.875 757.5 812.5 757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22clippy%22%0D      unicode%3D%22%26%23xF035%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M125 7.5H375V-55H125V7.5zM437.5 382.5H125V320H437.5V382.5zM562.5 195V320L375 132.5L562.5 -55V70H875V195H562.5zM281.25 257.5H125V195H281.25V257.5zM125 70H281.25V132.5H125V70zM687.5 7.5H750V-117.5C748.75 -135 743.125 -150 731.25 -161.25C719.375 -172.4999999999999 705 -178.7499999999999 687.5 -180H62.5C28.125 -180 0 -151.875 0 -117.5V570C0 604.375 28.125 632.5 62.5 632.5H250C250 701.875 305.625 757.5 375 757.5C444.375 757.5 500 701.875 500 632.5H687.5C721.875 632.5 750 604.375 750 570V257.5H687.5V445H62.5V-117.5H687.5V7.5zM125 507.5H625C625 541.875 596.875 570 562.5 570H500C465.625 570 437.5 598.125 437.5 632.5S409.375 695 375 695S312.5 666.875 312.5 632.5S284.375 570 250 570H187.5C153.125 570 125 541.875 125 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22clock%22%0D      unicode%3D%22%26%23xF046%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 320H687.5V195H437.5C403.125 195 375 223.125 375 257.5V570H500V320zM437.5 676.25C633.75 676.25 793.75 516.25 793.75 320S633.7499999999999 -36.25 437.5 -36.25A356.87500000000006 356.87500000000006 0 0 0 81.25 320C81.25 516.25 241.2500000000001 676.25 437.5 676.25zM437.5 757.5C196.25 757.5 0 561.25 0 320S196.25 -117.5 437.5 -117.5S875 78.75 875 320S678.75 757.5 437.5 757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22cloud-download%22%0D      unicode%3D%22%26%23xF00B%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M562.5 70H687.5L500 -117.5L312.5 70H437.5V382.5H562.5V70zM750 570C750 597.5 693.125 757.5 468.75 757.5C317.5 757.5 187.5 637.5 187.5 507.5C63.75 507.5 0 412.5 0 320C0 224.375 62.5 132.5 187.5 132.5H375V213.75H187.5C86.25 213.75 81.25 302.5 81.25 320C81.25 330.625 84.375 426.25 187.5 426.25H268.75V507.5C268.75 594.375 366.25 676.25 468.75 676.25C628.125 676.25 664.3749999999999 579.375 668.75 563.75V488.75H750C800.625 488.75 918.75 475 918.75 351.25C918.75 220.625 778.125 213.75 750 213.75H625V132.5H750C880 132.5 1000 205 1000 351.25C1000 503.75 880 570 750 570z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22cloud-upload%22%0D      unicode%3D%22%26%23xF00C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M437.5 257.5H312.5L500 445L687.5 257.5H562.5V-55H437.5V257.5zM750 507.5C750 535 693.125 695 468.75 695C317.5 695 187.5 575 187.5 445C63.75 445 0 350 0 257.5C0 161.875 62.5 70 187.5 70H375V151.25H187.5C86.25 151.25 81.25 240 81.25 257.5C81.25 268.125 84.375 363.75 187.5 363.75H268.75V445C268.75 531.875 366.25 613.75 468.75 613.75C628.125 613.75 664.3749999999999 516.875 668.75 501.25V426.25H750C800.625 426.25 918.75 412.5 918.75 288.75C918.75 158.125 778.125 151.25 750 151.25H625V70H750C880 70 1000 142.5 1000 288.75C1000 441.25 880 507.5 750 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22code%22%0D      unicode%3D%22%26%23xF05F%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M593.75 632.5L500 538.75L718.75 320L500 101.25L593.75 7.5L875 320L593.75 632.5zM281.25 632.5L0 320L281.25 7.5L375 101.25L156.25 320L375 538.75L281.25 632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22color-mode%22%0D      unicode%3D%22%26%23xF065%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M812.5 695H187.5C153.32 695 125 666.68 125 632.5V7.5C125 -26.6812500000001 153.32 -55 187.5 -55H812.5C846.6812500000001 -55 875 -26.6812500000001 875 7.5V632.5C875 666.68 846.6812500000001 695 812.5 695zM187.5 7.5V632.5H812.5L187.5 7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22comment-discussion%22%0D      unicode%3D%22%26%23xF04F%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M937.5 757.5H375C340.625 757.5 312.5 729.375 312.5 695V570H62.5C28.125 570 0 541.875 0 507.5V132.5C0 98.125 28.125 70 62.5 70H125V-117.5L312.5 70H562.5C596.875 70 625 98.125 625 132.5V257.5H687.5L875 70V257.5H937.5C971.875 257.5 1000 285.625 1000 320V695C1000 729.375 971.875 757.5 937.5 757.5zM562.5 132.5H281.25L187.5 38.75V132.5H62.5V507.5H312.5V320C312.5 285.625 340.625 257.5 375 257.5H562.5V132.5zM937.5 320H812.5V226.25L718.75 320H375V695H937.5V320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22comment%22%0D      unicode%3D%22%26%23xF02B%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M875 757.5H125C90.625 757.5 62.5 729.375 62.5 695V195C62.5 160.625 90.625 132.5 125 132.5H250V-86.25L468.75 132.5H875C909.375 132.5 937.5 160.625 937.5 195V695C937.5 729.375 909.375 757.5 875 757.5zM875 195H437.5L312.5 70V195H125V695H875V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22credit-card%22%0D      unicode%3D%22%26%23xF045%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M750 257.5H125V320H750V257.5zM1000 632.5V70C1000 35.625 971.875 7.5 937.5 7.5H62.5C28.125 7.5 0 35.625 0 70V632.5C0 666.875 28.125 695 62.5 695H937.5C971.875 695 1000 666.875 1000 632.5zM937.5 445H62.5V70H937.5V445zM937.5 632.5H62.5V570H937.5V632.5zM375 195H125V132.5H375V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22dash%22%0D      unicode%3D%22%26%23xF0CA%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M0 382.5V257.5H500V382.5H0z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22dashboard%22%0D      unicode%3D%22%26%23xF07D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M562.5 507.5H500V570H562.5V507.5zM812.5 320H750V257.5H812.5V320zM375 507.5H312.5V445H375V507.5zM312.5 320H250V257.5H312.5V320zM1000 663.75L968.75 695L562.5 382.5C558.75 383.75 500 382.5 500 382.5C465.625 382.5 437.5 354.375 437.5 320V257.5C437.5 223.125 465.625 195 500 195H562.5C596.875 195 625 223.125 625 257.5V315L1000 663.75zM900.625 408.125C912.5 370 919.375 330 919.375 288.75C919.375 75 745.6250000000001 -98.75 531.8750000000001 -98.75C318.1250000000001 -98.75 143.7500000000001 75 143.7500000000001 288.75C143.7500000000001 502.5 317.5000000000001 676.25 531.2500000000001 676.25C606.2500000000001 676.25 675.6250000000001 655 735.6250000000001 617.5L794.375 676.25A466.18749999999994 466.18749999999994 0 0 1 531.875 757.5C272.5 757.5 62.5 547.5 62.5 288.75C62.5 30 272.5 -180 531.25 -180C790 -180 1000 30 1000 288.75C1000 353.125 987.5 415 963.125 470.625L900.625 408.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22database%22%0D      unicode%3D%22%26%23xF096%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 -117.5C168.125 -117.5 0 -61.25 0 7.5V132.5C0 143.125 5.625 153.75 13.125 163.75C55 110 200.625 70 375 70S695.0000000000001 110 736.875 163.75C745 153.75 750 143.125 750 132.5V7.5C750 -61.25 581.875 -117.5 375 -117.5zM375 132.5C168.125 132.5 0 188.75 0 257.5V382.5C0 389.375 2.5 395.625 5.625 401.875C7.5 405.625 10 410 13.125 413.75C55 360 200.625 320 375 320S695.0000000000001 360 736.875 413.75C740 410 742.4999999999999 405.625 744.3749999999999 401.875C747.4999999999999 395.625 749.9999999999999 388.75 749.9999999999999 382.5V257.5C749.9999999999999 188.75 581.8749999999999 132.5 374.9999999999999 132.5zM375 382.5C168.125 382.5 0 438.75 0 507.5V632.5C0 701.25 168.125 757.5 375 757.5S750 701.25 750 632.5V507.5C750 438.75 581.875 382.5 375 382.5zM375 695C236.875 695 125 666.875 125 632.5S236.875 570 375 570S625 598.125 625 632.5S513.125 695 375 695z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22desktop-download%22%0D      unicode%3D%22%26%23xF0DC%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M250 445H437.5V820H562.5V445H750L500 195L250 445zM937.5 695H687.5V632.5H937.5V132.5H62.5V632.5H312.5V695H62.5C28.125 695 0 666.875 0 632.5V70C0 35.625 28.125 7.5 62.5 7.5H396.25C380.625 -30.625 342.5 -79.375 250 -117.5H750C657.5 -79.375 619.375 -30.625 603.75 7.5H937.5C971.875 7.5 1000 35.625 1000 70V632.5C1000 666.875 971.875 695 937.5 695z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22device-camera-video%22%0D      unicode%3D%22%26%23xF057%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M950 689.375L625 462.5V632.5C625 666.875 596.875 695 562.5 695H62.5C28.125 695 0 666.875 0 632.5V70C0 35.625 28.125 7.5 62.5 7.5H562.5C596.875 7.5 625 35.625 625 70V240L950 13.125C970.625 -1.25 1000 13.125 1000 38.75V663.75C1000 689.375 970.625 703.75 950 689.375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22device-camera%22%0D      unicode%3D%22%26%23xF056%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M937.5 632.5H437.5C437.5 666.875 409.375 695 375 695H125C90.625 695 62.5 666.875 62.5 632.5C28.125 632.5 0 604.375 0 570V7.5C0 -26.875 28.125 -55 62.5 -55H937.5C971.875 -55 1000 -26.875 1000 7.5V570C1000 604.375 971.875 632.5 937.5 632.5zM375 507.5H125V570H375V507.5zM656.25 70C535 70 437.5 167.5 437.5 288.75S535 507.5 656.25 507.5S875 410 875 288.75S777.5 70 656.25 70zM812.5 288.75C812.5 202.5000000000001 741.8750000000001 132.5 656.25 132.5S500 203.125 500 288.75S570.625 445 656.25 445S812.5 374.375 812.5 288.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22device-desktop%22%0D      unicode%3D%22%26%23xF27C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M937.5 695H62.5C28.125 695 0 666.875 0 632.5V70C0 35.625 28.125 7.5 62.5 7.5H396.25C380.625 -30.625 342.5 -79.375 250 -117.5H750C657.5 -79.375 619.375 -30.625 603.75 7.5H937.5C971.875 7.5 1000 35.625 1000 70V632.5C1000 666.875 971.875 695 937.5 695zM937.5 132.5H62.5V632.5H937.5V132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22device-mobile%22%0D      unicode%3D%22%26%23xF038%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M562.5 820H62.5C28.125 820 0 791.875 0 757.5V-117.5C0 -151.875 28.125 -180 62.5 -180H562.5C596.875 -180 625 -151.875 625 -117.5V757.5C625 791.875 596.875 820 562.5 820zM312.5 -136.25C267.5 -136.25 231.25 -100 231.25 -55C231.25 -10 267.5 26.25 312.5 26.25C357.5 26.25 393.75 -10 393.75 -55C393.75 -100 357.5 -136.25 312.5 -136.25zM562.5 70H62.5V695H562.5V70z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff-added%22%0D      unicode%3D%22%26%23xF06B%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V695C875 729.375 846.875 757.5 812.5 757.5zM812.5 -55H62.5V695H812.5V-55zM375 257.5H187.5V382.5H375V570H500V382.5H687.5V257.5H500V70H375V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff-ignored%22%0D      unicode%3D%22%26%23xF099%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V695C875 729.375 846.875 757.5 812.5 757.5zM812.5 -55H62.5V695H812.5V-55zM281.25 70H187.5V163.75L593.75 570H687.5V476.25L281.25 70z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff-modified%22%0D      unicode%3D%22%26%23xF06D%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V695C875 729.375 846.875 757.5 812.5 757.5zM812.5 -55H62.5V695H812.5V-55zM250 320C250 423.75 333.75 507.5 437.5 507.5S625 423.75 625 320S541.25 132.5 437.5 132.5S250 216.25 250 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff-removed%22%0D      unicode%3D%22%26%23xF06C%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V695C875 729.375 846.875 757.5 812.5 757.5zM812.5 -55H62.5V695H812.5V-55zM687.5 257.5H187.5V382.5H687.5V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff-renamed%22%0D      unicode%3D%22%26%23xF06E%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M375 257.5H187.5V382.5H375V570L687.5 320L375 70V257.5zM875 695V-55C875 -89.375 846.875 -117.5 812.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V695C0 729.375 28.125 757.5 62.5 757.5H812.5C846.875 757.5 875 729.375 875 695zM812.5 695H62.5V-55H812.5V695z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22diff%22%0D      unicode%3D%22%26%23xF04D%3B%22%0D      horiz-adv-x%3D%22812.5%22 d%3D%22 M375 382.5H500V320H375V195H312.5V320H187.5V382.5H312.5V507.5H375V382.5zM187.5 7.5H500V70H187.5V7.5zM468.75 695L687.5 476.25V-117.5C687.5 -151.875 659.375 -180 625 -180H62.5C28.125 -180 0 -151.875 0 -117.5V632.5C0 666.875 28.125 695 62.5 695H468.75zM625 445L437.5 632.5H62.5V-117.5H625V445zM531.25 820H187.5V757.5H500L750 507.5V7.5H812.5V538.75L531.25 820z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22ellipsis%22%0D      unicode%3D%22%26%23xF09A%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M687.5 507.5H62.5C28.125 507.5 0 479.375 0 445V195C0 160.625 28.125 132.5 62.5 132.5H687.5C721.875 132.5 750 160.625 750 195V445C750 479.375 721.875 507.5 687.5 507.5zM250 257.5H125V382.5H250V257.5zM437.5 257.5H312.5V382.5H437.5V257.5zM625 257.5H500V382.5H625V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22eye-closed%22%0D      unicode%3D%22%26%23xF103%3B%22%0D      horiz-adv-x%3D%221142.857142857143%22 d%3D%22 M1057.142857142857 812.8571428571429C1042.857142857143 827.1428571428571 1021.4285714285716 827.1428571428571 1007.1428571428572 812.8571428571429L857.1428571428573 655.7142857142857C778.5714285714288 712.8571428571429 685.7142857142858 748.5714285714286 578.5714285714287 748.5714285714286C214.2857142857144 755.7142857142857 1e-13 327.1428571428571 1e-13 327.1428571428571S85.7142857142858 162.8571428571429 235.7142857142859 34.2857142857142L85.7142857142858 -115.7142857142857C71.4285714285716 -130 71.4285714285716 -151.4285714285714 85.7142857142858 -165.7142857142857S121.4285714285716 -179.9999999999999 135.7142857142858 -165.7142857142857L1057.1428571428573 755.7142857142858C1071.4285714285716 770.0000000000001 1071.4285714285716 798.5714285714287 1057.1428571428573 812.857142857143zM642.8571428571429 448.5714285714286C621.4285714285714 462.8571428571429 600 470 571.4285714285714 470C492.8571428571429 470 428.5714285714286 405.7142857142857 428.5714285714286 327.1428571428572C428.5714285714286 298.5714285714286 435.7142857142857 277.1428571428571 450 255.7142857142858L350.0000000000001 148.5714285714287C307.1428571428572 198.5714285714286 285.7142857142857 255.7142857142858 285.7142857142857 327.1428571428572C285.7142857142857 484.2857142857144 414.2857142857143 612.8571428571429 571.4285714285714 612.8571428571429C635.7142857142858 612.8571428571429 700.0000000000001 591.4285714285716 750 548.5714285714287z M992.8571428571428 541.4285714285714L850 398.5714285714286C857.1428571428571 377.1428571428571 857.1428571428571 348.5714285714285 857.1428571428571 327.1428571428571C857.1428571428571 169.9999999999999 728.5714285714286 41.4285714285713 571.4285714285714 41.4285714285713C542.8571428571429 41.4285714285713 521.4285714285714 41.4285714285713 500 48.5714285714286L385.7142857142857 -65.7142857142858C442.8571428571429 -94.2857142857143 507.1428571428572 -108.5714285714285 578.5714285714287 -108.5714285714285C928.5714285714286 -108.5714285714285 1142.857142857143 320 1142.857142857143 320C1100 405.7142857142857 1050 477.1428571428572 992.8571428571428 541.4285714285714z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22eye%22%0D      unicode%3D%22%26%23xF04E%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M503.7500000000001 695C187.5 695 0 320 0 320S187.5 -55 503.7500000000001 -55C812.5 -55 1000 320 1000 320S812.5 695 503.7499999999999 695zM500 70C362.5 70 250 181.25 250 320C250 457.5 362.5 570 500 570C638.75 570 750 457.5 750 320C750 181.25 638.75 70 500 70zM625 320C625 250.625 569.375 195 500 195C430.625 195 375 250.625 375 320C375 389.375 430.625 445 500 445C569.375 445 625 389.375 625 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-binary%22%0D      unicode%3D%22%26%23xF094%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M250 70H312.5V7.5H125V70H187.5V195H125V257.5H250V70zM750 538.75V-55C750 -89.375 721.875 -117.5 687.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V695C0 729.375 28.125 757.5 62.5 757.5H531.25L750 538.75zM687.5 507.5L500 695H62.5V-55H687.5V507.5zM500 570H375V507.5H437.5V382.5H375V320H562.5V382.5H500V570zM125 570H312.5V320H125V570zM187.5 382.5H250V507.5H187.5V382.5zM375 257.5H562.5V7.5H375V257.5zM437.5 70H500V195H437.5V70z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-code%22%0D      unicode%3D%22%26%23xF010%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M531.25 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H687.5C721.875 -117.5 750 -89.375 750 -55V538.75L531.25 757.5zM687.5 -55H62.5V695H500L687.5 507.5V-55zM312.5 383.75L218.75 288.75L312.5 195L281.25 132.5L125 288.75L281.25 445L312.5 383.75zM468.75 445L625 288.75L468.75 132.5L437.5 193.75L531.25 288.75L437.5 382.5L468.75 445z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-directory%22%0D      unicode%3D%22%26%23xF016%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 570H437.5V632.5C437.5 673.75 418.125 695 375 695H62.5C28.125 695 0 666.875 0 632.5V7.5C0 -26.875 28.125 -55 62.5 -55H812.5C846.875 -55 875 -26.875 875 7.5V507.5C875 541.875 846.875 570 812.5 570zM375 570H62.5V632.5H375V570z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-media%22%0D      unicode%3D%22%26%23xF012%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 507.5H500V382.5H375V507.5zM750 538.75V-55C750 -89.375 721.875 -117.5 687.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V695C0 729.375 28.125 757.5 62.5 757.5H531.25L750 538.75zM687.5 507.5L500 695H62.5V7.5L250 320L375 70L500 195L687.5 7.5V507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-pdf%22%0D      unicode%3D%22%26%23xF014%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M531.25 757.5H62.5A62.5 62.5 0 0 1 0 695V-55A62.5 62.5 0 0 1 62.5 -117.5H687.5A62.5 62.5 0 0 1 750 -55V538.75L531.25 757.5zM62.5 695H312.5A42.50000000000001 42.50000000000001 0 0 1 293.125 682.5A67.5 67.5 0 0 1 278.75 653.125A263.75 263.75 0 0 1 273.125 561.25C276.875 523.1875 283.9375 485.5625 294.375 448.7500000000001A1361.2500000000002 1361.2500000000002 0 0 0 225 282.5C193.75 220 175 178.75 168.125 167.5A447.25 447.25 0 0 1 125 148.75C102.375 138.4375 81.3125 124.9999999999999 62.5 108.75V695zM338.75 395A353.125 353.125 0 0 1 411.875 264.375C429.0625 249.5625 449.0625 238.3125 470.6249999999999 231.25C430.625 225.625 393.75 218.75 357.5 210.625C318.8749999999999 201.25 281.0625 188.9375 244.3749999999999 173.75S258.125 201.25 282.5 251.875C305.3125 298.125 324.3749999999999 346.25 339.375 395.625L338.75 395zM687.5 -55H93.75A46.4375 46.4375 0 0 0 83.125 -55A132.5 132.5 0 0 1 128.75 -27.5A633.7500000000001 633.7500000000001 0 0 1 240 121.25C259.375 129.3750000000001 276.25 135.625 290.625 140.625L316.875 149.3750000000001C345.0000000000001 157.5000000000001 375.625 163.7500000000001 406.875 170.0000000000001S469.375 180.0000000000001 499.375 182.5C527.3125 169.0000000000001 556.3750000000001 157.875 586.25 149.3750000000001C611.4375000000001 142.5000000000001 637.125 137.625 663.1250000000001 135.0000000000001H686.8750000000001V-55H687.5zM687.5 248.75A233.93750000000003 233.93750000000003 0 0 1 647.5 266.2499999999999A263.8125 263.8125 0 0 1 600.625 273.1249999999999C574.9375 272.9374999999999 549.25 271.2499999999999 523.7499999999999 268.1249999999999A187.5 187.5 0 0 0 461.2499999999999 308.125A379.375 379.375 0 0 0 380.625 453.7499999999999C387.5625 495.0624999999999 391.75 536.875 393.125 578.7499999999999C394.375 594.3749999999999 394.375 609.9999999999999 393.125 625.6249999999999A65.625 65.625 0 0 1 380.625 680.6249999999999A51.24999999999999 51.24999999999999 0 0 1 342.5 694.9999999999999H500L687.5 507.4999999999999V248.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-submodule%22%0D      unicode%3D%22%26%23xF017%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M625 382.5H250V-55H812.5C846.875 -55 875 -26.875 875 7.5V320H625V382.5zM562.5 257.5H312.5V320H562.5V257.5zM812.5 570H437.5V632.5C437.5 673.75 418.125 695 375 695H62.5C28.125 695 0 666.875 0 632.5V7.5C0 -26.875 28.125 -55 62.5 -55H187.5V382.5C187.5 416.875 215.625 445 250 445H625C659.375 445 687.5 416.875 687.5 382.5H875V507.5C875 541.875 846.875 570 812.5 570zM375 570H62.5V632.5H375V570z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-symlink-directory%22%0D      unicode%3D%22%26%23xF0B1%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 570H437.5V632.5C437.5 673.75 418.125 695 375 695H62.5C28.125 695 0 666.875 0 632.5V7.5C0 -26.875 28.125 -55 62.5 -55H812.5C846.875 -55 875 -26.875 875 7.5V507.5C875 541.875 846.875 570 812.5 570zM62.5 632.5H375V570H62.5V632.5zM437.5 70V195C376.25 196.25 322.5 181.25 278.125 151.25C233.75 121.25 203.75 73.125 187.5 7.5C188.75 110 211.875 187.4999999999999 258.125 240.625C303.75 293.125 363.75 320 438.125 320V445L688.125 257.5L438.125 70H437.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-symlink-file%22%0D      unicode%3D%22%26%23xF0B0%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M531.25 757.5H62.5C28.125 757.5 0 729.375 0 695V-55C0 -89.375 28.125 -117.5 62.5 -117.5H687.5C721.875 -117.5 750 -89.375 750 -55V538.75L531.25 757.5zM687.5 -55H62.5V695H500L687.5 507.5V-55zM375 538.75L625 351.25L375 163.75V288.75C313.75 290 260 275 215.625 245C171.25 215 141.25 166.875 125 101.25C126.25 203.75 149.375 281.2499999999999 195.625 334.375C241.25 386.875 301.25 413.75 375.625 413.75V538.75H375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file-zip%22%0D      unicode%3D%22%26%23xF013%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M531.25 757.5H62.5A62.5 62.5 0 0 1 0 695V-55A62.5 62.5 0 0 1 62.5 -117.5H687.5A62.5 62.5 0 0 1 750 -55V538.75L531.25 757.5zM687.5 -55H62.5V695H250V632.5H312.5V695H500L687.5 507.5V-55zM312.5 570V632.5H375V570H312.5zM250 570H312.5V507.5H250V570zM312.5 445V507.5H375V445H312.5zM250 445H312.5V382.5H250V445zM312.5 320V382.5H375V320H312.5zM250 240A125 125 0 0 1 187.5 132.5V70H437.5V132.5A125 125 0 0 1 312.5 257.5V320H250V240zM375 195V132.5H250V195H375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22file%22%0D      unicode%3D%22%26%23xF283%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 507.5H125V570H375V507.5zM125 320H562.5V382.5H125V320zM125 195H562.5V257.5H125V195zM125 70H562.5V132.5H125V70zM750 538.75V-55C750 -89.375 721.875 -117.5 687.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V695C0 729.375 28.125 757.5 62.5 757.5H531.25L750 538.75zM687.5 507.5L500 695H62.5V-55H687.5V507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22flame%22%0D      unicode%3D%22%26%23xF0D2%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M315.625 800.625C366.25 665 341.25 589.375 283.125 531.25C221.875 465.625 123.75 416.875 56.25 321.25C-34.375 193.1249999999999 -50 -86.8750000000001 276.875 -160C139.375 -87.5 110 122.5 258.125 253.125C220 126.25 291.25 45 379.375 74.375C466.25 103.7500000000001 523.1250000000001 41.2500000000001 521.25 -30C520 -78.7499999999999 501.8749999999999 -120 450.625 -143.125C664.3749999999999 -106.25 749.375 70.625 749.375 204.3749999999999C749.375 381.8749999999999 591.25 405.625 671.25 555C576.25 546.875 544.375 484.3749999999999 553.125 383.125C558.75 315.625 489.375 270.6249999999999 436.875 300C395 325.625 395.625 374.375 433.125 411.25C511.25 488.125 542.5 666.875 315.625 800L314.375 801.25L315.625 800.625z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22fold-down%22%0D      unicode%3D%22%26%23xF104%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M250 132.5L437.5 -55L625 132.5H500V507.5H375V132.5H250zM0 132.5C0 98.125 28.125 70 62.5 70H218.75L156.25 132.5H93.75L218.75 257.5H312.5V320H218.75L93.75 445H312.5V507.5H62.5C28.125 507.5 0 479.375 0 445L156.25 288.75L0 132.5zM656.25 257.5H562.5V320H656.25L781.25 445H562.5V507.5H812.5C846.875 507.5 875 479.375 875 445L718.75 288.75L875 132.5C875 98.125 846.875 70 812.5 70H656.25L718.75 132.5H781.25L656.25 257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22fold-up%22%0D      unicode%3D%22%26%23xF105%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M625 445L437.5 632.5L250 445H375V70H500V445H625zM875 445C875 479.375 846.875 507.5 812.5 507.5H656.25L718.75 445H781.25L656.25 320H562.5V257.5H656.25L781.25 132.5H562.5V70H812.5C846.875 70 875 98.125 875 132.5L718.75 288.75L875 445zM218.75 320H312.5V257.5H218.75L93.75 132.5H312.5V70H62.5C28.125 70 0 98.125 0 132.5L156.25 288.75L0 445C0 479.375 28.125 507.5 62.5 507.5H218.75L156.25 445H93.75L218.75 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22fold%22%0D      unicode%3D%22%26%23xF0CC%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 257.5L625 70H500V-117.5H375V70H250L437.5 257.5zM625 632.5H500V820H375V632.5H250L437.5 445L625 632.5zM875 507.5C875 541.875 846.875 570 812.5 570H656.25L593.75 507.5H781.25L656.25 382.5H218.75L93.75 507.5H281.25L218.75 570H62.5C28.125 570 0 541.875 0 507.5L156.25 351.25L0 195C0 160.625 28.125 132.5 62.5 132.5H218.75L281.25 195H93.75L218.75 320H656.25L781.25 195H593.75L656.25 132.5H812.5C846.875 132.5 875 160.625 875 195L718.75 351.25L875 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22gear%22%0D      unicode%3D%22%26%23xF02F%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M875 271.875V371.875L753.75 411.875L725.6250000000001 480L780.6250000000001 595L710.0000000000002 665.625L596.8750000000001 608.75L528.7500000000001 636.875L485.6250000000002 756.875H385.6250000000003L346.2500000000003 635.625L276.8750000000003 607.5L161.8750000000002 662.5L91.2500000000002 591.875L148.1250000000002 478.7499999999999L120.0000000000002 410.625L0 368.125V268.75L121.25 228.75L149.375 160.625L94.375 45.625L165 -25L278.125 31.875L346.25 3.7500000000001L389.375 -116.2499999999999H488.75L528.1250000000001 5L597.5 33.125L712.5 -21.875L783.1250000000001 48.75L725.6250000000001 161.875L755.0000000000001 230L875 273.125V271.875zM437.5 132.5C333.75 132.5 250 216.25 250 320S333.75 507.5 437.5 507.5S625 423.75 625 320S541.25 132.5 437.5 132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22gift%22%0D      unicode%3D%22%26%23xF042%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 570H726.2500000000001C738.125 590.625 746.8750000000001 611.875 748.75 626.875C752.5000000000001 668.75 741.8750000000001 703.125 716.25 727.5C693.75 751.25 665.625 757.5 631.25 757.5H624.375C591.25 756.25 555 741.875 528.75 721.25C502.5000000000001 700.625 483.125 676.25 468.1250000000001 646.25C453.7500000000001 676.25 433.7500000000001 701.25 407.5000000000001 721.25C381.2500000000001 741.25 345.0000000000001 757.5 311.8750000000001 757.5H310.0000000000001C275 757.5 243.7500000000001 751.875 220.0000000000001 727.5C194.3750000000001 703.125 183.7500000000001 668.75 187.5000000000001 626.875C189.3750000000001 612.5 198.1250000000001 590.625 210.0000000000001 570H123.75C89.375 570 61.25 541.875 61.25 507.4999999999999V320H123.75V7.5C123.75 -26.875 151.875 -55 186.25 -55H748.75C783.1250000000001 -55 811.25 -26.875 811.25 7.5V320H873.75V507.5C873.75 541.875 845.6250000000001 570 811.25 570H812.5zM513.7499999999999 625C524.3749999999999 647.5 539.9999999999999 666.875 560.6249999999999 682.5C579.375 696.875 605.625 706.875 626.25 708.125H631.875C659.9999999999999 708.125 673.125 701.25 681.875 692.5S702.5 668.125 700.625 633.125C697.5 621.25 685 595 669.375 570.625H488.1250000000001L513.75 625.625V625zM255.625 692.5C263.75 700.625 275 708.125 312.5 708.125C331.875 708.125 357.5 697.5 376.875 682.5C397.5 666.875 413.125 648.125 423.75 625L450 570H268.75C253.125 594.375 240.625 620.625 237.5 632.5C235.625 667.5 247.5 683.125 256.25 691.875L255.625 692.5zM437.5 8.125H187.5V320H437.5V7.5V8.125zM437.5 383.125H125V507.5H437.5V382.5V383.125zM750 8.125H500V320H750V7.5V8.125zM812.5 383.125H500V507.5H812.5V382.5V383.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22gist-secret%22%0D      unicode%3D%22%26%23xF08C%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 163.75L562.5 -55H312.5L375 163.75L328.125 257.5H546.875L500 163.75zM625 445H250L125 382.5H750L625 445zM562.5 695L437.5 632.5L312.5 695L250 507.5H625L562.5 695zM814.3750000000001 210.625L625 257.5L687.5 132.5L562.5 -55H763.75C791.875 -55 817.5 -35.625 824.3750000000001 -8.125L859.3750000000001 134.375C868.1250000000001 167.4999999999999 847.5000000000001 201.875 814.3750000000001 210.625zM250 257.5L60.625 210.625C27.5 201.875 6.875 167.5 15.625 134.375L50.625 -8.125C57.5 -35.625 83.125 -55 111.25 -55H312.5L187.5 132.5L250 257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22gist%22%0D      unicode%3D%22%26%23xF00E%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M468.75 507.5L625 351.25L468.75 195L421.875 241.875L531.25 351.25L421.875 460.625L468.75 507.5zM281.25 507.5L125 351.25L281.25 195L328.125 241.875L218.75 351.25L328.125 460.625L281.25 507.5zM0 7.5V695C0 729.375 28.125 757.5 62.5 757.5H687.5C721.875 757.5 750 729.375 750 695V7.5C750 -26.875 721.875 -55 687.5 -55H62.5C28.125 -55 0 -26.875 0 7.5zM62.5 7.5H687.5V695H62.5V7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22git-branch%22%0D      unicode%3D%22%26%23xF020%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M625 507.5C625 576.875 569.375 632.5 500 632.5A124.56250000000001 124.56250000000001 0 0 1 437.5 400V381.25C436.25 348.75 423.125 320 398.125 295C373.125 270 344.375 256.875 311.875 255.6249999999999C260 254.375 219.375 245.6249999999999 186.875 227.5V525A124.56250000000001 124.56250000000001 0 0 1 124.375 757.5C55 757.5 0 701.875 0 632.5A125 125 0 0 1 62.5 525V115C25.625 93.1250000000001 0 53.125 0 7.5C0 -61.875 55.625 -117.5 125 -117.5C194.375 -117.5 250 -61.875 250 7.5C250 40.625 237.5 70 216.875 92.5C222.5 96.25 246.875 118.125 253.75 121.875C269.375 128.75 288.75 132.5 312.5 132.5C378.125 135.625 434.375 160.625 484.375 210.625S559.375 334.375 562.5 399.375H561.25C599.375 421.875 625 461.875 625 507.5zM125 707.5C166.25 707.5 200 673.125 200 632.5C200 591.875 165.625 557.5 125 557.5C84.375 557.5 50 591.875 50 632.5C50 673.125 84.375 707.5 125 707.5zM125 -68.125C83.75 -68.125 50 -33.75 50 6.8749999999999C50 47.4999999999999 84.375 81.8749999999999 125 81.8749999999999C165.625 81.8749999999999 200 47.4999999999998 200 6.8749999999999C200 -33.7500000000001 165.625 -68.125 125 -68.125zM500 431.875C458.75 431.875 425 466.2499999999999 425 506.8749999999999C425 547.5 459.375 581.875 500 581.875C540.625 581.875 575 547.5 575 506.8749999999999C575 466.2499999999999 540.6249999999999 431.875 499.9999999999999 431.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22git-commit%22%0D      unicode%3D%22%26%23xF01F%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M678.75 382.5C650.625 490 553.75 570 437.5 570C321.25 570 224.375 490 196.25 382.5H0V257.5H196.25C224.375 150 321.2500000000001 70 437.5 70C553.75 70 650.625 150 678.75 257.5H875V382.5H678.75zM437.5 182.5C361.25 182.5 300 243.7500000000001 300 320.0000000000001C300 396.2500000000001 361.25 457.5000000000001 437.5 457.5000000000001C513.75 457.5000000000001 575 396.2500000000001 575 320.0000000000001C575 243.7500000000001 513.7499999999999 182.5 437.5 182.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22git-compare%22%0D      unicode%3D%22%26%23xF0AC%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M312.5 70H250C233.125 71.25 220 76.875 206.875 89.375C193.75 101.875 188.125 115.625 187.5 132.5V525A124.56250000000001 124.56250000000001 0 0 1 125 757.5A124.56250000000001 124.56250000000001 0 0 1 62.5 525V132.5C64.375 83.75 83.75 40.625 121.25 3.75C158.75 -33.125 201.25 -53.125 250 -55H312.5V-180L500 7.5L312.5 195V70zM125 707.5C166.25 707.5 200 673.125 200 632.5C200 591.875 165.625 557.5 125 557.5C84.375 557.5 50 591.875 50 632.5C50 673.125 84.375 707.5 125 707.5zM812.5 114.9999999999999V507.5C810.625 556.25 791.25 599.375 753.75 636.25C716.25 673.125 673.7500000000001 693.125 625 695H562.5V820L375 632.5L562.5 445V570H625C641.875 568.75 655 563.125 668.125 550.625C681.25 538.125 686.875 524.375 687.5 507.5V114.9999999999999A124.56250000000001 124.56250000000001 0 0 1 750 -117.5A124.56250000000001 124.56250000000001 0 0 1 812.5 115zM750 -67.5000000000001C708.75 -67.5000000000001 675 -33.125 675 7.4999999999999C675 48.1249999999999 709.3750000000001 82.4999999999999 750 82.4999999999999C790.625 82.4999999999999 825 48.1249999999998 825 7.4999999999999C825 -33.1250000000001 790.6249999999999 -67.5000000000001 750 -67.5000000000001z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22git-merge%22%0D      unicode%3D%22%26%23xF023%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M625 382.5C579.375 382.5 538.7500000000001 356.875 516.875 318.75V320C451.25 321.25 375 342.5 321.25 383.75C274.375 420 227.5 484.375 203.125 536.25A124.56250000000001 124.56250000000001 0 0 1 125 758.125C55.625 758.125 0 701.875 0 632.5A125 125 0 0 1 62.5 525V115C25.625 93.1250000000001 0 53.125 0 7.5C0 -61.875 55.625 -117.5 125 -117.5A124.56250000000001 124.56250000000001 0 0 1 187.5 115V340.625C229.375 296.875 277.5 261.25 331.25 235C385 208.75 458.125 195.625 516.875 195V196.25C539.3749999999999 158.125 579.375 132.5 625 132.5C694.375 132.5 750 188.125 750 257.5C750 326.875 694.375 382.5 625 382.5zM200 7.5C200 -33.75 165.625 -67.5 125 -67.5C84.375 -67.5 50 -33.1249999999999 50 7.5C50 48.125 84.375 82.5 125 82.5C165.625 82.5 200 48.1249999999999 200 7.5zM125 557.5C83.75 557.5 50 591.875 50 632.5C50 673.125 84.375 707.5 125 707.5C165.625 707.5 200 673.125 200 632.5C200 591.875 165.625 557.5 125 557.5zM625 182.5C583.75 182.5 550 216.8750000000001 550 257.5C550 298.125 584.3750000000001 332.5 625 332.5C665.625 332.5 700 298.125 700 257.5C700 216.875 665.6249999999999 182.5 625 182.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22git-pull-request%22%0D      unicode%3D%22%26%23xF009%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M687.5 115V507.5C685.625 556.25 666.25 599.375 628.75 636.25C591.25 673.125 548.75 693.125 500 695H437.5V820L250 632.5L437.5 445V570H500C516.875 568.75 530 563.125 543.125 550.625C556.25 538.125 561.875 524.375 562.5 507.5V114.9999999999999A124.56250000000001 124.56250000000001 0 0 1 625 -117.5A124.56250000000001 124.56250000000001 0 0 1 687.5 115zM625 -67.5C583.75 -67.5 550 -33.1249999999999 550 7.5C550 48.125 584.3750000000001 82.5 625 82.5C665.625 82.5 700 48.1249999999999 700 7.5C700 -33.125 665.6249999999999 -67.5 625 -67.5zM250 632.5C250 701.875 194.375 757.5 125 757.5A124.56250000000001 124.56250000000001 0 0 1 62.5 525V114.9999999999999A124.56250000000001 124.56250000000001 0 0 1 125 -117.5A124.56250000000001 124.56250000000001 0 0 1 187.5 115V525C224.375 546.25 250 586.25 250 632.5zM200 7.5C200 -33.75 165.625 -67.5 125 -67.5C84.375 -67.5 50 -33.1249999999999 50 7.5C50 48.125 84.375 82.5 125 82.5C165.625 82.5 200 48.1249999999999 200 7.5zM125 557.5C83.75 557.5 50 591.875 50 632.5C50 673.125 84.375 707.5 125 707.5C165.625 707.5 200 673.125 200 632.5C200 591.875 165.625 557.5 125 557.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22github-action%22%0D      unicode%3D%22%26%23xF106%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M687.5 476.25C687.5 424.4733047033631 729.4733047033632 382.5 781.25 382.5C833.0266952966368 382.5 875 424.4733047033631 875 476.25C875 528.026695296637 833.0266952966368 570 781.25 570C729.4733047033632 570 687.5 528.026695296637 687.5 476.25z M937.5 695H562.5C562.5 732.5 537.5 757.5 500 757.5S437.5 732.5 437.5 695H62.5C31.25 695 0 663.75 0 632.5V7.5C0 -23.75 31.25 -55 62.5 -55H437.5C437.5 -92.5 462.5 -117.5 500 -117.5S562.5 -92.5 562.5 -55H937.5C968.75 -55 1000 -23.75 1000 7.5V632.5C1000 663.75 968.75 695 937.5 695zM937.5 7.5H62.5V632.5H937.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22globe%22%0D      unicode%3D%22%26%23xF0B6%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 757.5C196.25 757.5 0 561.25 0 320S196.25 -117.5 437.5 -117.5C467.5 -117.5 496.2499999999999 -114.375 523.7499999999999 -108.75C513.1249999999999 -103.75 511.25 -63.1249999999999 522.5 -40.625C534.3749999999999 -15 573.125 50 534.9999999999999 71.8750000000001C496.8749999999999 93.75 507.4999999999999 103.1250000000001 484.3749999999999 128.7500000000001C461.2499999999999 154.3750000000001 470.6249999999999 158.1250000000001 468.7499999999999 165.0000000000001C463.7499999999999 186.2500000000001 491.2499999999999 220.6250000000001 493.1249999999999 223.75C494.3749999999998 227.5000000000001 494.3749999999998 240.625 493.1249999999999 244.3750000000001C493.1249999999999 249.3750000000001 476.2499999999998 258.1250000000001 471.8749999999999 258.7500000000001C468.1249999999999 258.7500000000001 464.9999999999999 251.8750000000001 459.3749999999999 250.625C453.7499999999999 249.3750000000001 428.1249999999999 266.25 422.4999999999999 271.25C416.8749999999999 276.25 413.7499999999999 285.6250000000001 405.6249999999999 292.5C397.4999999999999 300.6250000000001 396.875 294.375 384.9999999999999 299.375S334.9999999999999 318.75 304.9999999999999 329.375C274.9999999999999 341.2500000000001 272.4999999999999 358.75 272.4999999999999 370.6250000000001C271.2499999999999 383.1250000000001 253.7499999999999 400 246.2499999999999 412.5C237.4999999999999 425.0000000000001 236.2499999999999 441.875 233.7499999999999 438.1250000000001C231.2499999999999 434.3750000000001 249.3749999999999 389.375 246.2499999999999 387.5C243.1249999999999 386.2500000000001 236.2499999999999 400 227.4999999999999 411.25C218.7499999999999 423.125 236.2499999999999 416.875 208.7499999999999 470.625S217.4999999999999 551.875 219.3749999999999 580C221.2499999999999 608.125 243.1249999999999 569.375 231.2499999999999 588.125C219.3749999999999 606.875 231.2499999999999 643.75 222.4999999999999 657.5C214.3749999999999 671.25 167.4999999999999 641.875 167.4999999999999 641.875C168.7499999999999 655.625 210.6249999999999 678.125 239.9999999999999 699.375C269.3749999999999 720.625 288.7499999999999 703.125 312.4999999999999 696.25C336.8749999999999 688.125 338.1249999999999 690.625 329.9999999999999 699.375C321.8749999999999 707.5 333.7499999999999 710 352.5 707.5C370 704.375 376.25 681.875 404.375 685C433.7499999999999 686.875 407.5 679.375 411.25 671.25S407.5 664.375 387.5 652.5C368.75 640 388.75 638.75 421.875 614.375S445.625 630 441.25 648.75C436.8749999999999 667.5 465.6249999999999 652.5 465.6249999999999 652.5C486.2499999999999 638.75 482.4999999999999 651.25 496.8749999999999 647.5C511.2499999999999 643.75 553.7499999999999 607.5 553.7499999999999 607.5C501.8749999999998 580 534.3749999999998 577.5 543.1249999999999 570.625C551.8749999999999 563.75 525.6249999999999 551.875 525.6249999999999 551.875C514.9999999999999 562.5 513.7499999999999 550.625 506.8749999999998 546.875C499.9999999999998 543.125 505.6249999999999 533.125 505.6249999999999 533.125C470.6249999999998 527.5 478.1249999999998 490.0000000000001 479.3749999999999 481.2500000000001C479.3749999999999 472.5000000000001 455.6249999999999 458.7500000000001 449.9999999999999 445.0000000000001C444.3749999999999 432.5000000000001 465.6249999999999 405.0000000000001 453.7499999999999 403.7500000000001C441.8749999999999 401.8750000000001 432.4999999999999 445.0000000000001 371.8749999999999 429.3750000000001C353.1249999999999 424.3750000000001 313.1249999999999 403.7500000000001 334.9999999999999 361.8750000000001C357.4999999999999 318.75 392.4999999999999 373.7500000000001 404.3749999999999 367.5000000000001C416.2499999999999 361.2500000000001 400.6249999999999 334.375 403.1249999999999 333.1250000000001C405.6249999999999 331.8750000000001 436.25 331.8750000000001 438.1249999999999 295.0000000000001C439.9999999999999 258.1250000000001 486.2499999999998 261.8750000000001 495.6249999999999 260.625C506.2499999999999 260.625 539.3749999999998 288.125 543.7499999999999 288.75C547.4999999999999 290.625 567.4999999999999 306.25 608.1249999999998 283.125C649.3749999999998 260.625 669.3749999999999 263.75 683.1249999999998 253.75C696.8749999999998 243.75 688.1249999999998 224.3749999999999 700.6249999999998 217.5C713.1249999999997 210.625 766.8749999999998 219.3749999999999 780.6249999999997 198.1249999999999C794.3749999999998 176.8749999999999 725.6249999999997 67.4999999999999 704.3749999999997 55.625C683.1249999999997 43.75 674.3749999999997 15.6249999999999 651.8749999999997 -1.875S601.2499999999997 -41.8750000000001 572.4999999999997 -58.75C546.8749999999997 -73.1250000000001 543.1249999999997 -100 531.2499999999997 -108.7500000000001C727.4999999999997 -65.0000000000001 873.7499999999997 109.9999999999999 873.7499999999997 318.75C873.7499999999997 559.9999999999999 677.4999999999997 756.2499999999999 436.2499999999997 756.2499999999999L437.5 757.5zM540 347.5C534.375 345.625 522.5000000000001 333.7500000000001 491.25 352.5000000000001C461.2500000000001 371.25 440.6250000000001 366.8750000000001 437.5 370.0000000000001C437.5 370.0000000000001 434.375 376.8750000000001 448.125 378.75C475.625 381.875 509.375 353.125 517.5 353.125C525.625 353.125 529.3749999999999 361.25 543.125 356.25C556.875 351.25 546.25 348.125 539.9999999999999 347.5zM396.25 713.75C393.125 715.625 398.125 718.75 401.875 722.5C403.75 724.375 403.125 729.375 405 731.25C411.875 738.125 443.125 746.875 437.5 729.375C430.625 712.5 401.25 710.625 396.25 713.75zM473.125 658.125C461.25 659.375 436.875 661.25 440.6250000000001 666.875C459.3750000000001 684.375 435.0000000000001 690.625 419.3750000000001 690.625C403.7500000000001 691.875 398.1250000000001 700.625 405.6250000000001 702.5C413.1250000000001 704.375 443.7500000000001 701.25 449.3750000000001 697.5C454.3750000000001 693.75 481.8750000000001 681.875 483.7500000000001 673.75C485.0000000000001 665.625 483.7500000000001 658.125 473.1250000000001 658.125zM565.0000000000001 661.25C556.25 655.625 513.125 686.875 505.6250000000001 693.75C470.6250000000001 723.75 450.0000000000001 713.125 443.1250000000001 719.375C436.2500000000001 725.625 438.1250000000001 731.25 450.0000000000001 740.625C461.8750000000002 750 493.1250000000002 736.875 512.5000000000002 735C531.2500000000002 733.125 553.7500000000002 718.125 553.7500000000002 700.625C555.0000000000001 685 574.3750000000002 669.375 565.6250000000001 661.25H565.0000000000001z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22grabber%22%0D      unicode%3D%22%26%23xF284%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M500 570V507.5H0V570H500zM0 320H500V382.5H0V320zM0 132.5H500V195H0V132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22graph%22%0D      unicode%3D%22%26%23xF043%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M1000 -55V-117.5H0V820H62.5V-55H1000zM312.5 7.5H187.5V320H312.5V7.5zM562.5 7.5H437.5V632.5H562.5V7.5zM812.5 7.5H687.5V445H812.5V7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22heart%22%0D      unicode%3D%22%26%23x2665%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M562.5 695C501.8749999999999 695 456.8750000000001 668.75 425 632.5C393.125 596.25 376.25 575 375 570C373.75 575 357.5 596.25 325 632.5C292.5 668.75 251.8750000000001 695 187.5 695C85.5 689.625 2.875 611.6875 0 507.5C0 475 5.625 412.5 41.875 340.625C78.125 268.75 188.125 156.875 375 7.5C561.25 156.875 673.125 268.125 708.75 340.625C744.375 413.125 750 476.25 750 507.5C747.0625 613.125 666.125 689.5625 562.5 695z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22history%22%0D      unicode%3D%22%26%23xF07E%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 7.5H375V445H687.5V320H500V7.5zM437.5 757.5C300.625 757.5 179.375 693.75 99.375 595.625L0 695V445H250L156.25 538.75C221.875 621.875 323.125 676.25 437.5 676.25C633.75 676.25 793.75 516.25 793.75 320S633.7499999999999 -36.25 437.5 -36.25A356.87500000000006 356.87500000000006 0 0 0 81.25 320C81.25 341.25 83.125 361.875 86.875 382.5H5C1.875 361.875 0 341.25 0 320C0 78.75 196.25 -117.5 437.5 -117.5S875 78.75 875 320S678.75 757.5 437.5 757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22home%22%0D      unicode%3D%22%26%23xF08D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M1000 257.5L812.5 445V695H687.5V570L500 757.5L0 257.5H125L187.5 -55C187.5 -89.375 215.625 -117.5 250 -117.5H750C784.375 -117.5 812.5 -89.375 812.5 -55L875 257.5H1000zM750 -55H562.5V195H437.5V-55H250L175.625 339.375L500 663.75L824.3750000000001 339.375L750 -55z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22horizontal-rule%22%0D      unicode%3D%22%26%23xF070%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M62.5 382.5H187.5V257.5H250V632.5H187.5V445H62.5V632.5H0V257.5H62.5V382.5zM625 257.5V382.5H562.5V257.5H625zM625 445V570H562.5V445H625zM437.5 445V570H562.5V632.5H375V257.5H437.5V382.5H562.5V445H437.5zM0 7.5H625V132.5H0V7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22hubot%22%0D      unicode%3D%22%26%23xF09D%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M187.5 445C153.125 445 125 416.875 125 382.5V257.5C125 223.125 153.125 195 187.5 195H687.5C721.875 195 750 223.125 750 257.5V382.5C750 416.875 721.875 445 687.5 445H187.5zM687.5 335.625L609.375 257.5H515.625L437.5 335.625L359.375 257.5H265.625L187.5 335.625V382.5H234.375L312.5 304.375L390.625 382.5H484.375L562.5 304.375L640.625 382.5H687.5V335.625zM312.5 132.5H562.5V70H312.5V132.5zM437.5 695C196.25 695 0 513.125 0 288.75V7.5C0 -26.875 28.125 -55 62.5 -55H812.5C846.875 -55 875 -26.875 875 7.5V288.75C875 513.125 678.75 695 437.5 695zM812.5 7.5H62.5V288.75C62.5 481.875 227.5 638.125 437.5 638.125S812.5 481.875 812.5 288.75V7.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22inbox%22%0D      unicode%3D%22%26%23xF0CF%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M875 257.5L804.3750000000001 703.75C799.3750000000001 733.75 773.1250000000001 757.5 741.8750000000001 757.5H133.125C101.875 757.5 75.625 733.75 70.625 703.75L0 257.5V-55C0 -89.375 28.125 -117.5 62.5 -117.5H812.5C846.875 -117.5 875 -89.375 875 -55V257.5zM670 223.125L642.5000000000001 167.4999999999999C631.8750000000001 146.2499999999999 610.0000000000001 132.4999999999999 585.6250000000001 132.4999999999999H288.125C264.375 132.4999999999999 243.1250000000001 146.2499999999999 232.5 166.8749999999999L205 223.7499999999999C194.375 244.375 172.5 258.125 149.375 258.125H62.5L125 695.625H750L812.5 258.125H726.2500000000001C701.875 258.125 680.625 244.375 669.375 223.7499999999999L670 223.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22info%22%0D      unicode%3D%22%26%23xF059%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M393.75 464.375A58.875 58.875 0 0 0 376.25 508.125C376.25 525.625 381.875 540.625 393.75 551.875C405.625 563.125 420 569.375 437.5 569.375C455 569.375 470 563.75 481.25 551.875C492.5 540 498.75 525.625 498.75 508.125C498.75 490.6249999999999 493.1250000000001 475.625 481.25 464.375A62.5 62.5 0 0 0 437.5 445.625C420 445.625 405 452.5 393.75 464.375zM500 320.625C498.75 336.25 493.125 350.625 480.625 363.75C468.125 375.625 454.3750000000001 382.5 437.5 383.125H375C358.125 381.875 345 375 331.8750000000001 363.75C319.375 351.25 313.1250000000001 336.25 312.5000000000001 320.625H375.0000000000001V133.125C376.2500000000001 116.25 381.8750000000001 101.875 394.3750000000001 90C406.8750000000001 77.5000000000001 420.625 70.625 437.5 70.625H500C516.875 70.625 530 77.5 543.125 90C555.6249999999999 101.875 561.875 116.25 562.5 133.125H500V321.25V320.625zM437.5 676.25C241.25 676.25 81.25 517.5 81.25 321.2500000000001C81.25 125 241.25 -35 437.5 -35S793.75 124.3750000000001 793.75 321.2500000000001C793.75 518.125 633.7499999999999 676.875 437.5 676.875V676.25zM437.5 758.75C678.75 758.75 875 562.5 875 321.25S678.75 -116.25 437.5 -116.25S0 78.75 0 321.25S196.25 758.75 437.5 758.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22issue-closed%22%0D      unicode%3D%22%26%23xF028%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M437.5 195H562.5V70H437.5V195zM562.5 570H437.5V257.5H562.5V570zM656.25 476.25L593.75 413.75L750 257.5L1000 538.75L937.5 601.25L750 382.5L656.25 476.25zM500 -36.25A356.87500000000006 356.87500000000006 0 0 0 143.75 320C143.75 516.25 303.75 676.25 500 676.25C614.375 676.25 715.625 621.25 781.25 538.75L838.75 596.25A434.18749999999994 434.18749999999994 0 0 1 500 757.5C258.75 757.5 62.5 561.25 62.5 320S258.7500000000001 -117.5 500 -117.5S937.5 78.75 937.5 320L842.5 225C801.25 74.375 663.7500000000001 -36.875 500 -36.875V-36.2500000000001z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22issue-opened%22%0D      unicode%3D%22%26%23xF026%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 676.25C633.75 676.25 793.75 516.25 793.75 320S633.7499999999999 -36.25 437.5 -36.25A356.87500000000006 356.87500000000006 0 0 0 81.25 320C81.25 516.25 241.2500000000001 676.25 437.5 676.25zM437.5 757.5C196.25 757.5 0 561.25 0 320S196.25 -117.5 437.5 -117.5S875 78.75 875 320S678.75 757.5 437.5 757.5zM500 570H375V257.5H500V570zM500 195H375V70H500V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22issue-reopened%22%0D      unicode%3D%22%26%23xF027%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 257.5H375V570H500V257.5zM375 70H500V195H375V70zM770.625 195H625L718.75 101.25C653.125 18.125 551.875 -36.25 437.5 -36.25A356.87500000000006 356.87500000000006 0 0 0 81.25 320C81.25 341.25 83.125 361.875 86.875 382.5H5C1.875 361.875 0 341.25 0 320C0 78.75 196.25 -117.5 437.5 -117.5C574.375 -117.5 695.6249999999999 -53.75 775.625 44.375L875 -55V195H770.625zM104.375 445H250L156.25 538.75C221.875 621.875 323.125 676.25 437.5 676.25C633.75 676.25 793.75 516.25 793.75 320C793.75 298.75 791.875 278.125 788.125 257.5H870C873.125 278.125 875 298.75 875 320C875 561.25 678.75 757.5 437.5 757.5C300.6250000000001 757.5 179.375 693.75 99.375 595.625L0 695V445H104.375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22italic%22%0D      unicode%3D%22%26%23xF285%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M175.625 507.5H299.375L187.5 -55H62.5L175.625 507.5zM198.125 676.25C198.125 720 234.375 757.5 281.25 757.5C316.2500000000001 757.5 351.875 733.75 351.875 693.125C351.875 646.25 315 611.875 268.75 611.875C232.5 611.875 198.125 635.625 198.125 676.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22jersey%22%0D      unicode%3D%22%26%23xF019%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M281.25 445L250 413.75V101.25L281.25 70H406.25L437.5 101.25V413.75L406.25 445H281.25zM375 132.5H312.5V382.5H375V132.5zM766.875 585.625C753.125 671.875 747.5 750 750 820H563.75C563.75 803.125 555.6249999999999 790 539.3749999999999 776.875C523.7499999999999 764.375 499.9999999999999 758.125 468.7499999999999 758.125C437.5 758.125 413.75 763.75 398.125 776.875C383.75 789.375 375.625 803.125 375.625 820H187.5C190.625 749.375 185.625 671.25 171.875 585.625C159.375 499.375 121.875 452.5 62.5 445V-117.5C63.75 -134.375 69.375 -147.5 81.875 -160.625C94.375 -173.75 108.125 -179.375 125 -180H812.5C829.375 -178.75 842.5 -173.125 855.625 -160.625C868.75 -148.125 874.375 -134.375 875 -117.5V445C815.625 453.125 779.375 500 765.625 585.625H766.875zM812.5 -117.5H125V382.5C180.625 413.75 217.5 460.625 232.5 523.125S251.8750000000001 663.75 250 757.5H312.5C311.25 708.75 322.5 665.625 345 628.75C367.5 592.5 408.75 573.125 470 570C531.25 571.25 572.5 590.625 595 628.75C617.4999999999999 665.625 626.25 708.75 625 757.5H687.5C688.75 668.75 695.625 598.125 708.125 546.25C720.625 495.6250000000001 751.25 421.25 812.5 381.875V-118.125V-117.5zM531.25 445L500 413.75V101.25L531.25 70H656.25L687.5 101.25V413.75L656.25 445H531.25zM625 132.5H562.5V382.5H625V132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22kebab-horizontal%22%0D      unicode%3D%22%26%23xF286%3B%22%0D      horiz-adv-x%3D%22812.5%22 d%3D%22 M93.75 257.5A93.75 93.75 0 1 1 93.75 445A93.75 93.75 0 0 1 93.75 257.5zM406.25 257.5A93.75 93.75 0 1 1 406.25 445A93.75 93.75 0 0 1 406.25 257.5zM812.5 351.25A93.75 93.75 0 1 0 625 351.25A93.75 93.75 0 0 0 812.5 351.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22kebab-vertical%22%0D      unicode%3D%22%26%23xF287%3B%22%0D      horiz-adv-x%3D%22187.5%22 d%3D%22 M0 663.75A93.75 93.75 0 1 1 187.5 663.75A93.75 93.75 0 0 1 0 663.75zM0 351.25A93.75 93.75 0 1 1 187.5 351.25A93.75 93.75 0 0 1 0 351.25zM93.75 -55A93.75 93.75 0 1 0 93.75 132.5A93.75 93.75 0 0 0 93.75 -55z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22key%22%0D      unicode%3D%22%26%23xF049%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M801.875 684.375C755 731.25 696.25 755.625 625 757.5C554.3750000000001 755.625 495 731.25 448.125 684.375S377.5 578.75 375.625 507.5C375.625 488.75 377.5 470.625 381.25 451.875L0 70V7.5L62.5 -55H187.5L250 7.5V70H312.5V132.5H375V195H500L568.125 264.375C586.875 259.375 605 257.5 625 257.5C696.25 259.375 755 283.75 801.875 330.625S873.125 436.25 875 507.5C873.125 578.75 848.75 637.5 801.875 684.375zM687.5 483.75C639.375 483.75 601.2500000000001 521.875 601.2500000000001 570C601.2500000000001 618.125 639.375 656.25 687.5 656.25C735.625 656.25 773.7499999999999 618.125 773.7499999999999 570C773.7499999999999 521.875 735.625 483.75 687.5 483.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22keyboard%22%0D      unicode%3D%22%26%23xF00D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M625 507.5H562.5V570H625V507.5zM187.5 445H125V382.5H187.5V445zM500 570H437.5V507.5H500V570zM250 570H125V507.5H250V570zM750 132.5H875V195H750V132.5zM500 382.5H562.5V445H500V382.5zM250 195H125V132.5H250V195zM750 570H687.5V507.5H750V570zM875 570H812.5V507.5H875V570zM750 257.5H875V445H750V257.5zM1000 632.5V70C1000 35.625 971.875 7.5 937.5 7.5H62.5C28.125 7.5 0 35.625 0 70V632.5C0 666.875 28.125 695 62.5 695H937.5C971.875 695 1000 666.875 1000 632.5zM937.5 632.5H62.5V70H937.5V632.5zM375 382.5H437.5V445H375V382.5zM375 570H312.5V507.5H375V570zM250 382.5H312.5V445H250V382.5zM312.5 132.5H687.5V195H312.5V132.5zM625 382.5H687.5V445H625V382.5zM187.5 320H125V257.5H187.5V320zM500 320V257.5H562.5V320H500zM375 320V257.5H437.5V320H375zM312.5 320H250V257.5H312.5V320zM625 257.5H687.5V320H625V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22law%22%0D      unicode%3D%22%26%23xF0D8%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 570C385.625 570 343.75 611.875 343.75 663.75S385.625 757.5 437.5 757.5S531.25 715.625 531.25 663.75S489.375 570 437.5 570zM875 195C875 125.625 819.375 70 750 70H687.5C618.125 70 562.5 125.625 562.5 195L687.5 445H625C590.625 445 562.5 473.125 562.5 507.5H500V7.5C526.25 7.5 562.5 -20.625 562.5 -55H625C651.25 -55 687.5 -83.125 687.5 -117.5H187.5C187.5 -83.125 223.75 -55 250 -55H312.5C312.5 -20.625 348.75 7.5 375 7.5H376.875L375 507.5H312.5C312.5 473.125 284.375 445 250 445H187.5L312.5 195C312.5 125.625 256.875 70 187.5 70H125C55.625 70 0 125.625 0 195L125 445H62.5V507.5H250C250 541.875 278.125 570 312.5 570H562.5C596.875 570 625 541.875 625 507.5H812.5V445H750L875 195zM156.25 382.5L62.5 195H250L156.25 382.5zM812.5 195L718.75 382.5L625 195H812.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22light-bulb%22%0D      unicode%3D%22%26%23xF000%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M406.25 820C217.5 820 62.5 683.125 62.5 507.5C62.5 450 96.875 366.875 125 320C208.75 179.375 236.2500000000001 146.25 250 70V7.5H562.5V70C576.25 146.25 603.75 179.375 687.5 320C715.625 366.875 750 450 750 507.5C750 683.125 595 820 406.25 820zM633.75 352.5C618.125 325 604.375 302.4999999999999 591.875 283.125C538.1250000000001 195 513.75 154.375 501.2500000000001 81.25C500.0000000000001 78.1249999999999 500.0000000000001 74.375 500.0000000000001 70.625H312.5C312.5 74.375 312.5 78.75 311.25 81.25C298.75 154.375 274.3750000000001 195.625 220.625 283.125C208.125 302.5 194.375 325 178.75 352.5000000000001C152.5 396.25 125 466.875 125 507.5C125 645 251.25 757.5 406.25 757.5C482.5 757.5 553.75 731.25 607.5 683.125C659.375 636.25 687.5 573.75 687.5 507.5C687.5 466.25 660 396.25 633.75 352.5zM250 -55H562.5C548.125 -126.25 481.25 -180 406.25 -180S264.375 -126.25 250 -55z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22link-external%22%0D      unicode%3D%22%26%23xF07F%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M687.5 195H750V7.5C750 -26.875 721.875 -55 687.5 -55H62.5C28.125 -55 0 -26.875 0 7.5V632.5C0 666.875 28.125 695 62.5 695H250V632.5H62.5V7.5H687.5V195zM375 695L515.625 554.375L312.5 351.25L406.25 257.5L609.375 460.625L750 320V695H375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22link%22%0D      unicode%3D%22%26%23xF05C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M250 257.5H312.5V195H250C156.25 195 62.5 300.625 62.5 413.75S159.375 632.5 250 632.5H500C590.625 632.5 687.5 526.875 687.5 413.75C687.5 325.625 630.625 243.75 562.5 210.625V283.125C598.75 311.25 625 362.5 625 413.75C625 493.75 561.25 570 500 570H250C188.75 570 125 493.75 125 413.75S187.5 257.5 250 257.5zM812.5 445H750V382.5H812.5C875 382.5 937.5 306.25 937.5 226.25S873.75 70 812.5 70H562.5C501.25 70 437.5 146.25 437.5 226.25C437.5 278.125 463.75 328.75 500 356.875V429.375C431.875 396.25 375 314.375 375 226.25C375 113.125 471.875 7.5 562.5 7.5H812.5C903.125 7.5 1000 113.125 1000 226.25S906.25 445 812.5 445z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22list-ordered%22%0D      unicode%3D%22%26%23xF062%3B%22%0D      horiz-adv-x%3D%22812.5%22 d%3D%22 M750.625 7.5C750.625 -29.375 750.625 -55 713.75 -55H287.5C250.625 -55 250.625 -29.375 250.625 7.5C250.625 44.375 250.625 70 287.5 70H713.125C750 70 750 44.375 750 7.5H750.625zM287.5 570H713.125C750 570 750 595.625 750 632.5C750 669.375 750 695 713.125 695H287.5C250.625 695 250.625 669.375 250.625 632.5C250.625 595.625 250.625 570 287.5 570zM713.125 382.5H287.5C250.625 382.5 250.625 356.875 250.625 320C250.625 283.125 250.625 257.5 287.5 257.5H713.125C750 257.5 750 283.125 750 320C750 356.875 750 382.5 713.125 382.5zM125.625 757.5H80.625C61.875 745.625 44.375 741.875 16.25 736.25V695H63.125V561.25H10.625V507.5H188.125V561.25H125.625V757.5zM150.125 250C142.0625 250 113.125 247.5000000000001 100 245.625C133.125 280.6250000000001 171.25 323.7500000000001 171.25 363.75C170 412.5 136.25 445 86.25 445C49.375 445 25.625 432.5 0 405L36.25 368.75C48.125 380.6250000000001 60 392.5 76.25 392.5C93.75 392.5 106.25 382.5 106.25 360.0000000000001C106.25 326.875 58.125 285.0000000000001 0 231.25V195H187.5V250H150.125zM136.25 13.125V15C163.75 26.8749999999999 176.25 44.375 176.25 68.7499999999999C176.25 112.4999999999999 141.25 138.1249999999999 86.25 138.1249999999999C56.25 138.1249999999999 30.625 126.2499999999999 6.25 105.6249999999999L40.625 65.6249999999999C56.25 78.1249999999998 68.125 84.9999999999999 83.75 84.9999999999999C100.625 84.9999999999999 110 76.8749999999999 110 62.4999999999999C110 45.625 97.5 35 56.25 35V-11.875C108.125 -11.875 117.5 -22.5 117.5 -41.2500000000001C117.5 -56.8750000000001 103.125 -65.0000000000001 81.25 -65.0000000000001C63.75 -65.0000000000001 46.25 -56.2500000000001 30.625 -41.2500000000001L0.625 -82.5000000000001C19.375 -105 48.75 -117.5000000000001 88.75 -117.5000000000001C140.625 -117.5000000000001 184.375 -91.8750000000001 184.375 -45.0000000000001C184.375 -13.7500000000001 165 5.6249999999999 136.25 13.7499999999999V13.1249999999999z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22list-unordered%22%0D      unicode%3D%22%26%23xF061%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M125 7.5C125 -29.375 125 -55 88.125 -55H36.875C0 -55 0 -29.375 0 7.5C0 44.375 0 70 36.875 70H87.5C124.375 70 124.375 44.375 124.375 7.5H125zM286.875 570H712.4999999999999C749.3749999999999 570 749.3749999999999 595.625 749.3749999999999 632.5C749.3749999999999 669.375 749.3749999999999 695 712.4999999999999 695H286.875C250 695 250 669.375 250 632.5C250 595.625 250 570 286.875 570zM88.125 382.5H36.875C0 382.5 0 356.875 0 320C0 283.125 0 257.5 36.875 257.5H87.5C124.375 257.5 124.375 283.125 124.375 320C124.375 356.875 124.375 382.5 87.5 382.5H88.125zM88.125 695H36.875C0 695 0 669.375 0 632.5C0 595.625 0 570 36.875 570H87.5C124.375 570 124.375 595.625 124.375 632.5C124.375 669.375 124.375 695 87.5 695H88.125zM713.125 382.5H286.875C250 382.5 250 356.875 250 320C250 283.125 250 257.5 286.875 257.5H712.4999999999999C749.3749999999999 257.5 749.3749999999999 283.125 749.3749999999999 320C749.3749999999999 356.875 749.3749999999999 382.5 712.4999999999999 382.5H713.1249999999999zM713.125 70H286.875C250 70 250 44.375 250 7.5C250 -29.375 250 -55 286.875 -55H712.4999999999999C749.3749999999999 -55 749.3749999999999 -29.375 749.3749999999999 7.5C749.3749999999999 44.375 749.3749999999999 70 712.4999999999999 70H713.1249999999999z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22location%22%0D      unicode%3D%22%26%23xF060%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 820C168.125 820 0 663.75 0 476.25C0 193.75 375 -180 375 -180S750 193.75 750 476.25C750 663.75 581.875 820 375 820zM375 -89.375C258.75 37.5 62.5 292.5 62.5 476.25C62.5 631.25 203.125 757.5 375 757.5C458.75 757.5 538.125 727.5 597.5 672.5C655 618.75 687.5 549.375 687.5 476.25C687.5 292.5 491.2499999999999 37.5 375 -89.375zM500 476.25C500 406.875 444.375 351.25 375 351.25C305.625 351.25 250 406.875 250 476.25C250 545.625 305.625 601.25 375 601.25C444.375 601.25 500 545.625 500 476.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22lock%22%0D      unicode%3D%22%26%23xF06A%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M250 7.5H187.5V70H250V7.5zM750 382.5V-55C750 -89.375 721.875 -117.5 687.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V382.5C0 416.875 28.125 445 62.5 445H125V570C125 707.5 237.5 820 375 820S625 707.5 625 570V445H687.5C721.875 445 750 416.875 750 382.5zM237.5 445H513.125V570C513.125 646.25 451.875 707.5 375.6250000000001 707.5C299.3750000000001 707.5 238.1250000000001 646.25 238.1250000000001 570V445H237.5zM687.5 382.5H125V-55H687.5V382.5zM250 320H187.5V257.5H250V320zM250 195H187.5V132.5H250V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22logo-github%22%0D      unicode%3D%22%26%23xF092%3B%22%0D      horiz-adv-x%3D%222812.5%22 d%3D%22 M1158.125 68.125H1156.875C1157.4375000000002 68.125 1157.8125000000002 67.5 1158.3750000000002 67.4375000000001H1158.7500000000002L1158.125 68.0625000000001zM1158.3750000000002 67.4375000000001C1152.5625000000002 67.3750000000001 1137.9375 64.3125 1122.5 64.3125C1073.75 64.3125 1056.875 86.8125 1056.875 116.1875V311.875H1156.25C1161.875 311.875 1166.25 316.875 1166.25 323.75V430C1166.25 435.625 1161.2500000000002 440.625 1156.25 440.625H1056.875V572.5C1056.875 577.5 1053.75 580.625 1048.125 580.625H913.125C907.5 580.625 904.3749999999998 577.5 904.3749999999998 572.5V436.875S836.2499999999999 420 831.8749999999999 419.375C826.8749999999999 418.125 823.7499999999999 413.75 823.7499999999999 408.75V323.75C823.7499999999999 316.875 828.7499999999999 311.875 834.3749999999999 311.875H903.7499999999998V106.875C903.7499999999998 -45.625 1009.9999999999998 -61.25 1082.4999999999998 -61.25C1115.6249999999998 -61.25 1155.6249999999998 -50.625 1161.8749999999998 -47.4999999999999C1165.6249999999998 -46.25 1167.4999999999998 -41.875 1167.4999999999998 -37.4999999999999V56.2500000000001A11.0625 11.0625 0 0 1 1158.3749999999998 67.5zM2639.375 205C2639.375 318.1250000000001 2593.75 333.125 2545.625 328.125C2508.1249999999995 325.625 2478.125 306.875 2478.125 306.875V86.875S2508.75 65.625 2554.375 64.375C2618.75 62.5 2639.375 85.625 2639.375 205zM2791.25 215C2791.25 0.625 2721.875 -60.625 2600.625 -60.625C2498.125 -60.625 2443.1249999999995 -8.75 2443.1249999999995 -8.75S2440.625 -37.5 2437.4999999999995 -41.25C2435.6249999999995 -45 2432.4999999999995 -46.25 2428.7499999999995 -46.25H2336.2499999999995C2329.9999999999995 -46.25 2324.375 -41.25 2324.375 -35.625L2325.625 658.75C2325.625 664.375 2330.625 669.375 2336.25 669.375H2469.3750000000005C2475.0000000000005 669.375 2480.0000000000005 664.375 2480.0000000000005 658.75V423.125S2531.2500000000005 456.2500000000001 2606.2500000000005 456.2500000000001L2605.625000000001 457.5C2680.625000000001 457.5 2791.2500000000005 429.375 2791.2500000000005 215zM2246.25 440.625H2114.9999999999995C2108.125 440.625 2104.3749999999995 435.625 2104.3749999999995 428.75V88.7499999999999S2070 64.3749999999999 2023.1249999999995 64.3749999999999S1962.5 85.6249999999999 1962.5 132.4999999999999V429.375C1962.5 435 1957.5 440 1951.8749999999995 440H1818.1249999999995C1812.4999999999995 440 1807.4999999999995 435 1807.4999999999995 429.375V110C1807.4999999999995 -27.4999999999999 1884.3749999999995 -61.875 1989.9999999999995 -61.875C2076.875 -61.875 2147.5 -13.75 2147.5 -13.75S2150.625 -38.125 2152.5 -41.875C2153.75 -45 2158.125 -47.4999999999999 2162.4999999999995 -47.4999999999999H2246.25C2253.125 -47.4999999999999 2256.875 -42.4999999999999 2256.875 -36.8749999999999L2258.125 430.0000000000001C2258.125 435.6250000000001 2253.1250000000005 440.6250000000001 2246.2500000000005 440.6250000000001zM764.9999999999999 441.25H631.875C626.25 441.25 621.25 435.625 621.25 428.75V-30.0000000000001C621.25 -42.5 629.375 -46.8750000000001 640 -46.8750000000001H760C772.5 -46.8750000000001 775.625 -41.2500000000001 775.625 -30.0000000000001V430.625C775.625 436.25 770.625 441.25 765 441.25zM699.3749999999999 652.5C651.2499999999999 652.5 613.1249999999999 614.375 613.1249999999999 566.25C613.1249999999999 518.125 651.2499999999999 480 699.3749999999999 480C746.2499999999999 480 784.3749999999998 518.125 784.3749999999998 566.25C784.3749999999998 614.375 746.2499999999999 652.5 699.3749999999999 652.5zM1729.9999999999998 668.125H1598.1249999999998C1592.4999999999998 668.125 1587.4999999999998 663.125 1587.4999999999998 657.5V401.875H1380.6249999999998V657.5C1380.6249999999998 663.125 1375.6249999999998 668.125 1369.9999999999998 668.125H1236.8749999999998C1231.2499999999998 668.125 1226.2499999999995 663.125 1226.2499999999995 657.5V-36.8749999999999C1226.2499999999995 -42.4999999999999 1231.8749999999995 -47.4999999999999 1236.8749999999998 -47.4999999999999H1369.9999999999998C1375.6249999999995 -47.4999999999999 1380.6249999999998 -42.4999999999999 1380.6249999999998 -36.8749999999999V260H1587.4999999999998L1586.2499999999998 -36.875C1586.2499999999998 -42.5 1591.2499999999995 -47.5 1596.8749999999998 -47.5H1729.9999999999998C1735.6249999999998 -47.5 1740.6249999999998 -42.5 1740.6249999999998 -36.875V657.5C1740.6249999999998 663.125 1735.625 668.125 1729.9999999999998 668.125zM550.625 360.625V1.875C550.625 -0.6249999999999 550 -5 546.875 -6.25C546.875 -6.25 468.75 -61.8750000000001 340 -61.8750000000001C184.375 -61.8750000000001 -1e-13 -13.1250000000001 -1e-13 308.125S161.25 695.625 318.75 695C454.9999999999999 695 510 664.375 518.75 658.75C521.25 655.625 522.5000000000001 653.125 522.5000000000001 650L496.25 538.75C496.25 533.125 490.6250000000001 526.25 483.75 528.125C461.25 535 427.5 548.75 348.125 548.75C256.2500000000001 548.75 157.5 522.5 157.5 315.625S251.2500000000001 84.375 318.7500000000001 84.375C376.2500000000001 84.375 396.8750000000001 91.25 396.8750000000001 91.25V235H305C298.125 235 293.125 240 293.125 245.625V360.625C293.125 366.25 298.125 371.25 305 371.25H538.7500000000001C545.625 371.25 550.625 366.25 550.625 360.625z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mail-read%22%0D      unicode%3D%22%26%23xF03C%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M375 507.5H250V570H375V507.5zM562.5 445H250V382.5H562.5V445zM875 475V-55C875 -89.375 846.875 -117.5 812.5 -117.5H62.5C28.125 -117.5 0 -89.375 0 -55V475C0 495.6250000000001 10 514.375 26.25 525.625L125 596.25V632.5C125 666.875 153.125 695 187.5 695H262.5L437.5 820L612.5 695H687.5C721.875 695 750 666.875 750 632.5V596.25L848.75 525.625C865.625 513.75 875 495.6250000000001 875 475zM187.5 351.25L437.5 195L687.5 351.25V632.5H187.5V351.25zM62.5 -23.75L343.75 163.75L62.5 351.25V-23.75zM750 -55L437.5 132.5L125 -55H750zM812.5 351.25L531.25 163.75L812.5 -23.75V351.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mail%22%0D      unicode%3D%22%26%23xF03B%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M0 570V70C0 35.625 28.125 7.5 62.5 7.5H812.5C846.875 7.5 875 35.625 875 70V570C875 604.375 846.875 632.5 812.5 632.5H62.5C28.125 632.5 0 604.375 0 570zM812.5 570L437.5 257.5L62.5 570H812.5zM62.5 476.25L312.5 288.75L62.5 101.25V476.25zM125 70L343.75 257.5L437.5 163.75L531.25 257.5L750 70H125zM812.5 101.25L562.5 288.75L812.5 476.25V101.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mark-github%22%0D      unicode%3D%22%26%23xF00A%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M500 820C223.75 820 0 596.25 0 320C0 98.75 143.125 -88.1250000000001 341.875 -154.375C366.875 -158.75 376.25 -143.75 376.25 -130.6249999999999C376.25 -118.75 375.625 -79.3749999999999 375.625 -37.4999999999999C250 -60.6249999999999 217.5 -6.8749999999999 207.5 21.25C201.875 35.6250000000001 177.5 80 156.25 91.8750000000001C138.75 101.2500000000001 113.75 124.3750000000001 155.625 125C195 125.625 223.125 88.75 232.5 73.75C277.5 -1.8749999999999 349.375 19.3750000000001 378.1250000000001 32.5C382.5000000000001 65 395.6250000000001 86.875 410.0000000000001 99.375C298.75 111.875 182.5 155.0000000000001 182.5 346.2500000000001C182.5 400.6250000000001 201.875 445.6250000000001 233.75 480.625C228.75 493.1250000000001 211.25 544.375 238.7500000000001 613.125C238.7500000000001 613.125 280.625 626.25 376.2500000000001 561.875C416.25 573.125 458.7500000000001 578.75 501.25 578.75C543.75 578.75 586.2499999999999 573.125 626.25 561.875C721.8749999999999 626.875 763.7499999999999 613.125 763.7499999999999 613.125C791.2499999999999 544.375 773.7499999999999 493.125 768.7499999999999 480.625C800.6249999999999 445.625 820 401.2500000000001 820 346.25C820 154.375 703.125 111.875 591.8749999999999 99.3749999999999C609.9999999999999 83.7499999999999 625.6249999999999 53.7499999999999 625.6249999999999 6.8749999999999C625.6249999999999 -60.0000000000001 624.9999999999999 -113.7500000000001 624.9999999999999 -130.625C624.9999999999999 -143.7500000000001 634.3749999999999 -159.3750000000001 659.3749999999999 -154.3750000000001A500.81249999999994 500.81249999999994 0 0 1 1000 320C1000 596.25 776.25 820 500 820z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22markdown%22%0D      unicode%3D%22%26%23xF0C9%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M928.125 632.5H71.875C32.5 632.5 0 600 0 560.625V80C0 40 32.5 7.5 71.875 7.5H927.5C967.5 7.5 999.375 40 999.375 79.375V560.625C1000 600 967.5 632.5 928.125 632.5zM562.5 132.5H437.5V320L343.75 200L250 320V132.5H125V507.5H250L343.75 382.5L437.5 507.5H562.5V132.5zM749.375 101.25L593.75 320H687.5V507.5H812.5V320H906.25L749.375 101.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22megaphone%22%0D      unicode%3D%22%26%23xF077%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M625 757.5C614.375 757.5 602.5 754.375 592.5 748.75C502.4999999999999 693.75 281.25 533.75 187.5 507.5C101.25 507.5 0 465.625 0 351.25S101.875 195 187.5 195C206.25 190 227.5 180.625 250 169.375V-117.5H375V98.125C458.75 44.375 543.125 -16.25 592.5 -46.2500000000001C602.5 -51.8750000000001 613.75 -55.0000000000001 625 -55.0000000000001C657.5 -55.0000000000001 687.5 -28.7500000000001 687.5 7.4999999999999V695C687.5 731.25 657.5 757.5 625 757.5zM625 7.5C601.25 21.875 569.375 43.75 531.25 70C521.25 76.875 510.625 83.75 500 91.25V613.125C510 620 519.375 625.625 529.375 632.5C567.5 658.125 601.875 680.625 625 695V7.5zM750 382.5H1000V320H750V382.5zM750 257.5L1000 132.5V70L750 195V257.5zM1000 632.5V570L750 445V507.5L1000 632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mention%22%0D      unicode%3D%22%26%23xF0BE%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M411.25 -117.5C489.375 -117.5 568.75 -98.125 633.75 -58.75L607.5 -1e-13C555 -32.5 489.3750000000001 -51.8750000000001 418.1250000000001 -51.8750000000001C216.2500000000001 -51.8750000000001 65.6250000000001 78.1249999999999 65.6250000000001 305.625C65.6250000000001 578.75 267.5000000000001 754.375 476.8750000000001 754.375C692.5000000000001 754.375 803.1250000000001 617.5 803.1250000000001 429.375C803.1250000000001 280 719.3750000000001 188.1249999999999 646.8750000000001 188.1249999999999C581.25 188.1249999999999 561.8750000000001 233.75 581.25 324.9999999999999L626.8750000000001 559.3749999999999H561.25L554.3750000000001 514.3749999999999C528.75 553.7499999999999 495.6250000000001 566.2499999999999 456.8750000000001 566.2499999999999C320.0000000000001 566.2499999999999 228.1250000000001 416.875 228.1250000000001 292.4999999999999C228.1250000000001 188.1249999999999 286.875 129.375 371.875 129.375C424.375 129.375 476.25 162.4999999999999 515.625 207.5C522.5 148.75 574.375 116.875 639.375 116.875C743.75 116.875 875 221.25 875 429.375C875 656.875 724.375 820 489.375 820C228.75 820 0 611.875 0 299.375C0 25.625 182.5 -117.5 411.25 -117.5zM391.8750000000001 195C346.2500000000001 195 306.875 227.5 306.875 299.375C306.875 390 365.625 500.6250000000001 457.5 500.6250000000001C490 500.6250000000001 510 488.125 535.625 448.7500000000001L503.1250000000001 260.0000000000001C463.7500000000001 214.375 425.0000000000001 194.375 391.8750000000001 194.375V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22milestone%22%0D      unicode%3D%22%26%23xF075%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 695H375V820H500V695zM750 382.5H125C90.625 382.5 62.5 410.625 62.5 445V570C62.5 604.375 90.625 632.5 125 632.5H750L875 507.5L750 382.5zM500 570H375V445H500V570zM375 -180H500V320H375V-180z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mirror%22%0D      unicode%3D%22%26%23xF024%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M968.75 526.25L531.25 820L93.75 526.25C75 514.375 62.5 498.125 62.5 476.25V-180L531.25 70L1000 -180V476.25C1000 497.5 987.5 514.375 968.75 526.25zM937.5 -86.25L562.5 116.875V195H500V116.875L125 -86.25V476.25L500 726.25V445H562.5V726.25L937.5 476.25V-86.25zM375 382.5H687.5V507.5L875 320L687.5 132.5V257.5H375V132.5L187.5 320L375 507.5V382.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mortar-board%22%0D      unicode%3D%22%26%23xF0D7%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M506.8749999999999 645A21.250000000000004 21.250000000000004 0 0 1 494.3749999999999 645L16.875 496.25A21.875 21.875 0 0 1 16.875 454.375L125 420V309.375C106.25 298.75 93.75 278.125 93.75 255.625C93.75 243.7500000000001 96.875 233.1250000000001 102.5 224.375C97.5 215.625 93.75 205 93.75 193.125V31.875C93.75 -2.5 218.75 -2.5 218.75 31.875V193.125C218.75 205 215.625 215.625 210 224.375C215 233.1250000000001 218.75 243.7500000000001 218.75 255.625C218.75 279.3750000000001 206.25 298.75 187.5 309.375V400L493.125 304.375C496.8749999999999 303.125 501.8749999999999 303.125 505.625 304.375L983.125 453.125A21.875 21.875 0 0 1 983.125 495L506.25 644.375L506.8749999999999 645zM250 320L489.375 245.625H488.1250000000001C496.25 243.7500000000001 503.7500000000001 243.7500000000001 510.625 245.625L750 320V163.75C750 101.25 637.5 70 500 70S250 101.25 250 163.75V320zM438.75 476.25C438.75 458.75 466.875 445 501.25 445S563.75 458.75 563.75 476.25S535.625 507.5 501.25 507.5S438.75 493.75 438.75 476.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22mute%22%0D      unicode%3D%22%26%23xF080%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M500 644.375V-4.3750000000001C500 -46.2500000000001 449.375 -66.8750000000001 420 -37.5L187.5 195H62.5C28.125 195 0 223.125 0 257.5V382.5C0 416.875 28.125 445 62.5 445H187.5L420.0000000000001 677.5C449.375 706.875 500 686.25 500 644.375zM970.6250000000002 443.125L904.375 509.3749999999999L781.25 386.25L658.125 509.3749999999999L591.8749999999999 443.125L715 320L591.875 196.875L658.1250000000001 130.6249999999999L781.2500000000001 253.75L904.3750000000002 130.6249999999999L970.6250000000002 196.875L847.5 320L970.6250000000002 443.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22no-newline%22%0D      unicode%3D%22%26%23xF09C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M1000 507.5V320C1000 285.625 971.875 257.5 937.5 257.5H750V132.5L562.5 320L750 507.5V382.5H875V507.5H1000zM500 320C500 182.5 387.5 70 250 70S0 182.5 0 320S112.5 570 250 570S500 457.5 500 320zM93.75 216.25L353.75 476.25C323.75 495.625 288.125 507.5 250 507.5C146.25 507.5 62.5 423.75 62.5 320C62.5 281.875 74.375 246.875 93.75 216.25zM437.5 320C437.5 358.125 425.625 393.125 406.25 423.75L146.25 163.75C176.25 144.375 211.875 132.5 250 132.5C353.75 132.5 437.5 216.25 437.5 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22note%22%0D      unicode%3D%22%26%23xF289%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M187.5 195H437.5V257.5H187.5V195zM187.5 320H562.5V382.5H187.5V320zM187.5 445H687.5V507.5H187.5V445zM812.5 70H62.5V632.5H812.5V70zM62.5 695C28.125 695 0 666.875 0 632.5V70C0 35.625 28.125 7.5 62.5 7.5H812.5C846.875 7.5 875 35.625 875 70V632.5C875 666.875 846.875 695 812.5 695H62.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22octoface%22%0D      unicode%3D%22%26%23xF008%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M918.75 486.25C926.875 506.25 953.125 585.625 910.6249999999998 693.125C910.6249999999998 693.125 844.9999999999999 713.75 695.6249999999999 611.875C633.1249999999999 629.375 566.2499999999999 631.875 499.9999999999999 631.875S366.875 629.375 304.375 611.875C155 714.375 89.375 693.125 89.375 693.125C46.875 585.625 73.125 506.2499999999999 81.25 486.25C30.625 431.875 0 361.875 0 276.875C0 -45 208.125 -117.5 498.75 -117.5S1000 -45 1000 276.875C1000 361.8750000000001 969.375 431.8750000000001 918.75 486.25zM500 -56.25C293.75 -56.25 126.25 -46.875 126.25 153.125C126.25 200.625 150 245.625 190 282.5C256.875 343.7500000000001 371.25 311.2500000000001 500 311.2500000000001C629.375 311.2500000000001 742.4999999999999 343.7500000000001 810 282.5C850.6250000000001 245.625 873.75 201.25 873.75 153.125C873.75 -46.25 706.25 -56.25 500 -56.25zM343.125 256.875C301.875 256.875 268.125 206.875 268.125 145.625S301.875 33.7500000000001 343.125 33.7500000000001C384.375 33.7500000000001 418.125 83.7500000000001 418.125 145.625S384.375 256.875 343.125 256.875zM656.875 256.875C615.625 256.875 581.875 207.5 581.875 145.625S615.6250000000001 33.7500000000001 656.875 33.7500000000001C698.125 33.7500000000001 731.8749999999999 83.7500000000001 731.8749999999999 145.625S698.75 256.875 656.875 256.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22organization-filled%22%0D      unicode%3D%22%26%23x26A2%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M1000 7.5625C1000 -19.875 971.875 -54.9375 937.5 -54.9375H499.6875C466 -54.9375 437.5625 -27.0000000000001 437.5 7.5H62.5C28.75 7.5 0 42.5625 0 70C0 234.625 187.5 320 187.5 320S201.8125 345.5625 187.5 382.5C134.9375 421.3125 121.375 419.375 125 570C128.625 721.1875 210.4375 757.5 281.25 757.5S433.875 721.25 437.5 570C441.125 419.375 427.5625 421.3125 375 382.5C360.6875 345.625 375 320 375 320S471.8124999999999 275.5625 526.25 189.4999999999999C574.75 234.4375 625 257.5625 625 257.5625S639.3125 283.125 625 320.0625C572.4375 358.8125 558.875 356.9375 562.5 507.5624999999999C566.125 658.75 647.9375 695.0625 718.75 695.0625S871.0625 658.75 874.6875000000001 507.5624999999999C878.375 356.9375 864.8125000000001 358.8125 812.1875000000001 320.0625C797.8750000000001 283.1875 812.1875000000001 257.5625 812.1875000000001 257.5625S1000 172.1875 1000 7.5625z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22organization-outline%22%0D      unicode%3D%22%26%23xF037%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M296.875 510.43C331.055 470.390625 380.859375 445 437.5 445C494.140625 445 543.945 470.390625 578.125 510.43C599.609375 471.3675 640.625 445 687.5 445C756.8375000000001 445 812.5 500.66375 812.5 570C812.5 639.33625 756.8375000000001 695 687.5 695C662.1125 695 639.6500000000001 687.1875 620.1175 674.4925C600.58625 757.5 526.3675 820 437.5 820C348.6325 820 274.41375 757.5 254.8825 674.4925C235.35125 687.1875 212.890625 695 187.5 695C118.16375 695 62.5 639.33625 62.5 570C62.5 500.66375 118.16375 445 187.5 445C234.375 445 275.390625 471.3675 296.875 510.43zM622.07 605.15625C634.7625 628.59375 659.1812500000001 645.195 687.5 645.195C728.5125 645.195 762.6937499999999 611.015625 762.6937499999999 570C762.6937499999999 528.984375 728.5125 494.805 687.5 494.805C646.4875 494.805 614.2575 528.0074999999999 613.28125 568.046875C617.1875 579.765625 620.1175 592.46125 622.07 605.15625zM437.5 758.4765625C506.83625 758.4765625 563.47625 701.8362500000001 563.47625 632.5C563.47625 563.1637499999999 506.83625 506.52375 437.5 506.52375C368.16375 506.52375 311.52375 563.1637499999999 311.52375 632.5C311.52375 701.8362500000001 368.16375 758.4765625 437.5 758.4765625zM187.5 494.805C146.484375 494.805 112.305 528.984375 112.305 570C112.305 611.015625 146.484375 645.195 187.5 645.195C215.82 645.195 240.234375 628.59375 252.93 605.15625C254.8825 592.46125 257.8125 579.765625 261.71875 568.046875C260.7425 528.0074999999999 228.515625 494.805 187.5 494.805zM812.5 445H62.5C28.3203125 445 0 416.68 0 382.5V195C0 160.8187499999999 28.3203125 132.5 62.5 132.5V7.5C62.5 -26.6812500000001 90.82 -55 125 -55H187.5C221.68 -55 250 -26.6812500000001 250 7.5V70H312.5V-117.5C312.5 -151.6812500000001 340.82 -180 375 -180H500C534.18 -180 562.5 -151.6812500000001 562.5 -117.5V70H625V7.5C625 -26.6812500000001 653.3187499999999 -55 687.5 -55H750C784.1812500000001 -55 812.5 -26.6812500000001 812.5 7.5V132.5C846.6812500000001 132.5 875 160.8187499999999 875 195V382.5C875 416.68 846.6812500000001 445 812.5 445zM187.5 7.5H125V195H62.5V382.5H187.5V7.5zM625 132.5H562.5V257.5H500V-117.5H375V257.5H312.5V132.5H250V382.5H625V132.5zM812.5 195H750V7.5H687.5V382.5H812.5V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22package%22%0D      unicode%3D%22%26%23xF0C4%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M62.5 553.125V86.2500000000001C62.5 58.1250000000001 81.25 33.7500000000001 109.375 25.6250000000001L515.625 -82.5C525.625 -85.625 536.875 -85.625 546.875 -82.5L953.125 25.6250000000001C981.25 33.7500000000001 1000 58.125 1000 86.2500000000001V553.125C1000 581.25 981.25 605.625 953.125 613.75L546.875 722.5A87.5 87.5 0 0 1 515.625 722.5L109.375 613.75C81.25 605.625 62.5 581.25 62.5 553.125zM500 -15L125 84.375V507.5L500 406.875V-15zM125 570L281.25 611.875L687.5 503.75L531.25 461.8750000000001L125 570zM937.5 84.375L562.5 -15V406.875L687.5 441.25V288.75L812.5 321.875V474.375L937.5 507.5V84.375zM812.5 536.875L406.25 645L531.25 678.125L937.5 570L812.5 536.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22paintcan%22%0D      unicode%3D%22%26%23xF0D1%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 820C168.125 820 0 651.875 0 445V382.5C0 348.125 28.125 320 62.5 320V7.5C62.5 -61.25 202.5 -117.5 375 -117.5S687.5 -61.25 687.5 7.5V320C721.875 320 750 348.125 750 382.5V445C750 651.875 581.875 820 375 820zM562.5 195V163.75C562.5 146.25 548.75 132.5 531.25 132.5S500 146.25 500 163.75V195C500 212.5 486.25 226.25 468.75 226.25S437.5 212.5 437.5 195V38.75C437.5 21.25 423.75 7.5 406.25 7.5S375 21.25 375 38.75V163.75C375 181.25 361.25 195 343.75 195S312.5 181.25 312.5 163.75V132.5C312.5 98.125 284.375 70 250 70S187.5 98.125 187.5 132.5V195C153.125 195 125 223.125 125 257.5V370C181.875 339.375 272.5 320 375 320C477.5 320 568.125 339.375 625 370V257.5C625 223.125 596.875 195 562.5 195zM375 382.5C270 382.5 180 408.125 143.125 445C180 481.875 270 507.5 375 507.5C480 507.5 570.0000000000001 481.875 606.875 445C570.0000000000001 408.125 480.0000000000001 382.5 375.0000000000001 382.5zM375 570C202.5 570 62.5 514.375 62.5 445C62.5 617.5 202.5 757.5 375 757.5S687.5 617.5 687.5 445C687.5 513.75 547.5 570 375 570z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22pencil%22%0D      unicode%3D%22%26%23xF058%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M0 70V-117.5H187.5L687.5 382.5L500 570L0 70zM187.5 -55H62.5V70H125V7.5H187.5V-55zM831.25 526.25L750 445L562.5 632.5L643.75 713.75A62.25000000000001 62.25000000000001 0 0 0 731.875 713.75L831.25 614.375C855.6250000000001 590 855.6250000000001 550.625 831.25 526.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22person-filled%22%0D      unicode%3D%22%26%23x26A3%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M750 -55.125A62.37500000000001 62.37500000000001 0 0 0 687.625 -117.5H62.5625A62.5 62.5 0 0 0 0 -54.9375V7.5C0 172.0625 250 257.5 250 257.5S264.3125 283.0625 250 320C197.4375 358.75 191 419.375 187.5 570C198.3125 720.8125 304.1875 757.5 375 757.5S551.6875 720.875 562.5 570C559 419.375 552.5625 358.75 500 320C485.6875 283.125 500 257.5 500 257.5S750 172.0625 750 7.5V-55.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22person-outline%22%0D      unicode%3D%22%26%23xF018%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M437.5 445H62.5C28.3203125 445 0 416.68 0 382.5V70H125V-117.5C125 -151.6812500000001 153.32 -180 187.5 -180H312.5C346.68 -180 375 -151.6812500000001 375 -117.5V70H500V382.5C500 416.68 471.68 445 437.5 445zM437.5 132.5H375V257.5H312.5V-117.5H187.5V257.5H125V132.5H62.5V382.5H437.5V132.5zM437.5 632.5C437.5 736.015625 353.515625 820 250 820C146.484375 820 62.5 736.015625 62.5 632.5C62.5 528.984375 146.484375 445 250 445C353.515625 445 437.5 528.984375 437.5 632.5zM250 507.5C180.66375 507.5 125 563.1637499999999 125 632.5C125 701.8362500000001 180.66375 757.5 250 757.5C319.33625 757.5 375 701.8362500000001 375 632.5C375 563.1637499999999 319.33625 507.5 250 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22pin%22%0D      unicode%3D%22%26%23xF041%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M625 745V695L656.25 632.5L375 445H137.5C110 445 95.625 411.875 116.25 391.25L312.5 195L62.5 -117.5L375 132.5L571.25 -63.75A31.25 31.25 0 0 1 625 -42.5V195L812.5 476.25L875 445H925C952.5 445 966.875 478.125 946.25 498.75L678.75 766.25A31.25 31.25 0 0 1 625 745z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22play%22%0D      unicode%3D%22%26%23xF107%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M875 320A437.49999999999994 437.49999999999994 0 1 0 0 320A437.49999999999994 437.49999999999994 0 0 0 875 320zM361.0625 102.375L648.5 294A31.25 31.25 0 0 1 648.5 346L361.0625 537.625A31.25 31.25 0 0 1 312.5 511.625V128.3750000000001A31.25 31.25 0 0 1 361.0625 102.375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22plug%22%0D      unicode%3D%22%26%23xF0D4%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M875 445V507.5H625V632.5H500V570H375C310.625 570 264.375 519.375 250 445L187.5 382.5C83.75 382.5 0 298.75 0 195V70H62.5V195C62.5 264.375 118.125 320 187.5 320L250 257.5C265.625 185 311.25 132.5 375 132.5H500V70H625V195H875V257.5H625V445H875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22plus%22%0D      unicode%3D%22%26%23xF05D%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M750 257.5H437.5V-55H312.5V257.5H0V382.5H312.5V695H437.5V382.5H750V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22primitive-dot%22%0D      unicode%3D%22%26%23xF052%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M0 320C0 457.5 112.5 570 250 570S500 457.5 500 320S387.5 70 250 70S0 182.5 0 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22primitive-square%22%0D      unicode%3D%22%26%23xF053%3B%22%0D      horiz-adv-x%3D%22500%22 d%3D%22 M500 70H0V570H500V70z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22project%22%0D      unicode%3D%22%26%23xF28B%3B%22%0D      horiz-adv-x%3D%22937.5%22 d%3D%22 M375 695H562.5V195H375z M125 695H312.5V-55H125z M625 695H812.5V70H625z M875 820H62.5C25 820 0 795 0 757.5V-117.5C0 -155 25 -180 62.5 -180H875C912.5 -180 937.5 -155 937.5 -117.5V757.5C937.5 795 912.5 820 875 820zM875 -117.5H62.5V757.5H875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22pulse%22%0D      unicode%3D%22%26%23xF085%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M718.75 320L550 482.5L412.5 288.75L343.75 720L148.75 320H0V195H225L281.25 307.5L337.5 -30L562.5 288.75L662.5 195H875V320H718.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22question%22%0D      unicode%3D%22%26%23xF02C%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M375 195H500V70H375V195zM625 413.75C625 280 500 257.5 500 257.5H375C375 291.875 403.125 320 437.5 320H468.75C486.25 320 500 333.75 500 351.25V413.75C500 431.25 486.25 445 468.75 445H406.25C388.75 445 375 431.25 375 413.75V382.5H250C250 476.25 343.75 570 437.5 570S625 507.5 625 413.75zM437.5 676.25C633.75 676.25 793.75 516.25 793.75 320S633.7499999999999 -36.25 437.5 -36.25A356.87500000000006 356.87500000000006 0 0 0 81.25 320C81.25 516.25 241.2500000000001 676.25 437.5 676.25zM437.5 757.5C196.25 757.5 0 561.25 0 320S196.25 -117.5 437.5 -117.5S875 78.75 875 320S678.75 757.5 437.5 757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22quote%22%0D      unicode%3D%22%26%23xF063%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M385 601.25C233.125 503.75 159.375 403.125 159.375 235C169.375 238.1250000000001 178.125 238.1250000000001 186.875 238.1250000000001C266.25 238.1250000000001 343.125 184.3750000000001 343.125 87.5000000000001C343.125 -13.1249999999999 278.75 -75.6249999999999 186.875 -75.6249999999999C68.125 -75.6249999999999 0 19.3750000000001 0 190.0000000000001C0 427.5000000000001 109.375 598.1250000000001 313.75 716.2500000000001L385 601.25zM822.5 601.25C670.625 503.7499999999999 596.875 403.125 596.875 235C606.875 238.1250000000001 615.6250000000001 238.1250000000001 624.375 238.1250000000001C703.75 238.1250000000001 780.625 184.3750000000001 780.625 87.5000000000001C780.625 -13.1249999999999 716.25 -75.6249999999999 624.375 -75.6249999999999C506.25 -75.6249999999999 438.125 19.3750000000001 438.125 190.0000000000001C438.125 427.5000000000001 547.5 598.1250000000001 751.875 716.2500000000001L823.125 601.2500000000001H822.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22radio-tower%22%0D      unicode%3D%22%26%23xF030%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M299.375 438.125C315 453.75 315 480 299.375 495.625C279.375 516.25 269.3750000000001 543.125 269.3750000000001 570C269.3750000000001 596.875 279.3750000000001 623.75 299.3750000000001 644.375C315.0000000000001 660.625 315.0000000000001 686.25 299.3750000000001 701.875A38.3125 38.3125 0 0 1 271.2500000000001 713.75C261.2500000000001 713.75 250.6250000000001 710 243.1250000000001 701.875C207.5000000000001 665.625 190 617.5 190 570C190 522.5 208.125 474.375 243.1250000000001 438.1250000000001C258.7500000000001 422.5000000000001 284.3750000000001 422.5000000000001 299.3750000000001 438.1250000000001zM145.625 787.5A40.6875 40.6875 0 0 1 88.125 787.5C30 727.5 0.625 648.75 0.625 570.625C0.625 491.875 30 413.125 88.125 353.125C103.75 336.875 129.375 336.875 145 353.125S160.625 395.625 145 411.875C102.5 455.6249999999999 81.25 513.125 81.25 570.625C81.25 628.1249999999999 102.5 685.6249999999999 145 729.3749999999999A41.25 41.25 0 0 1 145.625 787.4999999999999zM501.25 468.7500000000001A101.25 101.25 0 1 1 400 570C399.3750000000001 514.375 445 468.75 501.25 468.75zM911.875 786.875A39.25 39.25 0 0 1 855 786.875C839.375 770.625 839.375 744.375 855 728.125C897.5 684.375 918.75 626.875 918.75 569.375C918.75 511.875 897.5 455 855 410.625C839.375 394.375 839.375 368.1250000000001 855 351.875A40.6875 40.6875 0 0 1 912.5 351.875C970.625 411.875 1000 490.625 1000 569.375A315.5 315.5 0 0 1 911.875 786.875zM501.25 387.5C475.6249999999999 387.5 449.375 393.75 426.25 406.25L229.375 -116.8749999999999H322.5L376.25 -54.3749999999999H626.25L678.75 -116.8749999999999H771.875L575.625 406.25C551.875 393.75 526.8750000000001 387.5 501.2500000000001 387.5zM500.625 357.5L563.75 132.5H438.75L500.625 357.5zM376.25 8.125L438.75 70.625H563.75L626.25 8.125H376.25zM700.625 701.875C685 686.25 685 660 700.625 644.375C720.6250000000001 623.75 730.6250000000001 596.875 730.6250000000001 570C730.6250000000001 543.125 720.6250000000001 516.25 700.625 495.6250000000001C685 479.3750000000001 685 453.7500000000001 700.625 438.1250000000001A39.375 39.375 0 0 1 756.8750000000001 438.1250000000001C792.5000000000001 474.3750000000001 810 522.5 810 570C810 617.5 792.5000000000001 665.625 756.8750000000001 701.875A39.625 39.625 0 0 1 700.625 701.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22reply%22%0D      unicode%3D%22%26%23xF28C%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M375 601.25C620 573.75 875 405.9375 875 -23.75C730.5 292.6250000000001 578.125 351.25 375 351.25V132.5L31.25 476.25L375 820V601.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo-clone%22%0D      unicode%3D%22%26%23xF04C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M937.5 820H562.5V382.5C562.5 348.125 590.625 320 625 320H687.5V257.5H750V320H937.5C971.875 320 1000 348.125 1000 382.5V757.5C1000 791.875 971.875 820 937.5 820zM687.5 382.5H625V445H687.5V382.5zM937.5 382.5H750V445H937.5V382.5zM937.5 507.5H687.5V757.5H937.5V507.5zM250 507.5H187.5V570H250V507.5zM250 632.5H187.5V695H250V632.5zM125 757.5H500V820H62.5C28.125 820 0 791.875 0 757.5V7.5C0 -26.875 28.125 -55 62.5 -55H187.5V-180L281.25 -86.25L375 -180V-55H687.5C721.875 -55 750 -26.875 750 7.5V195H125V757.5zM687.5 132.5V7.5H375V70H187.5V7.5H62.5V132.5H687.5zM187.5 320H250V257.5H187.5V320zM250 382.5H187.5V445H250V382.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo-force-push%22%0D      unicode%3D%22%26%23xF04A%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M625 257.5H500V-180H375V257.5H250L390.625 445H250L437.5 695L625 445H484.375L625 257.5zM687.5 820H62.5C28.125 820 0 791.875 0 757.5V7.5C0 -26.875 28.125 -55 62.5 -55H312.5V7.5H62.5V132.5H312.5V195H125V757.5H687.5V195H562.5V132.5H687.5V7.5H562.5V-55H687.5C721.875 -55 750 -26.875 750 7.5V757.5C750 791.875 721.875 820 687.5 820z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo-forked%22%0D      unicode%3D%22%26%23xF002%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M500 757.5A124.56250000000001 124.56250000000001 0 0 1 437.5 525V445L312.5 320L187.5 445V525A124.56250000000001 124.56250000000001 0 0 1 125 757.5A124.56250000000001 124.56250000000001 0 0 1 62.5 525V413.75L250 226.25V115A124.56250000000001 124.56250000000001 0 0 1 312.5 -117.5A124.56250000000001 124.56250000000001 0 0 1 375 115V226.25L562.5 413.75V525A124.56250000000001 124.56250000000001 0 0 1 500 757.5zM125 557.5C83.75 557.5 50 591.875 50 632.5C50 673.125 84.375 707.5 125 707.5C165.625 707.5 200 673.125 200 632.5C200 591.875 165.625 557.5 125 557.5zM312.5 -67.5C271.25 -67.5 237.5 -33.1249999999999 237.5 7.5C237.5 48.125 271.875 82.5 312.5 82.5C353.125 82.5 387.5 48.1249999999999 387.5 7.5C387.5 -33.125 353.125 -67.5 312.5 -67.5zM500 557.5C458.75 557.5 425 591.875 425 632.5C425 673.125 459.375 707.5 500 707.5C540.625 707.5 575 673.125 575 632.5C575 591.875 540.6249999999999 557.5 499.9999999999999 557.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo-pull%22%0D      unicode%3D%22%26%23xF006%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M812.5 320V445H437.5V570H812.5V695L1000 507.5L812.5 320zM250 695H187.5V632.5H250V695zM687.5 382.5H750V7.5C750 -26.875 721.875 -55 687.5 -55H375V-180L281.25 -86.25L187.5 -180V-55H62.5C28.125 -55 0 -26.875 0 7.5V757.5C0 791.875 28.125 820 62.5 820H687.5C721.875 820 750 791.875 750 757.5V632.5H687.5V757.5H125V195H687.5V382.5zM687.5 132.5H62.5V7.5H187.5V70H375V7.5H687.5V132.5zM250 445H187.5V382.5H250V445zM250 570H187.5V507.5H250V570zM187.5 257.5H250V320H187.5V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo-push%22%0D      unicode%3D%22%26%23xF005%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M250 632.5H187.5V695H250V632.5zM187.5 507.5H250V570H187.5V507.5zM437.5 507.5L250 257.5H375V-180H500V257.5H625L437.5 507.5zM687.5 820H62.5C28.125 820 0 791.875 0 757.5V7.5C0 -26.875 28.125 -55 62.5 -55H312.5V7.5H62.5V132.5H312.5V195H125V757.5H688.75L687.5 195H562.5V132.5H687.5V7.5H562.5V-55H687.5C721.875 -55 750 -26.875 750 7.5V757.5C750 791.875 721.875 820 687.5 820z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22repo%22%0D      unicode%3D%22%26%23xF001%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M250 257.5H187.5V320H250V257.5zM250 445H187.5V382.5H250V445zM250 570H187.5V507.5H250V570zM250 695H187.5V632.5H250V695zM750 757.5V7.5C750 -26.875 721.875 -55 687.5 -55H375V-180L281.25 -86.25L187.5 -180V-55H62.5C28.125 -55 0 -26.875 0 7.5V757.5C0 791.875 28.125 820 62.5 820H687.5C721.875 820 750 791.875 750 757.5zM687.5 132.5H62.5V7.5H187.5V70H375V7.5H687.5V132.5zM687.5 757.5H125V195H687.5V757.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22report%22%0D      unicode%3D%22%26%23xF28D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M437.5 320H562.5V195H437.5z M437.5 632.5H562.5V382.5H437.5z M937.5 757.5H62.5C25 757.5 0 732.5 0 695V132.5C0 95 25 70 62.5 70H187.5V-180L437.5 70H937.5C975 70 1000 95 1000 132.5V695C1000 732.5 975 757.5 937.5 757.5zM937.5 132.5H406.25L250 -23.75V132.5H62.5V695H937.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22request-changes%22%0D      unicode%3D%22%26%23xF108%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M0 757.5A62.5 62.5 0 0 0 62.5 820H937.5A62.5 62.5 0 0 0 1000 757.5V132.5A62.5 62.5 0 0 0 937.5 70H468.75L250 -148.75V70H62.5A62.5 62.5 0 0 0 0 132.5V757.5zM62.5 757.5V132.5H312.5V7.5L437.5 132.5H937.5V757.5H62.5zM531.25 570H656.25V507.5H531.25V382.5H468.75V507.5H343.75V570H468.75V695H531.25V570zM656.25 257.5H343.75V320H656.25V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22rocket%22%0D      unicode%3D%22%26%23xF033%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M760.625 580.625C743.75 597.5 731.25 615 721.25 635.625C711.2499999999999 655 704.375 676.875 700 699.375C663.75 678.75 627.5 655.625 591.8749999999999 628.75C555.6249999999999 601.25 520.6249999999999 570 486.2499999999999 536.25C442.5 492.5 403.125 423.125 375 383.125H187.5L0 195H187.5L312.5 320C291.25 271.875 248.75 133.75 250 132.5L312.5 70C313.75 68.75 451.875 110 500 132.5L375 7.5V-180L562.5 7.5V195C602.5 223.125 671.875 263.125 715.625 306.25C750 340.625 781.25 376.875 807.5 412.5C835 448.75 858.125 485 878.75 520C856.2500000000001 525 835.0000000000001 531.875 814.3750000000001 541.25A211.87500000000003 211.87500000000003 0 0 0 760.6250000000001 580.625zM1000 820S994.375 796.25 981.25 753.75C968.75 710 946.8749999999998 655 914.9999999999998 587.5C871.25 592.5 835.625 608.125 811.2499999999999 632.5C786.8749999999999 656.875 771.8749999999999 691.25 767.5 735C835 767.5 889.375 790 932.5 802.5C976.25 815 1000 820 1000 820z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22rss%22%0D      unicode%3D%22%26%23xF034%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M125 7.5H0V132.5C69.375 132.5 125 76.875 125 7.5zM0 632.5V570A562.5 562.5 0 0 0 562.5 7.5H625C625 352.5 345 632.5 0 632.5zM0 382.5V320C171.875 320 312.5 179.375 312.5 7.5H375C375 214.375 206.875 382.5 0 382.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22ruby%22%0D      unicode%3D%22%26%23xF047%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M812.5 445L500 132.5V570H687.5L812.5 445zM1000 445L500 -55L0 445L250 695H750L1000 445zM500 38.75L906.25 445L718.75 632.5H281.25L93.75 445L500 38.75z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22screen-full%22%0D      unicode%3D%22%26%23xF066%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 195H875V7.5C875 -26.6875 846.6875 -55 812.5 -55H625V7.5H812.5V195zM62.5 195H0V7.5C0 -26.6875 28.3125 -55 62.5 -55H250V7.5H62.5V195zM62.5 632.5H250V695H62.5C28.3125 695 0 666.6875 0 632.5V445H62.5V632.5zM125 570H750V70H125V570zM250 195H625V445H250V195zM625 695V632.5H812.5V445H875V632.5C875 666.6875 846.6875 695 812.5 695H625z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22screen-normal%22%0D      unicode%3D%22%26%23xF067%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M125 570H0V632.5H125V757.5H187.5V632.5C187.5 598.3125 159.1875 570 125 570zM125 70H0V7.5H125V-117.5H187.5V7.5C187.5 41.6875 159.1875 70 125 70zM687.5 195C687.5 160.8125 659.1875 132.5 625 132.5H250C215.8125 132.5 187.5 160.8125 187.5 195V445C187.5 479.1875 215.8125 507.5 250 507.5H625C659.1875 507.5 687.5 479.1875 687.5 445V195zM562.5 382.5H312.5V257.5H562.5V382.5zM687.5 7.5V-117.5H750V7.5H875V70H750C715.8125 70 687.5 41.6875 687.5 7.5zM750 632.5V757.5H687.5V632.5C687.5 598.3125 715.8125 570 750 570H875V632.5H750z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22search%22%0D      unicode%3D%22%26%23xF02E%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M981.25 -11.25L743.1249999999999 228.125A370.62499999999994 370.62499999999994 0 0 1 812.5 445C812.5 651.875 644.375 820 437.5 820S62.5 651.875 62.5 445S230.625 70 437.5 70C518.75 70 592.5 95.625 654.375 139.375L893.75 -98.7500000000001C905.625 -111.25 921.875 -117.5000000000001 937.5 -117.5000000000001C953.125 -117.5000000000001 970 -111.8750000000001 981.25 -98.7500000000001A62.25000000000001 62.25000000000001 0 0 1 981.25 -10.6250000000001V-11.25zM437.5 151.25C275.625 151.25 143.75 283.125 143.75 445.0000000000001C143.75 606.875 275.625 738.7500000000001 437.5 738.7500000000001C599.375 738.7500000000001 731.25 606.8750000000001 731.25 445.0000000000001C731.25 283.125 599.375 151.25 437.5 151.25z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22server%22%0D      unicode%3D%22%26%23xF097%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M687.5 445H62.5C28.125 445 0 416.875 0 382.5V257.5C0 223.125 28.125 195 62.5 195H687.5C721.875 195 750 223.125 750 257.5V382.5C750 416.875 721.875 445 687.5 445zM125 257.5H62.5V382.5H125V257.5zM250 257.5H187.5V382.5H250V257.5zM375 257.5H312.5V382.5H375V257.5zM500 257.5H437.5V382.5H500V257.5zM687.5 757.5H62.5C28.125 757.5 0 729.375 0 695V570C0 535.625 28.125 507.5 62.5 507.5H687.5C721.875 507.5 750 535.625 750 570V695C750 729.375 721.875 757.5 687.5 757.5zM125 570H62.5V695H125V570zM250 570H187.5V695H250V570zM375 570H312.5V695H375V570zM500 570H437.5V695H500V570zM687.5 632.5H625V695H687.5V632.5zM687.5 132.5H62.5C28.125 132.5 0 104.375 0 70V-55C0 -89.375 28.125 -117.5 62.5 -117.5H687.5C721.875 -117.5 750 -89.375 750 -55V70C750 104.375 721.875 132.5 687.5 132.5zM125 -55H62.5V70H125V-55zM250 -55H187.5V70H250V-55zM375 -55H312.5V70H375V-55zM500 -55H437.5V70H500V-55z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22settings%22%0D      unicode%3D%22%26%23xF07C%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M250 382.5H187.5V695H250V382.5zM187.5 -55H250V132.5H187.5V-55zM500 -55H562.5V320H500V-55zM812.5 -55H875V70H812.5V-55zM875 695H812.5V320H875V695zM562.5 695H500V570H562.5V695zM312.5 320H125C90.625 320 62.5 291.875 62.5 257.5S90.625 195 125 195H312.5C346.875 195 375 223.125 375 257.5S346.875 320 312.5 320zM625 507.5H437.5C403.125 507.5 375 479.375 375 445S403.125 382.5 437.5 382.5H625C659.375 382.5 687.5 410.625 687.5 445S659.375 507.5 625 507.5zM937.5 257.5H750C715.625 257.5 687.5 229.375 687.5 195S715.625 132.5 750 132.5H937.5C971.875 132.5 1000 160.625 1000 195S971.875 257.5 937.5 257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22shield%22%0D      unicode%3D%22%26%23xF0E1%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 820L0 695V318.75C0 26.875 331.875 -180 437.5 -180C543.125 -180 875 26.875 875 318.75V695L437.5 820zM312.5 132.5L383.75 307.5A35.5 35.5 0 0 1 368.125 344.3750000000001C333.125 366.875 312.5 403.75 312.5 445C312.5 513.125 368.125 570 436.25 570C503.7500000000001 570 562.5 513.125 562.5 445C562.5 403.75 541.875 366.875 506.8749999999999 344.375C494.9999999999999 336.25 488.125 321.875 491.2499999999999 307.4999999999999L562.5 132.5H312.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22sign-in%22%0D      unicode%3D%22%26%23xF036%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 398.125V70H687.5V320H750V70C750 35.625 721.875 7.5 687.5 7.5H437.5V-180L96.875 -10C76.25 0.625 62.5 22.5 62.5 46.875V757.5C62.5 791.875 90.625 820 125 820H687.5C721.875 820 750 791.875 750 757.5V570H687.5V757.5H187.5L437.5 632.5V491.875L625 632.5V507.5H875V382.5H625V257.5L437.5 398.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22sign-out%22%0D      unicode%3D%22%26%23xF032%3B%22%0D      horiz-adv-x%3D%22941.1764705882352%22 d%3D%22 M705.8823529411765 290.5882352941177V408.2352941176471H470.5882352941176V525.8823529411765H705.8823529411765V643.5294117647059L941.1764705882352 467.0588235294118L705.8823529411765 290.5882352941177zM588.2352941176471 114.1176470588235H352.9411764705883V643.5294117647059L117.6470588235294 761.1764705882352H588.2352941176471V584.7058823529412H647.0588235294117V761.1764705882352C647.0588235294117 793.5294117647059 620.5882352941177 820 588.2352941176471 820H58.8235294117647C26.4705882352941 820 0 793.5294117647059 0 761.1764705882352V91.7647058823529C0 68.8235294117646 12.9411764705882 48.8235294117646 32.3529411764706 38.2352941176471L352.9411764705883 -121.764705882353V55.2941176470589H588.2352941176471C620.5882352941177 55.2941176470589 647.0588235294117 81.7647058823529 647.0588235294117 114.1176470588235V349.4117647058824H588.2352941176471V114.1176470588235z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22smiley%22%0D      unicode%3D%22%26%23xF27D%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M500 820C223.75 820 0 596.25 0 320S223.75 -180 500 -180S1000 43.75 1000 320S776.25 820 500 820zM800.6249999999999 19.375A419.99999999999994 419.99999999999994 0 0 0 664.9999999999999 -71.25C613.1249999999999 -93.75 557.4999999999999 -104.375 499.9999999999999 -104.375C442.4999999999999 -104.375 386.8749999999999 -93.75 334.9999999999999 -71.25C284.3749999999999 -50 238.1249999999999 -19.375 199.3749999999999 19.375A423.31249999999994 423.31249999999994 0 0 0 108.7499999999999 155A411.875 411.875 0 0 0 75.625 320C75.625 377.5 86.25 433.1250000000001 108.75 485.0000000000001C130 535.625 160.625 581.875 199.375 620.625C238.125 659.375 284.375 690 335 711.25A411.875 411.875 0 0 0 500 744.375C557.5 744.375 613.125 733.75 665 711.25C715.6250000000001 690 761.8750000000001 659.375 800.625 620.625C839.375 581.875 870 535.625 891.25 485.0000000000001C913.75 433.1250000000001 924.375 377.5000000000001 924.375 320C924.375 262.5 913.75 206.875 891.25 155C870 104.3749999999999 839.375 58.1249999999999 800.625 19.375zM250 395V431.875C250 473.125 283.125 506.25 325 506.25H361.875C403.125 506.25 436.25 473.125 436.25 431.8750000000001V395.0000000000001C436.25 353.1250000000001 403.125 320.0000000000001 361.8750000000001 320.0000000000001H325C283.125 320 250 353.125 250 395zM562.5 395V431.875C562.5 473.125 595.625 506.25 637.5 506.25H674.375C715.625 506.25 748.7499999999999 473.125 748.7499999999999 431.8750000000001V395.0000000000001C748.7499999999999 353.1250000000001 715.625 320.0000000000001 674.375 320.0000000000001H637.5C595.625 320 562.5 353.125 562.5 395zM812.5 195C767.5 77.5000000000001 630.625 7.5 500 7.5S232.5 78.1249999999999 187.5 195C178.75 219.375 201.875 257.5 228.75 257.5H765.625C791.25 257.5 821.25 219.375 812.5 195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22squirrel%22%0D      unicode%3D%22%26%23xF0B2%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M750 757.5C611.875 757.5 500 675.625 500 575C500 453.7500000000001 531.25 385.6250000000001 500 195C500 476.25 326.875 591.25 250 591.25C253.125 622.5 220 632.5 220 632.5S206.25 625.625 201.25 611.25C184.375 630.625 166.25 628.125 166.25 628.125L158.125 591.875S43.75 551.875 42.5 390.625C55 370 138.125 353.125 196.875 363.75C252.5 360.625 238.7500000000001 314.375 226.25 301.875C173.75 249.375 125 320 62.5 320S0 257.5 62.5 257.5S125 195 250 195C56.875 120 250 -55 250 -55H187.5C125 -55 125 -117.5 125 -117.5H500C687.5 -117.5 812.5 -55 812.5 99.375C812.5 152.5 785.625 211.2500000000001 750 257.5C680.625 348.75 764.375 425 812.5 382.5C860.625 340 1000 320 1000 507.5C1000 645.625 888.125 757.5 750 757.5zM156.25 445C138.75 445 125 458.75 125 476.25S138.75 507.5 156.25 507.5S187.5 493.75 187.5 476.25S173.75 445 156.25 445z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22star%22%0D      unicode%3D%22%26%23xF02A%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M875 445L568.75 485L437.5 757.5L306.25 485L0 445L225 241.25L166.875 -55L437.5 90.625L708.125 -55L650 241.25L875 445z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22stop%22%0D      unicode%3D%22%26%23xF08F%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M625 757.5H250L0 507.5V132.5L250 -117.5H625L875 132.5V507.5L625 757.5zM812.5 163.75L593.75 -55H281.25L62.5 163.75V476.25L281.25 695H593.75L812.5 476.25V163.75zM375 570H500V257.5H375V570zM375 195H500V70H375V195z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22sync%22%0D      unicode%3D%22%26%23xF087%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M640 357.5A259.37500000000006 259.37500000000006 0 0 0 565.0000000000001 132.5A271.625 271.625 0 0 0 226.8750000000001 98.75L300 170L31.25 207.5L68.75 -55L150.625 23.75C298.125 -85 506.8749999999999 -74.375 640.625 57.5A367.25 367.25 0 0 1 749.375 336.2500000000001L640 357.5000000000001zM185 507.5A271.625 271.625 0 0 0 523.1250000000001 541.25L450 470L718.75 432.5000000000001L681.25 695L599.375 616.25C451.875 725.0000000000001 243.125 714.3750000000001 108.75 582.5C31.25 505.625 -3.75 404.375 0.625 303.75L110 281.875A260.625 260.625 0 0 0 185 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22tag%22%0D      unicode%3D%22%26%23xF015%3B%22%0D      horiz-adv-x%3D%22937.5%22 d%3D%22 M483.125 711.875C453.75 741.25 413.75 757.5 372.5 757.5H218.75C133.125 757.5 62.5 686.875 62.5 601.25V446.875C62.5 405.625 79.375 365.625 108.125 336.25L486.8749999999999 -42.5C511.25 -66.8750000000001 550.6249999999999 -66.8750000000001 575 -42.5L861.875 244.375A62.25000000000001 62.25000000000001 0 0 1 861.875 332.5L483.125 711.875zM148.75 376.875C129.375 395.625 119.375 420.625 119.375 447.5V601.25C119.375 656.25 164.375 700.625 218.75 700.625H373.1250000000001C399.3750000000001 700.625 425.0000000000001 690.625 443.7500000000001 671.25L827.5 288.125L531.875 -7.5L148.75 376.875zM188.125 632.5H313.125V507.5H187.5V632.5H188.125z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22tasklist%22%0D      unicode%3D%22%26%23xF27E%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M963.125 257.5H474.375C437.5 257.5 437.5 283.125 437.5 320C437.5 356.875 437.5 382.5 474.375 382.5H962.4999999999998C999.3749999999998 382.5 999.3749999999998 356.875 999.3749999999998 320C999.3749999999998 283.125 999.3749999999998 257.5 962.4999999999998 257.5H963.1249999999998zM599.375 570C562.5 570 562.5 595.625 562.5 632.5C562.5 669.375 562.5 695 599.375 695H962.4999999999998C999.3749999999998 695 999.3749999999998 669.375 999.3749999999998 632.5C999.3749999999998 595.625 999.3749999999998 570 962.4999999999998 570H599.375zM0 575.625L88.125 656.875L187.5 557.5L443.125 820L531.25 731.875L187.5 388.125L0 575.625zM474.375 70H962.4999999999998C999.3749999999998 70 999.3749999999998 44.375 999.3749999999998 7.5C999.3749999999998 -29.375 999.3749999999998 -55 962.4999999999998 -55H474.375C437.5 -55 437.5 -29.375 437.5 7.5C437.5 44.375 437.5 70 474.375 70z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22telescope%22%0D      unicode%3D%22%26%23xF088%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M500 257.5L687.5 -117.5H625L500 132.5V-180H437.5V195L312.5 -117.5H250L375 195L500 257.5zM437.5 820H375V757.5H437.5V820zM312.5 632.5H250V570H312.5V632.5zM125 757.5H62.5V695H125V757.5zM39.375 257.5A32.5 32.5 0 0 1 29.375 215.625L63.75 158.125C71.875 143.75 89.375 138.75 103.75 145.625L190.625 186.8750000000001L118.125 311.8750000000001L38.75 258.1250000000001L39.375 257.5000000000001zM532.5 594.375L170 347.5L246.875 213.75L642.5000000000001 403.125L531.8750000000001 594.375H532.5000000000001zM796.2499999999999 514.375L704.3749999999999 671.875A31.875 31.875 0 0 1 659.3749999999998 682.5L584.3749999999999 630.625L699.3749999999999 430.625L782.4999999999999 470.6249999999999C799.3749999999999 478.7499999999999 804.9999999999998 498.125 796.2499999999999 514.375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22terminal%22%0D      unicode%3D%22%26%23xF0C8%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M437.5 195H687.5V132.5H437.5V195zM250 132.5L437.5 320L250 507.5L203.125 460.625L343.75 320L203.125 179.375L250 132.5zM875 632.5V7.5C875 -26.875 846.875 -55 812.5 -55H62.5C28.125 -55 0 -26.875 0 7.5V632.5C0 666.875 28.125 695 62.5 695H812.5C846.875 695 875 666.875 875 632.5zM812.5 632.5H62.5V7.5H812.5V632.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22text-size%22%0D      unicode%3D%22%26%23xF27F%3B%22%0D      horiz-adv-x%3D%221125%22 d%3D%22 M851.25 252.5L756.25 591.25H752.5L658.75 252.5H851.25zM356.25 186.875S292.5 412.5 283.125 443.75H278.125L207.5 186.8750000000001H356.25zM1081.875 -55H941.2499999999998L881.875 148.125H627.5L568.125 -55H427.5L384.375 90.625H179.375L135.625 -55H0L206.25 544.375H362.5L498.125 148.125L678.75 695H836.2499999999999L1082.5 -55H1081.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22three-bars%22%0D      unicode%3D%22%26%23xF05E%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M713.125 257.5H36.875C0 257.5 0 283.125 0 320C0 356.875 0 382.5 36.875 382.5H712.5C749.375 382.5 749.375 356.875 749.375 320C749.375 283.125 749.375 257.5 712.5 257.5H713.125zM713.125 507.5H36.875C0 507.5 0 533.125 0 570C0 606.875 0 632.5 36.875 632.5H712.5C749.375 632.5 749.375 606.875 749.375 570C749.375 533.125 749.375 507.5 712.5 507.5H713.125zM36.875 132.5H712.5C749.375 132.5 749.375 106.875 749.375 70C749.375 33.125 749.375 7.5 712.5 7.5H36.875C0 7.5 0 33.125 0 70C0 106.875 0 132.5 36.875 132.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22thumbsdown%22%0D      unicode%3D%22%26%23xF0DB%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M998.1176470588234 330.9411764705883L937.5294117647059 702.5882352941176C926.9411764705882 788.7647058823529 820.1176470588235 820 749.5294117647059 820H355.4117647058824A63.52941176470589 63.52941176470589 0 0 1 322.2941176470589 811.2352941176471L232.3529411764707 757.5294117647059H124.9411764705882C58.7058823529412 757.5294117647059 0 698.8235294117648 0 632.5882352941177V382.764705882353C0 316.5882352941177 58.7058823529412 256.5882352941177 124.9411764705882 257.8235294117648H249.8235294117647C306.7058823529412 257.8235294117648 336.6470588235294 229.764705882353 399.1176470588236 161.0588235294118C455.9411764705882 98.5882352941177 454.1176470588235 48.5882352941177 438.5294117647059 -43.2352941176471C433.4705882352941 -74.4117647058823 442.235294117647 -105.6470588235294 464.7058823529412 -131.8823529411766C489.0588235294118 -161.2941176470589 525.8823529411765 -180.0000000000001 562.1764705882352 -180.0000000000001C676.470588235294 -180.0000000000001 749.5294117647059 52.3529411764704 749.5294117647059 133.5294117647058L748.2941176470588 194.7647058823528H875.7058823529411C948.1764705882352 194.7647058823528 997.4705882352941 244.7647058823528 999.3529411764706 317.8235294117646C999.3529411764706 321.5882352941175 1000.6470588235292 325.9411764705881 998.1764705882354 330.2941176470587V330.8823529411763zM875.0588235294117 256.5882352941177H750.7647058823529C707.0588235294117 256.5882352941177 686.470588235294 239.1176470588236 686.470588235294 196.0000000000001L688.235294117647 131.7647058823531C688.235294117647 52.4117647058824 615.1764705882351 -118.1176470588235 563.3529411764705 -118.1176470588235C532.1176470588233 -118.1176470588235 495.8823529411764 -86.8823529411765 500.8823529411764 -55.6470588235294C516.470588235294 43.0588235294117 522.1176470588234 118 445.2941176470588 202.9411764705882C381.5882352941175 273.5294117647058 334.7058823529411 320.3529411764705 249.7647058823529 320.3529411764705V695.0588235294117L354.1176470588235 757.5294117647059H749.470588235294C795.0588235294117 757.5294117647059 871.235294117647 738.1764705882354 874.4117647058823 695.0588235294117L875.5882352941176 693.8823529411765L938.1176470588236 319.0588235294118C936.235294117647 279.0588235294118 914.3529411764706 256.5882352941177 875.6470588235294 256.5882352941177H875.0588235294118z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22thumbsup%22%0D      unicode%3D%22%26%23xF0DA%3B%22%0D      horiz-adv-x%3D%221062.5%22 d%3D%22 M875 -55C871.875 -98.125 795.625 -117.5 750 -117.5H354.375L250 -55V320C335 320 381.875 366.875 445.625 437.5C522.5 522.5 516.875 597.5 500.625 695.625C495.625 726.875 531.875 758.125 563.125 758.125C615 758.125 688.125 587.5 688.125 508.125L686.875 443.75C686.875 400.625 707.5 383.125 750.625 383.125H875.625C915 383.125 936.875 360.625 938.125 320.625L875.625 -54.375L875 -55zM875 445H748.75L750 506.25C750 587.5 676.875 820 562.5 820C526.25 820 489.375 801.25 464.9999999999999 771.875C442.5 746.25 433.75 715 438.75 683.75C454.375 591.25 456.25 541.25 399.375 478.7500000000001C336.875 410.6250000000001 306.875 381.8750000000001 250 381.8750000000001H125C58.75 382.5 0 323.75 0 257.5V7.5C0 -58.75 58.75 -117.5 125 -117.5H232.5L322.5 -171.25C332.5 -176.875 343.125 -180 355 -180H750.625C821.25 -180 928.125 -148.75 938.125 -62.5000000000001L999.375 309.3749999999999C1000.6250000000002 314.3749999999999 1000.6250000000002 318.125 1000.6250000000002 321.8749999999999C998.7500000000002 394.9999999999999 948.1250000000002 444.9999999999999 875.6250000000001 444.9999999999999H875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22tools%22%0D      unicode%3D%22%26%23xF031%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M280 365.625C296.25 349.3750000000001 360.0000000000001 282.5 360.0000000000001 282.5L395 318.75L340 375.6250000000001L445.6250000000001 488.125S398.1250000000001 534.375 418.7500000000001 516.25C438.7500000000001 590.625 420.6250000000001 673.125 364.3750000000001 731.25C308.125 788.75 228.75 807.5 157.5 788.125L278.125 663.125L246.2500000000001 540.625L128.1250000000001 508.125L7.5 633.125C-11.875 559.375 6.25 477.5 62.5 420C121.25 358.75 205.625 341.25 280 365.625zM682.5000000000001 244.3750000000001L536.8750000000001 100.6250000000001L776.8750000000001 -148.1249999999999C796.2500000000001 -168.7499999999999 822.5000000000001 -178.7499999999999 848.1250000000001 -178.7499999999999C873.7500000000001 -178.7499999999999 899.3750000000001 -168.7499999999999 919.3750000000002 -148.1249999999999C958.7500000000002 -107.4999999999999 958.7500000000002 -41.875 919.3750000000002 -1.2499999999999L682.5000000000001 244.3750000000001zM1000 661.875L846.875 820L395.625 353.75L450.625 296.875L181.25 18.1250000000001L119.375 -14.9999999999999L32.5 -156.8749999999998L54.375 -179.9999999999998L191.8750000000001 -89.9999999999998L223.7500000000001 -26.2499999999999L493.75 252.5L548.7500000000001 195.625L1000 661.875z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22trashcan%22%0D      unicode%3D%22%26%23xF0D0%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M687.5 695H562.5C562.5 729.375 534.375 757.5 500 757.5H312.5C278.125 757.5 250 729.375 250 695H125C90.625 695 62.5 666.875 62.5 632.5V570C62.5 535.625 90.625 507.5 125 507.5V-55C125 -89.375 153.125 -117.5 187.5 -117.5H625C659.375 -117.5 687.5 -89.375 687.5 -55V507.5C721.875 507.5 750 535.625 750 570V632.5C750 666.875 721.875 695 687.5 695zM625 -55H187.5V507.5H250V7.5H312.5V507.5H375V7.5H437.5V507.5H500V7.5H562.5V507.5H625V-55zM687.5 570H125V632.5H687.5V570z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22triangle-down%22%0D      unicode%3D%22%26%23xF05B%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M0 507.5L375 132.5L750 507.5H0z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22triangle-left%22%0D      unicode%3D%22%26%23xF044%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M375 695L0 320L375 -55V695z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22triangle-right%22%0D      unicode%3D%22%26%23xF05A%3B%22%0D      horiz-adv-x%3D%22375%22 d%3D%22 M0 -55L375 320L0 695V-55z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22triangle-up%22%0D      unicode%3D%22%26%23xF0AA%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M750 132.5L375 507.5L0 132.5H750z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22unfold%22%0D      unicode%3D%22%26%23xF039%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M718.75 351.25L875 195C875 160.625 846.875 132.5 812.5 132.5H562.5V195H781.25L656.25 320H218.75L93.75 195H312.5V132.5H62.5C28.125 132.5 0 160.625 0 195L156.25 351.25L0 507.5C0 541.875 28.125 570 62.5 570H312.5V507.5H93.75L218.75 382.5H656.25L781.25 507.5H562.5V570H812.5C846.875 570 875 541.875 875 507.5L718.75 351.25zM375 445H500V632.5H625L437.5 820L250 632.5H375V445zM500 257.5H375V70H250L437.5 -117.5L625 70H500V257.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22unmute%22%0D      unicode%3D%22%26%23xF0BA%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M750 318.75C750 250.625 721.875 188.125 676.875 141.875L635 183.75C669.375 218.75 690.625 265.625 690.625 318.75C690.625 371.875 669.375 419.3750000000001 635 453.7500000000001L676.875 495.6250000000001A249.375 249.375 0 0 0 750 318.75zM482.5 677.5L250 445H125C90.625 445 62.5 416.875 62.5 382.5V257.5C62.5 223.125 90.625 195 125 195H250L482.5000000000001 -37.5C511.8750000000001 -66.8750000000001 562.5 -46.2500000000001 562.5 -4.3750000000001V644.375C562.5 686.25 511.8749999999999 706.875 482.5 677.5zM853.75 672.5L811.875 630.625A437.24999999999994 437.24999999999994 0 0 0 940.625 319.375C940.625 198.125 891.8750000000001 88.125 811.875 8.125L853.75 -33.75A498.31249999999994 498.31249999999994 0 0 1 1000 320C1000 458.7500000000001 944.375 583.75 853.75 673.75V672.5zM765.625 584.375L722.5 542.5A315.62499999999994 315.62499999999994 0 0 0 815.0000000000001 318.75C815.0000000000001 231.875 780 152.5 722.5 96.25L765.625 54.375A373.18750000000006 373.18750000000006 0 0 1 875 318.75C875 421.8750000000001 833.125 516.25 765.625 584.375z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22unverified%22%0D      unicode%3D%22%26%23xF280%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M979.4117647058822 378.4117647058824L911.941176470588 462.1176470588236A93.8235294117647 93.8235294117647 0 0 0 892.5294117647057 510.1764705882354L880.705882352941 616.3529411764706A94.29411764705883 94.29411764705883 0 0 1 797.6470588235293 699.4705882352941L691.4117647058822 711.2941176470589A95.11764705882354 95.11764705882354 0 0 0 642.7058823529411 731.8823529411766L559 799.4117647058823A93.94117647058822 93.94117647058822 0 0 1 441.5882352941176 799.4117647058823L357.8823529411764 731.9411764705883C344.1764705882353 721.3529411764706 327.8823529411765 714.4705882352941 309.8235294117647 712.5294117647059L203.6470588235294 700.7058823529412A94.29411764705883 94.29411764705883 0 0 1 120.5294117647059 617.6470588235294L108.7058823529412 511.4705882352941C106.8235294117647 492.7058823529412 98.7058823529412 476.4705882352941 88.1176470588235 462.7058823529412L20.5882352941176 379.0000000000001A93.94117647058822 93.94117647058822 0 0 1 20.5882352941176 261.5882352941177L88.0588235294118 177.8823529411765C98.6470588235294 164.1764705882353 105.5294117647059 147.8823529411765 107.4705882352941 129.8235294117648L119.2941176470588 23.6470588235294A94.29411764705883 94.29411764705883 0 0 1 202.3529411764706 -59.4705882352941L308.5294117647059 -71.2941176470588C327.2941176470588 -73.1764705882354 343.5294117647059 -81.2941176470588 357.2941176470588 -91.8823529411765L441 -159.4117647058824A93.94117647058822 93.94117647058822 0 0 1 558.4117647058823 -159.4117647058824L642.1176470588235 -91.9411764705883C655.8235294117648 -81.3529411764707 672.1176470588235 -74.4705882352941 690.1764705882352 -72.529411764706L796.3529411764706 -60.7058823529412A94.29411764705883 94.29411764705883 0 0 1 879.4705882352941 22.3529411764705L891.2941176470588 128.5882352941176C893.1764705882354 147.2941176470588 901.2941176470588 163.5294117647059 911.8823529411764 177.2941176470588L979.4117647058824 260.9999999999999A93.94117647058822 93.94117647058822 0 0 1 979.4117647058824 378.4117647058823zM562.7647058823528 101.0588235294118C562.7647058823528 83.5882352941177 549.0588235294116 69.8823529411766 531.5882352941176 69.8823529411766H468.9999999999999A31.294117647058826 31.294117647058826 0 0 0 437.8235294117647 101.0588235294118V163.5294117647059C437.8235294117647 181.0000000000001 452.1764705882352 194.7647058823531 468.9999999999999 194.7647058823531H531.4705882352941C549 194.7647058823531 562.7058823529412 181.0000000000001 562.7058823529412 163.5882352941178V101.0588235294118zM660.235294117647 406.5294117647059C656.470588235294 395.9411764705883 649.6470588235293 385.9411764705883 641.4705882352939 377.1176470588236C633.3529411764704 367.1176470588236 632.7058823529411 365.2941176470589 620.8823529411764 353.4117647058824A205.8823529411764 205.8823529411764 0 0 0 588.3529411764704 325.2941176470589C581.5294117647057 319.7058823529412 575.8823529411762 313.4705882352941 570.8823529411762 308.4705882352942C565.8823529411762 303.4705882352942 562.1764705882351 297.8823529411766 558.9999999999998 291.5882352941177A95.88235294117646 95.88235294117646 0 0 1 552.1764705882351 272.8235294117647C550.2941176470586 266 550.2941176470586 264.7058823529411 550.2941176470586 257.235294117647H446C446 270.9411764705882 446 276.5882352941176 447.8235294117647 287.235294117647C449.7058823529411 299.0588235294117 452.8235294117646 309.7058823529411 456.5882352941176 319.7058823529411C460.3529411764706 328.4117647058822 465.3529411764706 337.1764705882352 472.1764705882352 345.9411764705881C479.0588235294118 354.0588235294116 486.5882352941175 361.5294117647058 497.8235294117646 369.6470588235293C514.7058823529411 381.5294117647058 520.2941176470588 388.4117647058822 527.8235294117646 402.1176470588234C535.2941176470588 415.8823529411764 540.2941176470587 425.8823529411764 540.2941176470587 438.9999999999999C540.2941176470587 455.8823529411763 536.5294117647057 467.1176470588234 527.8235294117646 475.2352941176469C519.6470588235294 483.3529411764704 508.4117647058823 487.0588235294115 491.5882352941176 487.0588235294115C485.9411764705882 487.0588235294115 479.7058823529411 485.8823529411763 472.8235294117646 483.9411764705881C465.9411764705881 482.0588235294115 462.235294117647 478.3529411764704 457.235294117647 473.9411764705881C452.235294117647 469.5882352941175 448.4705882352941 467.1176470588234 444.7058823529411 461.4705882352939A25.58823529411765 25.58823529411765 0 0 1 439.1176470588234 443.9999999999999H314.1176470588235C314.1176470588235 467.705882352941 322.235294117647 478.9411764705881 331 495.8235294117646C341 512.705882352941 353.4705882352941 527.0588235294116 369.0588235294118 537.705882352941C384.7058823529412 548.2941176470587 403.4117647058823 556.4117647058822 424.0588235294117 561.4117647058822A290.5882352941176 290.5882352941176 0 0 0 492.1176470588235 569.5294117647057C519.5882352941177 569.5294117647057 543.9999999999999 566.4117647058822 565.2352941176471 561.4117647058822C586.4117647058823 555.7647058823528 604.5882352941177 547.6470588235293 620.1764705882352 537.0588235294117C634.5294117647057 526.470588235294 645.7647058823529 513.2941176470588 654.5294117647057 497.6470588235293C662.6470588235293 482.0588235294117 666.4117647058822 463.3529411764704 666.4117647058822 442.7647058823528C666.4117647058822 428.9999999999999 666.4117647058822 416.5294117647058 661.4117647058822 405.8823529411764L660.1764705882351 406.4705882352941z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22verified%22%0D      unicode%3D%22%26%23xF281%3B%22%0D      horiz-adv-x%3D%221000%22 d%3D%22 M979.4117647058822 378.4117647058824L911.941176470588 462.1176470588236A93.8235294117647 93.8235294117647 0 0 0 892.5294117647057 510.1764705882354L880.705882352941 616.3529411764706A94.29411764705883 94.29411764705883 0 0 1 797.6470588235293 699.4705882352941L691.4117647058822 711.2941176470589A95.11764705882354 95.11764705882354 0 0 0 642.7058823529411 731.8823529411766L559 799.4117647058823A93.94117647058822 93.94117647058822 0 0 1 441.5882352941176 799.4117647058823L357.8823529411764 731.9411764705883C344.1764705882353 721.3529411764706 327.8823529411765 714.4705882352941 309.8235294117647 712.5294117647059L203.6470588235294 700.7058823529412A94.29411764705883 94.29411764705883 0 0 1 120.5294117647059 617.6470588235294L108.7058823529412 511.4705882352941C106.8235294117647 492.7058823529412 98.7058823529412 476.4705882352941 88.1176470588235 462.7058823529412L20.5882352941176 379.0000000000001A93.94117647058822 93.94117647058822 0 0 1 20.5882352941176 261.5882352941177L88.0588235294118 177.8823529411765C98.6470588235294 164.1764705882353 105.5294117647059 147.8823529411765 107.4705882352941 129.8235294117648L119.2941176470588 23.6470588235294A94.29411764705883 94.29411764705883 0 0 1 202.3529411764706 -59.4705882352941L308.5294117647059 -71.2941176470588C327.2941176470588 -73.1764705882354 343.5294117647059 -81.2941176470588 357.2941176470588 -91.8823529411765L441 -159.4117647058824A93.94117647058822 93.94117647058822 0 0 1 558.4117647058823 -159.4117647058824L642.1176470588235 -91.9411764705883C655.8235294117648 -81.3529411764707 672.1176470588235 -74.4705882352941 690.1764705882352 -72.529411764706L796.3529411764706 -60.7058823529412A94.29411764705883 94.29411764705883 0 0 1 879.4705882352941 22.3529411764705L891.2941176470588 128.5882352941176C893.1764705882354 147.2941176470588 901.2941176470588 163.5294117647059 911.8823529411764 177.2941176470588L979.4117647058824 260.9999999999999A93.94117647058822 93.94117647058822 0 0 1 979.4117647058824 378.4117647058823zM406.6470588235293 69.8235294117648L188 288.4705882352942L281.764705882353 382.1764705882354L406.7058823529412 257.2352941176471L718.9999999999999 569.5294117647059L812.7058823529411 472.7058823529412L406.7058823529411 69.8235294117648z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22versions%22%0D      unicode%3D%22%26%23xF064%3B%22%0D      horiz-adv-x%3D%22875%22 d%3D%22 M812.5 632.5H437.5C403.125 632.5 375 604.375 375 570V70C375 35.625 403.125 7.5 437.5 7.5H812.5C846.875 7.5 875 35.625 875 70V570C875 604.375 846.875 632.5 812.5 632.5zM750 132.5H500V507.5H750V132.5zM250 570H312.5V507.5H250V132.5H312.5V70H250C215.625 70 187.5 98.125 187.5 132.5V507.5C187.5 541.875 215.625 570 250 570zM62.5 507.5H125V445H62.5V195H125V132.5H62.5C28.125 132.5 0 160.625 0 195V445C0 479.375 28.125 507.5 62.5 507.5z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22watch%22%0D      unicode%3D%22%26%23xF0E0%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M375 320H500V257.5H312.5V507.5H375V320zM750 320C750 181.25 675 60 562.5 -4.3750000000001V-117.5C562.5 -151.875 534.375 -180 500 -180H250C215.625 -180 187.5 -151.875 187.5 -117.5V-4.375C75 60 0 181.25 0 320S75 580 187.5 644.375V757.5C187.5 791.875 215.625 820 250 820H500C534.375 820 562.5 791.875 562.5 757.5V644.375C675 580 750 458.75 750 320zM687.5 320C687.5 493.125 548.125 632.5 375 632.5S62.5 493.125 62.5 320S201.875 7.5 375 7.5S687.5 146.875 687.5 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22x%22%0D      unicode%3D%22%26%23xF081%3B%22%0D      horiz-adv-x%3D%22750%22 d%3D%22 M467.5 320L701.875 85.625L609.375 -6.875L375 227.5L140.625 -6.875L48.125 85.625L282.5 320L48.125 554.375L140.625 646.875L375 412.5L609.375 646.875L701.875 554.375L467.5 320z%22 %2F%3E%0D    %3Cglyph glyph-name%3D%22zap%22%0D      unicode%3D%22%26%23x26A1%3B%22%0D      horiz-adv-x%3D%22625%22 d%3D%22 M625 382.5H375L562.5 820L0 257.5H250L62.5 -180L625 382.5z%22 %2F%3E%0D  %3C%2Ffont%3E%0D%3C%2Fdefs%3E%0D%3C%2Fsvg%3E%0D") format("svg");\r\n}\r\n\r\n.octicon, .mega-octicon {\r\n    font: normal normal normal 16px/1 octicons;\r\n    display: inline-block;\r\n    text-decoration: none;\r\n    text-rendering: auto;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n\r\n.mega-octicon { font-size: 32px; }\r\n\r\n\r\n\r\n.octicon-alert:before { content: "\\F02D" }\r\n.octicon-arrow-down:before { content: "\\F03F" }\r\n.octicon-arrow-left:before { content: "\\F040" }\r\n.octicon-arrow-right:before { content: "\\F03E" }\r\n.octicon-arrow-small-down:before { content: "\\F0A0" }\r\n.octicon-arrow-small-left:before { content: "\\F0A1" }\r\n.octicon-arrow-small-right:before { content: "\\F071" }\r\n.octicon-arrow-small-up:before { content: "\\F09F" }\r\n.octicon-arrow-up:before { content: "\\F03D" }\r\n.octicon-beaker:before { content: "\\F0DD" }\r\n.octicon-bell:before { content: "\\F0DE" }\r\n.octicon-bold:before { content: "\\F282" }\r\n.octicon-book:before { content: "\\F007" }\r\n.octicon-bookmark:before { content: "\\F07B" }\r\n.octicon-briefcase:before { content: "\\F0D3" }\r\n.octicon-broadcast:before { content: "\\F048" }\r\n.octicon-browser:before { content: "\\F0C5" }\r\n.octicon-bug:before { content: "\\F091" }\r\n.octicon-calendar:before { content: "\\F068" }\r\n.octicon-check:before { content: "\\F03A" }\r\n.octicon-checklist:before { content: "\\F076" }\r\n.octicon-chevron-down:before { content: "\\F0A3" }\r\n.octicon-chevron-left:before { content: "\\F0A4" }\r\n.octicon-chevron-right:before { content: "\\F078" }\r\n.octicon-chevron-up:before { content: "\\F0A2" }\r\n.octicon-circle-slash:before { content: "\\F084" }\r\n.octicon-circuit-board:before { content: "\\F0D6" }\r\n.octicon-clippy:before { content: "\\F035" }\r\n.octicon-clock:before { content: "\\F046" }\r\n.octicon-clone:before { content: "\\F0DC" }\r\n.octicon-cloud-download:before { content: "\\F00B" }\r\n.octicon-cloud-upload:before { content: "\\F00C" }\r\n.octicon-code:before { content: "\\F05F" }\r\n.octicon-color-mode:before { content: "\\F065" }\r\n.octicon-comment-add:before { content: "\\F02B" }\r\n.octicon-comment-discussion:before { content: "\\F04F" }\r\n.octicon-comment:before { content: "\\F02B" }\r\n.octicon-credit-card:before { content: "\\F045" }\r\n.octicon-dash:before { content: "\\F0CA" }\r\n.octicon-dashboard:before { content: "\\F07D" }\r\n.octicon-database:before { content: "\\F096" }\r\n.octicon-desktop-download:before { content: "\\F0DC" }\r\n.octicon-device-camera-video:before { content: "\\F057" }\r\n.octicon-device-camera:before { content: "\\F056" }\r\n.octicon-device-desktop:before { content: "\\F27C" }\r\n.octicon-device-mobile:before { content: "\\F038" }\r\n.octicon-diff-added:before { content: "\\F06B" }\r\n.octicon-diff-ignored:before { content: "\\F099" }\r\n.octicon-diff-modified:before { content: "\\F06D" }\r\n.octicon-diff-removed:before { content: "\\F06C" }\r\n.octicon-diff-renamed:before { content: "\\F06E" }\r\n.octicon-diff:before { content: "\\F04D" }\r\n.octicon-ellipsis:before { content: "\\F09A" }\r\n.octicon-eye-unwatch:before { content: "\\F04E" }\r\n.octicon-eye-watch:before { content: "\\F04E" }\r\n.octicon-eye:before { content: "\\F04E" }\r\n.octicon-file-add:before { content: "\\F05D" }\r\n.octicon-file-binary:before { content: "\\F094" }\r\n.octicon-file-code:before { content: "\\F010" }\r\n.octicon-file-directory-create:before { content: "\\F05D" }\r\n.octicon-file-directory:before { content: "\\F016" }\r\n.octicon-file-media:before { content: "\\F012" }\r\n.octicon-file-pdf:before { content: "\\F014" }\r\n.octicon-file-submodule:before { content: "\\F017" }\r\n.octicon-file-symlink-directory:before { content: "\\F0B1" }\r\n.octicon-file-symlink-file:before { content: "\\F0B0" }\r\n.octicon-file-text:before { content: "\\F283" }\r\n.octicon-file-zip:before { content: "\\F013" }\r\n.octicon-file:before { content: "\\F283" }\r\n.octicon-flame:before { content: "\\F0D2" }\r\n.octicon-fold:before { content: "\\F0CC" }\r\n.octicon-gear:before { content: "\\F02F" }\r\n.octicon-gift:before { content: "\\F042" }\r\n.octicon-gist-fork:before { content: "\\F002" }\r\n.octicon-gist-new:before { content: "\\F05D" }\r\n.octicon-gist-private:before { content: "\\F06A" }\r\n.octicon-gist-secret:before { content: "\\F08C" }\r\n.octicon-gist:before { content: "\\F00E" }\r\n.octicon-git-branch-create:before { content: "\\F020" }\r\n.octicon-git-branch-delete:before { content: "\\F020" }\r\n.octicon-git-branch:before { content: "\\F020" }\r\n.octicon-git-commit:before { content: "\\F01F" }\r\n.octicon-git-compare:before { content: "\\F0AC" }\r\n.octicon-git-fork-private:before { content: "\\F06A" }\r\n.octicon-git-merge:before { content: "\\F023" }\r\n.octicon-git-pull-request-abandoned:before { content: "\\F009" }\r\n.octicon-git-pull-request:before { content: "\\F009" }\r\n.octicon-globe:before { content: "\\F0B6" }\r\n.octicon-grabber:before { content: "\\F284" }\r\n.octicon-graph:before { content: "\\F043" }\r\n.octicon-heart:before { content: "\\2665" }\r\n.octicon-history:before { content: "\\F07E" }\r\n.octicon-home:before { content: "\\F08D" }\r\n.octicon-horizontal-rule:before { content: "\\F070" }\r\n.octicon-hubot:before { content: "\\F09D" }\r\n.octicon-inbox:before { content: "\\F0CF" }\r\n.octicon-info:before { content: "\\F059" }\r\n.octicon-issue-closed:before { content: "\\F028" }\r\n.octicon-issue-opened:before { content: "\\F026" }\r\n.octicon-issue-reopened:before { content: "\\F027" }\r\n.octicon-italic:before { content: "\\F285" }\r\n.octicon-jersey:before { content: "\\F019" }\r\n.octicon-kebab-horizontal:before { content: "\\F286" }\r\n.octicon-kebab-vertical:before { content: "\\F287" }\r\n.octicon-key:before { content: "\\F049" }\r\n.octicon-keyboard:before { content: "\\F00D" }\r\n.octicon-law:before { content: "\\F0D8" }\r\n.octicon-light-bulb:before { content: "\\F000" }\r\n.octicon-link-external:before { content: "\\F07F" }\r\n.octicon-link:before { content: "\\F05C" }\r\n.octicon-list-ordered:before { content: "\\F062" }\r\n.octicon-list-unordered:before { content: "\\F061" }\r\n.octicon-location:before { content: "\\F060" }\r\n.octicon-lock:before { content: "\\F06A" }\r\n.octicon-log-in:before { content: "\\F036" }\r\n.octicon-log-out:before { content: "\\F032" }\r\n.octicon-logo-gist:before { content: "\\F288" }\r\n.octicon-logo-github:before { content: "\\F092" }\r\n.octicon-mail-read:before { content: "\\F03C" }\r\n.octicon-mail-reply:before { content: "\\F28C" }\r\n.octicon-mail:before { content: "\\F03B" }\r\n.octicon-mark-github:before { content: "\\F00A" }\r\n.octicon-markdown:before { content: "\\F0C9" }\r\n.octicon-megaphone:before { content: "\\F077" }\r\n.octicon-mention:before { content: "\\F0BE" }\r\n.octicon-microscope:before { content: "\\F0DD" }\r\n.octicon-milestone:before { content: "\\F075" }\r\n.octicon-mirror-private:before { content: "\\F06A" }\r\n.octicon-mirror-public:before { content: "\\F024" }\r\n.octicon-mirror:before { content: "\\F024" }\r\n.octicon-mortar-board:before { content: "\\F0D7" }\r\n.octicon-mute:before { content: "\\F080" }\r\n.octicon-no-newline:before { content: "\\F09C" }\r\n.octicon-note:before { content: "\\F289" }\r\n.octicon-octoface:before { content: "\\F008" }\r\n.octicon-organization:before { content: "\\F037" }\r\n.octicon-organization-filled:before { content: "\\26A2" }\r\n.octicon-organization-outline:before { content: "\\F037" }\r\n.octicon-package:before { content: "\\F0C4" }\r\n.octicon-paintcan:before { content: "\\F0D1" }\r\n.octicon-pencil:before { content: "\\F058" }\r\n.octicon-person-add:before { content: "\\F018" }\r\n.octicon-person-follow:before { content: "\\F018" }\r\n.octicon-person:before { content: "\\F018" }\r\n.octicon-person-filled:before { content: "\\26A3" }\r\n.octicon-person-outline:before { content: "\\F018" }\r\n.octicon-pin:before { content: "\\F041" }\r\n.octicon-plug:before { content: "\\F0D4" }\r\n.octicon-plus-small:before { content: "\\F28A" }\r\n.octicon-plus:before { content: "\\F05D" }\r\n.octicon-primitive-dot:before { content: "\\F052" }\r\n.octicon-primitive-square:before { content: "\\F053" }\r\n.octicon-project:before { content: "\\F28B" }\r\n.octicon-pulse:before { content: "\\F085" }\r\n.octicon-question:before { content: "\\F02C" }\r\n.octicon-quote:before { content: "\\F063" }\r\n.octicon-radio-tower:before { content: "\\F030" }\r\n.octicon-remove-close:before { content: "\\F081" }\r\n.octicon-reply:before { content: "\\F28C" }\r\n.octicon-repo-clone:before { content: "\\F04C" }\r\n.octicon-repo-create:before { content: "\\F05D" }\r\n.octicon-repo-delete:before { content: "\\F001" }\r\n.octicon-repo-force-push:before { content: "\\F04A" }\r\n.octicon-repo-forked:before { content: "\\F002" }\r\n.octicon-repo-pull:before { content: "\\F006" }\r\n.octicon-repo-push:before { content: "\\F005" }\r\n.octicon-repo-sync:before { content: "\\F087" }\r\n.octicon-repo:before { content: "\\F001" }\r\n.octicon-report:before { content: "\\F28D" }\r\n.octicon-rocket:before { content: "\\F033" }\r\n.octicon-rss:before { content: "\\F034" }\r\n.octicon-ruby:before { content: "\\F047" }\r\n.octicon-screen-full:before { content: "\\F066" }\r\n.octicon-screen-normal:before { content: "\\F067" }\r\n.octicon-search-save:before { content: "\\F02E" }\r\n.octicon-search:before { content: "\\F02E" }\r\n.octicon-server:before { content: "\\F097" }\r\n.octicon-settings:before { content: "\\F07C" }\r\n.octicon-shield:before { content: "\\F0E1" }\r\n.octicon-sign-in:before { content: "\\F036" }\r\n.octicon-sign-out:before { content: "\\F032" }\r\n.octicon-smiley:before { content: "\\F27D" }\r\n.octicon-squirrel:before { content: "\\F0B2" }\r\n.octicon-star-add:before { content: "\\F02A" }\r\n.octicon-star-delete:before { content: "\\F02A" }\r\n.octicon-star:before { content: "\\F02A" }\r\n.octicon-stop:before { content: "\\F08F" }\r\n.octicon-sync:before { content: "\\F087" }\r\n.octicon-tag-add:before { content: "\\F015" }\r\n.octicon-tag-remove:before { content: "\\F015" }\r\n.octicon-tag:before { content: "\\F015" }\r\n.octicon-tasklist:before { content: "\\F27E" }\r\n.octicon-telescope:before { content: "\\F088" }\r\n.octicon-terminal:before { content: "\\F0C8" }\r\n.octicon-text-size:before { content: "\\F27F" }\r\n.octicon-three-bars:before { content: "\\F05E" }\r\n.octicon-thumbsdown:before { content: "\\F0DB" }\r\n.octicon-thumbsup:before { content: "\\F0DA" }\r\n.octicon-tools:before { content: "\\F031" }\r\n.octicon-trashcan:before { content: "\\F0D0" }\r\n.octicon-triangle-down:before { content: "\\F05B" }\r\n.octicon-triangle-left:before { content: "\\F044" }\r\n.octicon-triangle-right:before { content: "\\F05A" }\r\n.octicon-triangle-up:before { content: "\\F0AA" }\r\n.octicon-unfold:before { content: "\\F039" }\r\n.octicon-unmute:before { content: "\\F0BA" }\r\n.octicon-unverified:before { content: "\\F280" }\r\n.octicon-verified:before { content: "\\F281" }\r\n.octicon-versions:before { content: "\\F064" }\r\n.octicon-watch:before { content: "\\F0E0" }\r\n.octicon-x:before { content: "\\F081" }\r\n.octicon-zap:before { content: "\\26A1" }\r\n.octicon-archive:before { content: "\\F101" }\r\n.octicon-arrow-both:before { content: "\\F102" }\r\n.octicon-eye-closed:before { content: "\\F103" }\r\n.octicon-fold-down:before { content: "\\F104" }\r\n.octicon-fold-up:before { content: "\\F105" }\r\n.octicon-github-action:before { content: "\\F106" }\r\n.octicon-play:before { content: "\\F107" }\r\n.octicon-request-changes:before { content: "\\F108" }\r\n');
var ei;

function ti(e) {
  return he(e).replace(/\$\(((.+?)(~(.*?))?)\)/g, function (e, t, i, o, n) {
    return "<span class=\"octicon octicon-".concat(i, " ").concat(n ? "octicon-animation-".concat(n) : "", "\"></span>");
  });
}

ye("/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n@keyframes octicon-spin {\r\n\t100% {\r\n\t\ttransform:rotate(360deg);\r\n\t}\r\n}\r\n\r\n.octicon-animation-spin {\r\n\tanimation: octicon-spin 2s linear infinite;\r\n}");

var ii =
/*#__PURE__*/
function () {
  function ii(e, t) {
    _classCallCheck(this, ii);

    this.supportOcticons = t, this.domNode = document.createElement("span"), this.domNode.className = "monaco-highlighted-label", this.didEverRender = !1, e.appendChild(this.domNode);
  }

  _createClass(ii, [{
    key: "set",
    value: function set(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var o = arguments.length > 3 ? arguments[3] : undefined;
      e || (e = ""), o && (e = ii.escapeNewLines(e, t)), this.didEverRender && this.text === e && this.title === i && function e(t, i) {
        if (t === i) return !0;
        if (null == t || null == i) return !1;
        if (typeof t != typeof i) return !1;
        if ("object" != typeof t) return !1;
        if (Array.isArray(t) !== Array.isArray(i)) return !1;
        var o, n;

        if (Array.isArray(t)) {
          if (t.length !== i.length) return !1;

          for (o = 0; o < t.length; o++) {
            if (!e(t[o], i[o])) return !1;
          }
        } else {
          var _s7 = [];

          for (n in t) {
            _s7.push(n);
          }

          _s7.sort();

          var _r3 = [];

          for (n in i) {
            _r3.push(n);
          }

          if (_r3.sort(), !e(_s7, _r3)) return !1;

          for (o = 0; o < _s7.length; o++) {
            if (!e(t[_s7[o]], i[_s7[o]])) return !1;
          }
        }

        return !0;
      }(this.highlights, t) || (Array.isArray(t) || (t = []), this.text = e, this.title = i, this.highlights = t, this.render());
    }
  }, {
    key: "render",
    value: function render() {
      !function (e) {
        for (; e.firstChild;) {
          e.removeChild(e.firstChild);
        }
      }(this.domNode);
      var e = [],
          t = 0;
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = this.highlights[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _i24 = _step3.value;
          if (_i24.end === _i24.start) continue;

          if (t < _i24.start) {
            e.push("<span>");

            var _o8 = this.text.substring(t, _i24.start);

            e.push(this.supportOcticons ? ti(_o8) : he(_o8)), e.push("</span>"), t = _i24.end;
          }

          e.push('<span class="highlight">');

          var _o7 = this.text.substring(_i24.start, _i24.end);

          e.push(this.supportOcticons ? ti(_o7) : he(_o7)), e.push("</span>"), t = _i24.end;
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      if (t < this.text.length) {
        e.push("<span>");

        var _i23 = this.text.substring(t);

        e.push(this.supportOcticons ? ti(_i23) : he(_i23)), e.push("</span>");
      }

      this.domNode.innerHTML = e.join(""), this.domNode.title = this.title, this.didEverRender = !0;
    }
  }, {
    key: "element",
    get: function get() {
      return this.domNode;
    }
  }], [{
    key: "escapeNewLines",
    value: function escapeNewLines(e, t) {
      var i = 0,
          o = 0;
      return e.replace(/\r\n|\r|\n/, function (e, n) {
        o = "\r\n" === e ? -1 : 0, n += i;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = t[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _e25 = _step4.value;
            _e25.end <= n || (_e25.start >= n && (_e25.start += o), _e25.end >= n && (_e25.end += o));
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return i += o, "⏎";
      });
    }
  }]);

  return ii;
}();

var oi =
/*#__PURE__*/
function () {
  function oi(e) {
    _classCallCheck(this, oi);

    this._element = e;
  }

  _createClass(oi, [{
    key: "dispose",
    value: function dispose() {
      this.disposed = !0;
    }
  }, {
    key: "element",
    get: function get() {
      return this._element;
    }
  }, {
    key: "textContent",
    set: function set(e) {
      this.disposed || e === this._textContent || (this._textContent = e, this._element.textContent = e);
    }
  }, {
    key: "className",
    set: function set(e) {
      this.disposed || e === this._className || (this._className = e, this._element.className = e);
    }
  }, {
    key: "title",
    set: function set(e) {
      this.disposed || e === this._title || (this._title = e, this._title ? this._element.title = e : this._element.removeAttribute("title"));
    }
  }, {
    key: "empty",
    set: function set(e) {
      this.disposed || e === this._empty || (this._empty = e, this._element.style.marginLeft = e ? "0" : null);
    }
  }]);

  return oi;
}();

var ni =
/*#__PURE__*/
function (_f4) {
  _inherits(ni, _f4);

  function ni(e, t) {
    var _this19;

    _classCallCheck(this, ni);

    _this19 = _possibleConstructorReturn(this, _getPrototypeOf(ni).call(this)), _this19.domNode = _this19._register(new oi(kt(e, Ut(".monaco-icon-label")))), _this19.labelDescriptionContainer = _this19._register(new oi(kt(_this19.domNode.element, Ut(".monaco-icon-label-description-container")))), t && t.supportHighlights ? _this19.labelNode = new ii(kt(_this19.labelDescriptionContainer.element, Ut("a.label-name")), !t.donotSupportOcticons) : _this19.labelNode = _this19._register(new oi(kt(_this19.labelDescriptionContainer.element, Ut("a.label-name")))), t && t.supportDescriptionHighlights ? _this19.descriptionNodeFactory = function () {
      return new ii(kt(_this19.labelDescriptionContainer.element, Ut("span.label-description")), !t.donotSupportOcticons);
    } : _this19.descriptionNodeFactory = function () {
      return _this19._register(new oi(kt(_this19.labelDescriptionContainer.element, Ut("span.label-description"))));
    };
    return _this19;
  }

  _createClass(ni, [{
    key: "setLabel",
    value: function setLabel(e, t, i) {
      var o = ["monaco-icon-label"];
      i && (i.extraClasses && o.push.apply(o, _toConsumableArray(i.extraClasses)), i.italic && o.push("italic")), this.domNode.className = o.join(" "), this.domNode.title = i && i.title ? i.title : "", this.labelNode instanceof ii ? this.labelNode.set(e || "", i ? i.matches : void 0, i && i.title ? i.title : void 0, i && i.labelEscapeNewLines) : this.labelNode.textContent = e || "", (t || this.descriptionNode) && (this.descriptionNode || (this.descriptionNode = this.descriptionNodeFactory()), this.descriptionNode instanceof ii ? (this.descriptionNode.set(t || "", i ? i.descriptionMatches : void 0), i && i.descriptionTitle ? this.descriptionNode.element.title = i.descriptionTitle : this.descriptionNode.element.removeAttribute("title")) : (this.descriptionNode.textContent = t || "", this.descriptionNode.title = i && i.descriptionTitle ? i.descriptionTitle : "", this.descriptionNode.empty = !t));
    }
  }, {
    key: "element",
    get: function get() {
      return this.domNode.element;
    }
  }]);

  return ni;
}(f);

!function (e) {
  e[e.FILE = 0] = "FILE", e[e.FOLDER = 1] = "FOLDER", e[e.ROOT_FOLDER = 2] = "ROOT_FOLDER";
}(ei || (ei = {}));
var si = {
  onDidChangeVisibility: v.None
};

var ri =
/*#__PURE__*/
function (_f5) {
  _inherits(ri, _f5);

  function ri(e, t) {
    var _this20;

    _classCallCheck(this, ri);

    _this20 = _possibleConstructorReturn(this, _getPrototypeOf(ri).call(this)), _this20.instantiationService = t, _this20._widgets = [], _this20._labels = [], _this20.registerListeners(e);
    return _this20;
  }

  _createClass(ri, [{
    key: "registerListeners",
    value: function registerListeners(e) {}
  }, {
    key: "get",
    value: function get(e) {
      return this._labels[e];
    }
  }, {
    key: "create",
    value: function create(e, t) {
      var _this21 = this;

      var i = this.instantiationService.createInstance(Ai, e, t),
          o = {
        element: i.element,
        onDidRender: i.onDidRender,
        setLabel: function setLabel(e, t, o) {
          return i.setLabel(e, t, o);
        },
        setResource: function setResource(e, t) {
          return i.setResource(e, t);
        },
        setFile: function setFile(e, t) {
          return i.setFile(e, t);
        },
        clear: function clear() {
          return i.clear();
        },
        dispose: function dispose() {
          return _this21.disposeWidget(i);
        }
      };
      return this._labels.push(o), this._widgets.push(i), o;
    }
  }, {
    key: "disposeWidget",
    value: function disposeWidget(e) {
      var t = this._widgets.indexOf(e);

      t > -1 && (this._widgets.splice(t, 1), this._labels.splice(t, 1)), C(e);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._widgets = C(this._widgets), this._labels = [];
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(ri.prototype), "dispose", this).call(this), this.clear();
    }
  }]);

  return ri;
}(f);

ri = r([l(1, i)], ri);

var li =
/*#__PURE__*/
function (_ri) {
  _inherits(li, _ri);

  function li(e, t, i) {
    var _this22;

    _classCallCheck(this, li);

    _this22 = _possibleConstructorReturn(this, _getPrototypeOf(li).call(this, si, i)), _this22._label = _this22._register(_this22.create(e, t));
    return _this22;
  }

  _createClass(li, [{
    key: "element",
    get: function get() {
      return this._label;
    }
  }]);

  return li;
}(ri);

var ai;
li = r([l(2, i)], li), function (e) {
  e[e.Basic = 1] = "Basic", e[e.Full = 2] = "Full";
}(ai || (ai = {}));

var Ai =
/*#__PURE__*/
function (_ni) {
  _inherits(Ai, _ni);

  function Ai(e, t) {
    var _this23;

    _classCallCheck(this, Ai);

    _this23 = _possibleConstructorReturn(this, _getPrototypeOf(Ai).call(this, e, t)), _this23._onDidRender = _this23._register(new b()), _this23.isHidden = !1;
    return _this23;
  }

  _createClass(Ai, [{
    key: "notifyVisibilityChanged",
    value: function notifyVisibilityChanged(e) {
      e === this.isHidden && (this.isHidden = !e, e && this.needsRedraw && (this.render(this.needsRedraw !== ai.Basic), this.needsRedraw = void 0));
    }
  }, {
    key: "notifyFileDecorationsChanges",
    value: function notifyFileDecorationsChanges(e) {
      this.options && this.label && this.label.resource && this.options.fileDecorations && e.affectsResource(this.label.resource) && this.render(!1);
    }
  }, {
    key: "notifyExtensionsRegistered",
    value: function notifyExtensionsRegistered() {
      this.render(!0);
    }
  }, {
    key: "notifyThemeChange",
    value: function notifyThemeChange() {
      this.render(!1);
    }
  }, {
    key: "notifyFileAssociationsChange",
    value: function notifyFileAssociationsChange() {
      this.render(!0);
    }
  }, {
    key: "setResource",
    value: function setResource(e, t) {
      var i = this.hasResourceChanged(e, t);
      this.label = e, this.options = t, i && (this.computedPathLabel = void 0), this.render(i);
    }
  }, {
    key: "hasResourceChanged",
    value: function hasResourceChanged(e, t) {
      var i = e ? e.resource : void 0,
          o = this.label ? this.label.resource : void 0;
      return i && o ? i.toString() !== o.toString() : !(!i && !o);
    }
  }, {
    key: "setFile",
    value: function setFile(e, t) {}
  }, {
    key: "clear",
    value: function clear() {
      this.label = void 0, this.options = void 0, this.lastKnownConfiguredLangId = void 0, this.computedIconClasses = void 0, this.computedPathLabel = void 0, this.setLabel();
    }
  }, {
    key: "render",
    value: function render(e) {
      var _t$extraClasses;

      if (this.isHidden) return this.needsRedraw || (this.needsRedraw = e ? ai.Full : ai.Basic), void (this.needsRedraw === ai.Basic && e && (this.needsRedraw = ai.Full));
      if (e && (this.computedIconClasses = void 0), !this.label) return;
      var t = {
        title: "",
        italic: this.options && this.options.italic,
        matches: this.options && this.options.matches,
        extraClasses: []
      },
          i = (this.label.resource, this.label.name);
      this.options && this.options.extraClasses && (_t$extraClasses = t.extraClasses).push.apply(_t$extraClasses, _toConsumableArray(this.options.extraClasses)), this.setLabel(i, this.label.description, t), this._onDidRender.fire();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Ai.prototype), "dispose", this).call(this), this.label = void 0, this.options = void 0, this.lastKnownConfiguredLangId = void 0, this.computedIconClasses = void 0, this.computedPathLabel = void 0;
    }
  }, {
    key: "onDidRender",
    get: function get() {
      return this._onDidRender.event;
    }
  }]);

  return Ai;
}(ni);

ye("/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n.monaco-tl-row {\r\n\tdisplay: flex;\r\n\theight: 100%;\r\n\talign-items: center;\r\n}\r\n\r\n.monaco-tl-twistie,\r\n.monaco-tl-contents {\r\n\theight: 100%;\r\n}\r\n\r\n.monaco-tl-twistie {\r\n\tfont-size: 10px;\r\n\ttext-align: right;\r\n\tmargin-right: 6px;\r\n\tflex-shrink: 0;\r\n\twidth: 16px;\r\n}\r\n\r\n.monaco-tl-contents {\r\n\tflex: 1;\r\n\toverflow: hidden;\r\n}\r\n\r\n.monaco-tl-twistie.collapsible {\r\n\tbackground-size: 16px;\r\n\tbackground-position: 3px 50%;\r\n\tbackground-repeat: no-repeat;\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 16 16%22%3E%3Cpath fill%3D%22%23646465%22 d%3D%22M11 10H5.344L11 4.414V10z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.monaco-tl-twistie.collapsible.collapsed:not(.loading) {\r\n\tdisplay: inline-block;\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 16 16%22%3E%3Cpath fill%3D%22%23646465%22 d%3D%22M6 4v8l4-4-4-4zm1 2.414L8.586 8 7 9.586V6.414z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.vs-dark .monaco-tl-twistie.collapsible:not(.loading) {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 16 16%22%3E%3Cpath fill%3D%22%23E8E8E8%22 d%3D%22M11 10H5.344L11 4.414V10z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.vs-dark .monaco-tl-twistie.collapsible.collapsed:not(.loading) {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 16 16%22%3E%3Cpath fill%3D%22%23E8E8E8%22 d%3D%22M6 4v8l4-4-4-4zm1 2.414L8.586 8 7 9.586V6.414z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.hc-black .monaco-tl-twistie.collapsible:not(.loading) {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2216%22 height%3D%2216%22%3E%3Cpath fill%3D%22%23fff%22 d%3D%22M11 10.07h-5.656l5.656-5.656v5.656z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.hc-black .monaco-tl-twistie.collapsible.collapsed:not(.loading) {\r\n\tbackground-image: url(\"data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2216%22 height%3D%2216%22%3E%3Cpath fill%3D%22%23fff%22 d%3D%22M6 4v8l4-4-4-4zm1 2.414l1.586 1.586-1.586 1.586v-3.172z%22%2F%3E%3C%2Fsvg%3E\");\r\n}\r\n\r\n.monaco-tl-twistie.loading {\r\n\tbackground-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D'1.0' standalone%3D'no' %3F%3E%0D%3Csvg xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' version%3D'1.1' width%3D'10px' height%3D'10px'%3E%0D%09%3Cstyle%3E%0D    circle %7B%0D      animation%3A ball 0.6s linear infinite%3B%0D    %7D%0D%0D    circle%3Anth-child(2) %7B animation-delay%3A 0.075s%3B %7D%0D    circle%3Anth-child(3) %7B animation-delay%3A 0.15s%3B %7D%0D    circle%3Anth-child(4) %7B animation-delay%3A 0.225s%3B %7D%0D    circle%3Anth-child(5) %7B animation-delay%3A 0.3s%3B %7D%0D    circle%3Anth-child(6) %7B animation-delay%3A 0.375s%3B %7D%0D    circle%3Anth-child(7) %7B animation-delay%3A 0.45s%3B %7D%0D    circle%3Anth-child(8) %7B animation-delay%3A 0.525s%3B %7D%0D%0D    %40keyframes ball %7B%0D      from %7B opacity%3A 1%3B %7D%0D      to %7B opacity%3A 0.3%3B %7D%0D    %7D%0D%09%3C%2Fstyle%3E%0D%09%3Cg%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'1' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'9' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'9' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'1' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%3C%2Fg%3E%0D%3C%2Fsvg%3E%0D\");\r\n\tbackground-position: 0 center;\r\n}\r\n\r\n.vs-dark .monaco-tl-twistie.loading {\r\n\tbackground-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D'1.0' standalone%3D'no' %3F%3E%0D%3Csvg xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' version%3D'1.1' width%3D'10px' height%3D'10px'%3E%0D%09%3Cstyle%3E%0D    circle %7B%0D      animation%3A ball 0.6s linear infinite%3B%0D    %7D%0D%0D    circle%3Anth-child(2) %7B animation-delay%3A 0.075s%3B %7D%0D    circle%3Anth-child(3) %7B animation-delay%3A 0.15s%3B %7D%0D    circle%3Anth-child(4) %7B animation-delay%3A 0.225s%3B %7D%0D    circle%3Anth-child(5) %7B animation-delay%3A 0.3s%3B %7D%0D    circle%3Anth-child(6) %7B animation-delay%3A 0.375s%3B %7D%0D    circle%3Anth-child(7) %7B animation-delay%3A 0.45s%3B %7D%0D    circle%3Anth-child(8) %7B animation-delay%3A 0.525s%3B %7D%0D%0D    %40keyframes ball %7B%0D      from %7B opacity%3A 1%3B %7D%0D      to %7B opacity%3A 0.3%3B %7D%0D    %7D%0D%09%3C%2Fstyle%3E%0D%09%3Cg style%3D%22fill%3Agrey%3B%22%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'1' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'9' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'9' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'1' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%3C%2Fg%3E%0D%3C%2Fsvg%3E%0D\");\r\n}\r\n\r\n.hc-black .monaco-tl-twistie.loading {\r\n\tbackground-image: url(\"data:image/svg+xml,%3C%3Fxml version%3D'1.0' standalone%3D'no' %3F%3E%0D%3Csvg xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg' version%3D'1.1' width%3D'10px' height%3D'10px'%3E%0D%09%3Cstyle%3E%0D    circle %7B%0D      animation%3A ball 0.6s linear infinite%3B%0D    %7D%0D%0D    circle%3Anth-child(2) %7B animation-delay%3A 0.075s%3B %7D%0D    circle%3Anth-child(3) %7B animation-delay%3A 0.15s%3B %7D%0D    circle%3Anth-child(4) %7B animation-delay%3A 0.225s%3B %7D%0D    circle%3Anth-child(5) %7B animation-delay%3A 0.3s%3B %7D%0D    circle%3Anth-child(6) %7B animation-delay%3A 0.375s%3B %7D%0D    circle%3Anth-child(7) %7B animation-delay%3A 0.45s%3B %7D%0D    circle%3Anth-child(8) %7B animation-delay%3A 0.525s%3B %7D%0D%0D    %40keyframes ball %7B%0D      from %7B opacity%3A 1%3B %7D%0D      to %7B opacity%3A 0.3%3B %7D%0D    %7D%0D%09%3C%2Fstyle%3E%0D%09%3Cg style%3D%22fill%3Awhite%3B%22%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'1' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'9' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'7.8284' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'5' cy%3D'9' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'7.8284' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'1' cy%3D'5' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%09%3Ccircle cx%3D'2.1716' cy%3D'2.1716' r%3D'1' style%3D'opacity%3A0.3%3B' %2F%3E%0D%09%3C%2Fg%3E%0D%3C%2Fsvg%3E%0D\");\r\n}");
var hi, ci;

function di(e, t, i) {
  var o = null,
      n = null;
  if ("function" == typeof i.value ? (o = "value", 0 !== (n = i.value).length && console.warn("Memoize should only be used in functions with zero parameters")) : "function" == typeof i.get && (o = "get", n = i.get), !n) throw new Error("not supported");
  var s = "$memoize$".concat(t);

  i[o] = function () {
    for (var _len11 = arguments.length, e = new Array(_len11), _key11 = 0; _key11 < _len11; _key11++) {
      e[_key11] = arguments[_key11];
    }

    return this.hasOwnProperty(s) || Object.defineProperty(this, s, {
      configurable: !1,
      enumerable: !1,
      writable: !1,
      value: n.apply(this, e)
    }), this[s];
  };
}

ye('/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n.monaco-list {\r\n\tposition: relative;\r\n\theight: 100%;\r\n\twidth: 100%;\r\n\twhite-space: nowrap;\r\n}\r\n\r\n.monaco-list.mouse-support {\r\n\t-webkit-user-select: none;\r\n\t-khtml-user-select: none;\r\n\t-moz-user-select: -moz-none;\r\n\t-ms-user-select: none;\r\n\t-o-user-select: none;\r\n\tuser-select: none;\r\n}\r\n\r\n.monaco-list > .monaco-scrollable-element {\r\n\theight: 100%;\r\n}\r\n\r\n.monaco-list-rows {\r\n\tposition: relative;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n}\r\n\r\n.monaco-list.horizontal-scrolling .monaco-list-rows {\r\n\twidth: auto;\r\n\tmin-width: 100%;\r\n}\r\n\r\n.monaco-list-row {\r\n\tposition: absolute;\r\n\t-moz-box-sizing:\tborder-box;\r\n\t-o-box-sizing:\t\tborder-box;\r\n\t-ms-box-sizing:\t\tborder-box;\r\n\tbox-sizing:\t\t\tborder-box;\r\n\toverflow: hidden;\r\n\twidth: 100%;\r\n}\r\n\r\n.monaco-list.mouse-support .monaco-list-row {\r\n\tcursor: pointer;\r\n\ttouch-action: none;\r\n}\r\n\r\n/* for OS X ballistic scrolling */\r\n.monaco-list-row.scrolling {\r\n\tdisplay: none !important;\r\n}\r\n\r\n/* Focus */\r\n.monaco-list.element-focused, .monaco-list.selection-single, .monaco-list.selection-multiple {\r\n\toutline: 0 !important;\r\n}\r\n\r\n/* Dnd */\r\n.monaco-drag-image {\r\n\tdisplay: inline-block;\r\n\tpadding: 1px 7px;\r\n\tborder-radius: 10px;\r\n\tfont-size: 12px;\r\n\tposition: absolute;\r\n}\r\n\r\n/* Type filter */\r\n\r\n.monaco-list-type-filter {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tposition: absolute;\r\n\tborder-radius: 2px;\r\n\tpadding: 0px 3px;\r\n\tmax-width: calc(100% - 10px);\r\n\ttext-overflow: ellipsis;\r\n\toverflow: hidden;\r\n\ttext-align: right;\r\n\tbox-sizing: border-box;\r\n\tcursor: all-scroll;\r\n\tfont-size: 13px;\r\n\tline-height: 18px;\r\n\theight: 20px;\r\n\tz-index: 1;\r\n\ttop: 4px;\r\n}\r\n\r\n.monaco-list-type-filter.dragging {\r\n\ttransition: top 0.2s, left 0.2s;\r\n}\r\n\r\n.monaco-list-type-filter.ne {\r\n\tright: 4px;\r\n}\r\n\r\n.monaco-list-type-filter.nw {\r\n\tleft: 4px;\r\n}\r\n\r\n.monaco-list-type-filter > .controls {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tbox-sizing: border-box;\r\n\ttransition: width 0.2s;\r\n\twidth: 0;\r\n}\r\n\r\n.monaco-list-type-filter.dragging > .controls,\r\n.monaco-list-type-filter:hover > .controls {\r\n\twidth: 36px;\r\n}\r\n\r\n.monaco-list-type-filter > .controls > * {\r\n\tbox-sizing: border-box;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tmargin: 0 0 0 2px;\r\n\tflex-shrink: 0;\r\n}\r\n\r\n.monaco-list-type-filter > .controls > .filter {\r\n\t-webkit-appearance: none;\r\n\twidth: 16px;\r\n\theight: 16px;\r\n\tbackground: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M6 9.99951H2V11.9995H6V9.99951Z%22 fill%3D%22%234B4B4B%22%2F%3E%0D%3Cpath d%3D%22M10 7H2V9H10V7Z%22 fill%3D%22%234B4B4B%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22%234B4B4B%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n\tbackground-position: 50% 50%;\r\n\tcursor: pointer;\r\n}\r\n\r\n.monaco-list-type-filter > .controls > .filter:checked {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M10.0002 10H6.00024V12H10.0002V10Z%22 fill%3D%22%23424242%22%2F%3E%0D%3Cpath d%3D%22M11.9998 7H3.99976V9H11.9998V7Z%22 fill%3D%22%23424242%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22%23424242%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.vs-dark .monaco-list-type-filter > .controls > .filter {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M6 9.99951H2V11.9995H6V9.99951Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3Cpath d%3D%22M10 7H2V9H10V7Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.vs-dark .monaco-list-type-filter > .controls > .filter:checked {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M10.0002 10H6.00024V12H10.0002V10Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3Cpath d%3D%22M11.9998 7H3.99976V9H11.9998V7Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22%23E8E8E8%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.hc-black .monaco-list-type-filter > .controls > .filter {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M6 9.99951H2V11.9995H6V9.99951Z%22 fill%3D%22white%22%2F%3E%0D%3Cpath d%3D%22M10 7H2V9H10V7Z%22 fill%3D%22white%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22white%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.hc-black .monaco-list-type-filter > .controls > .filter:checked {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg width%3D%2216%22 height%3D%2216%22 viewBox%3D%220 0 16 16%22 fill%3D%22none%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%3Cpath d%3D%22M10.0002 10H6.00024V12H10.0002V10Z%22 fill%3D%22white%22%2F%3E%0D%3Cpath d%3D%22M11.9998 7H3.99976V9H11.9998V7Z%22 fill%3D%22white%22%2F%3E%0D%3Cpath d%3D%22M14 4H2V6H14V4Z%22 fill%3D%22white%22%2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.monaco-list-type-filter > .controls > .clear {\r\n\tborder: none;\r\n\tbackground: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2216%22 height%3D%2216%22 viewBox%3D%223 3 16 16%22 enable-background%3D%22new 3 3 16 16%22%3E%3Cpolygon fill%3D%22%23424242%22 points%3D%2212.597%2C11.042 15.4%2C13.845 13.844%2C15.4 11.042%2C12.598 8.239%2C15.4 6.683%2C13.845 9.485%2C11.042 6.683%2C8.239 8.238%2C6.683 11.042%2C9.486 13.845%2C6.683 15.4%2C8.239%22%2F%3E%3C%2Fsvg%3E");\r\n\tcursor: pointer;\r\n}\r\n\r\n.vs-dark .monaco-list-type-filter > .controls > .clear {\r\n\tbackground-image: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 width%3D%2216%22 height%3D%2216%22 viewBox%3D%223 3 16 16%22 enable-background%3D%22new 3 3 16 16%22%3E%3Cpolygon fill%3D%22%23e8e8e8%22 points%3D%2212.597%2C11.042 15.4%2C13.845 13.844%2C15.4 11.042%2C12.598 8.239%2C15.4 6.683%2C13.845 9.485%2C11.042 6.683%2C8.239 8.238%2C6.683 11.042%2C9.486 13.845%2C6.683 15.4%2C8.239%22%2F%3E%3C%2Fsvg%3E");\r\n}\r\n\r\n.hc-black .monaco-list-type-filter > .controls > .clear {\r\n\tbackground-image: url("data:image/svg+xml,%3C%3Fxml version%3D%221.0%22 encoding%3D%22UTF-8%22 standalone%3D%22no%22%3F%3E%0D%3Csvg%0D   xmlns%3Adc%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Felements%2F1.1%2F%22%0D   xmlns%3Acc%3D%22http%3A%2F%2Fcreativecommons.org%2Fns%23%22%0D   xmlns%3Ardf%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2F02%2F22-rdf-syntax-ns%23%22%0D   xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%0D   xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%0D   id%3D%22svg7320%22%0D   version%3D%221.1%22%0D   enable-background%3D%22new 3 3 16 16%22%0D   viewBox%3D%223 3 16 16%22%0D   height%3D%2216%22%0D   width%3D%2216%22%3E%0D  %3Cmetadata%0D     id%3D%22metadata7326%22%3E%0D    %3Crdf%3ARDF%3E%0D      %3Ccc%3AWork%0D         rdf%3Aabout%3D%22%22%3E%0D        %3Cdc%3Aformat%3Eimage%2Fsvg%2Bxml%3C%2Fdc%3Aformat%3E%0D        %3Cdc%3Atype%0D           rdf%3Aresource%3D%22http%3A%2F%2Fpurl.org%2Fdc%2Fdcmitype%2FStillImage%22 %2F%3E%0D        %3Cdc%3Atitle%3E%3C%2Fdc%3Atitle%3E%0D      %3C%2Fcc%3AWork%3E%0D    %3C%2Frdf%3ARDF%3E%0D  %3C%2Fmetadata%3E%0D  %3Cdefs%0D     id%3D%22defs7324%22 %2F%3E%0D  %3Cpolygon%0D     style%3D%22fill%3A%23ffffff%3Bfill-opacity%3A1%22%0D     id%3D%22polygon7318%22%0D     points%3D%2212.597%2C11.042 15.4%2C13.845 13.844%2C15.4 11.042%2C12.598 8.239%2C15.4 6.683%2C13.845 9.485%2C11.042 6.683%2C8.239 8.238%2C6.683 11.042%2C9.486 13.845%2C6.683 15.4%2C8.239%22%0D     fill%3D%22%23424242%22 %2F%3E%0D%3C%2Fsvg%3E%0D");\r\n}\r\n\r\n.monaco-list-type-filter-message {\r\n\tposition: absolute;\r\n\tbox-sizing: border-box;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tpadding: 40px 1em 1em 1em;\r\n\ttext-align: center;\r\n\twhite-space: normal;\r\n\topacity: 0.7;\r\n\tpointer-events: none;\r\n}\r\n\r\n.monaco-list-type-filter-message:empty {\r\n\tdisplay: none;\r\n}\r\n\r\n/* Electron */\r\n\r\n.monaco-list-type-filter {\r\n\tcursor: -webkit-grab;\r\n}\r\n\r\n.monaco-list-type-filter.dragging {\r\n\tcursor: -webkit-grabbing;\r\n}'), function (e) {
  e.Tap = "-monaco-gesturetap", e.Change = "-monaco-gesturechange", e.Start = "-monaco-gesturestart", e.End = "-monaco-gesturesend", e.Contextmenu = "-monaco-gesturecontextmenu";
}(hi || (hi = {}));

var ui =
/*#__PURE__*/
function (_f6) {
  _inherits(ui, _f6);

  function ui() {
    var _this24;

    _classCallCheck(this, ui);

    _this24 = _possibleConstructorReturn(this, _getPrototypeOf(ui).call(this)), _this24.activeTouches = {}, _this24.handle = null, _this24.targets = [], _this24._register(bt(document, "touchstart", function (e) {
      return _this24.onTouchStart(e);
    })), _this24._register(bt(document, "touchend", function (e) {
      return _this24.onTouchEnd(e);
    })), _this24._register(bt(document, "touchmove", function (e) {
      return _this24.onTouchMove(e);
    }));
    return _this24;
  }

  _createClass(ui, [{
    key: "dispose",
    value: function dispose() {
      this.handle && (this.handle.dispose(), this.handle = null), _get(_getPrototypeOf(ui.prototype), "dispose", this).call(this);
    }
  }, {
    key: "onTouchStart",
    value: function onTouchStart(e) {
      var t = Date.now();
      this.handle && (this.handle.dispose(), this.handle = null);

      for (var _i25 = 0, _o9 = e.targetTouches.length; _i25 < _o9; _i25++) {
        var _o10 = e.targetTouches.item(_i25);

        this.activeTouches[_o10.identifier] = {
          id: _o10.identifier,
          initialTarget: _o10.target,
          initialTimeStamp: t,
          initialPageX: _o10.pageX,
          initialPageY: _o10.pageY,
          rollingTimestamps: [t],
          rollingPageX: [_o10.pageX],
          rollingPageY: [_o10.pageY]
        };

        var _n12 = this.newGestureEvent(hi.Start, _o10.target);

        _n12.pageX = _o10.pageX, _n12.pageY = _o10.pageY, this.dispatchEvent(_n12);
      }

      this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
    }
  }, {
    key: "onTouchEnd",
    value: function onTouchEnd(e) {
      var _this25 = this;

      var t = Date.now(),
          i = Object.keys(this.activeTouches).length;

      var _loop = function _loop(_o11, _n13) {
        var n = e.changedTouches.item(_o11);

        if (!_this25.activeTouches.hasOwnProperty(String(n.identifier))) {
          console.warn("move of an UNKNOWN touch", n);
          return "continue";
        }

        var s = _this25.activeTouches[n.identifier],
            r = Date.now() - s.initialTimeStamp;

        if (r < ui.HOLD_DELAY && Math.abs(s.initialPageX - dt(s.rollingPageX)) < 30 && Math.abs(s.initialPageY - dt(s.rollingPageY)) < 30) {
          var _e26 = _this25.newGestureEvent(hi.Tap, s.initialTarget);

          _e26.pageX = dt(s.rollingPageX), _e26.pageY = dt(s.rollingPageY), _this25.dispatchEvent(_e26);
        } else if (r >= ui.HOLD_DELAY && Math.abs(s.initialPageX - dt(s.rollingPageX)) < 30 && Math.abs(s.initialPageY - dt(s.rollingPageY)) < 30) {
          var _e27 = _this25.newGestureEvent(hi.Contextmenu, s.initialTarget);

          _e27.pageX = dt(s.rollingPageX), _e27.pageY = dt(s.rollingPageY), _this25.dispatchEvent(_e27);
        } else if (1 === i) {
          var _e28 = dt(s.rollingPageX),
              _i26 = dt(s.rollingPageY),
              _o12 = dt(s.rollingTimestamps) - s.rollingTimestamps[0],
              _n14 = _e28 - s.rollingPageX[0],
              _r4 = _i26 - s.rollingPageY[0];

          var _l = _this25.targets.filter(function (e) {
            return s.initialTarget instanceof Node && e.contains(s.initialTarget);
          });

          _this25.inertia(_l, t, Math.abs(_n14) / _o12, _n14 > 0 ? 1 : -1, _e28, Math.abs(_r4) / _o12, _r4 > 0 ? 1 : -1, _i26);
        }

        _this25.dispatchEvent(_this25.newGestureEvent(hi.End, s.initialTarget)), delete _this25.activeTouches[n.identifier];
      };

      for (var _o11 = 0, _n13 = e.changedTouches.length; _o11 < _n13; _o11++) {
        var _ret = _loop(_o11, _n13);

        if (_ret === "continue") continue;
      }

      this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
    }
  }, {
    key: "newGestureEvent",
    value: function newGestureEvent(e, t) {
      var i = document.createEvent("CustomEvent");
      return i.initEvent(e, !1, !0), i.initialTarget = t, i;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e) {
      var _this26 = this;

      this.targets.forEach(function (t) {
        e.initialTarget instanceof Node && t.contains(e.initialTarget) && (t.dispatchEvent(e), _this26.dispatched = !0);
      });
    }
  }, {
    key: "inertia",
    value: function inertia(e, t, i, o, n, s, r, l) {
      var _this27 = this;

      this.handle = Ft(function () {
        var a = Date.now(),
            A = a - t,
            h = 0,
            c = 0,
            d = !0;
        i += ui.SCROLL_FRICTION * A, s += ui.SCROLL_FRICTION * A, i > 0 && (d = !1, h = o * i * A), s > 0 && (d = !1, c = r * s * A);

        var u = _this27.newGestureEvent(hi.Change);

        u.translationX = h, u.translationY = c, e.forEach(function (e) {
          return e.dispatchEvent(u);
        }), d || _this27.inertia(e, a, i, o, n + h, s, r, l + c);
      });
    }
  }, {
    key: "onTouchMove",
    value: function onTouchMove(e) {
      var t = Date.now();

      for (var _i27 = 0, _o13 = e.changedTouches.length; _i27 < _o13; _i27++) {
        var _o14 = e.changedTouches.item(_i27);

        if (!this.activeTouches.hasOwnProperty(String(_o14.identifier))) {
          console.warn("end of an UNKNOWN touch", _o14);
          continue;
        }

        var _n15 = this.activeTouches[_o14.identifier],
            _s8 = this.newGestureEvent(hi.Change, _n15.initialTarget);

        _s8.translationX = _o14.pageX - dt(_n15.rollingPageX), _s8.translationY = _o14.pageY - dt(_n15.rollingPageY), _s8.pageX = _o14.pageX, _s8.pageY = _o14.pageY, this.dispatchEvent(_s8), _n15.rollingPageX.length > 3 && (_n15.rollingPageX.shift(), _n15.rollingPageY.shift(), _n15.rollingTimestamps.shift()), _n15.rollingPageX.push(_o14.pageX), _n15.rollingPageY.push(_o14.pageY), _n15.rollingTimestamps.push(t);
      }

      this.dispatched && (e.preventDefault(), e.stopPropagation(), this.dispatched = !1);
    }
  }], [{
    key: "addTarget",
    value: function addTarget(e) {
      ui.isTouchDevice() && (ui.INSTANCE || (ui.INSTANCE = new ui()), ui.INSTANCE.targets.push(e));
    }
  }, {
    key: "isTouchDevice",
    value: function isTouchDevice() {
      return "ontouchstart" in window || navigator.maxTouchPoints > 0 || window.navigator.msMaxTouchPoints > 0;
    }
  }]);

  return ui;
}(f);

ui.SCROLL_FRICTION = -.005, ui.HOLD_DELAY = 700, r([di], ui, "isTouchDevice", null), function (e) {
  e.TREE = "tree", e.FORM = "form";
}(ci || (ci = {}));
ye('/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n/* Arrows */\r\n.monaco-scrollable-element > .scrollbar > .up-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg viewBox%3D%220 0 11 11%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22m9.48046%2C8.9615l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22 fill%3D%22%23424242%22%2F%3E%3C%2Fsvg%3E");\r\n\tcursor: pointer;\r\n}\r\n.monaco-scrollable-element > .scrollbar > .down-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 11 11%22%3E%3Cpath transform%3D%22rotate(-180 5.49045991897583%2C5.811500072479248)%22 fill%3D%22%23424242%22 d%3D%22m9.48046%2C8.9615l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n\tcursor: pointer;\r\n}\r\n.monaco-scrollable-element > .scrollbar > .left-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 11 11%22%3E%3Cpath transform%3D%22rotate(-90 5.490459918975831%2C5.431382179260254)%22 fill%3D%22%23424242%22 d%3D%22m9.48046%2C8.58138l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n\tcursor: pointer;\r\n}\r\n.monaco-scrollable-element > .scrollbar > .right-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg viewBox%3D%220 0 11 11%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath transform%3D%22rotate(90 5.6171650886535645%2C5.55808973312378) %22 fill%3D%22%23424242%22 d%3D%22m9.60717%2C8.70809l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n\tcursor: pointer;\r\n}\r\n\r\n.hc-black .monaco-scrollable-element > .scrollbar > .up-arrow,\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .up-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg viewBox%3D%220 0 11 11%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath d%3D%22m9.48046%2C8.9615l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22 fill%3D%22%23E8E8E8%22%2F%3E%3C%2Fsvg%3E");\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .down-arrow,\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .down-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 11 11%22%3E%3Cpath transform%3D%22rotate(-180 5.49045991897583%2C5.811500072479248)%22 fill%3D%22%23E8E8E8%22 d%3D%22m9.48046%2C8.9615l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .left-arrow,\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .left-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22 viewBox%3D%220 0 11 11%22%3E%3Cpath transform%3D%22rotate(-90 5.490459918975831%2C5.431382179260254)%22 fill%3D%22%23E8E8E8%22 d%3D%22m9.48046%2C8.58138l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .right-arrow,\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .right-arrow {\r\n\tbackground: url("data:image/svg+xml,%3Csvg viewBox%3D%220 0 11 11%22 xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath transform%3D%22rotate(90 5.6171650886535645%2C5.55808973312378) %22 fill%3D%22%23E8E8E8%22 d%3D%22m9.60717%2C8.70809l1.26%2C-1.26l-5.04%2C-5.04l-5.46%2C5.04l1.26%2C1.26l4.2%2C-3.78l3.78%2C3.78z%22%2F%3E%3C%2Fsvg%3E");\r\n}\r\n\r\n.monaco-scrollable-element > .visible {\r\n\topacity: 1;\r\n\r\n\t/* Background rule added for IE9 - to allow clicks on dom node */\r\n\tbackground:rgba(0,0,0,0);\r\n\r\n\ttransition: opacity 100ms linear;\r\n}\r\n.monaco-scrollable-element > .invisible {\r\n\topacity: 0;\r\n\tpointer-events: none;\r\n}\r\n.monaco-scrollable-element > .invisible.fade {\r\n\ttransition: opacity 800ms linear;\r\n}\r\n\r\n/* Scrollable Content Inset Shadow */\r\n.monaco-scrollable-element > .shadow {\r\n\tposition: absolute;\r\n\tdisplay: none;\r\n}\r\n.monaco-scrollable-element > .shadow.top {\r\n\tdisplay: block;\r\n\ttop: 0;\r\n\tleft: 3px;\r\n\theight: 3px;\r\n\twidth: 100%;\r\n\tbox-shadow: #DDD 0 6px 6px -6px inset;\r\n}\r\n.monaco-scrollable-element > .shadow.left {\r\n\tdisplay: block;\r\n\ttop: 3px;\r\n\tleft: 0;\r\n\theight: 100%;\r\n\twidth: 3px;\r\n\tbox-shadow: #DDD 6px 0 6px -6px inset;\r\n}\r\n.monaco-scrollable-element > .shadow.top-left-corner {\r\n\tdisplay: block;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\theight: 3px;\r\n\twidth: 3px;\r\n}\r\n.monaco-scrollable-element > .shadow.top.left {\r\n\tbox-shadow: #DDD 6px 6px 6px -6px inset;\r\n}\r\n\r\n/* ---------- Default Style ---------- */\r\n\r\n.monaco-scrollable-element > .scrollbar > .slider {\r\n\tbackground: rgba(100, 100, 100, .4);\r\n}\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .slider {\r\n\tbackground: rgba(121, 121, 121, .4);\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .slider {\r\n\tbackground: rgba(111, 195, 223, .6);\r\n}\r\n\r\n.monaco-scrollable-element > .scrollbar > .slider:hover {\r\n\tbackground: rgba(100, 100, 100, .7);\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .slider:hover {\r\n\tbackground: rgba(111, 195, 223, .8);\r\n}\r\n\r\n.monaco-scrollable-element > .scrollbar > .slider.active {\r\n\tbackground: rgba(0, 0, 0, .6);\r\n}\r\n.vs-dark .monaco-scrollable-element > .scrollbar > .slider.active {\r\n\tbackground: rgba(191, 191, 191, .4);\r\n}\r\n.hc-black .monaco-scrollable-element > .scrollbar > .slider.active {\r\n\tbackground: rgba(111, 195, 223, 1);\r\n}\r\n\r\n.vs-dark .monaco-scrollable-element .shadow.top {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.vs-dark .monaco-scrollable-element .shadow.left {\r\n\tbox-shadow: #000 6px 0 6px -6px inset;\r\n}\r\n\r\n.vs-dark .monaco-scrollable-element .shadow.top.left {\r\n\tbox-shadow: #000 6px 6px 6px -6px inset;\r\n}\r\n\r\n.hc-black .monaco-scrollable-element .shadow.top {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.hc-black .monaco-scrollable-element .shadow.left {\r\n\tbox-shadow: none;\r\n}\r\n\r\n.hc-black .monaco-scrollable-element .shadow.top.left {\r\n\tbox-shadow: none;\r\n}');

var gi =
/*#__PURE__*/
function () {
  function gi(e) {
    _classCallCheck(this, gi);

    this.domNode = e, this._maxWidth = -1, this._width = -1, this._height = -1, this._top = -1, this._left = -1, this._bottom = -1, this._right = -1, this._fontFamily = "", this._fontWeight = "", this._fontSize = -1, this._lineHeight = -1, this._letterSpacing = -100, this._className = "", this._display = "", this._position = "", this._visibility = "", this._layerHint = !1;
  }

  _createClass(gi, [{
    key: "setMaxWidth",
    value: function setMaxWidth(e) {
      this._maxWidth !== e && (this._maxWidth = e, this.domNode.style.maxWidth = this._maxWidth + "px");
    }
  }, {
    key: "setWidth",
    value: function setWidth(e) {
      this._width !== e && (this._width = e, this.domNode.style.width = this._width + "px");
    }
  }, {
    key: "setHeight",
    value: function setHeight(e) {
      this._height !== e && (this._height = e, this.domNode.style.height = this._height + "px");
    }
  }, {
    key: "setTop",
    value: function setTop(e) {
      this._top !== e && (this._top = e, this.domNode.style.top = this._top + "px");
    }
  }, {
    key: "unsetTop",
    value: function unsetTop() {
      -1 !== this._top && (this._top = -1, this.domNode.style.top = "");
    }
  }, {
    key: "setLeft",
    value: function setLeft(e) {
      this._left !== e && (this._left = e, this.domNode.style.left = this._left + "px");
    }
  }, {
    key: "setBottom",
    value: function setBottom(e) {
      this._bottom !== e && (this._bottom = e, this.domNode.style.bottom = this._bottom + "px");
    }
  }, {
    key: "setRight",
    value: function setRight(e) {
      this._right !== e && (this._right = e, this.domNode.style.right = this._right + "px");
    }
  }, {
    key: "setFontFamily",
    value: function setFontFamily(e) {
      this._fontFamily !== e && (this._fontFamily = e, this.domNode.style.fontFamily = this._fontFamily);
    }
  }, {
    key: "setFontWeight",
    value: function setFontWeight(e) {
      this._fontWeight !== e && (this._fontWeight = e, this.domNode.style.fontWeight = this._fontWeight);
    }
  }, {
    key: "setFontSize",
    value: function setFontSize(e) {
      this._fontSize !== e && (this._fontSize = e, this.domNode.style.fontSize = this._fontSize + "px");
    }
  }, {
    key: "setLineHeight",
    value: function setLineHeight(e) {
      this._lineHeight !== e && (this._lineHeight = e, this.domNode.style.lineHeight = this._lineHeight + "px");
    }
  }, {
    key: "setLetterSpacing",
    value: function setLetterSpacing(e) {
      this._letterSpacing !== e && (this._letterSpacing = e, this.domNode.style.letterSpacing = this._letterSpacing + "px");
    }
  }, {
    key: "setClassName",
    value: function setClassName(e) {
      this._className !== e && (this._className = e, this.domNode.className = this._className);
    }
  }, {
    key: "toggleClassName",
    value: function toggleClassName(e, t) {
      Mt(this.domNode, e, t), this._className = this.domNode.className;
    }
  }, {
    key: "setDisplay",
    value: function setDisplay(e) {
      this._display !== e && (this._display = e, this.domNode.style.display = this._display);
    }
  }, {
    key: "setPosition",
    value: function setPosition(e) {
      this._position !== e && (this._position = e, this.domNode.style.position = this._position);
    }
  }, {
    key: "setVisibility",
    value: function setVisibility(e) {
      this._visibility !== e && (this._visibility = e, this.domNode.style.visibility = this._visibility);
    }
  }, {
    key: "setLayerHinting",
    value: function setLayerHinting(e) {
      this._layerHint !== e && (this._layerHint = e, this.domNode.style.willChange = this._layerHint ? "transform" : "auto");
    }
  }, {
    key: "setAttribute",
    value: function setAttribute(e, t) {
      this.domNode.setAttribute(e, t);
    }
  }, {
    key: "removeAttribute",
    value: function removeAttribute(e) {
      this.domNode.removeAttribute(e);
    }
  }, {
    key: "appendChild",
    value: function appendChild(e) {
      this.domNode.appendChild(e.domNode);
    }
  }, {
    key: "removeChild",
    value: function removeChild(e) {
      this.domNode.removeChild(e.domNode);
    }
  }]);

  return gi;
}();

function Ci(e) {
  return new gi(e);
}

function pi(e, t) {
  var i = new tt(t);
  return i.preventDefault(), {
    leftButton: i.leftButton,
    posx: i.posx,
    posy: i.posy
  };
}

var mi =
/*#__PURE__*/
function (_f7) {
  _inherits(mi, _f7);

  function mi() {
    var _this28;

    _classCallCheck(this, mi);

    _this28 = _possibleConstructorReturn(this, _getPrototypeOf(mi).call(this)), _this28.hooks = [], _this28.mouseMoveEventMerger = null, _this28.mouseMoveCallback = null, _this28.onStopCallback = null;
    return _this28;
  }

  _createClass(mi, [{
    key: "dispose",
    value: function dispose() {
      this.stopMonitoring(!1), _get(_getPrototypeOf(mi.prototype), "dispose", this).call(this);
    }
  }, {
    key: "stopMonitoring",
    value: function stopMonitoring(e) {
      if (!this.isMonitoring()) return;
      this.hooks = C(this.hooks), this.mouseMoveEventMerger = null, this.mouseMoveCallback = null;
      var t = this.onStopCallback;
      this.onStopCallback = null, e && t && t();
    }
  }, {
    key: "isMonitoring",
    value: function isMonitoring() {
      return this.hooks.length > 0;
    }
  }, {
    key: "startMonitoring",
    value: function startMonitoring(e, t, i) {
      var _this29 = this;

      if (this.isMonitoring()) return;
      this.mouseMoveEventMerger = e, this.mouseMoveCallback = t, this.onStopCallback = i;
      var o = et.getSameOriginWindowChain();
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = o[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _e30 = _step5.value;
          this.hooks.push((n = _e30.window.document, new Vt(n, "mousemove", function (e) {
            return _this29.mouseMoveCallback(e);
          }, function (e, t) {
            return _this29.mouseMoveEventMerger(e, t);
          }, void 0))), this.hooks.push(bt(_e30.window.document, "mouseup", function (e) {
            return _this29.stopMonitoring(!0);
          }));
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var n;

      if (et.hasDifferentOriginAncestor()) {
        var _e29 = o[o.length - 1];
        this.hooks.push(bt(_e29.window.document, "mouseout", function (e) {
          "html" === new tt(e).target.tagName.toLowerCase() && _this29.stopMonitoring(!0);
        })), this.hooks.push(bt(_e29.window.document, "mouseover", function (e) {
          "html" === new tt(e).target.tagName.toLowerCase() && _this29.stopMonitoring(!0);
        })), this.hooks.push(bt(_e29.window.document.body, "mouseleave", function (e) {
          _this29.stopMonitoring(!0);
        }));
      }
    }
  }]);

  return mi;
}(f);

var fi =
/*#__PURE__*/
function (_f8) {
  _inherits(fi, _f8);

  function fi() {
    _classCallCheck(this, fi);

    return _possibleConstructorReturn(this, _getPrototypeOf(fi).apply(this, arguments));
  }

  _createClass(fi, [{
    key: "onclick",
    value: function onclick(e, t) {
      this._register(bt(e, Tt.CLICK, function (e) {
        return t(new tt(e));
      }));
    }
  }, {
    key: "onmousedown",
    value: function onmousedown(e, t) {
      this._register(bt(e, Tt.MOUSE_DOWN, function (e) {
        return t(new tt(e));
      }));
    }
  }, {
    key: "onmouseover",
    value: function onmouseover(e, t) {
      this._register(bt(e, Tt.MOUSE_OVER, function (e) {
        return t(new tt(e));
      }));
    }
  }, {
    key: "onnonbubblingmouseout",
    value: function onnonbubblingmouseout(e, t) {
      var i, o;

      this._register((o = function o(e) {
        return t(new tt(e));
      }, bt(i = e, "mouseout", function (e) {
        var t = e.relatedTarget || e.target;

        for (; t && t !== i;) {
          t = t.parentNode;
        }

        t !== i && o(e);
      })));
    }
  }, {
    key: "onkeydown",
    value: function onkeydown(e, t) {
      this._register(bt(e, Tt.KEY_DOWN, function (e) {
        return t(new We(e));
      }));
    }
  }, {
    key: "onkeyup",
    value: function onkeyup(e, t) {
      this._register(bt(e, Tt.KEY_UP, function (e) {
        return t(new We(e));
      }));
    }
  }, {
    key: "oninput",
    value: function oninput(e, t) {
      this._register(bt(e, Tt.INPUT, t));
    }
  }, {
    key: "onblur",
    value: function onblur(e, t) {
      this._register(bt(e, Tt.BLUR, t));
    }
  }, {
    key: "onfocus",
    value: function onfocus(e, t) {
      this._register(bt(e, Tt.FOCUS, t));
    }
  }, {
    key: "onchange",
    value: function onchange(e, t) {
      this._register(bt(e, Tt.CHANGE, t));
    }
  }]);

  return fi;
}(f);

var Di = 11;

var wi =
/*#__PURE__*/
function (_fi) {
  _inherits(wi, _fi);

  function wi(e) {
    var _this30;

    _classCallCheck(this, wi);

    _this30 = _possibleConstructorReturn(this, _getPrototypeOf(wi).call(this)), _this30._onActivate = e.onActivate, _this30.bgDomNode = document.createElement("div"), _this30.bgDomNode.className = "arrow-background", _this30.bgDomNode.style.position = "absolute", _this30.bgDomNode.style.width = e.bgWidth + "px", _this30.bgDomNode.style.height = e.bgHeight + "px", void 0 !== e.top && (_this30.bgDomNode.style.top = "0px"), void 0 !== e.left && (_this30.bgDomNode.style.left = "0px"), void 0 !== e.bottom && (_this30.bgDomNode.style.bottom = "0px"), void 0 !== e.right && (_this30.bgDomNode.style.right = "0px"), _this30.domNode = document.createElement("div"), _this30.domNode.className = e.className, _this30.domNode.style.position = "absolute", _this30.domNode.style.width = Di + "px", _this30.domNode.style.height = Di + "px", void 0 !== e.top && (_this30.domNode.style.top = e.top + "px"), void 0 !== e.left && (_this30.domNode.style.left = e.left + "px"), void 0 !== e.bottom && (_this30.domNode.style.bottom = e.bottom + "px"), void 0 !== e.right && (_this30.domNode.style.right = e.right + "px"), _this30._mouseMoveMonitor = _this30._register(new mi()), _this30.onmousedown(_this30.bgDomNode, function (e) {
      return _this30._arrowMouseDown(e);
    }), _this30.onmousedown(_this30.domNode, function (e) {
      return _this30._arrowMouseDown(e);
    }), _this30._mousedownRepeatTimer = _this30._register(new ct()), _this30._mousedownScheduleRepeatTimer = _this30._register(new ht());
    return _this30;
  }

  _createClass(wi, [{
    key: "_arrowMouseDown",
    value: function _arrowMouseDown(e) {
      var _this31 = this;

      this._onActivate(), this._mousedownRepeatTimer.cancel(), this._mousedownScheduleRepeatTimer.cancelAndSet(function () {
        _this31._mousedownRepeatTimer.cancelAndSet(function () {
          return _this31._onActivate();
        }, 1e3 / 24);
      }, 200), this._mouseMoveMonitor.startMonitoring(pi, function (e) {}, function () {
        _this31._mousedownRepeatTimer.cancel(), _this31._mousedownScheduleRepeatTimer.cancel();
      }), e.preventDefault();
    }
  }]);

  return wi;
}(fi);

var vi =
/*#__PURE__*/
function (_f9) {
  _inherits(vi, _f9);

  function vi(e, t, i) {
    var _this32;

    _classCallCheck(this, vi);

    _this32 = _possibleConstructorReturn(this, _getPrototypeOf(vi).call(this)), _this32._visibility = e, _this32._visibleClassName = t, _this32._invisibleClassName = i, _this32._domNode = null, _this32._isVisible = !1, _this32._isNeeded = !1, _this32._shouldBeVisible = !1, _this32._revealTimer = _this32._register(new ht());
    return _this32;
  }

  _createClass(vi, [{
    key: "applyVisibilitySetting",
    value: function applyVisibilitySetting(e) {
      return 2 !== this._visibility && (3 === this._visibility || e);
    }
  }, {
    key: "setShouldBeVisible",
    value: function setShouldBeVisible(e) {
      var t = this.applyVisibilitySetting(e);
      this._shouldBeVisible !== t && (this._shouldBeVisible = t, this.ensureVisibility());
    }
  }, {
    key: "setIsNeeded",
    value: function setIsNeeded(e) {
      this._isNeeded !== e && (this._isNeeded = e, this.ensureVisibility());
    }
  }, {
    key: "setDomNode",
    value: function setDomNode(e) {
      this._domNode = e, this._domNode.setClassName(this._invisibleClassName), this.setShouldBeVisible(!1);
    }
  }, {
    key: "ensureVisibility",
    value: function ensureVisibility() {
      this._isNeeded ? this._shouldBeVisible ? this._reveal() : this._hide(!0) : this._hide(!1);
    }
  }, {
    key: "_reveal",
    value: function _reveal() {
      var _this33 = this;

      this._isVisible || (this._isVisible = !0, this._revealTimer.setIfNotSet(function () {
        _this33._domNode && _this33._domNode.setClassName(_this33._visibleClassName);
      }, 0));
    }
  }, {
    key: "_hide",
    value: function _hide(e) {
      this._revealTimer.cancel(), this._isVisible && (this._isVisible = !1, this._domNode && this._domNode.setClassName(this._invisibleClassName + (e ? " fade" : "")));
    }
  }]);

  return vi;
}(f);

var Ei = 140;

var yi =
/*#__PURE__*/
function (_fi2) {
  _inherits(yi, _fi2);

  function yi(e) {
    var _this34;

    _classCallCheck(this, yi);

    _this34 = _possibleConstructorReturn(this, _getPrototypeOf(yi).call(this)), _this34._lazyRender = e.lazyRender, _this34._host = e.host, _this34._scrollable = e.scrollable, _this34._scrollbarState = e.scrollbarState, _this34._visibilityController = _this34._register(new vi(e.visibility, "visible scrollbar " + e.extraScrollbarClassName, "invisible scrollbar " + e.extraScrollbarClassName)), _this34._mouseMoveMonitor = _this34._register(new mi()), _this34._shouldRender = !0, _this34.domNode = Ci(document.createElement("div")), _this34.domNode.setAttribute("role", "presentation"), _this34.domNode.setAttribute("aria-hidden", "true"), _this34._visibilityController.setDomNode(_this34.domNode), _this34.domNode.setPosition("absolute"), _this34.onmousedown(_this34.domNode.domNode, function (e) {
      return _this34._domNodeMouseDown(e);
    });
    return _this34;
  }

  _createClass(yi, [{
    key: "_createArrow",
    value: function _createArrow(e) {
      var t = this._register(new wi(e));

      this.domNode.domNode.appendChild(t.bgDomNode), this.domNode.domNode.appendChild(t.domNode);
    }
  }, {
    key: "_createSlider",
    value: function _createSlider(e, t, i, o) {
      var _this35 = this;

      this.slider = Ci(document.createElement("div")), this.slider.setClassName("slider"), this.slider.setPosition("absolute"), this.slider.setTop(e), this.slider.setLeft(t), "number" == typeof i && this.slider.setWidth(i), "number" == typeof o && this.slider.setHeight(o), this.slider.setLayerHinting(!0), this.domNode.domNode.appendChild(this.slider.domNode), this.onmousedown(this.slider.domNode, function (e) {
        e.leftButton && (e.preventDefault(), _this35._sliderMouseDown(e, function () {}));
      });
    }
  }, {
    key: "_onElementSize",
    value: function _onElementSize(e) {
      return this._scrollbarState.setVisibleSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
  }, {
    key: "_onElementScrollSize",
    value: function _onElementScrollSize(e) {
      return this._scrollbarState.setScrollSize(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
  }, {
    key: "_onElementScrollPosition",
    value: function _onElementScrollPosition(e) {
      return this._scrollbarState.setScrollPosition(e) && (this._visibilityController.setIsNeeded(this._scrollbarState.isNeeded()), this._shouldRender = !0, this._lazyRender || this.render()), this._shouldRender;
    }
  }, {
    key: "beginReveal",
    value: function beginReveal() {
      this._visibilityController.setShouldBeVisible(!0);
    }
  }, {
    key: "beginHide",
    value: function beginHide() {
      this._visibilityController.setShouldBeVisible(!1);
    }
  }, {
    key: "render",
    value: function render() {
      this._shouldRender && (this._shouldRender = !1, this._renderDomNode(this._scrollbarState.getRectangleLargeSize(), this._scrollbarState.getRectangleSmallSize()), this._updateSlider(this._scrollbarState.getSliderSize(), this._scrollbarState.getArrowSize() + this._scrollbarState.getSliderPosition()));
    }
  }, {
    key: "_domNodeMouseDown",
    value: function _domNodeMouseDown(e) {
      e.target === this.domNode.domNode && this._onMouseDown(e);
    }
  }, {
    key: "delegateMouseDown",
    value: function delegateMouseDown(e) {
      var t = this.domNode.domNode.getClientRects()[0].top,
          i = t + this._scrollbarState.getSliderPosition(),
          o = t + this._scrollbarState.getSliderPosition() + this._scrollbarState.getSliderSize(),
          n = this._sliderMousePosition(e);

      i <= n && n <= o ? e.leftButton && (e.preventDefault(), this._sliderMouseDown(e, function () {})) : this._onMouseDown(e);
    }
  }, {
    key: "_onMouseDown",
    value: function _onMouseDown(e) {
      var t, i;
      if (e.target === this.domNode.domNode && "number" == typeof e.browserEvent.offsetX && "number" == typeof e.browserEvent.offsetY) t = e.browserEvent.offsetX, i = e.browserEvent.offsetY;else {
        var _o15 = function (e) {
          var t = e.getBoundingClientRect();
          return {
            left: t.left + Pt.scrollX,
            top: t.top + Pt.scrollY,
            width: t.width,
            height: t.height
          };
        }(this.domNode.domNode);

        t = e.posx - _o15.left, i = e.posy - _o15.top;
      }
      this._setDesiredScrollPositionNow(this._scrollbarState.getDesiredScrollPositionFromOffset(this._mouseDownRelativePosition(t, i))), e.leftButton && (e.preventDefault(), this._sliderMouseDown(e, function () {}));
    }
  }, {
    key: "_sliderMouseDown",
    value: function _sliderMouseDown(e, t) {
      var _this36 = this;

      var i = this._sliderMousePosition(e),
          o = this._sliderOrthogonalMousePosition(e),
          n = this._scrollbarState.clone();

      this.slider.toggleClassName("active", !0), this._mouseMoveMonitor.startMonitoring(pi, function (e) {
        var t = _this36._sliderOrthogonalMousePosition(e),
            s = Math.abs(t - o);

        if (T && s > Ei) return void _this36._setDesiredScrollPositionNow(n.getScrollPosition());
        var r = _this36._sliderMousePosition(e) - i;

        _this36._setDesiredScrollPositionNow(n.getDesiredScrollPositionFromDelta(r));
      }, function () {
        _this36.slider.toggleClassName("active", !1), _this36._host.onDragEnd(), t();
      }), this._host.onDragStart();
    }
  }, {
    key: "_setDesiredScrollPositionNow",
    value: function _setDesiredScrollPositionNow(e) {
      var t = {};
      this.writeScrollPosition(t, e), this._scrollable.setScrollPositionNow(t);
    }
  }]);

  return yi;
}(fi);

var Mi = 20;

var Bi =
/*#__PURE__*/
function () {
  function Bi(e, t, i) {
    _classCallCheck(this, Bi);

    this._scrollbarSize = Math.round(t), this._oppositeScrollbarSize = Math.round(i), this._arrowSize = Math.round(e), this._visibleSize = 0, this._scrollSize = 0, this._scrollPosition = 0, this._computedAvailableSize = 0, this._computedIsNeeded = !1, this._computedSliderSize = 0, this._computedSliderRatio = 0, this._computedSliderPosition = 0, this._refreshComputedValues();
  }

  _createClass(Bi, [{
    key: "clone",
    value: function clone() {
      var e = new Bi(this._arrowSize, this._scrollbarSize, this._oppositeScrollbarSize);
      return e.setVisibleSize(this._visibleSize), e.setScrollSize(this._scrollSize), e.setScrollPosition(this._scrollPosition), e;
    }
  }, {
    key: "setVisibleSize",
    value: function setVisibleSize(e) {
      var t = Math.round(e);
      return this._visibleSize !== t && (this._visibleSize = t, this._refreshComputedValues(), !0);
    }
  }, {
    key: "setScrollSize",
    value: function setScrollSize(e) {
      var t = Math.round(e);
      return this._scrollSize !== t && (this._scrollSize = t, this._refreshComputedValues(), !0);
    }
  }, {
    key: "setScrollPosition",
    value: function setScrollPosition(e) {
      var t = Math.round(e);
      return this._scrollPosition !== t && (this._scrollPosition = t, this._refreshComputedValues(), !0);
    }
  }, {
    key: "_refreshComputedValues",
    value: function _refreshComputedValues() {
      var e = Bi._computeValues(this._oppositeScrollbarSize, this._arrowSize, this._visibleSize, this._scrollSize, this._scrollPosition);

      this._computedAvailableSize = e.computedAvailableSize, this._computedIsNeeded = e.computedIsNeeded, this._computedSliderSize = e.computedSliderSize, this._computedSliderRatio = e.computedSliderRatio, this._computedSliderPosition = e.computedSliderPosition;
    }
  }, {
    key: "getArrowSize",
    value: function getArrowSize() {
      return this._arrowSize;
    }
  }, {
    key: "getScrollPosition",
    value: function getScrollPosition() {
      return this._scrollPosition;
    }
  }, {
    key: "getRectangleLargeSize",
    value: function getRectangleLargeSize() {
      return this._computedAvailableSize;
    }
  }, {
    key: "getRectangleSmallSize",
    value: function getRectangleSmallSize() {
      return this._scrollbarSize;
    }
  }, {
    key: "isNeeded",
    value: function isNeeded() {
      return this._computedIsNeeded;
    }
  }, {
    key: "getSliderSize",
    value: function getSliderSize() {
      return this._computedSliderSize;
    }
  }, {
    key: "getSliderPosition",
    value: function getSliderPosition() {
      return this._computedSliderPosition;
    }
  }, {
    key: "getDesiredScrollPositionFromOffset",
    value: function getDesiredScrollPositionFromOffset(e) {
      if (!this._computedIsNeeded) return 0;
      var t = e - this._arrowSize - this._computedSliderSize / 2;
      return Math.round(t / this._computedSliderRatio);
    }
  }, {
    key: "getDesiredScrollPositionFromDelta",
    value: function getDesiredScrollPositionFromDelta(e) {
      if (!this._computedIsNeeded) return 0;
      var t = this._computedSliderPosition + e;
      return Math.round(t / this._computedSliderRatio);
    }
  }], [{
    key: "_computeValues",
    value: function _computeValues(e, t, i, o, n) {
      var s = Math.max(0, i - e),
          r = Math.max(0, s - 2 * t),
          l = o > 0 && o > i;
      if (!l) return {
        computedAvailableSize: Math.round(s),
        computedIsNeeded: l,
        computedSliderSize: Math.round(r),
        computedSliderRatio: 0,
        computedSliderPosition: 0
      };
      var a = Math.round(Math.max(Mi, Math.floor(i * r / o))),
          A = (r - a) / (o - i),
          h = n * A;
      return {
        computedAvailableSize: Math.round(s),
        computedIsNeeded: l,
        computedSliderSize: Math.round(a),
        computedSliderRatio: A,
        computedSliderPosition: Math.round(h)
      };
    }
  }]);

  return Bi;
}();

var bi =
/*#__PURE__*/
function (_yi) {
  _inherits(bi, _yi);

  function bi(e, t, i) {
    var _this37;

    _classCallCheck(this, bi);

    if (_this37 = _possibleConstructorReturn(this, _getPrototypeOf(bi).call(this, {
      lazyRender: t.lazyRender,
      host: i,
      scrollbarState: new Bi(t.horizontalHasArrows ? t.arrowSize : 0, 2 === t.horizontal ? 0 : t.horizontalScrollbarSize, 2 === t.vertical ? 0 : t.verticalScrollbarSize),
      visibility: t.horizontal,
      extraScrollbarClassName: "horizontal",
      scrollable: e
    })), t.horizontalHasArrows) {
      var _e31 = (t.arrowSize - Di) / 2,
          _i28 = (t.horizontalScrollbarSize - Di) / 2;

      _this37._createArrow({
        className: "left-arrow",
        top: _i28,
        left: _e31,
        bottom: void 0,
        right: void 0,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: function onActivate() {
          return _this37._host.onMouseWheel(new it(null, 1, 0));
        }
      }), _this37._createArrow({
        className: "right-arrow",
        top: _i28,
        left: void 0,
        bottom: void 0,
        right: _e31,
        bgWidth: t.arrowSize,
        bgHeight: t.horizontalScrollbarSize,
        onActivate: function onActivate() {
          return _this37._host.onMouseWheel(new it(null, -1, 0));
        }
      });
    }

    _this37._createSlider(Math.floor((t.horizontalScrollbarSize - t.horizontalSliderSize) / 2), 0, void 0, t.horizontalSliderSize);

    return _possibleConstructorReturn(_this37);
  }

  _createClass(bi, [{
    key: "_updateSlider",
    value: function _updateSlider(e, t) {
      this.slider.setWidth(e), this.slider.setLeft(t);
    }
  }, {
    key: "_renderDomNode",
    value: function _renderDomNode(e, t) {
      this.domNode.setWidth(e), this.domNode.setHeight(t), this.domNode.setLeft(0), this.domNode.setBottom(0);
    }
  }, {
    key: "onDidScroll",
    value: function onDidScroll(e) {
      return this._shouldRender = this._onElementScrollSize(e.scrollWidth) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollLeft) || this._shouldRender, this._shouldRender = this._onElementSize(e.width) || this._shouldRender, this._shouldRender;
    }
  }, {
    key: "_mouseDownRelativePosition",
    value: function _mouseDownRelativePosition(e, t) {
      return e;
    }
  }, {
    key: "_sliderMousePosition",
    value: function _sliderMousePosition(e) {
      return e.posx;
    }
  }, {
    key: "_sliderOrthogonalMousePosition",
    value: function _sliderOrthogonalMousePosition(e) {
      return e.posy;
    }
  }, {
    key: "writeScrollPosition",
    value: function writeScrollPosition(e, t) {
      e.scrollLeft = t;
    }
  }]);

  return bi;
}(yi);

var Fi =
/*#__PURE__*/
function (_yi2) {
  _inherits(Fi, _yi2);

  function Fi(e, t, i) {
    var _this38;

    _classCallCheck(this, Fi);

    if (_this38 = _possibleConstructorReturn(this, _getPrototypeOf(Fi).call(this, {
      lazyRender: t.lazyRender,
      host: i,
      scrollbarState: new Bi(t.verticalHasArrows ? t.arrowSize : 0, 2 === t.vertical ? 0 : t.verticalScrollbarSize, 0),
      visibility: t.vertical,
      extraScrollbarClassName: "vertical",
      scrollable: e
    })), t.verticalHasArrows) {
      var _e32 = (t.arrowSize - Di) / 2,
          _i29 = (t.verticalScrollbarSize - Di) / 2;

      _this38._createArrow({
        className: "up-arrow",
        top: _e32,
        left: _i29,
        bottom: void 0,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: function onActivate() {
          return _this38._host.onMouseWheel(new it(null, 0, 1));
        }
      }), _this38._createArrow({
        className: "down-arrow",
        top: void 0,
        left: _i29,
        bottom: _e32,
        right: void 0,
        bgWidth: t.verticalScrollbarSize,
        bgHeight: t.arrowSize,
        onActivate: function onActivate() {
          return _this38._host.onMouseWheel(new it(null, 0, -1));
        }
      });
    }

    _this38._createSlider(0, Math.floor((t.verticalScrollbarSize - t.verticalSliderSize) / 2), t.verticalSliderSize, void 0);

    return _possibleConstructorReturn(_this38);
  }

  _createClass(Fi, [{
    key: "_updateSlider",
    value: function _updateSlider(e, t) {
      this.slider.setHeight(e), this.slider.setTop(t);
    }
  }, {
    key: "_renderDomNode",
    value: function _renderDomNode(e, t) {
      this.domNode.setWidth(t), this.domNode.setHeight(e), this.domNode.setRight(0), this.domNode.setTop(0);
    }
  }, {
    key: "onDidScroll",
    value: function onDidScroll(e) {
      return this._shouldRender = this._onElementScrollSize(e.scrollHeight) || this._shouldRender, this._shouldRender = this._onElementScrollPosition(e.scrollTop) || this._shouldRender, this._shouldRender = this._onElementSize(e.height) || this._shouldRender, this._shouldRender;
    }
  }, {
    key: "_mouseDownRelativePosition",
    value: function _mouseDownRelativePosition(e, t) {
      return t;
    }
  }, {
    key: "_sliderMousePosition",
    value: function _sliderMousePosition(e) {
      return e.posy;
    }
  }, {
    key: "_sliderOrthogonalMousePosition",
    value: function _sliderOrthogonalMousePosition(e) {
      return e.posx;
    }
  }, {
    key: "writeScrollPosition",
    value: function writeScrollPosition(e, t) {
      e.scrollTop = t;
    }
  }]);

  return Fi;
}(yi);

var Hi =
/*#__PURE__*/
function () {
  function Hi(e, t, i, o, n, s) {
    _classCallCheck(this, Hi);

    (e |= 0) < 0 && (e = 0), (i |= 0) + e > (t |= 0) && (i = t - e), i < 0 && (i = 0), (o |= 0) < 0 && (o = 0), (s |= 0) + o > (n |= 0) && (s = n - o), s < 0 && (s = 0), this.width = e, this.scrollWidth = t, this.scrollLeft = i, this.height = o, this.scrollHeight = n, this.scrollTop = s;
  }

  _createClass(Hi, [{
    key: "equals",
    value: function equals(e) {
      return this.width === e.width && this.scrollWidth === e.scrollWidth && this.scrollLeft === e.scrollLeft && this.height === e.height && this.scrollHeight === e.scrollHeight && this.scrollTop === e.scrollTop;
    }
  }, {
    key: "withScrollDimensions",
    value: function withScrollDimensions(e) {
      return new Hi(void 0 !== e.width ? e.width : this.width, void 0 !== e.scrollWidth ? e.scrollWidth : this.scrollWidth, this.scrollLeft, void 0 !== e.height ? e.height : this.height, void 0 !== e.scrollHeight ? e.scrollHeight : this.scrollHeight, this.scrollTop);
    }
  }, {
    key: "withScrollPosition",
    value: function withScrollPosition(e) {
      return new Hi(this.width, this.scrollWidth, void 0 !== e.scrollLeft ? e.scrollLeft : this.scrollLeft, this.height, this.scrollHeight, void 0 !== e.scrollTop ? e.scrollTop : this.scrollTop);
    }
  }, {
    key: "createScrollEvent",
    value: function createScrollEvent(e) {
      var t = this.width !== e.width,
          i = this.scrollWidth !== e.scrollWidth,
          o = this.scrollLeft !== e.scrollLeft,
          n = this.height !== e.height,
          s = this.scrollHeight !== e.scrollHeight,
          r = this.scrollTop !== e.scrollTop;
      return {
        width: this.width,
        scrollWidth: this.scrollWidth,
        scrollLeft: this.scrollLeft,
        height: this.height,
        scrollHeight: this.scrollHeight,
        scrollTop: this.scrollTop,
        widthChanged: t,
        scrollWidthChanged: i,
        scrollLeftChanged: o,
        heightChanged: n,
        scrollHeightChanged: s,
        scrollTopChanged: r
      };
    }
  }]);

  return Hi;
}();

var Si =
/*#__PURE__*/
function (_f10) {
  _inherits(Si, _f10);

  function Si(e, t) {
    var _this39;

    _classCallCheck(this, Si);

    _this39 = _possibleConstructorReturn(this, _getPrototypeOf(Si).call(this)), _this39._onScroll = _this39._register(new b()), _this39.onScroll = _this39._onScroll.event, _this39._smoothScrollDuration = e, _this39._scheduleAtNextAnimationFrame = t, _this39._state = new Hi(0, 0, 0, 0, 0, 0), _this39._smoothScrolling = null;
    return _this39;
  }

  _createClass(Si, [{
    key: "dispose",
    value: function dispose() {
      this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), _get(_getPrototypeOf(Si.prototype), "dispose", this).call(this);
    }
  }, {
    key: "setSmoothScrollDuration",
    value: function setSmoothScrollDuration(e) {
      this._smoothScrollDuration = e;
    }
  }, {
    key: "validateScrollPosition",
    value: function validateScrollPosition(e) {
      return this._state.withScrollPosition(e);
    }
  }, {
    key: "getScrollDimensions",
    value: function getScrollDimensions() {
      return this._state;
    }
  }, {
    key: "setScrollDimensions",
    value: function setScrollDimensions(e) {
      var t = this._state.withScrollDimensions(e);

      this._setState(t), this._smoothScrolling && this._smoothScrolling.acceptScrollDimensions(this._state);
    }
  }, {
    key: "getFutureScrollPosition",
    value: function getFutureScrollPosition() {
      return this._smoothScrolling ? this._smoothScrolling.to : this._state;
    }
  }, {
    key: "getCurrentScrollPosition",
    value: function getCurrentScrollPosition() {
      return this._state;
    }
  }, {
    key: "setScrollPositionNow",
    value: function setScrollPositionNow(e) {
      var t = this._state.withScrollPosition(e);

      this._smoothScrolling && (this._smoothScrolling.dispose(), this._smoothScrolling = null), this._setState(t);
    }
  }, {
    key: "setScrollPositionSmooth",
    value: function setScrollPositionSmooth(e) {
      var _this40 = this;

      if (0 === this._smoothScrollDuration) return this.setScrollPositionNow(e);

      if (this._smoothScrolling) {
        e = {
          scrollLeft: void 0 === e.scrollLeft ? this._smoothScrolling.to.scrollLeft : e.scrollLeft,
          scrollTop: void 0 === e.scrollTop ? this._smoothScrolling.to.scrollTop : e.scrollTop
        };

        var _t21 = this._state.withScrollPosition(e);

        if (this._smoothScrolling.to.scrollLeft === _t21.scrollLeft && this._smoothScrolling.to.scrollTop === _t21.scrollTop) return;

        var _i30 = this._smoothScrolling.combine(this._state, _t21, this._smoothScrollDuration);

        this._smoothScrolling.dispose(), this._smoothScrolling = _i30;
      } else {
        var _t22 = this._state.withScrollPosition(e);

        this._smoothScrolling = Vi.start(this._state, _t22, this._smoothScrollDuration);
      }

      this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(function () {
        _this40._smoothScrolling && (_this40._smoothScrolling.animationFrameDisposable = null, _this40._performSmoothScrolling());
      });
    }
  }, {
    key: "_performSmoothScrolling",
    value: function _performSmoothScrolling() {
      var _this41 = this;

      if (!this._smoothScrolling) return;

      var e = this._smoothScrolling.tick(),
          t = this._state.withScrollPosition(e);

      if (this._setState(t), e.isDone) return this._smoothScrolling.dispose(), void (this._smoothScrolling = null);
      this._smoothScrolling.animationFrameDisposable = this._scheduleAtNextAnimationFrame(function () {
        _this41._smoothScrolling && (_this41._smoothScrolling.animationFrameDisposable = null, _this41._performSmoothScrolling());
      });
    }
  }, {
    key: "_setState",
    value: function _setState(e) {
      var t = this._state;
      t.equals(e) || (this._state = e, this._onScroll.fire(this._state.createScrollEvent(t)));
    }
  }]);

  return Si;
}(f);

var zi = function zi(e, t, i) {
  _classCallCheck(this, zi);

  this.scrollLeft = e, this.scrollTop = t, this.isDone = i;
};

function xi(e, t) {
  var i = t - e;
  return function (t) {
    return e + i * (1 - function (e) {
      return Math.pow(e, 3);
    }(1 - t));
  };
}

var Vi =
/*#__PURE__*/
function () {
  function Vi(e, t, i, o) {
    _classCallCheck(this, Vi);

    this.from = e, this.to = t, this.duration = o, this._startTime = i, this.animationFrameDisposable = null, this._initAnimations();
  }

  _createClass(Vi, [{
    key: "_initAnimations",
    value: function _initAnimations() {
      this.scrollLeft = this._initAnimation(this.from.scrollLeft, this.to.scrollLeft, this.to.width), this.scrollTop = this._initAnimation(this.from.scrollTop, this.to.scrollTop, this.to.height);
    }
  }, {
    key: "_initAnimation",
    value: function _initAnimation(e, t, i) {
      if (Math.abs(e - t) > 2.5 * i) {
        var _r5, _l2;

        return e < t ? (_r5 = e + .75 * i, _l2 = t - .75 * i) : (_r5 = e - .75 * i, _l2 = t + .75 * i), o = xi(e, _r5), n = xi(_l2, t), s = .33, function (e) {
          return e < s ? o(e / s) : n((e - s) / (1 - s));
        };
      }

      var o, n, s;
      return xi(e, t);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      null !== this.animationFrameDisposable && (this.animationFrameDisposable.dispose(), this.animationFrameDisposable = null);
    }
  }, {
    key: "acceptScrollDimensions",
    value: function acceptScrollDimensions(e) {
      this.to = e.withScrollPosition(this.to), this._initAnimations();
    }
  }, {
    key: "tick",
    value: function tick() {
      return this._tick(Date.now());
    }
  }, {
    key: "_tick",
    value: function _tick(e) {
      var t = (e - this._startTime) / this.duration;

      if (t < 1) {
        var _e33 = this.scrollLeft(t),
            _i31 = this.scrollTop(t);

        return new zi(_e33, _i31, !1);
      }

      return new zi(this.to.scrollLeft, this.to.scrollTop, !0);
    }
  }, {
    key: "combine",
    value: function combine(e, t, i) {
      return Vi.start(e, t, i);
    }
  }], [{
    key: "start",
    value: function start(e, t, i) {
      i += 10;
      var o = Date.now() - 10;
      return new Vi(e, t, o, i);
    }
  }]);

  return Vi;
}();

var Ii = 500,
    _i = 50;

var Ni = function Ni(e, t, i) {
  _classCallCheck(this, Ni);

  this.timestamp = e, this.deltaX = t, this.deltaY = i, this.score = 0;
};

var Li =
/*#__PURE__*/
function () {
  function Li() {
    _classCallCheck(this, Li);

    this._capacity = 5, this._memory = [], this._front = -1, this._rear = -1;
  }

  _createClass(Li, [{
    key: "isPhysicalMouseWheel",
    value: function isPhysicalMouseWheel() {
      if (-1 === this._front && -1 === this._rear) return !1;
      var e = 1,
          t = 0,
          i = 1,
          o = this._rear;

      for (;;) {
        var _n16 = o === this._front ? e : Math.pow(2, -i);

        if (e -= _n16, t += this._memory[o].score * _n16, o === this._front) break;
        o = (this._capacity + o - 1) % this._capacity, i++;
      }

      return t <= .5;
    }
  }, {
    key: "accept",
    value: function accept(e, t, i) {
      var o = new Ni(e, t, i);
      o.score = this._computeScore(o), -1 === this._front && -1 === this._rear ? (this._memory[0] = o, this._front = 0, this._rear = 0) : (this._rear = (this._rear + 1) % this._capacity, this._rear === this._front && (this._front = (this._front + 1) % this._capacity), this._memory[this._rear] = o);
    }
  }, {
    key: "_computeScore",
    value: function _computeScore(e) {
      if (Math.abs(e.deltaX) > 0 && Math.abs(e.deltaY) > 0) return 1;
      var t = .5;
      -1 === this._front && -1 === this._rear || this._memory[this._rear];
      return (Math.abs(e.deltaX - Math.round(e.deltaX)) > 0 || Math.abs(e.deltaY - Math.round(e.deltaY)) > 0) && (t += .25), Math.min(Math.max(t, 0), 1);
    }
  }]);

  return Li;
}();

Li.INSTANCE = new Li();

var Pi =
/*#__PURE__*/
function (_fi3) {
  _inherits(Pi, _fi3);

  function Pi(e, t, i) {
    var _this42;

    _classCallCheck(this, Pi);

    _this42 = _possibleConstructorReturn(this, _getPrototypeOf(Pi).call(this)), _this42._onScroll = _this42._register(new b()), _this42.onScroll = _this42._onScroll.event, e.style.overflow = "hidden", _this42._options = Ri(t), _this42._scrollable = i, _this42._register(_this42._scrollable.onScroll(function (e) {
      _this42._onDidScroll(e), _this42._onScroll.fire(e);
    }));
    var o = {
      onMouseWheel: function onMouseWheel(e) {
        return _this42._onMouseWheel(e);
      },
      onDragStart: function onDragStart() {
        return _this42._onDragStart();
      },
      onDragEnd: function onDragEnd() {
        return _this42._onDragEnd();
      }
    };
    _this42._verticalScrollbar = _this42._register(new Fi(_this42._scrollable, _this42._options, o)), _this42._horizontalScrollbar = _this42._register(new bi(_this42._scrollable, _this42._options, o)), _this42._domNode = document.createElement("div"), _this42._domNode.className = "monaco-scrollable-element " + _this42._options.className, _this42._domNode.setAttribute("role", "presentation"), _this42._domNode.style.position = "relative", _this42._domNode.style.overflow = "hidden", _this42._domNode.appendChild(e), _this42._domNode.appendChild(_this42._horizontalScrollbar.domNode.domNode), _this42._domNode.appendChild(_this42._verticalScrollbar.domNode.domNode), _this42._options.useShadows && (_this42._leftShadowDomNode = Ci(document.createElement("div")), _this42._leftShadowDomNode.setClassName("shadow"), _this42._domNode.appendChild(_this42._leftShadowDomNode.domNode), _this42._topShadowDomNode = Ci(document.createElement("div")), _this42._topShadowDomNode.setClassName("shadow"), _this42._domNode.appendChild(_this42._topShadowDomNode.domNode), _this42._topLeftShadowDomNode = Ci(document.createElement("div")), _this42._topLeftShadowDomNode.setClassName("shadow top-left-corner"), _this42._domNode.appendChild(_this42._topLeftShadowDomNode.domNode)), _this42._listenOnDomNode = _this42._options.listenOnDomNode || _this42._domNode, _this42._mouseWheelToDispose = [], _this42._setListeningToMouseWheel(_this42._options.handleMouseWheel), _this42.onmouseover(_this42._listenOnDomNode, function (e) {
      return _this42._onMouseOver(e);
    }), _this42.onnonbubblingmouseout(_this42._listenOnDomNode, function (e) {
      return _this42._onMouseOut(e);
    }), _this42._hideTimeout = _this42._register(new ht()), _this42._isDragging = !1, _this42._mouseIsOver = !1, _this42._shouldRender = !0, _this42._revealOnScroll = !0;
    return _this42;
  }

  _createClass(Pi, [{
    key: "dispose",
    value: function dispose() {
      this._mouseWheelToDispose = C(this._mouseWheelToDispose), _get(_getPrototypeOf(Pi.prototype), "dispose", this).call(this);
    }
  }, {
    key: "getDomNode",
    value: function getDomNode() {
      return this._domNode;
    }
  }, {
    key: "getOverviewRulerLayoutInfo",
    value: function getOverviewRulerLayoutInfo() {
      return {
        parent: this._domNode,
        insertBefore: this._verticalScrollbar.domNode.domNode
      };
    }
  }, {
    key: "delegateVerticalScrollbarMouseDown",
    value: function delegateVerticalScrollbarMouseDown(e) {
      this._verticalScrollbar.delegateMouseDown(e);
    }
  }, {
    key: "getScrollDimensions",
    value: function getScrollDimensions() {
      return this._scrollable.getScrollDimensions();
    }
  }, {
    key: "setScrollDimensions",
    value: function setScrollDimensions(e) {
      this._scrollable.setScrollDimensions(e);
    }
  }, {
    key: "updateClassName",
    value: function updateClassName(e) {
      this._options.className = e, k && (this._options.className += " mac"), this._domNode.className = "monaco-scrollable-element " + this._options.className;
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(e) {
      var t = Ri(e);
      this._options.handleMouseWheel = t.handleMouseWheel, this._options.mouseWheelScrollSensitivity = t.mouseWheelScrollSensitivity, this._options.fastScrollSensitivity = t.fastScrollSensitivity, this._setListeningToMouseWheel(this._options.handleMouseWheel), this._options.lazyRender || this._render();
    }
  }, {
    key: "setRevealOnScroll",
    value: function setRevealOnScroll(e) {
      this._revealOnScroll = e;
    }
  }, {
    key: "_setListeningToMouseWheel",
    value: function _setListeningToMouseWheel(e) {
      var _this43 = this;

      if (this._mouseWheelToDispose.length > 0 !== e && (this._mouseWheelToDispose = C(this._mouseWheelToDispose), e)) {
        var _e34 = function _e34(e) {
          _this43._onMouseWheel(new it(e));
        };

        this._mouseWheelToDispose.push(bt(this._listenOnDomNode, "mousewheel", _e34));
      }
    }
  }, {
    key: "_onMouseWheel",
    value: function _onMouseWheel(e) {
      var t = Li.INSTANCE;

      if (t.accept(Date.now(), e.deltaX, e.deltaY), e.deltaY || e.deltaX) {
        var _ref7;

        var _i32 = e.deltaY * this._options.mouseWheelScrollSensitivity,
            _o16 = e.deltaX * this._options.mouseWheelScrollSensitivity;

        this._options.flipAxes && (_ref7 = [_o16, _i32], _i32 = _ref7[0], _o16 = _ref7[1], _ref7);

        var _n17 = !k && e.browserEvent && e.browserEvent.shiftKey;

        !this._options.scrollYToX && !_n17 || _o16 || (_o16 = _i32, _i32 = 0), e.browserEvent && e.browserEvent.altKey && (_o16 *= this._options.fastScrollSensitivity, _i32 *= this._options.fastScrollSensitivity);

        var _s9 = this._scrollable.getFutureScrollPosition();

        var _r6 = {};

        if (_i32) {
          var _e35 = _s9.scrollTop - _i * _i32;

          this._verticalScrollbar.writeScrollPosition(_r6, _e35);
        }

        if (_o16) {
          var _e36 = _s9.scrollLeft - _i * _o16;

          this._horizontalScrollbar.writeScrollPosition(_r6, _e36);
        }

        if (_r6 = this._scrollable.validateScrollPosition(_r6), _s9.scrollLeft !== _r6.scrollLeft || _s9.scrollTop !== _r6.scrollTop) {
          this._options.mouseWheelSmoothScroll && t.isPhysicalMouseWheel() ? this._scrollable.setScrollPositionSmooth(_r6) : this._scrollable.setScrollPositionNow(_r6), this._shouldRender = !0;
        }
      }

      (this._options.alwaysConsumeMouseWheel || this._shouldRender) && (e.preventDefault(), e.stopPropagation());
    }
  }, {
    key: "_onDidScroll",
    value: function _onDidScroll(e) {
      this._shouldRender = this._horizontalScrollbar.onDidScroll(e) || this._shouldRender, this._shouldRender = this._verticalScrollbar.onDidScroll(e) || this._shouldRender, this._options.useShadows && (this._shouldRender = !0), this._revealOnScroll && this._reveal(), this._options.lazyRender || this._render();
    }
  }, {
    key: "renderNow",
    value: function renderNow() {
      if (!this._options.lazyRender) throw new Error("Please use `lazyRender` together with `renderNow`!");

      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      if (this._shouldRender && (this._shouldRender = !1, this._horizontalScrollbar.render(), this._verticalScrollbar.render(), this._options.useShadows)) {
        var _e37 = this._scrollable.getCurrentScrollPosition();

        var _t23 = _e37.scrollTop > 0,
            _i33 = _e37.scrollLeft > 0;

        this._leftShadowDomNode.setClassName("shadow" + (_i33 ? " left" : "")), this._topShadowDomNode.setClassName("shadow" + (_t23 ? " top" : "")), this._topLeftShadowDomNode.setClassName("shadow top-left-corner" + (_t23 ? " top" : "") + (_i33 ? " left" : ""));
      }
    }
  }, {
    key: "_onDragStart",
    value: function _onDragStart() {
      this._isDragging = !0, this._reveal();
    }
  }, {
    key: "_onDragEnd",
    value: function _onDragEnd() {
      this._isDragging = !1, this._hide();
    }
  }, {
    key: "_onMouseOut",
    value: function _onMouseOut(e) {
      this._mouseIsOver = !1, this._hide();
    }
  }, {
    key: "_onMouseOver",
    value: function _onMouseOver(e) {
      this._mouseIsOver = !0, this._reveal();
    }
  }, {
    key: "_reveal",
    value: function _reveal() {
      this._verticalScrollbar.beginReveal(), this._horizontalScrollbar.beginReveal(), this._scheduleHide();
    }
  }, {
    key: "_hide",
    value: function _hide() {
      this._mouseIsOver || this._isDragging || (this._verticalScrollbar.beginHide(), this._horizontalScrollbar.beginHide());
    }
  }, {
    key: "_scheduleHide",
    value: function _scheduleHide() {
      var _this44 = this;

      this._mouseIsOver || this._isDragging || this._hideTimeout.cancelAndSet(function () {
        return _this44._hide();
      }, Ii);
    }
  }]);

  return Pi;
}(fi);

var Qi =
/*#__PURE__*/
function (_Pi) {
  _inherits(Qi, _Pi);

  function Qi(e, t) {
    var _this45;

    _classCallCheck(this, Qi);

    (t = t || {}).mouseWheelSmoothScroll = !1;
    var i = new Si(0, function (e) {
      return Ft(e);
    });
    _this45 = _possibleConstructorReturn(this, _getPrototypeOf(Qi).call(this, e, t, i)), _this45._register(i);
    return _this45;
  }

  _createClass(Qi, [{
    key: "setScrollPosition",
    value: function setScrollPosition(e) {
      this._scrollable.setScrollPositionNow(e);
    }
  }, {
    key: "getScrollPosition",
    value: function getScrollPosition() {
      return this._scrollable.getCurrentScrollPosition();
    }
  }]);

  return Qi;
}(Pi);

function Ri(e) {
  var t = {
    lazyRender: void 0 !== e.lazyRender && e.lazyRender,
    className: void 0 !== e.className ? e.className : "",
    useShadows: void 0 === e.useShadows || e.useShadows,
    handleMouseWheel: void 0 === e.handleMouseWheel || e.handleMouseWheel,
    flipAxes: void 0 !== e.flipAxes && e.flipAxes,
    alwaysConsumeMouseWheel: void 0 !== e.alwaysConsumeMouseWheel && e.alwaysConsumeMouseWheel,
    scrollYToX: void 0 !== e.scrollYToX && e.scrollYToX,
    mouseWheelScrollSensitivity: void 0 !== e.mouseWheelScrollSensitivity ? e.mouseWheelScrollSensitivity : 1,
    fastScrollSensitivity: void 0 !== e.fastScrollSensitivity ? e.fastScrollSensitivity : 5,
    mouseWheelSmoothScroll: void 0 === e.mouseWheelSmoothScroll || e.mouseWheelSmoothScroll,
    arrowSize: void 0 !== e.arrowSize ? e.arrowSize : 11,
    listenOnDomNode: void 0 !== e.listenOnDomNode ? e.listenOnDomNode : null,
    horizontal: void 0 !== e.horizontal ? e.horizontal : 1,
    horizontalScrollbarSize: void 0 !== e.horizontalScrollbarSize ? e.horizontalScrollbarSize : 10,
    horizontalSliderSize: void 0 !== e.horizontalSliderSize ? e.horizontalSliderSize : 0,
    horizontalHasArrows: void 0 !== e.horizontalHasArrows && e.horizontalHasArrows,
    vertical: void 0 !== e.vertical ? e.vertical : 1,
    verticalScrollbarSize: void 0 !== e.verticalScrollbarSize ? e.verticalScrollbarSize : 10,
    verticalHasArrows: void 0 !== e.verticalHasArrows && e.verticalHasArrows,
    verticalSliderSize: void 0 !== e.verticalSliderSize ? e.verticalSliderSize : 0
  };
  return t.horizontalSliderSize = void 0 !== e.horizontalSliderSize ? e.horizontalSliderSize : t.horizontalScrollbarSize, t.verticalSliderSize = void 0 !== e.verticalSliderSize ? e.verticalSliderSize : t.verticalScrollbarSize, k && (t.className += " mac"), t;
}

var Ti;

function ki(e, t) {
  var i = [];
  var _iteratorNormalCompletion6 = true;
  var _didIteratorError6 = false;
  var _iteratorError6 = undefined;

  try {
    for (var _iterator6 = t[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
      var _o17 = _step6.value;
      if (e.start >= _o17.range.end) continue;
      if (e.end < _o17.range.start) break;

      var _t24 = Ti.intersect(e, _o17.range);

      Ti.isEmpty(_t24) || i.push({
        range: _t24,
        size: _o17.size
      });
    }
  } catch (err) {
    _didIteratorError6 = true;
    _iteratorError6 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
        _iterator6.return();
      }
    } finally {
      if (_didIteratorError6) {
        throw _iteratorError6;
      }
    }
  }

  return i;
}

function Yi(_ref8, i) {
  var e = _ref8.start,
      t = _ref8.end;
  return {
    start: e + i,
    end: t + i
  };
}

!function (e) {
  function t(e, t) {
    if (e.start >= t.end || t.start >= e.end) return {
      start: 0,
      end: 0
    };
    var i = Math.max(e.start, t.start),
        o = Math.min(e.end, t.end);
    return o - i <= 0 ? {
      start: 0,
      end: 0
    } : {
      start: i,
      end: o
    };
  }

  function i(e) {
    return e.end - e.start <= 0;
  }

  e.intersect = t, e.isEmpty = i, e.intersects = function (e, o) {
    return !i(t(e, o));
  }, e.relativeComplement = function (e, t) {
    var o = [],
        n = {
      start: e.start,
      end: Math.min(t.start, e.end)
    },
        s = {
      start: Math.max(t.end, e.start),
      end: e.end
    };
    return i(n) || o.push(n), i(s) || o.push(s), o;
  };
}(Ti || (Ti = {}));

var Ui =
/*#__PURE__*/
function () {
  function Ui() {
    _classCallCheck(this, Ui);

    this.groups = [], this._size = 0;
  }

  _createClass(Ui, [{
    key: "splice",
    value: function splice(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var o = i.length - t,
          n = ki({
        start: 0,
        end: e
      }, this.groups),
          s = ki({
        start: e + t,
        end: Number.POSITIVE_INFINITY
      }, this.groups).map(function (e) {
        return {
          range: Yi(e.range, o),
          size: e.size
        };
      }),
          r = i.map(function (t, i) {
        return {
          range: {
            start: e + i,
            end: e + i + 1
          },
          size: t.size
        };
      });
      this.groups = function () {
        for (var _len12 = arguments.length, e = new Array(_len12), _key12 = 0; _key12 < _len12; _key12++) {
          e[_key12] = arguments[_key12];
        }

        return function (e) {
          var t = [];
          var i = null;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = e[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var _o18 = _step7.value;
              var _e38 = _o18.range.start,
                  _n18 = _o18.range.end,
                  _s10 = _o18.size;
              i && _s10 === i.size ? i.range.end = _n18 : (i = {
                range: {
                  start: _e38,
                  end: _n18
                },
                size: _s10
              }, t.push(i));
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          return t;
        }(e.reduce(function (e, t) {
          return e.concat(t);
        }, []));
      }(n, r, s), this._size = this.groups.reduce(function (e, t) {
        return e + t.size * (t.range.end - t.range.start);
      }, 0);
    }
  }, {
    key: "indexAt",
    value: function indexAt(e) {
      if (e < 0) return -1;
      var t = 0,
          i = 0;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = this.groups[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var _o19 = _step8.value;

          var _n19 = _o19.range.end - _o19.range.start,
              _s11 = i + _n19 * _o19.size;

          if (e < _s11) return t + Math.floor((e - i) / _o19.size);
          t += _n19, i = _s11;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      return t;
    }
  }, {
    key: "indexAfter",
    value: function indexAfter(e) {
      return Math.min(this.indexAt(e) + 1, this.count);
    }
  }, {
    key: "positionAt",
    value: function positionAt(e) {
      if (e < 0) return -1;
      var t = 0,
          i = 0;
      var _iteratorNormalCompletion9 = true;
      var _didIteratorError9 = false;
      var _iteratorError9 = undefined;

      try {
        for (var _iterator9 = this.groups[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
          var _o20 = _step9.value;

          var _n20 = _o20.range.end - _o20.range.start,
              _s12 = i + _n20;

          if (e < _s12) return t + (e - i) * _o20.size;
          t += _n20 * _o20.size, i = _s12;
        }
      } catch (err) {
        _didIteratorError9 = true;
        _iteratorError9 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
            _iterator9.return();
          }
        } finally {
          if (_didIteratorError9) {
            throw _iteratorError9;
          }
        }
      }

      return -1;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.groups = null;
    }
  }, {
    key: "count",
    get: function get() {
      var e = this.groups.length;
      return e ? this.groups[e - 1].range.end : 0;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }]);

  return Ui;
}();

var Ji =
/*#__PURE__*/
function () {
  function Ji(e) {
    _classCallCheck(this, Ji);

    this.renderers = e, this.cache = new Map();
  }

  _createClass(Ji, [{
    key: "alloc",
    value: function alloc(e) {
      var t = this.getTemplateCache(e).pop();

      if (!t) {
        var _i34 = Ut(".monaco-list-row");

        t = {
          domNode: _i34,
          templateId: e,
          templateData: this.getRenderer(e).renderTemplate(_i34)
        };
      }

      return t;
    }
  }, {
    key: "release",
    value: function release(e) {
      e && this.releaseRow(e);
    }
  }, {
    key: "releaseRow",
    value: function releaseRow(e) {
      var t = e.domNode,
          i = e.templateId;
      t && (yt(t, "scrolling"), function (e) {
        try {
          e.parentElement && e.parentElement.removeChild(e);
        } catch (e) {}
      }(t)), this.getTemplateCache(i).push(e);
    }
  }, {
    key: "getTemplateCache",
    value: function getTemplateCache(e) {
      var t = this.cache.get(e);
      return t || (t = [], this.cache.set(e, t)), t;
    }
  }, {
    key: "garbageCollect",
    value: function garbageCollect() {
      var _this46 = this;

      this.renderers && (this.cache.forEach(function (e, t) {
        var _iteratorNormalCompletion10 = true;
        var _didIteratorError10 = false;
        var _iteratorError10 = undefined;

        try {
          for (var _iterator10 = e[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
            var _i35 = _step10.value;
            _this46.getRenderer(t).disposeTemplate(_i35.templateData), _i35.domNode = null, _i35.templateData = null;
          }
        } catch (err) {
          _didIteratorError10 = true;
          _iteratorError10 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
              _iterator10.return();
            }
          } finally {
            if (_didIteratorError10) {
              throw _iteratorError10;
            }
          }
        }
      }), this.cache.clear());
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.garbageCollect(), this.cache.clear(), this.renderers = null;
    }
  }, {
    key: "getRenderer",
    value: function getRenderer(e) {
      var t = this.renderers.get(e);
      if (!t) throw new Error("No renderer found for ".concat(e));
      return t;
    }
  }]);

  return Ji;
}();

var ji = {
  RESOURCES: "ResourceURLs",
  DOWNLOAD_URL: "DownloadURL",
  FILES: "Files",
  TEXT: "text/plain"
},
    Gi = {
  CurrentDragAndDropData: void 0
},
    Oi = {
  useShadows: !0,
  verticalScrollMode: 1,
  setRowLineHeight: !0,
  supportDynamicHeights: !1,
  dnd: {
    getDragElements: function getDragElements(e) {
      return [e];
    },
    getDragURI: function getDragURI() {
      return null;
    },
    onDragStart: function onDragStart() {},
    onDragOver: function onDragOver() {
      return !1;
    },
    drop: function drop() {}
  },
  horizontalScrolling: !1
};

var Ki =
/*#__PURE__*/
function () {
  function Ki(e) {
    _classCallCheck(this, Ki);

    this.elements = e;
  }

  _createClass(Ki, [{
    key: "update",
    value: function update() {}
  }, {
    key: "getData",
    value: function getData() {
      return this.elements;
    }
  }]);

  return Ki;
}();

var Wi =
/*#__PURE__*/
function () {
  function Wi(e) {
    _classCallCheck(this, Wi);

    this.elements = e;
  }

  _createClass(Wi, [{
    key: "update",
    value: function update() {}
  }, {
    key: "getData",
    value: function getData() {
      return this.elements;
    }
  }]);

  return Wi;
}();

var Xi =
/*#__PURE__*/
function () {
  function Xi() {
    _classCallCheck(this, Xi);

    this.types = [], this.files = [];
  }

  _createClass(Xi, [{
    key: "update",
    value: function update(e) {
      var _this$types;

      if (e.types && (_this$types = this.types).splice.apply(_this$types, [0, this.types.length].concat(_toConsumableArray(e.types))), e.files) {
        this.files.splice(0, this.files.length);

        for (var _t25 = 0; _t25 < e.files.length; _t25++) {
          var _i36 = e.files.item(_t25);

          _i36 && (_i36.size || _i36.type) && this.files.push(_i36);
        }
      }
    }
  }, {
    key: "getData",
    value: function getData() {
      return {
        types: this.types,
        files: this.files
      };
    }
  }]);

  return Xi;
}();

var Zi =
/*#__PURE__*/
function () {
  function Zi(e, t, i) {
    var _this47 = this;

    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Oi;

    _classCallCheck(this, Zi);

    if (this.virtualDelegate = t, this.domId = "list_id_".concat(++Zi.InstanceCount), this.renderers = new Map(), this.renderWidth = 0, this.scrollableElementUpdateDisposable = null, this.scrollableElementWidthDelayer = new at(50), this.splicing = !1, this.dragOverAnimationStopDisposable = f.None, this.canUseTranslate3d = void 0, this.canDrop = !1, this.currentDragFeedbackDisposable = f.None, this.onDragLeaveTimeout = f.None, this._onDidChangeContentHeight = new b(), this.onDidChangeContentHeight = v.latch(this._onDidChangeContentHeight.event), o.horizontalScrolling && o.supportDynamicHeights) throw new Error("Horizontal scrolling and dynamic heights not supported simultaneously");
    this.items = [], this.itemId = 0, this.rangeMap = new Ui();
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = i[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var _e39 = _step11.value;
        this.renderers.set(_e39.templateId, _e39);
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    this.cache = new Ji(this.renderers), this.lastRenderTop = 0, this.lastRenderHeight = 0, this.domNode = document.createElement("div"), this.domNode.className = "monaco-list", Et(this.domNode, this.domId), this.domNode.tabIndex = 0, Mt(this.domNode, "mouse-support", "boolean" != typeof o.mouseSupport || o.mouseSupport), this.horizontalScrolling = $t(o, function (e) {
      return e.horizontalScrolling;
    }, Oi.horizontalScrolling), Mt(this.domNode, "horizontal-scrolling", this.horizontalScrolling), this.ariaSetProvider = o.ariaSetProvider || {
      getSetSize: function getSetSize(e, t, i) {
        return i;
      },
      getPosInSet: function getPosInSet(e, t) {
        return t + 1;
      }
    }, this.rowsContainer = document.createElement("div"), this.rowsContainer.className = "monaco-list-rows", ui.addTarget(this.rowsContainer), this.scrollableElement = new Qi(this.rowsContainer, {
      alwaysConsumeMouseWheel: !0,
      horizontal: this.horizontalScrolling ? 1 : 2,
      vertical: $t(o, function (e) {
        return e.verticalScrollMode;
      }, Oi.verticalScrollMode),
      useShadows: $t(o, function (e) {
        return e.useShadows;
      }, Oi.useShadows)
    }), this.domNode.appendChild(this.scrollableElement.getDomNode()), e.appendChild(this.domNode), this.disposables = [this.rangeMap, this.gesture, this.scrollableElement, this.cache], this.onDidScroll = v.signal(this.scrollableElement.onScroll), this.scrollableElement.onScroll(this.onScroll, this, this.disposables), xe(this.rowsContainer, hi.Change)(this.onTouchChange, this, this.disposables), xe(this.scrollableElement.getDomNode(), "scroll")(function (e) {
      return e.target.scrollTop = 0;
    }, null, this.disposables), v.map(xe(this.domNode, "dragover"), function (e) {
      return _this47.toDragEvent(e);
    })(this.onDragOver, this, this.disposables), v.map(xe(this.domNode, "drop"), function (e) {
      return _this47.toDragEvent(e);
    })(this.onDrop, this, this.disposables), xe(this.domNode, "dragleave")(this.onDragLeave, this, this.disposables), xe(window, "dragend")(this.onDragEnd, this, this.disposables), this.setRowLineHeight = $t(o, function (e) {
      return e.setRowLineHeight;
    }, Oi.setRowLineHeight), this.supportDynamicHeights = $t(o, function (e) {
      return e.supportDynamicHeights;
    }, Oi.supportDynamicHeights), this.dnd = $t(o, function (e) {
      return e.dnd;
    }, Oi.dnd), this.layout();
  }

  _createClass(Zi, [{
    key: "splice",
    value: function splice(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (this.splicing) throw new Error("Can't run recursive splices.");
      this.splicing = !0;

      try {
        return this._splice(e, t, i);
      } finally {
        this.splicing = !1, this._onDidChangeContentHeight.fire(this.contentHeight);
      }
    }
  }, {
    key: "_splice",
    value: function _splice(e, t) {
      var _this48 = this,
          _this$items;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var o = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight),
          n = {
        start: e,
        end: e + t
      },
          s = Ti.intersect(o, n);

      for (var _e40 = s.start; _e40 < s.end; _e40++) {
        this.removeItemFromDOM(_e40);
      }

      var r = {
        start: e + t,
        end: this.items.length
      },
          l = Ti.intersect(r, o),
          a = Ti.relativeComplement(r, o),
          A = i.map(function (e) {
        return {
          id: String(_this48.itemId++),
          element: e,
          templateId: _this48.virtualDelegate.getTemplateId(e),
          size: _this48.virtualDelegate.getHeight(e),
          width: void 0,
          hasDynamicHeight: !!_this48.virtualDelegate.hasDynamicHeight && _this48.virtualDelegate.hasDynamicHeight(e),
          lastDynamicHeightWidth: void 0,
          row: null,
          uri: void 0,
          dropTarget: !1,
          dragStartDisposable: f.None
        };
      });
      var h;
      0 === e && t >= this.items.length ? (this.rangeMap = new Ui(), this.rangeMap.splice(0, 0, A), this.items = A, h = []) : (this.rangeMap.splice(e, t, A), h = (_this$items = this.items).splice.apply(_this$items, [e, t].concat(_toConsumableArray(A))));
      var c = i.length - t,
          d = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight),
          u = Yi(l, c),
          g = Ti.intersect(d, u);

      for (var _e41 = g.start; _e41 < g.end; _e41++) {
        this.updateItemInDOM(this.items[_e41], _e41);
      }

      var C = Ti.relativeComplement(u, d);
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = C[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _e42 = _step12.value;

          for (var _t26 = _e42.start; _t26 < _e42.end; _t26++) {
            this.removeItemFromDOM(_t26);
          }
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }

      var p = a.map(function (e) {
        return Yi(e, c);
      }),
          m = [{
        start: e,
        end: e + i.length
      }].concat(_toConsumableArray(p)).map(function (e) {
        return Ti.intersect(d, e);
      }),
          D = this.getNextToLastElement(m);
      var _iteratorNormalCompletion13 = true;
      var _didIteratorError13 = false;
      var _iteratorError13 = undefined;

      try {
        for (var _iterator13 = m[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
          var _e43 = _step13.value;

          for (var _t27 = _e43.start; _t27 < _e43.end; _t27++) {
            this.insertItemInDOM(_t27, D);
          }
        }
      } catch (err) {
        _didIteratorError13 = true;
        _iteratorError13 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
            _iterator13.return();
          }
        } finally {
          if (_didIteratorError13) {
            throw _iteratorError13;
          }
        }
      }

      return this.eventuallyUpdateScrollDimensions(), this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), h.map(function (e) {
        return e.element;
      });
    }
  }, {
    key: "eventuallyUpdateScrollDimensions",
    value: function eventuallyUpdateScrollDimensions() {
      var _this49 = this;

      this._scrollHeight = this.contentHeight, this.rowsContainer.style.height = "".concat(this._scrollHeight, "px"), this.scrollableElementUpdateDisposable || (this.scrollableElementUpdateDisposable = Ft(function () {
        _this49.scrollableElement.setScrollDimensions({
          scrollHeight: _this49.scrollHeight
        }), _this49.updateScrollWidth(), _this49.scrollableElementUpdateDisposable = null;
      }));
    }
  }, {
    key: "eventuallyUpdateScrollWidth",
    value: function eventuallyUpdateScrollWidth() {
      var _this50 = this;

      this.horizontalScrolling && this.scrollableElementWidthDelayer.trigger(function () {
        return _this50.updateScrollWidth();
      });
    }
  }, {
    key: "updateScrollWidth",
    value: function updateScrollWidth() {
      if (!this.horizontalScrolling) return;
      0 === this.items.length && this.scrollableElement.setScrollDimensions({
        scrollWidth: 0
      });
      var e = 0;
      var _iteratorNormalCompletion14 = true;
      var _didIteratorError14 = false;
      var _iteratorError14 = undefined;

      try {
        for (var _iterator14 = this.items[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
          var _t28 = _step14.value;
          void 0 !== _t28.width && (e = Math.max(e, _t28.width));
        }
      } catch (err) {
        _didIteratorError14 = true;
        _iteratorError14 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
            _iterator14.return();
          }
        } finally {
          if (_didIteratorError14) {
            throw _iteratorError14;
          }
        }
      }

      this.scrollWidth = e, this.scrollableElement.setScrollDimensions({
        scrollWidth: e + 10
      });
    }
  }, {
    key: "updateWidth",
    value: function updateWidth(e) {
      if (!this.horizontalScrolling || void 0 === this.scrollWidth) return;
      var t = this.items[e];
      this.measureItemWidth(t), void 0 !== t.width && t.width > this.scrollWidth && (this.scrollWidth = t.width, this.scrollableElement.setScrollDimensions({
        scrollWidth: this.scrollWidth + 10
      }));
    }
  }, {
    key: "rerender",
    value: function rerender() {
      if (this.supportDynamicHeights) {
        var _iteratorNormalCompletion15 = true;
        var _didIteratorError15 = false;
        var _iteratorError15 = undefined;

        try {
          for (var _iterator15 = this.items[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
            var _e44 = _step15.value;
            _e44.lastDynamicHeightWidth = void 0;
          }
        } catch (err) {
          _didIteratorError15 = true;
          _iteratorError15 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
              _iterator15.return();
            }
          } finally {
            if (_didIteratorError15) {
              throw _iteratorError15;
            }
          }
        }

        this._rerender(this.lastRenderTop, this.lastRenderHeight);
      }
    }
  }, {
    key: "element",
    value: function element(e) {
      return this.items[e].element;
    }
  }, {
    key: "domElement",
    value: function domElement(e) {
      var t = this.items[e].row;
      return t && t.domNode;
    }
  }, {
    key: "elementHeight",
    value: function elementHeight(e) {
      return this.items[e].size;
    }
  }, {
    key: "elementTop",
    value: function elementTop(e) {
      return this.rangeMap.positionAt(e);
    }
  }, {
    key: "indexAt",
    value: function indexAt(e) {
      return this.rangeMap.indexAt(e);
    }
  }, {
    key: "indexAfter",
    value: function indexAfter(e) {
      return this.rangeMap.indexAfter(e);
    }
  }, {
    key: "layout",
    value: function layout(e, t) {
      var i = {
        height: "number" == typeof e ? e : Rt(this.domNode)
      };
      this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, i.scrollHeight = this.scrollHeight), this.scrollableElement.setScrollDimensions(i), void 0 !== t && (this.renderWidth = t, this.supportDynamicHeights && this._rerender(this.scrollTop, this.renderHeight), this.horizontalScrolling && this.scrollableElement.setScrollDimensions({
        width: "number" == typeof t ? t : Qt(this.domNode)
      }));
    }
  }, {
    key: "render",
    value: function render(e, t, i, o) {
      var n = this.getRenderRange(this.lastRenderTop, this.lastRenderHeight),
          s = this.getRenderRange(e, t),
          r = Ti.relativeComplement(s, n),
          l = Ti.relativeComplement(n, s),
          a = this.getNextToLastElement(r);
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = r[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var _e45 = _step16.value;

          for (var _t30 = _e45.start; _t30 < _e45.end; _t30++) {
            this.insertItemInDOM(_t30, a);
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      var _iteratorNormalCompletion17 = true;
      var _didIteratorError17 = false;
      var _iteratorError17 = undefined;

      try {
        for (var _iterator17 = l[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
          var _e46 = _step17.value;

          for (var _t31 = _e46.start; _t31 < _e46.end; _t31++) {
            this.removeItemFromDOM(_t31);
          }
        }
      } catch (err) {
        _didIteratorError17 = true;
        _iteratorError17 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
            _iterator17.return();
          }
        } finally {
          if (_didIteratorError17) {
            throw _iteratorError17;
          }
        }
      }

      var A = !T && !He && 0 === Me.INSTANCE.getZoomLevel();

      if (A) {
        var _t29 = "translate3d(-".concat(i, "px, -").concat(e, "px, 0px)");

        this.rowsContainer.style.transform = _t29, this.rowsContainer.style.webkitTransform = _t29, A !== this.canUseTranslate3d && (this.rowsContainer.style.left = "0", this.rowsContainer.style.top = "0");
      } else this.rowsContainer.style.left = "-".concat(i, "px"), this.rowsContainer.style.top = "-".concat(e, "px"), A !== this.canUseTranslate3d && (this.rowsContainer.style.transform = "", this.rowsContainer.style.webkitTransform = "");

      this.horizontalScrolling && (this.rowsContainer.style.width = "".concat(Math.max(o, this.renderWidth), "px")), this.canUseTranslate3d = A, this.lastRenderTop = e, this.lastRenderHeight = t;
    }
  }, {
    key: "insertItemInDOM",
    value: function insertItemInDOM(e, t) {
      var _this51 = this;

      var i = this.items[e];
      i.row || (i.row = this.cache.alloc(i.templateId), i.row.domNode.setAttribute("role", "treeitem")), i.row.domNode.parentElement || (t ? this.rowsContainer.insertBefore(i.row.domNode, t) : this.rowsContainer.appendChild(i.row.domNode)), this.updateItemInDOM(i, e);
      var o = this.renderers.get(i.templateId);
      if (!o) throw new Error("No renderer found for template id ".concat(i.templateId));
      o && o.renderElement(i.element, e, i.row.templateData);
      var n = this.dnd.getDragURI(i.element);

      if (i.dragStartDisposable.dispose(), i.row.domNode.draggable = !!n, n) {
        var _e47 = xe(i.row.domNode, "dragstart");

        i.dragStartDisposable = _e47(function (e) {
          return _this51.onDragStart(i.element, n, e);
        });
      }

      this.horizontalScrolling && (this.measureItemWidth(i), this.eventuallyUpdateScrollWidth());
    }
  }, {
    key: "measureItemWidth",
    value: function measureItemWidth(e) {
      if (!e.row || !e.row.domNode) return;
      e.row.domNode.style.width = "fit-content", e.width = Qt(e.row.domNode);
      var t = window.getComputedStyle(e.row.domNode);
      t.paddingLeft && (e.width += parseFloat(t.paddingLeft)), t.paddingRight && (e.width += parseFloat(t.paddingRight)), e.row.domNode.style.width = "";
    }
  }, {
    key: "updateItemInDOM",
    value: function updateItemInDOM(e, t) {
      e.row.domNode.style.top = "".concat(this.elementTop(t), "px"), e.row.domNode.style.height = "".concat(e.size, "px"), this.setRowLineHeight && (e.row.domNode.style.lineHeight = "".concat(e.size, "px")), e.row.domNode.setAttribute("data-index", "".concat(t)), e.row.domNode.setAttribute("data-last-element", t === this.length - 1 ? "true" : "false"), e.row.domNode.setAttribute("aria-setsize", String(this.ariaSetProvider.getSetSize(e.element, t, this.length))), e.row.domNode.setAttribute("aria-posinset", String(this.ariaSetProvider.getPosInSet(e.element, t))), e.row.domNode.setAttribute("id", this.getElementDomId(t)), Mt(e.row.domNode, "drop-target", e.dropTarget);
    }
  }, {
    key: "removeItemFromDOM",
    value: function removeItemFromDOM(e) {
      var t = this.items[e];
      t.dragStartDisposable.dispose();
      var i = this.renderers.get(t.templateId);
      i && i.disposeElement && i.disposeElement(t.element, e, t.row.templateData), this.cache.release(t.row), t.row = null, this.horizontalScrolling && this.eventuallyUpdateScrollWidth();
    }
  }, {
    key: "getScrollTop",
    value: function getScrollTop() {
      return this.scrollableElement.getScrollPosition().scrollTop;
    }
  }, {
    key: "setScrollTop",
    value: function setScrollTop(e) {
      this.scrollableElementUpdateDisposable && (this.scrollableElementUpdateDisposable.dispose(), this.scrollableElementUpdateDisposable = null, this.scrollableElement.setScrollDimensions({
        scrollHeight: this.scrollHeight
      })), this.scrollableElement.setScrollPosition({
        scrollTop: e
      });
    }
  }, {
    key: "toMouseEvent",
    value: function toMouseEvent(e) {
      var t = this.getItemIndexFromEventTarget(e.target || null),
          i = void 0 === t ? void 0 : this.items[t];
      return {
        browserEvent: e,
        index: t,
        element: i && i.element
      };
    }
  }, {
    key: "toTouchEvent",
    value: function toTouchEvent(e) {
      var t = this.getItemIndexFromEventTarget(e.target || null),
          i = void 0 === t ? void 0 : this.items[t];
      return {
        browserEvent: e,
        index: t,
        element: i && i.element
      };
    }
  }, {
    key: "toGestureEvent",
    value: function toGestureEvent(e) {
      var t = this.getItemIndexFromEventTarget(e.initialTarget || null),
          i = void 0 === t ? void 0 : this.items[t];
      return {
        browserEvent: e,
        index: t,
        element: i && i.element
      };
    }
  }, {
    key: "toDragEvent",
    value: function toDragEvent(e) {
      var t = this.getItemIndexFromEventTarget(e.target || null),
          i = void 0 === t ? void 0 : this.items[t];
      return {
        browserEvent: e,
        index: t,
        element: i && i.element
      };
    }
  }, {
    key: "onScroll",
    value: function onScroll(e) {
      try {
        this.render(e.scrollTop, e.height, e.scrollLeft, e.scrollWidth), this.supportDynamicHeights && this._rerender(e.scrollTop, e.height);
      } catch (t) {
        throw console.error("Got bad scroll event:", e), t;
      }
    }
  }, {
    key: "onTouchChange",
    value: function onTouchChange(e) {
      e.preventDefault(), e.stopPropagation(), this.scrollTop -= e.translationY;
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e, t, i) {
      if (!i.dataTransfer) return;
      var o = this.dnd.getDragElements(e);

      if (i.dataTransfer.effectAllowed = "copyMove", i.dataTransfer.setData(ji.RESOURCES, JSON.stringify([t])), i.dataTransfer.setDragImage) {
        var _e48;

        this.dnd.getDragLabel && (_e48 = this.dnd.getDragLabel(o)), void 0 === _e48 && (_e48 = String(o.length));

        var _t32 = Ut(".monaco-drag-image");

        _t32.textContent = _e48, document.body.appendChild(_t32), i.dataTransfer.setDragImage(_t32, -10, -10), setTimeout(function () {
          return document.body.removeChild(_t32);
        }, 0);
      }

      this.currentDragData = new Ki(o), Gi.CurrentDragAndDropData = new Wi(o), this.dnd.onDragStart && this.dnd.onDragStart(this.currentDragData, i);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e) {
      var _this52 = this;

      if (this.onDragLeaveTimeout.dispose(), Gi.CurrentDragAndDropData && "vscode-ui" === Gi.CurrentDragAndDropData.getData()) return !1;
      if (this.setupDragAndDropScrollTopAnimation(e.browserEvent), !e.browserEvent.dataTransfer) return !1;
      if (!this.currentDragData) if (Gi.CurrentDragAndDropData) this.currentDragData = Gi.CurrentDragAndDropData;else {
        if (!e.browserEvent.dataTransfer.types) return !1;
        this.currentDragData = new Xi();
      }
      var t = this.dnd.onDragOver(this.currentDragData, e.element, e.index, e.browserEvent);
      if (this.canDrop = "boolean" == typeof t ? t : t.accept, !this.canDrop) return this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), !1;
      var i;
      if (e.browserEvent.dataTransfer.dropEffect = "boolean" != typeof t && 0 === t.effect ? "copy" : "move", 0 === (i = -1 === (i = Ct(i = "boolean" != typeof t && t.feedback ? t.feedback : void 0 === e.index ? [-1] : [e.index]).filter(function (e) {
        return e >= -1 && e < _this52.length;
      }).sort())[0] ? [-1] : i).length) throw new Error("Invalid empty feedback list");
      if (o = this.currentDragFeedback, n = i, Array.isArray(o) && Array.isArray(n) ? ut(o, n) : o === n) return !0;
      var o, n;
      if (this.currentDragFeedback = i, this.currentDragFeedbackDisposable.dispose(), -1 === i[0]) Et(this.domNode, "drop-target"), this.currentDragFeedbackDisposable = m(function () {
        return yt(_this52.domNode, "drop-target");
      });else {
        var _iteratorNormalCompletion18 = true;
        var _didIteratorError18 = false;
        var _iteratorError18 = undefined;

        try {
          for (var _iterator18 = i[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
            var _e50 = _step18.value;
            var _t34 = this.items[_e50];
            _t34.dropTarget = !0, _t34.row && _t34.row.domNode && Et(_t34.row.domNode, "drop-target");
          }
        } catch (err) {
          _didIteratorError18 = true;
          _iteratorError18 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
              _iterator18.return();
            }
          } finally {
            if (_didIteratorError18) {
              throw _iteratorError18;
            }
          }
        }

        this.currentDragFeedbackDisposable = m(function () {
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = i[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var _e49 = _step19.value;
              var _t33 = _this52.items[_e49];
              _t33.dropTarget = !1, _t33.row && _t33.row.domNode && yt(_t33.row.domNode, "drop-target");
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }
        });
      }
      return !0;
    }
  }, {
    key: "onDragLeave",
    value: function onDragLeave() {
      var _this53 = this;

      this.onDragLeaveTimeout.dispose(), this.onDragLeaveTimeout = At(function () {
        return _this53.clearDragOverFeedback();
      }, 100);
    }
  }, {
    key: "onDrop",
    value: function onDrop(e) {
      if (!this.canDrop) return;
      var t = this.currentDragData;
      this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.currentDragData = void 0, Gi.CurrentDragAndDropData = void 0, t && e.browserEvent.dataTransfer && (e.browserEvent.preventDefault(), t.update(e.browserEvent.dataTransfer), this.dnd.drop(t, e.element, e.index, e.browserEvent));
    }
  }, {
    key: "onDragEnd",
    value: function onDragEnd() {
      this.canDrop = !1, this.teardownDragAndDropScrollTopAnimation(), this.clearDragOverFeedback(), this.currentDragData = void 0, Gi.CurrentDragAndDropData = void 0;
    }
  }, {
    key: "clearDragOverFeedback",
    value: function clearDragOverFeedback() {
      this.currentDragFeedback = void 0, this.currentDragFeedbackDisposable.dispose(), this.currentDragFeedbackDisposable = f.None;
    }
  }, {
    key: "setupDragAndDropScrollTopAnimation",
    value: function setupDragAndDropScrollTopAnimation(e) {
      var _this54 = this;

      if (!this.dragOverAnimationDisposable) {
        var _e51 = function (e) {
          var t = e.offsetParent,
              i = e.offsetTop,
              o = e.offsetLeft;

          for (; null !== (e = e.parentNode) && e !== document.body && e !== document.documentElement;) {
            i -= e.scrollTop;

            var _n21 = It(e);

            _n21 && (o -= "rtl" !== _n21.direction ? e.scrollLeft : -e.scrollLeft), e === t && (o += Lt.getBorderLeftWidth(e), i += Lt.getBorderTopWidth(e), i += e.offsetTop, o += e.offsetLeft, t = e.offsetParent);
          }

          return {
            left: o,
            top: i
          };
        }(this.domNode).top;

        this.dragOverAnimationDisposable = function (e) {
          var t = function t() {
            e(), i = Ft(t);
          };

          var i = Ft(t);
          return m(function () {
            return i.dispose();
          });
        }(this.animateDragAndDropScrollTop.bind(this, _e51));
      }

      this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationStopDisposable = At(function () {
        _this54.dragOverAnimationDisposable && (_this54.dragOverAnimationDisposable.dispose(), _this54.dragOverAnimationDisposable = void 0);
      }, 1e3), this.dragOverMouseY = e.pageY;
    }
  }, {
    key: "animateDragAndDropScrollTop",
    value: function animateDragAndDropScrollTop(e) {
      if (void 0 === this.dragOverMouseY) return;
      var t = this.dragOverMouseY - e,
          i = this.renderHeight - 35;
      t < 35 ? this.scrollTop += Math.max(-14, Math.floor(.3 * (t - 35))) : t > i && (this.scrollTop += Math.min(14, Math.floor(.3 * (t - i))));
    }
  }, {
    key: "teardownDragAndDropScrollTopAnimation",
    value: function teardownDragAndDropScrollTopAnimation() {
      this.dragOverAnimationStopDisposable.dispose(), this.dragOverAnimationDisposable && (this.dragOverAnimationDisposable.dispose(), this.dragOverAnimationDisposable = void 0);
    }
  }, {
    key: "getItemIndexFromEventTarget",
    value: function getItemIndexFromEventTarget(e) {
      var t = e;

      for (; t instanceof HTMLElement && t !== this.rowsContainer;) {
        var _e52 = t.getAttribute("data-index");

        if (_e52) {
          var _t35 = Number(_e52);

          if (!isNaN(_t35)) return _t35;
        }

        t = t.parentElement;
      }
    }
  }, {
    key: "getRenderRange",
    value: function getRenderRange(e, t) {
      return {
        start: this.rangeMap.indexAt(e),
        end: this.rangeMap.indexAfter(e + t - 1)
      };
    }
  }, {
    key: "_rerender",
    value: function _rerender(e, t) {
      var i = this.getRenderRange(e, t);
      var o, n;
      e === this.elementTop(i.start) ? (o = i.start, n = 0) : i.end - i.start > 1 && (o = i.start + 1, n = this.elementTop(o) - e);
      var s = 0;

      for (;;) {
        var _r7 = this.getRenderRange(e, t);

        var _l3 = !1;

        for (var _e53 = _r7.start; _e53 < _r7.end; _e53++) {
          var _t36 = this.probeDynamicHeight(_e53);

          0 !== _t36 && this.rangeMap.splice(_e53, 1, [this.items[_e53]]), s += _t36, _l3 = _l3 || 0 !== _t36;
        }

        if (!_l3) {
          0 !== s && this.eventuallyUpdateScrollDimensions();

          var _e54 = Ti.relativeComplement(i, _r7);

          var _iteratorNormalCompletion20 = true;
          var _didIteratorError20 = false;
          var _iteratorError20 = undefined;

          try {
            for (var _iterator20 = _e54[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
              var _t38 = _step20.value;

              for (var _e56 = _t38.start; _e56 < _t38.end; _e56++) {
                this.items[_e56].row && this.removeItemFromDOM(_e56);
              }
            }
          } catch (err) {
            _didIteratorError20 = true;
            _iteratorError20 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
                _iterator20.return();
              }
            } finally {
              if (_didIteratorError20) {
                throw _iteratorError20;
              }
            }
          }

          var _t37 = Ti.relativeComplement(_r7, i);

          var _iteratorNormalCompletion21 = true;
          var _didIteratorError21 = false;
          var _iteratorError21 = undefined;

          try {
            for (var _iterator21 = _t37[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
              var _e57 = _step21.value;

              for (var _t39 = _e57.start; _t39 < _e57.end; _t39++) {
                var _e58 = _t39 + 1,
                    _i37 = _e58 < this.items.length ? this.items[_e58].row : null,
                    _o21 = _i37 ? _i37.domNode : null;

                this.insertItemInDOM(_t39, _o21);
              }
            }
          } catch (err) {
            _didIteratorError21 = true;
            _iteratorError21 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
                _iterator21.return();
              }
            } finally {
              if (_didIteratorError21) {
                throw _iteratorError21;
              }
            }
          }

          for (var _e55 = _r7.start; _e55 < _r7.end; _e55++) {
            this.items[_e55].row && this.updateItemInDOM(this.items[_e55], _e55);
          }

          return "number" == typeof o && (this.scrollTop = this.elementTop(o) - n), void this._onDidChangeContentHeight.fire(this.contentHeight);
        }
      }
    }
  }, {
    key: "probeDynamicHeight",
    value: function probeDynamicHeight(e) {
      var t = this.items[e];
      if (!t.hasDynamicHeight || t.lastDynamicHeightWidth === this.renderWidth) return 0;
      var i = t.size,
          o = this.cache.alloc(t.templateId);
      o.domNode.style.height = "", this.rowsContainer.appendChild(o.domNode);
      var n = this.renderers.get(t.templateId);
      return n && (n.renderElement(t.element, e, o.templateData, !0), n.disposeElement && n.disposeElement(t.element, e, o.templateData, !0)), t.size = o.domNode.offsetHeight, t.lastDynamicHeightWidth = this.renderWidth, this.rowsContainer.removeChild(o.domNode), this.cache.release(o), t.size - i;
    }
  }, {
    key: "getNextToLastElement",
    value: function getNextToLastElement(e) {
      var t = e[e.length - 1];
      if (!t) return null;
      var i = this.items[t.end];
      return i && i.row ? i.row.domNode : null;
    }
  }, {
    key: "getElementDomId",
    value: function getElementDomId(e) {
      return "".concat(this.domId, "_").concat(e);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      if (this.items) {
        var _iteratorNormalCompletion22 = true;
        var _didIteratorError22 = false;
        var _iteratorError22 = undefined;

        try {
          for (var _iterator22 = this.items[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
            var _e59 = _step22.value;

            if (_e59.row) {
              var _t40 = this.renderers.get(_e59.row.templateId);

              _t40 && _t40.disposeTemplate(_e59.row.templateData);
            }
          }
        } catch (err) {
          _didIteratorError22 = true;
          _iteratorError22 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
              _iterator22.return();
            }
          } finally {
            if (_didIteratorError22) {
              throw _iteratorError22;
            }
          }
        }

        this.items = [];
      }

      this.domNode && this.domNode.parentNode && this.domNode.parentNode.removeChild(this.domNode), this.disposables = C(this.disposables);
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.rangeMap.size;
    }
  }, {
    key: "length",
    get: function get() {
      return this.items.length;
    }
  }, {
    key: "renderHeight",
    get: function get() {
      return this.scrollableElement.getScrollDimensions().height;
    }
  }, {
    key: "firstVisibleIndex",
    get: function get() {
      return this.getRenderRange(this.lastRenderTop, this.lastRenderHeight).start;
    }
  }, {
    key: "lastVisibleIndex",
    get: function get() {
      return this.getRenderRange(this.lastRenderTop, this.lastRenderHeight).end - 1;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.getScrollTop();
    },
    set: function set(e) {
      this.setScrollTop(e);
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this._scrollHeight + (this.horizontalScrolling ? 10 : 0);
    }
  }, {
    key: "onMouseClick",
    get: function get() {
      var _this55 = this;

      return v.map(xe(this.domNode, "click"), function (e) {
        return _this55.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseDblClick",
    get: function get() {
      var _this56 = this;

      return v.map(xe(this.domNode, "dblclick"), function (e) {
        return _this56.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseMiddleClick",
    get: function get() {
      var _this57 = this;

      return v.filter(v.map(xe(this.domNode, "auxclick"), function (e) {
        return _this57.toMouseEvent(e);
      }), function (e) {
        return 1 === e.browserEvent.button;
      });
    }
  }, {
    key: "onMouseUp",
    get: function get() {
      var _this58 = this;

      return v.map(xe(this.domNode, "mouseup"), function (e) {
        return _this58.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseDown",
    get: function get() {
      var _this59 = this;

      return v.map(xe(this.domNode, "mousedown"), function (e) {
        return _this59.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseOver",
    get: function get() {
      var _this60 = this;

      return v.map(xe(this.domNode, "mouseover"), function (e) {
        return _this60.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseMove",
    get: function get() {
      var _this61 = this;

      return v.map(xe(this.domNode, "mousemove"), function (e) {
        return _this61.toMouseEvent(e);
      });
    }
  }, {
    key: "onMouseOut",
    get: function get() {
      var _this62 = this;

      return v.map(xe(this.domNode, "mouseout"), function (e) {
        return _this62.toMouseEvent(e);
      });
    }
  }, {
    key: "onContextMenu",
    get: function get() {
      var _this63 = this;

      return v.map(xe(this.domNode, "contextmenu"), function (e) {
        return _this63.toMouseEvent(e);
      });
    }
  }, {
    key: "onTouchStart",
    get: function get() {
      var _this64 = this;

      return v.map(xe(this.domNode, "touchstart"), function (e) {
        return _this64.toTouchEvent(e);
      });
    }
  }, {
    key: "onTap",
    get: function get() {
      var _this65 = this;

      return v.map(xe(this.rowsContainer, hi.Tap), function (e) {
        return _this65.toGestureEvent(e);
      });
    }
  }]);

  return Zi;
}();

Zi.InstanceCount = 0, r([di], Zi.prototype, "onMouseClick", null), r([di], Zi.prototype, "onMouseDblClick", null), r([di], Zi.prototype, "onMouseMiddleClick", null), r([di], Zi.prototype, "onMouseUp", null), r([di], Zi.prototype, "onMouseDown", null), r([di], Zi.prototype, "onMouseOver", null), r([di], Zi.prototype, "onMouseMove", null), r([di], Zi.prototype, "onMouseOut", null), r([di], Zi.prototype, "onContextMenu", null), r([di], Zi.prototype, "onTouchStart", null), r([di], Zi.prototype, "onTap", null);

var qi =
/*#__PURE__*/
function () {
  function qi(e) {
    _classCallCheck(this, qi);

    this.spliceables = e;
  }

  _createClass(qi, [{
    key: "splice",
    value: function splice(e, t, i) {
      this.spliceables.forEach(function (o) {
        return o.splice(e, t, i);
      });
    }
  }]);

  return qi;
}();

function $i(e, t, i) {
  return Math.min(Math.max(e, t), i);
}

var eo =
/*#__PURE__*/
function () {
  function eo(e) {
    _classCallCheck(this, eo);

    this.trait = e, this.renderedElements = [];
  }

  _createClass(eo, [{
    key: "renderTemplate",
    value: function renderTemplate(e) {
      return e;
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i) {
      var o = pt(this.renderedElements, function (e) {
        return e.templateData === i;
      });

      if (o >= 0) {
        var _e60 = this.renderedElements[o];
        this.trait.unrender(i), _e60.index = t;
      } else {
        var _e61 = {
          index: t,
          templateData: i
        };
        this.renderedElements.push(_e61);
      }

      this.trait.renderIndex(t, i);
    }
  }, {
    key: "splice",
    value: function splice(e, t, i) {
      var o = [];
      var _iteratorNormalCompletion23 = true;
      var _didIteratorError23 = false;
      var _iteratorError23 = undefined;

      try {
        for (var _iterator23 = this.renderedElements[Symbol.iterator](), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
          var _n22 = _step23.value;
          _n22.index < e ? o.push(_n22) : _n22.index >= e + t && o.push({
            index: _n22.index + i - t,
            templateData: _n22.templateData
          });
        }
      } catch (err) {
        _didIteratorError23 = true;
        _iteratorError23 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion23 && _iterator23.return != null) {
            _iterator23.return();
          }
        } finally {
          if (_didIteratorError23) {
            throw _iteratorError23;
          }
        }
      }

      this.renderedElements = o;
    }
  }, {
    key: "renderIndexes",
    value: function renderIndexes(e) {
      var _iteratorNormalCompletion24 = true;
      var _didIteratorError24 = false;
      var _iteratorError24 = undefined;

      try {
        for (var _iterator24 = this.renderedElements[Symbol.iterator](), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
          var _ref10 = _step24.value;
          var _t41 = _ref10.index;
          var _i38 = _ref10.templateData;
          e.indexOf(_t41) > -1 && this.trait.renderIndex(_t41, _i38);
        }
      } catch (err) {
        _didIteratorError24 = true;
        _iteratorError24 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion24 && _iterator24.return != null) {
            _iterator24.return();
          }
        } finally {
          if (_didIteratorError24) {
            throw _iteratorError24;
          }
        }
      }
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {
      var t = pt(this.renderedElements, function (t) {
        return t.templateData === e;
      });
      t < 0 || this.renderedElements.splice(t, 1);
    }
  }, {
    key: "templateId",
    get: function get() {
      return "template:".concat(this.trait.trait);
    }
  }]);

  return eo;
}();

var to =
/*#__PURE__*/
function () {
  function to(e) {
    _classCallCheck(this, to);

    this._trait = e, this._onChange = new b(), this.indexes = [];
  }

  _createClass(to, [{
    key: "splice",
    value: function splice(e, t, i) {
      var o = i.length - t,
          n = e + t,
          s = [].concat(_toConsumableArray(this.indexes.filter(function (t) {
        return t < e;
      })), _toConsumableArray(i.map(function (t, i) {
        return t ? i + e : -1;
      }).filter(function (e) {
        return -1 !== e;
      })), _toConsumableArray(this.indexes.filter(function (e) {
        return e >= n;
      }).map(function (e) {
        return e + o;
      })));
      this.renderer.splice(e, t, i.length), this.set(s);
    }
  }, {
    key: "renderIndex",
    value: function renderIndex(e, t) {
      Mt(t, this._trait, this.contains(e));
    }
  }, {
    key: "unrender",
    value: function unrender(e) {
      yt(e, this._trait);
    }
  }, {
    key: "set",
    value: function set(e, t) {
      var i = this.indexes;
      this.indexes = e;
      var o = mo(i, e);
      return this.renderer.renderIndexes(o), this._onChange.fire({
        indexes: e,
        browserEvent: t
      }), i;
    }
  }, {
    key: "get",
    value: function get() {
      return this.indexes;
    }
  }, {
    key: "contains",
    value: function contains(e) {
      return this.indexes.some(function (t) {
        return t === e;
      });
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._onChange = C(this._onChange);
    }
  }, {
    key: "onChange",
    get: function get() {
      return this._onChange.event;
    }
  }, {
    key: "trait",
    get: function get() {
      return this._trait;
    }
  }, {
    key: "renderer",
    get: function get() {
      return new eo(this);
    }
  }]);

  return to;
}();

r([di], to.prototype, "renderer", null);

var io =
/*#__PURE__*/
function (_to) {
  _inherits(io, _to);

  function io() {
    _classCallCheck(this, io);

    return _possibleConstructorReturn(this, _getPrototypeOf(io).call(this, "focused"));
  }

  _createClass(io, [{
    key: "renderIndex",
    value: function renderIndex(e, t) {
      _get(_getPrototypeOf(io.prototype), "renderIndex", this).call(this, e, t), this.contains(e) ? t.setAttribute("aria-selected", "true") : t.removeAttribute("aria-selected");
    }
  }]);

  return io;
}(to);

var oo =
/*#__PURE__*/
function () {
  function oo(e, t, i) {
    _classCallCheck(this, oo);

    this.trait = e, this.view = t, this.identityProvider = i;
  }

  _createClass(oo, [{
    key: "splice",
    value: function splice(e, t, i) {
      var _this66 = this;

      if (!this.identityProvider) return this.trait.splice(e, t, i.map(function () {
        return !1;
      }));
      var o = this.trait.get().map(function (e) {
        return _this66.identityProvider.getId(_this66.view.element(e)).toString();
      }),
          n = i.map(function (e) {
        return o.indexOf(_this66.identityProvider.getId(e).toString()) > -1;
      });
      this.trait.splice(e, t, n);
    }
  }]);

  return oo;
}();

function no(e) {
  return "INPUT" === e.tagName || "TEXTAREA" === e.tagName;
}

var so =
/*#__PURE__*/
function () {
  function so(e, t, i) {
    _classCallCheck(this, so);

    this.list = e, this.view = t;
    var o = !(!1 === i.multipleSelectionSupport);
    this.disposables = [], this.openController = i.openController || co;
    var n = v.chain(xe(t.domNode, "keydown")).filter(function (e) {
      return !no(e.target);
    }).map(function (e) {
      return new We(e);
    });
    n.filter(function (e) {
      return 3 === e.keyCode;
    }).on(this.onEnter, this, this.disposables), n.filter(function (e) {
      return 16 === e.keyCode;
    }).on(this.onUpArrow, this, this.disposables), n.filter(function (e) {
      return 18 === e.keyCode;
    }).on(this.onDownArrow, this, this.disposables), n.filter(function (e) {
      return 11 === e.keyCode;
    }).on(this.onPageUpArrow, this, this.disposables), n.filter(function (e) {
      return 12 === e.keyCode;
    }).on(this.onPageDownArrow, this, this.disposables), n.filter(function (e) {
      return 9 === e.keyCode;
    }).on(this.onEscape, this, this.disposables), o && n.filter(function (e) {
      return (k ? e.metaKey : e.ctrlKey) && 31 === e.keyCode;
    }).on(this.onCtrlA, this, this.disposables);
  }

  _createClass(so, [{
    key: "onEnter",
    value: function onEnter(e) {
      e.preventDefault(), e.stopPropagation(), this.list.setSelection(this.list.getFocus(), e.browserEvent), this.openController.shouldOpen(e.browserEvent) && this.list.open(this.list.getFocus(), e.browserEvent);
    }
  }, {
    key: "onUpArrow",
    value: function onUpArrow(e) {
      e.preventDefault(), e.stopPropagation(), this.list.focusPrevious(1, !1, e.browserEvent), this.list.reveal(this.list.getFocus()[0]), this.view.domNode.focus();
    }
  }, {
    key: "onDownArrow",
    value: function onDownArrow(e) {
      e.preventDefault(), e.stopPropagation(), this.list.focusNext(1, !1, e.browserEvent), this.list.reveal(this.list.getFocus()[0]), this.view.domNode.focus();
    }
  }, {
    key: "onPageUpArrow",
    value: function onPageUpArrow(e) {
      e.preventDefault(), e.stopPropagation(), this.list.focusPreviousPage(e.browserEvent), this.list.reveal(this.list.getFocus()[0]), this.view.domNode.focus();
    }
  }, {
    key: "onPageDownArrow",
    value: function onPageDownArrow(e) {
      e.preventDefault(), e.stopPropagation(), this.list.focusNextPage(e.browserEvent), this.list.reveal(this.list.getFocus()[0]), this.view.domNode.focus();
    }
  }, {
    key: "onCtrlA",
    value: function onCtrlA(e) {
      e.preventDefault(), e.stopPropagation(), this.list.setSelection(mt(this.list.length), e.browserEvent), this.view.domNode.focus();
    }
  }, {
    key: "onEscape",
    value: function onEscape(e) {
      e.preventDefault(), e.stopPropagation(), this.list.setSelection([], e.browserEvent), this.view.domNode.focus();
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposables = C(this.disposables);
    }
  }]);

  return so;
}();

var ro;
!function (e) {
  e[e.Idle = 0] = "Idle", e[e.Typing = 1] = "Typing";
}(ro || (ro = {}));

var lo =
/*#__PURE__*/
function () {
  function lo(e, t, i) {
    _classCallCheck(this, lo);

    this.list = e, this.view = t, this.keyboardNavigationLabelProvider = i, this.enabled = !1, this.state = ro.Idle, this.automaticKeyboardNavigation = !0, this.triggered = !1, this.enabledDisposables = [], this.disposables = [], this.updateOptions(e.options);
  }

  _createClass(lo, [{
    key: "updateOptions",
    value: function updateOptions(e) {
      void 0 === e.enableKeyboardNavigation || !!e.enableKeyboardNavigation ? this.enable() : this.disable(), void 0 !== e.automaticKeyboardNavigation && (this.automaticKeyboardNavigation = e.automaticKeyboardNavigation);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.triggered = !this.triggered;
    }
  }, {
    key: "enable",
    value: function enable() {
      var _this67 = this;

      if (this.enabled) return;
      var e = v.chain(xe(this.view.domNode, "keydown")).filter(function (e) {
        return !no(e.target);
      }).filter(function () {
        return _this67.automaticKeyboardNavigation || _this67.triggered;
      }).map(function (e) {
        return new We(e);
      }).filter(this.keyboardNavigationLabelProvider.mightProducePrintableCharacter ? function (e) {
        return _this67.keyboardNavigationLabelProvider.mightProducePrintableCharacter(e);
      } : function (e) {
        return function (e) {
          return !(e.ctrlKey || e.metaKey || e.altKey) && (e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30 || e.keyCode >= 80 && e.keyCode <= 90);
        }(e);
      }).forEach(function (e) {
        e.stopPropagation(), e.preventDefault();
      }).map(function (e) {
        return e.browserEvent.key;
      }).event,
          t = v.debounce(e, function () {
        return null;
      }, 800);
      v.reduce(v.any(e, t), function (e, t) {
        return null === t ? null : (e || "") + t;
      })(this.onInput, this, this.enabledDisposables), this.enabled = !0, this.triggered = !1;
    }
  }, {
    key: "disable",
    value: function disable() {
      this.enabled && (this.enabledDisposables = C(this.enabledDisposables), this.enabled = !1, this.triggered = !1);
    }
  }, {
    key: "onInput",
    value: function onInput(e) {
      if (!e) return this.state = ro.Idle, void (this.triggered = !1);
      var t = this.list.getFocus(),
          i = t.length > 0 ? t[0] : 0,
          o = this.state === ro.Idle ? 1 : 0;
      this.state = ro.Typing;

      for (var _t42 = 0; _t42 < this.list.length; _t42++) {
        var _n23 = (i + _t42 + o) % this.list.length,
            _s13 = this.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(this.view.element(_n23)),
            _r8 = _s13 && _s13.toString();

        if (void 0 === _r8 || ge(e, _r8)) return this.list.setFocus([_n23]), void this.list.reveal(_n23);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disable(), this.disposables = C(this.disposables);
    }
  }]);

  return lo;
}();

var ao =
/*#__PURE__*/
function () {
  function ao(e, t) {
    _classCallCheck(this, ao);

    this.list = e, this.view = t, this.disposables = [], this.disposables = [], v.chain(xe(t.domNode, "keydown")).filter(function (e) {
      return !no(e.target);
    }).map(function (e) {
      return new We(e);
    }).filter(function (e) {
      return !(2 !== e.keyCode || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey);
    }).on(this.onTab, this, this.disposables);
  }

  _createClass(ao, [{
    key: "onTab",
    value: function onTab(e) {
      if (e.target !== this.view.domNode) return;
      var t = this.list.getFocus();
      if (0 === t.length) return;
      var i = this.view.domElement(t[0]);
      if (!i) return;
      var o = i.querySelector("[tabIndex]");
      if (!(o && o instanceof HTMLElement && -1 !== o.tabIndex)) return;
      var n = window.getComputedStyle(o);
      "hidden" !== n.visibility && "none" !== n.display && (e.preventDefault(), e.stopPropagation(), o.focus());
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposables = C(this.disposables);
    }
  }]);

  return ao;
}();

function Ao(e) {
  return e instanceof MouseEvent && 2 === e.button;
}

var ho = {
  isSelectionSingleChangeEvent: function isSelectionSingleChangeEvent(e) {
    return k ? e.browserEvent.metaKey : e.browserEvent.ctrlKey;
  },
  isSelectionRangeChangeEvent: function isSelectionRangeChangeEvent(e) {
    return e.browserEvent.shiftKey;
  }
},
    co = {
  shouldOpen: function shouldOpen(e) {
    return !(e instanceof MouseEvent) || !Ao(e);
  }
};

var uo =
/*#__PURE__*/
function () {
  function uo(e) {
    _classCallCheck(this, uo);

    this.list = e, this.disposables = [], this.multipleSelectionSupport = !(!1 === e.options.multipleSelectionSupport), this.multipleSelectionSupport && (this.multipleSelectionController = e.options.multipleSelectionController || ho), this.openController = e.options.openController || co, this.mouseSupport = void 0 === e.options.mouseSupport || !!e.options.mouseSupport, this.mouseSupport && (e.onMouseDown(this.onMouseDown, this, this.disposables), e.onContextMenu(this.onContextMenu, this, this.disposables), e.onMouseDblClick(this.onDoubleClick, this, this.disposables), e.onTouchStart(this.onMouseDown, this, this.disposables), ui.addTarget(e.getHTMLElement())), e.onMouseClick(this.onPointer, this, this.disposables), e.onMouseMiddleClick(this.onPointer, this, this.disposables), e.onTap(this.onPointer, this, this.disposables);
  }

  _createClass(uo, [{
    key: "isSelectionSingleChangeEvent",
    value: function isSelectionSingleChangeEvent(e) {
      return this.multipleSelectionController ? this.multipleSelectionController.isSelectionSingleChangeEvent(e) : k ? e.browserEvent.metaKey : e.browserEvent.ctrlKey;
    }
  }, {
    key: "isSelectionRangeChangeEvent",
    value: function isSelectionRangeChangeEvent(e) {
      return this.multipleSelectionController ? this.multipleSelectionController.isSelectionRangeChangeEvent(e) : e.browserEvent.shiftKey;
    }
  }, {
    key: "isSelectionChangeEvent",
    value: function isSelectionChangeEvent(e) {
      return this.isSelectionSingleChangeEvent(e) || this.isSelectionRangeChangeEvent(e);
    }
  }, {
    key: "onMouseDown",
    value: function onMouseDown(e) {
      document.activeElement !== e.browserEvent.target && this.list.domFocus();
    }
  }, {
    key: "onContextMenu",
    value: function onContextMenu(e) {
      var t = void 0 === e.index ? [] : [e.index];
      this.list.setFocus(t, e.browserEvent);
    }
  }, {
    key: "onPointer",
    value: function onPointer(e) {
      if (!this.mouseSupport) return;
      if (no(e.browserEvent.target)) return;
      var t = this.list.getFocus()[0];
      var i = this.list.getSelection();
      t = void 0 === t ? i[0] : t;
      var o = e.index;
      return void 0 === o ? (this.list.setFocus([], e.browserEvent), void this.list.setSelection([], e.browserEvent)) : this.multipleSelectionSupport && this.isSelectionRangeChangeEvent(e) ? this.changeSelection(e, t) : this.multipleSelectionSupport && this.isSelectionChangeEvent(e) ? this.changeSelection(e, t) : (this.list.setFocus([o], e.browserEvent), void (Ao(e.browserEvent) || (this.list.setSelection([o], e.browserEvent), this.openController.shouldOpen(e.browserEvent) && this.list.open([o], e.browserEvent))));
    }
  }, {
    key: "onDoubleClick",
    value: function onDoubleClick(e) {
      if (no(e.browserEvent.target)) return;
      if (this.multipleSelectionSupport && this.isSelectionChangeEvent(e)) return;
      var t = this.list.getFocus();
      this.list.setSelection(t, e.browserEvent), this.list.pin(t);
    }
  }, {
    key: "changeSelection",
    value: function changeSelection(e, t) {
      var i = e.index;

      if (this.isSelectionRangeChangeEvent(e) && void 0 !== t) {
        var _o22 = mt(Math.min(t, i), Math.max(t, i) + 1),
            _n24 = this.list.getSelection(),
            _s14 = function (e, t) {
          var i = e.indexOf(t);
          if (-1 === i) return [];
          var o = [];
          var n = i - 1;

          for (; n >= 0 && e[n] === t - (i - n);) {
            o.push(e[n--]);
          }

          o.reverse(), n = i;

          for (; n < e.length && e[n] === t + (n - i);) {
            o.push(e[n++]);
          }

          return o;
        }(mo(_n24, [t]), t);

        if (0 === _s14.length) return;

        var _r9 = mo(_o22, function (e, t) {
          var i = [];
          var o = 0,
              n = 0;

          for (; o < e.length || n < t.length;) {
            if (o >= e.length) i.push(t[n++]);else if (n >= t.length) i.push(e[o++]);else {
              if (e[o] === t[n]) {
                o++, n++;
                continue;
              }

              e[o] < t[n] ? i.push(e[o++]) : n++;
            }
          }

          return i;
        }(_n24, _s14));

        this.list.setSelection(_r9, e.browserEvent);
      } else if (this.isSelectionSingleChangeEvent(e)) {
        var _t43 = this.list.getSelection(),
            _o23 = _t43.filter(function (e) {
          return e !== i;
        });

        _t43.length === _o23.length ? this.list.setSelection([].concat(_toConsumableArray(_o23), [i]), e.browserEvent) : this.list.setSelection(_o23, e.browserEvent);
      }
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposables = C(this.disposables);
    }
  }]);

  return uo;
}();

var go =
/*#__PURE__*/
function () {
  function go(e, t) {
    _classCallCheck(this, go);

    this.styleElement = e, this.selectorSuffix = t;
  }

  _createClass(go, [{
    key: "style",
    value: function style(e) {
      var t = this.selectorSuffix ? ".".concat(this.selectorSuffix) : "",
          i = [];
      e.listFocusBackground && (i.push(".monaco-list".concat(t, ":focus .monaco-list-row.focused { background-color: ").concat(e.listFocusBackground, "; }")), i.push(".monaco-list".concat(t, ":focus .monaco-list-row.focused:hover { background-color: ").concat(e.listFocusBackground, "; }"))), e.listFocusForeground && i.push(".monaco-list".concat(t, ":focus .monaco-list-row.focused { color: ").concat(e.listFocusForeground, "; }")), e.listActiveSelectionBackground && (i.push(".monaco-list".concat(t, ":focus .monaco-list-row.selected { background-color: ").concat(e.listActiveSelectionBackground, "; }")), i.push(".monaco-list".concat(t, ":focus .monaco-list-row.selected:hover { background-color: ").concat(e.listActiveSelectionBackground, "; }"))), e.listActiveSelectionForeground && i.push(".monaco-list".concat(t, ":focus .monaco-list-row.selected { color: ").concat(e.listActiveSelectionForeground, "; }")), e.listFocusAndSelectionBackground && i.push("\n\t\t\t\t.monaco-drag-image,\n\t\t\t\t.monaco-list".concat(t, ":focus .monaco-list-row.selected.focused { background-color: ").concat(e.listFocusAndSelectionBackground, "; }\n\t\t\t")), e.listFocusAndSelectionForeground && i.push("\n\t\t\t\t.monaco-drag-image,\n\t\t\t\t.monaco-list".concat(t, ":focus .monaco-list-row.selected.focused { color: ").concat(e.listFocusAndSelectionForeground, "; }\n\t\t\t")), e.listInactiveFocusBackground && (i.push(".monaco-list".concat(t, " .monaco-list-row.focused { background-color:  ").concat(e.listInactiveFocusBackground, "; }")), i.push(".monaco-list".concat(t, " .monaco-list-row.focused:hover { background-color:  ").concat(e.listInactiveFocusBackground, "; }"))), e.listInactiveSelectionBackground && (i.push(".monaco-list".concat(t, " .monaco-list-row.selected { background-color:  ").concat(e.listInactiveSelectionBackground, "; }")), i.push(".monaco-list".concat(t, " .monaco-list-row.selected:hover { background-color:  ").concat(e.listInactiveSelectionBackground, "; }"))), e.listInactiveSelectionForeground && i.push(".monaco-list".concat(t, " .monaco-list-row.selected { color: ").concat(e.listInactiveSelectionForeground, "; }")), e.listHoverBackground && i.push(".monaco-list".concat(t, ":not(.drop-target) .monaco-list-row:hover:not(.selected):not(.focused) { background-color:  ").concat(e.listHoverBackground, "; }")), e.listHoverForeground && i.push(".monaco-list".concat(t, " .monaco-list-row:hover:not(.selected):not(.focused) { color:  ").concat(e.listHoverForeground, "; }")), e.listSelectionOutline && i.push(".monaco-list".concat(t, " .monaco-list-row.selected { outline: 1px dotted ").concat(e.listSelectionOutline, "; outline-offset: -1px; }")), e.listFocusOutline && i.push("\n\t\t\t\t.monaco-drag-image,\n\t\t\t\t.monaco-list".concat(t, ":focus .monaco-list-row.focused { outline: 1px solid ").concat(e.listFocusOutline, "; outline-offset: -1px; }\n\t\t\t")), e.listInactiveFocusOutline && i.push(".monaco-list".concat(t, " .monaco-list-row.focused { outline: 1px dotted ").concat(e.listInactiveFocusOutline, "; outline-offset: -1px; }")), e.listHoverOutline && i.push(".monaco-list".concat(t, " .monaco-list-row:hover { outline: 1px dashed ").concat(e.listHoverOutline, "; outline-offset: -1px; }")), e.listDropBackground && i.push("\n\t\t\t\t.monaco-list".concat(t, ".drop-target,\n\t\t\t\t.monaco-list").concat(t, " .monaco-list-row.drop-target { background-color: ").concat(e.listDropBackground, " !important; color: inherit !important; }\n\t\t\t")), e.listFilterWidgetBackground && i.push(".monaco-list-type-filter { background-color: ".concat(e.listFilterWidgetBackground, " }")), e.listFilterWidgetOutline && i.push(".monaco-list-type-filter { border: 1px solid ".concat(e.listFilterWidgetOutline, "; }")), e.listFilterWidgetNoMatchesOutline && i.push(".monaco-list-type-filter.no-matches { border: 1px solid ".concat(e.listFilterWidgetNoMatchesOutline, "; }")), e.listMatchesShadow && i.push(".monaco-list-type-filter { box-shadow: 1px 1px 1px ".concat(e.listMatchesShadow, "; }"));
      var o = i.join("\n");
      o !== this.styleElement.innerHTML && (this.styleElement.innerHTML = o);
    }
  }]);

  return go;
}();

var Co = {
  listFocusBackground: I.fromHex("#073655"),
  listActiveSelectionBackground: I.fromHex("#0E639C"),
  listActiveSelectionForeground: I.fromHex("#FFFFFF"),
  listFocusAndSelectionBackground: I.fromHex("#094771"),
  listFocusAndSelectionForeground: I.fromHex("#FFFFFF"),
  listInactiveSelectionBackground: I.fromHex("#3F3F46"),
  listHoverBackground: I.fromHex("#2A2D2E"),
  listDropBackground: I.fromHex("#383B3D")
},
    po = {
  keyboardSupport: !0,
  mouseSupport: !0,
  multipleSelectionSupport: !0,
  dnd: {
    getDragURI: function getDragURI() {
      return null;
    },
    onDragStart: function onDragStart() {},
    onDragOver: function onDragOver() {
      return !1;
    },
    drop: function drop() {}
  },
  ariaRootRole: ci.TREE
};

function mo(e, t) {
  var i = [];
  var o = 0,
      n = 0;

  for (; o < e.length || n < t.length;) {
    if (o >= e.length) i.push(t[n++]);else if (n >= t.length) i.push(e[o++]);else {
      if (e[o] === t[n]) {
        i.push(e[o]), o++, n++;
        continue;
      }

      e[o] < t[n] ? i.push(e[o++]) : i.push(t[n++]);
    }
  }

  return i;
}

var fo = function fo(e, t) {
  return e - t;
};

var Do =
/*#__PURE__*/
function () {
  function Do(e, t) {
    _classCallCheck(this, Do);

    this._templateId = e, this.renderers = t;
  }

  _createClass(Do, [{
    key: "renderTemplate",
    value: function renderTemplate(e) {
      return this.renderers.map(function (t) {
        return t.renderTemplate(e);
      });
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i, o) {
      var n = 0;
      var _iteratorNormalCompletion25 = true;
      var _didIteratorError25 = false;
      var _iteratorError25 = undefined;

      try {
        for (var _iterator25 = this.renderers[Symbol.iterator](), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
          var _s15 = _step25.value;

          _s15.renderElement(e, t, i[n++], o);
        }
      } catch (err) {
        _didIteratorError25 = true;
        _iteratorError25 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion25 && _iterator25.return != null) {
            _iterator25.return();
          }
        } finally {
          if (_didIteratorError25) {
            throw _iteratorError25;
          }
        }
      }
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(e, t, i, o) {
      var n = 0;
      var _iteratorNormalCompletion26 = true;
      var _didIteratorError26 = false;
      var _iteratorError26 = undefined;

      try {
        for (var _iterator26 = this.renderers[Symbol.iterator](), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
          var _s16 = _step26.value;
          _s16.disposeElement && _s16.disposeElement(e, t, i[n], o), n += 1;
        }
      } catch (err) {
        _didIteratorError26 = true;
        _iteratorError26 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion26 && _iterator26.return != null) {
            _iterator26.return();
          }
        } finally {
          if (_didIteratorError26) {
            throw _iteratorError26;
          }
        }
      }
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {
      var t = 0;
      var _iteratorNormalCompletion27 = true;
      var _didIteratorError27 = false;
      var _iteratorError27 = undefined;

      try {
        for (var _iterator27 = this.renderers[Symbol.iterator](), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
          var _i39 = _step27.value;

          _i39.disposeTemplate(e[t++]);
        }
      } catch (err) {
        _didIteratorError27 = true;
        _iteratorError27 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion27 && _iterator27.return != null) {
            _iterator27.return();
          }
        } finally {
          if (_didIteratorError27) {
            throw _iteratorError27;
          }
        }
      }
    }
  }, {
    key: "templateId",
    get: function get() {
      return this._templateId;
    }
  }]);

  return Do;
}();

var wo =
/*#__PURE__*/
function () {
  function wo(e) {
    _classCallCheck(this, wo);

    this.accessibilityProvider = e, this.templateId = "a18n";
  }

  _createClass(wo, [{
    key: "renderTemplate",
    value: function renderTemplate(e) {
      return e;
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i) {
      var o = this.accessibilityProvider.getAriaLabel(e);
      o ? i.setAttribute("aria-label", o) : i.removeAttribute("aria-label");
      var n = this.accessibilityProvider.getAriaLevel && this.accessibilityProvider.getAriaLevel(e);
      "number" == typeof n ? i.setAttribute("aria-level", "".concat(n)) : i.removeAttribute("aria-level");
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {}
  }]);

  return wo;
}();

var vo =
/*#__PURE__*/
function () {
  function vo(e, t) {
    _classCallCheck(this, vo);

    this.list = e, this.dnd = t;
  }

  _createClass(vo, [{
    key: "getDragElements",
    value: function getDragElements(e) {
      var t = this.list.getSelectedElements();
      return t.indexOf(e) > -1 ? t : [e];
    }
  }, {
    key: "getDragURI",
    value: function getDragURI(e) {
      return this.dnd.getDragURI(e);
    }
  }, {
    key: "getDragLabel",
    value: function getDragLabel(e) {
      if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e);
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e, t) {
      this.dnd.onDragStart && this.dnd.onDragStart(e, t);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e, t, i, o) {
      return this.dnd.onDragOver(e, t, i, o);
    }
  }, {
    key: "drop",
    value: function drop(e, t, i, o) {
      this.dnd.drop(e, t, i, o);
    }
  }]);

  return vo;
}();

var Eo =
/*#__PURE__*/
function () {
  function Eo(e, t, i) {
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : po;

    _classCallCheck(this, Eo);

    this._options = o, this.eventBufferer = new F(), this._onDidOpen = new b(), this.onDidOpen = this._onDidOpen.event, this._onPin = new b(), this.didJustPressContextMenuKey = !1, this._onDidDispose = new b(), this.focus = new io(), this.selection = new to("selected"), function e(t, i) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      return Gt(t) ? (Gt(i) && Object.keys(i).forEach(function (n) {
        n in t ? o && (Gt(t[n]) && Gt(i[n]) ? e(t[n], i[n], o) : t[n] = i[n]) : t[n] = i[n];
      }), t) : i;
    }(o, Co, !1);
    var n = [this.focus.renderer, this.selection.renderer];
    o.accessibilityProvider && n.push(new wo(o.accessibilityProvider)), i = i.map(function (e) {
      return new Do(e.templateId, [].concat(n, [e]));
    });
    var s = Object.assign({}, o, {
      dnd: o.dnd && new vo(this, o.dnd)
    });

    if (this.view = new Zi(e, t, i, s), "string" != typeof o.ariaRole ? this.view.domNode.setAttribute("role", ci.TREE) : this.view.domNode.setAttribute("role", o.ariaRole), this.styleElement = function () {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.getElementsByTagName("head")[0];
      var t = document.createElement("style");
      return t.type = "text/css", t.media = "screen", e.appendChild(t), t;
    }(this.view.domNode), this.styleController = o.styleController || new go(this.styleElement, this.view.domId), this.spliceable = new qi([new oo(this.focus, this.view, o.identityProvider), new oo(this.selection, this.view, o.identityProvider), this.view]), this.disposables = [this.focus, this.selection, this.view, this._onDidDispose], this.onDidFocus = v.map(xe(this.view.domNode, "focus", !0), function () {
      return null;
    }), this.onDidBlur = v.map(xe(this.view.domNode, "blur", !0), function () {
      return null;
    }), this.disposables.push(new ao(this, this.view)), "boolean" != typeof o.keyboardSupport || o.keyboardSupport) {
      var _e62 = new so(this, this.view, o);

      this.disposables.push(_e62);
    }

    o.keyboardNavigationLabelProvider && (this.typeLabelController = new lo(this, this.view, o.keyboardNavigationLabelProvider), this.disposables.push(this.typeLabelController)), this.disposables.push(this.createMouseController(o)), this.onFocusChange(this._onFocusChange, this, this.disposables), this.onSelectionChange(this._onSelectionChange, this, this.disposables), o.ariaLabel, this.style(o);
  }

  _createClass(Eo, [{
    key: "createMouseController",
    value: function createMouseController(e) {
      return new uo(this);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = Object.assign({}, this._options, e), this.typeLabelController && this.typeLabelController.updateOptions(this._options);
    }
  }, {
    key: "splice",
    value: function splice(e, t) {
      var _this68 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (e < 0 || e > this.view.length) throw new Error("Invalid start index: ".concat(e));
      if (t < 0) throw new Error("Invalid delete count: ".concat(t));
      0 === t && 0 === i.length || this.eventBufferer.bufferEvents(function () {
        return _this68.spliceable.splice(e, t, i);
      });
    }
  }, {
    key: "updateWidth",
    value: function updateWidth(e) {
      this.view.updateWidth(e);
    }
  }, {
    key: "rerender",
    value: function rerender() {
      this.view.rerender();
    }
  }, {
    key: "element",
    value: function element(e) {
      return this.view.element(e);
    }
  }, {
    key: "domFocus",
    value: function domFocus() {
      this.view.domNode.focus();
    }
  }, {
    key: "layout",
    value: function layout(e, t) {
      this.view.layout(e, t);
    }
  }, {
    key: "toggleKeyboardNavigation",
    value: function toggleKeyboardNavigation() {
      this.typeLabelController && this.typeLabelController.toggle();
    }
  }, {
    key: "setSelection",
    value: function setSelection(e, t) {
      var _iteratorNormalCompletion28 = true;
      var _didIteratorError28 = false;
      var _iteratorError28 = undefined;

      try {
        for (var _iterator28 = e[Symbol.iterator](), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
          var _t44 = _step28.value;
          if (_t44 < 0 || _t44 >= this.length) throw new Error("Invalid index ".concat(_t44));
        }
      } catch (err) {
        _didIteratorError28 = true;
        _iteratorError28 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion28 && _iterator28.return != null) {
            _iterator28.return();
          }
        } finally {
          if (_didIteratorError28) {
            throw _iteratorError28;
          }
        }
      }

      e = e.sort(fo), this.selection.set(e, t);
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      return this.selection.get();
    }
  }, {
    key: "getSelectedElements",
    value: function getSelectedElements() {
      var _this69 = this;

      return this.getSelection().map(function (e) {
        return _this69.view.element(e);
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      var _iteratorNormalCompletion29 = true;
      var _didIteratorError29 = false;
      var _iteratorError29 = undefined;

      try {
        for (var _iterator29 = e[Symbol.iterator](), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
          var _t45 = _step29.value;
          if (_t45 < 0 || _t45 >= this.length) throw new Error("Invalid index ".concat(_t45));
        }
      } catch (err) {
        _didIteratorError29 = true;
        _iteratorError29 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion29 && _iterator29.return != null) {
            _iterator29.return();
          }
        } finally {
          if (_didIteratorError29) {
            throw _iteratorError29;
          }
        }
      }

      e = e.sort(fo), this.focus.set(e, t);
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      if (0 === this.length) return;
      var n = this.focus.get(),
          s = this.findNextIndex(n.length > 0 ? n[0] + e : 0, t, o);
      s > -1 && this.setFocus([s], i);
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      if (0 === this.length) return;
      var n = this.focus.get(),
          s = this.findPreviousIndex(n.length > 0 ? n[0] - e : 0, t, o);
      s > -1 && this.setFocus([s], i);
    }
  }, {
    key: "focusNextPage",
    value: function focusNextPage(e, t) {
      var _this70 = this;

      var i = this.view.indexAt(this.view.getScrollTop() + this.view.renderHeight);
      i = 0 === i ? 0 : i - 1;
      var o = this.view.element(i),
          n = this.getFocusedElements()[0];

      if (n !== o) {
        var _o24 = this.findPreviousIndex(i, !1, t);

        _o24 > -1 && n !== this.view.element(_o24) ? this.setFocus([_o24], e) : this.setFocus([i], e);
      } else {
        var _o25 = this.view.getScrollTop();

        this.view.setScrollTop(_o25 + this.view.renderHeight - this.view.elementHeight(i)), this.view.getScrollTop() !== _o25 && setTimeout(function () {
          return _this70.focusNextPage(e, t);
        }, 0);
      }
    }
  }, {
    key: "focusPreviousPage",
    value: function focusPreviousPage(e, t) {
      var _this71 = this;

      var i;
      var o = this.view.getScrollTop();
      i = 0 === o ? this.view.indexAt(o) : this.view.indexAfter(o - 1);
      var n = this.view.element(i),
          s = this.getFocusedElements()[0];

      if (s !== n) {
        var _o26 = this.findNextIndex(i, !1, t);

        _o26 > -1 && s !== this.view.element(_o26) ? this.setFocus([_o26], e) : this.setFocus([i], e);
      } else {
        var _i40 = o;
        this.view.setScrollTop(o - this.view.renderHeight), this.view.getScrollTop() !== _i40 && setTimeout(function () {
          return _this71.focusPreviousPage(e, t);
        }, 0);
      }
    }
  }, {
    key: "focusLast",
    value: function focusLast(e, t) {
      if (0 === this.length) return;
      var i = this.findPreviousIndex(this.length - 1, !1, t);
      i > -1 && this.setFocus([i], e);
    }
  }, {
    key: "focusFirst",
    value: function focusFirst(e, t) {
      if (0 === this.length) return;
      var i = this.findNextIndex(0, !1, t);
      i > -1 && this.setFocus([i], e);
    }
  }, {
    key: "findNextIndex",
    value: function findNextIndex(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;

      for (var _o27 = 0; _o27 < this.length; _o27++) {
        if (e >= this.length && !t) return -1;
        if (e %= this.length, !i || i(this.element(e))) return e;
        e++;
      }

      return -1;
    }
  }, {
    key: "findPreviousIndex",
    value: function findPreviousIndex(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;

      for (var _o28 = 0; _o28 < this.length; _o28++) {
        if (e < 0 && !t) return -1;
        if (e = (this.length + e % this.length) % this.length, !i || i(this.element(e))) return e;
        e--;
      }

      return -1;
    }
  }, {
    key: "getFocus",
    value: function getFocus() {
      return this.focus.get();
    }
  }, {
    key: "getFocusedElements",
    value: function getFocusedElements() {
      var _this72 = this;

      return this.getFocus().map(function (e) {
        return _this72.view.element(e);
      });
    }
  }, {
    key: "reveal",
    value: function reveal(e, t) {
      if (e < 0 || e >= this.length) throw new Error("Invalid index ".concat(e));
      var i = this.view.getScrollTop(),
          o = this.view.elementTop(e),
          n = this.view.elementHeight(e);

      if ((typeof (s = t) === Jt.number || s instanceof Number) && !isNaN(s)) {
        var _e63 = n - this.view.renderHeight;

        this.view.setScrollTop(_e63 * $i(t, 0, 1) + o);
      } else {
        var _e64 = o + n,
            _t46 = i + this.view.renderHeight;

        o < i ? this.view.setScrollTop(o) : _e64 >= _t46 && this.view.setScrollTop(_e64 - this.view.renderHeight);
      }

      var s;
    }
  }, {
    key: "getRelativeTop",
    value: function getRelativeTop(e) {
      if (e < 0 || e >= this.length) throw new Error("Invalid index ".concat(e));
      var t = this.view.getScrollTop(),
          i = this.view.elementTop(e),
          o = this.view.elementHeight(e);
      if (i < t || i + o > t + this.view.renderHeight) return null;
      var n = o - this.view.renderHeight;
      return Math.abs((t - i) / n);
    }
  }, {
    key: "isDOMFocused",
    value: function isDOMFocused() {
      return this.view.domNode === document.activeElement;
    }
  }, {
    key: "getHTMLElement",
    value: function getHTMLElement() {
      return this.view.domNode;
    }
  }, {
    key: "open",
    value: function open(e, t) {
      var _this73 = this;

      var _iteratorNormalCompletion30 = true;
      var _didIteratorError30 = false;
      var _iteratorError30 = undefined;

      try {
        for (var _iterator30 = e[Symbol.iterator](), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
          var _t47 = _step30.value;
          if (_t47 < 0 || _t47 >= this.length) throw new Error("Invalid index ".concat(_t47));
        }
      } catch (err) {
        _didIteratorError30 = true;
        _iteratorError30 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion30 && _iterator30.return != null) {
            _iterator30.return();
          }
        } finally {
          if (_didIteratorError30) {
            throw _iteratorError30;
          }
        }
      }

      this._onDidOpen.fire({
        indexes: e,
        elements: e.map(function (e) {
          return _this73.view.element(e);
        }),
        browserEvent: t
      });
    }
  }, {
    key: "pin",
    value: function pin(e) {
      var _iteratorNormalCompletion31 = true;
      var _didIteratorError31 = false;
      var _iteratorError31 = undefined;

      try {
        for (var _iterator31 = e[Symbol.iterator](), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
          var _t48 = _step31.value;
          if (_t48 < 0 || _t48 >= this.length) throw new Error("Invalid index ".concat(_t48));
        }
      } catch (err) {
        _didIteratorError31 = true;
        _iteratorError31 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion31 && _iterator31.return != null) {
            _iterator31.return();
          }
        } finally {
          if (_didIteratorError31) {
            throw _iteratorError31;
          }
        }
      }

      this._onPin.fire(e);
    }
  }, {
    key: "style",
    value: function style(e) {
      this.styleController.style(e);
    }
  }, {
    key: "toListEvent",
    value: function toListEvent(_ref11) {
      var _this74 = this;

      var e = _ref11.indexes,
          t = _ref11.browserEvent;
      return {
        indexes: e,
        elements: e.map(function (e) {
          return _this74.view.element(e);
        }),
        browserEvent: t
      };
    }
  }, {
    key: "_onFocusChange",
    value: function _onFocusChange() {
      var e = this.focus.get();
      e.length > 0 ? this.view.domNode.setAttribute("aria-activedescendant", this.view.getElementDomId(e[0])) : this.view.domNode.removeAttribute("aria-activedescendant"), this.view.domNode.setAttribute("role", "tree"), Mt(this.view.domNode, "element-focused", e.length > 0);
    }
  }, {
    key: "_onSelectionChange",
    value: function _onSelectionChange() {
      var e = this.selection.get();
      Mt(this.view.domNode, "selection-none", 0 === e.length), Mt(this.view.domNode, "selection-single", 1 === e.length), Mt(this.view.domNode, "selection-multiple", e.length > 1);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._onDidDispose.fire(), this.disposables = C(this.disposables), this._onDidOpen.dispose(), this._onPin.dispose(), this._onDidDispose.dispose();
    }
  }, {
    key: "onFocusChange",
    get: function get() {
      var _this75 = this;

      return v.map(this.eventBufferer.wrapEvent(this.focus.onChange), function (e) {
        return _this75.toListEvent(e);
      });
    }
  }, {
    key: "onSelectionChange",
    get: function get() {
      var _this76 = this;

      return v.map(this.eventBufferer.wrapEvent(this.selection.onChange), function (e) {
        return _this76.toListEvent(e);
      });
    }
  }, {
    key: "onPin",
    get: function get() {
      var _this77 = this;

      return v.map(this._onPin.event, function (e) {
        return _this77.toListEvent({
          indexes: e
        });
      });
    }
  }, {
    key: "onDidScroll",
    get: function get() {
      return this.view.onDidScroll;
    }
  }, {
    key: "onMouseClick",
    get: function get() {
      return this.view.onMouseClick;
    }
  }, {
    key: "onMouseDblClick",
    get: function get() {
      return this.view.onMouseDblClick;
    }
  }, {
    key: "onMouseMiddleClick",
    get: function get() {
      return this.view.onMouseMiddleClick;
    }
  }, {
    key: "onMouseUp",
    get: function get() {
      return this.view.onMouseUp;
    }
  }, {
    key: "onMouseDown",
    get: function get() {
      return this.view.onMouseDown;
    }
  }, {
    key: "onMouseOver",
    get: function get() {
      return this.view.onMouseOver;
    }
  }, {
    key: "onMouseMove",
    get: function get() {
      return this.view.onMouseMove;
    }
  }, {
    key: "onMouseOut",
    get: function get() {
      return this.view.onMouseOut;
    }
  }, {
    key: "onTouchStart",
    get: function get() {
      return this.view.onTouchStart;
    }
  }, {
    key: "onTap",
    get: function get() {
      return this.view.onTap;
    }
  }, {
    key: "onContextMenu",
    get: function get() {
      var _this78 = this;

      var e = v.chain(xe(this.view.domNode, "keydown")).map(function (e) {
        return new We(e);
      }).filter(function (e) {
        return _this78.didJustPressContextMenuKey = 58 === e.keyCode || e.shiftKey && 68 === e.keyCode;
      }).filter(function (e) {
        return e.preventDefault(), e.stopPropagation(), !1;
      }).map(function (e) {
        var t = _this78.getFocus()[0];

        return {
          index: t,
          element: _this78.view.element(t),
          anchor: _this78.view.domElement(t) || void 0,
          browserEvent: e.browserEvent
        };
      }).event,
          t = v.chain(xe(this.view.domNode, "keyup")).filter(function () {
        var e = _this78.didJustPressContextMenuKey;
        return _this78.didJustPressContextMenuKey = !1, e;
      }).filter(function () {
        return _this78.getFocus().length > 0;
      }).map(function (e) {
        var t = _this78.getFocus()[0];

        return {
          index: t,
          element: _this78.view.element(t),
          anchor: _this78.view.domElement(t) || void 0,
          browserEvent: e
        };
      }).filter(function (_ref12) {
        var e = _ref12.anchor;
        return !!e;
      }).event,
          i = v.chain(this.view.onContextMenu).filter(function () {
        return !_this78.didJustPressContextMenuKey;
      }).map(function (_ref13) {
        var e = _ref13.element,
            t = _ref13.index,
            i = _ref13.browserEvent;
        return {
          element: e,
          index: t,
          anchor: {
            x: i.clientX + 1,
            y: i.clientY
          },
          browserEvent: i
        };
      }).event;
      return v.any(e, t, i);
    }
  }, {
    key: "onKeyDown",
    get: function get() {
      return xe(this.view.domNode, "keydown");
    }
  }, {
    key: "onKeyUp",
    get: function get() {
      return xe(this.view.domNode, "keyup");
    }
  }, {
    key: "onKeyPress",
    get: function get() {
      return xe(this.view.domNode, "keypress");
    }
  }, {
    key: "onDidDispose",
    get: function get() {
      return this._onDidDispose.event;
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "length",
    get: function get() {
      return this.view.length;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.view.contentHeight;
    }
  }, {
    key: "onDidChangeContentHeight",
    get: function get() {
      return this.view.onDidChangeContentHeight;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.view.getScrollTop();
    },
    set: function set(e) {
      this.view.setScrollTop(e);
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.view.scrollHeight;
    }
  }, {
    key: "renderHeight",
    get: function get() {
      return this.view.renderHeight;
    }
  }, {
    key: "firstVisibleIndex",
    get: function get() {
      return this.view.firstVisibleIndex;
    }
  }, {
    key: "lastVisibleIndex",
    get: function get() {
      return this.view.lastVisibleIndex;
    }
  }]);

  return Eo;
}();

function yo(e) {
  switch (e) {
    case !0:
      return 1;

    case !1:
      return 0;

    default:
      return e;
  }
}

function Mo(e) {
  var t = e.element,
      i = e.collapsed;
  return {
    element: t,
    children: w.map(w.fromArray(e.children), Mo),
    collapsed: i
  };
}

r([di], Eo.prototype, "onFocusChange", null), r([di], Eo.prototype, "onSelectionChange", null), r([di], Eo.prototype, "onPin", null), r([di], Eo.prototype, "onContextMenu", null);

var Bo =
/*#__PURE__*/
function () {
  function Bo(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Bo);

    this.list = e, this.rootRef = [], this.eventBufferer = new F(), this._onDidChangeCollapseState = new b(), this.onDidChangeCollapseState = this.eventBufferer.wrapEvent(this._onDidChangeCollapseState.event), this._onDidChangeRenderNodeCount = new b(), this.onDidChangeRenderNodeCount = this.eventBufferer.wrapEvent(this._onDidChangeRenderNodeCount.event), this._onDidSplice = new b(), this.onDidSplice = this._onDidSplice.event, this.collapseByDefault = void 0 !== i.collapseByDefault && i.collapseByDefault, this.filter = i.filter, this.autoExpandSingleChildren = void 0 !== i.autoExpandSingleChildren && i.autoExpandSingleChildren, this.root = {
      parent: void 0,
      element: t,
      children: [],
      depth: 0,
      visibleChildrenCount: 0,
      visibleChildIndex: -1,
      collapsible: !1,
      collapsed: !1,
      renderNodeCount: 0,
      visible: !0,
      filterData: void 0
    };
  }

  _createClass(Bo, [{
    key: "splice",
    value: function splice(e, t, i, o, n) {
      var _this79 = this,
          _s$children;

      if (0 === e.length) throw new Error("Invalid tree location");

      var _this$getParentNodeWi = this.getParentNodeWithListIndex(e),
          s = _this$getParentNodeWi.parentNode,
          r = _this$getParentNodeWi.listIndex,
          l = _this$getParentNodeWi.revealed,
          a = _this$getParentNodeWi.visible,
          A = [],
          h = w.map(w.from(i), function (e) {
        return _this79.createTreeNode(e, s, s.visible ? 1 : 0, l, A, o);
      }),
          c = e[e.length - 1];

      var d = 0;

      for (var _e65 = c; _e65 >= 0 && _e65 < s.children.length; _e65--) {
        var _t49 = s.children[_e65];

        if (_t49.visible) {
          d = _t49.visibleChildIndex;
          break;
        }
      }

      var u = [];
      var g = 0,
          C = 0;
      w.forEach(h, function (e) {
        u.push(e), C += e.renderNodeCount, e.visible && (e.visibleChildIndex = d + g++);
      });

      var p = (_s$children = s.children).splice.apply(_s$children, [c, t].concat(u));

      var m = 0;
      var _iteratorNormalCompletion32 = true;
      var _didIteratorError32 = false;
      var _iteratorError32 = undefined;

      try {
        for (var _iterator32 = p[Symbol.iterator](), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
          var _e69 = _step32.value;
          _e69.visible && m++;
        }
      } catch (err) {
        _didIteratorError32 = true;
        _iteratorError32 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion32 && _iterator32.return != null) {
            _iterator32.return();
          }
        } finally {
          if (_didIteratorError32) {
            throw _iteratorError32;
          }
        }
      }

      if (0 !== m) for (var _e66 = c + u.length; _e66 < s.children.length; _e66++) {
        var _t50 = s.children[_e66];
        _t50.visible && (_t50.visibleChildIndex -= m);
      }

      if (s.visibleChildrenCount += g - m, l && a) {
        var _e67 = p.reduce(function (e, t) {
          return e + t.renderNodeCount;
        }, 0);

        this._updateAncestorsRenderNodeCount(s, C - _e67), this.list.splice(r, _e67, A);
      }

      if (p.length > 0 && n) {
        var _e68 = function _e68(t) {
          n(t), t.children.forEach(_e68);
        };

        p.forEach(_e68);
      }

      var f = w.map(w.fromArray(p), Mo);
      return this._onDidSplice.fire({
        insertedNodes: u,
        deletedNodes: p
      }), f;
    }
  }, {
    key: "rerender",
    value: function rerender(e) {
      if (0 === e.length) throw new Error("Invalid tree location");

      var _this$getTreeNodeWith = this.getTreeNodeWithListIndex(e),
          t = _this$getTreeNodeWith.node,
          i = _this$getTreeNodeWith.listIndex,
          o = _this$getTreeNodeWith.revealed;

      o && this.list.splice(i, 1, [t]);
    }
  }, {
    key: "getListIndex",
    value: function getListIndex(e) {
      var _this$getTreeNodeWith2 = this.getTreeNodeWithListIndex(e),
          t = _this$getTreeNodeWith2.listIndex,
          i = _this$getTreeNodeWith2.visible,
          o = _this$getTreeNodeWith2.revealed;

      return i && o ? t : -1;
    }
  }, {
    key: "getListRenderCount",
    value: function getListRenderCount(e) {
      return this.getTreeNode(e).renderNodeCount;
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(e) {
      return this.getTreeNode(e).collapsible;
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(e) {
      return this.getTreeNode(e).collapsed;
    }
  }, {
    key: "setCollapsed",
    value: function setCollapsed(e, t, i) {
      var _this80 = this;

      var o = this.getTreeNode(e);
      return void 0 === t && (t = !o.collapsed), this.eventBufferer.bufferEvents(function () {
        return _this80._setCollapsed(e, t, i);
      });
    }
  }, {
    key: "_setCollapsed",
    value: function _setCollapsed(e, t, i) {
      var _this$getTreeNodeWith3 = this.getTreeNodeWithListIndex(e),
          o = _this$getTreeNodeWith3.node,
          n = _this$getTreeNodeWith3.listIndex,
          s = _this$getTreeNodeWith3.revealed,
          r = this._setListNodeCollapsed(o, n, s, t, i || !1);

      if (this.autoExpandSingleChildren && !t && !i) {
        var _t51 = -1;

        for (var _e70 = 0; _e70 < o.children.length; _e70++) {
          if (o.children[_e70].visible) {
            if (_t51 > -1) {
              _t51 = -1;
              break;
            }

            _t51 = _e70;
          }
        }

        _t51 > -1 && this._setCollapsed([].concat(_toConsumableArray(e), [_t51]), !1, !1);
      }

      return r;
    }
  }, {
    key: "_setListNodeCollapsed",
    value: function _setListNodeCollapsed(e, t, i, o, n) {
      var s = this._setNodeCollapsed(e, o, n, !1);

      if (!i || !e.visible) return s;
      var r = e.renderNodeCount,
          l = this.updateNodeAfterCollapseChange(e),
          a = r - (-1 === t ? 0 : 1);
      return this.list.splice(t + 1, a, l.slice(1)), s;
    }
  }, {
    key: "_setNodeCollapsed",
    value: function _setNodeCollapsed(e, t, i, o) {
      var n = e.collapsible && e.collapsed !== t;

      if (e.collapsible && (e.collapsed = t, n && this._onDidChangeCollapseState.fire({
        node: e,
        deep: o
      })), i) {
        var _iteratorNormalCompletion33 = true;
        var _didIteratorError33 = false;
        var _iteratorError33 = undefined;

        try {
          for (var _iterator33 = e.children[Symbol.iterator](), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
            var _i41 = _step33.value;
            n = this._setNodeCollapsed(_i41, t, !0, !0) || n;
          }
        } catch (err) {
          _didIteratorError33 = true;
          _iteratorError33 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion33 && _iterator33.return != null) {
              _iterator33.return();
            }
          } finally {
            if (_didIteratorError33) {
              throw _iteratorError33;
            }
          }
        }
      }

      return n;
    }
  }, {
    key: "expandTo",
    value: function expandTo(e) {
      var _this81 = this;

      this.eventBufferer.bufferEvents(function () {
        var t = _this81.getTreeNode(e);

        for (; t.parent;) {
          t = t.parent, e = e.slice(0, e.length - 1), t.collapsed && _this81._setCollapsed(e, !1);
        }
      });
    }
  }, {
    key: "refilter",
    value: function refilter() {
      var e = this.root.renderNodeCount,
          t = this.updateNodeAfterFilterChange(this.root);
      this.list.splice(0, e, t);
    }
  }, {
    key: "createTreeNode",
    value: function createTreeNode(e, t, i, o, n, s) {
      var _this82 = this;

      var r = {
        parent: t,
        element: e.element,
        children: [],
        depth: t.depth + 1,
        visibleChildrenCount: 0,
        visibleChildIndex: -1,
        collapsible: "boolean" == typeof e.collapsible ? e.collapsible : void 0 !== e.collapsed,
        collapsed: void 0 === e.collapsed ? this.collapseByDefault : e.collapsed,
        renderNodeCount: 1,
        visible: !0,
        filterData: void 0
      },
          l = this._filterNode(r, i);

      o && n.push(r);
      var a = w.from(e.children),
          A = o && 0 !== l && !r.collapsed,
          h = w.map(a, function (e) {
        return _this82.createTreeNode(e, r, l, A, n, s);
      });
      var c = 0,
          d = 1;
      return w.forEach(h, function (e) {
        r.children.push(e), d += e.renderNodeCount, e.visible && (e.visibleChildIndex = c++);
      }), r.collapsible = r.collapsible || r.children.length > 0, r.visibleChildrenCount = c, r.visible = 2 === l ? c > 0 : 1 === l, r.visible ? r.collapsed || (r.renderNodeCount = d) : (r.renderNodeCount = 0, o && n.pop()), s && s(r), r;
    }
  }, {
    key: "updateNodeAfterCollapseChange",
    value: function updateNodeAfterCollapseChange(e) {
      var t = e.renderNodeCount,
          i = [];
      return this._updateNodeAfterCollapseChange(e, i), this._updateAncestorsRenderNodeCount(e.parent, i.length - t), i;
    }
  }, {
    key: "_updateNodeAfterCollapseChange",
    value: function _updateNodeAfterCollapseChange(e, t) {
      if (!1 === e.visible) return 0;

      if (t.push(e), e.renderNodeCount = 1, !e.collapsed) {
        var _iteratorNormalCompletion34 = true;
        var _didIteratorError34 = false;
        var _iteratorError34 = undefined;

        try {
          for (var _iterator34 = e.children[Symbol.iterator](), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
            var _i42 = _step34.value;
            e.renderNodeCount += this._updateNodeAfterCollapseChange(_i42, t);
          }
        } catch (err) {
          _didIteratorError34 = true;
          _iteratorError34 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion34 && _iterator34.return != null) {
              _iterator34.return();
            }
          } finally {
            if (_didIteratorError34) {
              throw _iteratorError34;
            }
          }
        }
      }

      return this._onDidChangeRenderNodeCount.fire(e), e.renderNodeCount;
    }
  }, {
    key: "updateNodeAfterFilterChange",
    value: function updateNodeAfterFilterChange(e) {
      var t = e.renderNodeCount,
          i = [];
      return this._updateNodeAfterFilterChange(e, e.visible ? 1 : 0, i), this._updateAncestorsRenderNodeCount(e.parent, i.length - t), i;
    }
  }, {
    key: "_updateNodeAfterFilterChange",
    value: function _updateNodeAfterFilterChange(e, t, i) {
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var n;

      if (e !== this.root) {
        if (0 === (n = this._filterNode(e, t))) return e.visible = !1, !1;
        o && i.push(e);
      }

      var s = i.length;
      e.renderNodeCount = e === this.root ? 0 : 1;
      var r = !1;
      if (e.collapsed && 0 === n) e.visibleChildrenCount = 0;else {
        var _t52 = 0;
        var _iteratorNormalCompletion35 = true;
        var _didIteratorError35 = false;
        var _iteratorError35 = undefined;

        try {
          for (var _iterator35 = e.children[Symbol.iterator](), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
            var _s17 = _step35.value;
            r = this._updateNodeAfterFilterChange(_s17, n, i, o && !e.collapsed) || r, _s17.visible && (_s17.visibleChildIndex = _t52++);
          }
        } catch (err) {
          _didIteratorError35 = true;
          _iteratorError35 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion35 && _iterator35.return != null) {
              _iterator35.return();
            }
          } finally {
            if (_didIteratorError35) {
              throw _iteratorError35;
            }
          }
        }

        e.visibleChildrenCount = _t52;
      }
      return e !== this.root && (e.visible = 2 === n ? r : 1 === n), e.visible ? e.collapsed || (e.renderNodeCount += i.length - s) : (e.renderNodeCount = 0, o && i.pop()), this._onDidChangeRenderNodeCount.fire(e), e.visible;
    }
  }, {
    key: "_updateAncestorsRenderNodeCount",
    value: function _updateAncestorsRenderNodeCount(e, t) {
      if (0 !== t) for (; e;) {
        e.renderNodeCount += t, this._onDidChangeRenderNodeCount.fire(e), e = e.parent;
      }
    }
  }, {
    key: "_filterNode",
    value: function _filterNode(e, t) {
      var i = this.filter ? this.filter.filter(e.element, t) : 1;
      return "boolean" == typeof i ? (e.filterData = void 0, i ? 1 : 0) : "object" == typeof (o = i) && "visibility" in o && "data" in o ? (e.filterData = i.data, yo(i.visibility)) : (e.filterData = void 0, yo(i));
      var o;
    }
  }, {
    key: "getTreeNode",
    value: function getTreeNode(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root;
      if (!e || 0 === e.length) return t;

      var _e71 = _toArray(e),
          i = _e71[0],
          o = _e71.slice(1);

      if (i < 0 || i > t.children.length) throw new Error("Invalid tree location");
      return this.getTreeNode(o, t.children[i]);
    }
  }, {
    key: "getTreeNodeWithListIndex",
    value: function getTreeNodeWithListIndex(e) {
      if (0 === e.length) return {
        node: this.root,
        listIndex: -1,
        revealed: !0,
        visible: !1
      };

      var _this$getParentNodeWi2 = this.getParentNodeWithListIndex(e),
          t = _this$getParentNodeWi2.parentNode,
          i = _this$getParentNodeWi2.listIndex,
          o = _this$getParentNodeWi2.revealed,
          n = _this$getParentNodeWi2.visible,
          s = e[e.length - 1];

      if (s < 0 || s > t.children.length) throw new Error("Invalid tree location");
      var r = t.children[s];
      return {
        node: r,
        listIndex: i,
        revealed: o,
        visible: n && r.visible
      };
    }
  }, {
    key: "getParentNodeWithListIndex",
    value: function getParentNodeWithListIndex(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.root;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
      var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;

      var _e72 = _toArray(e),
          s = _e72[0],
          r = _e72.slice(1);

      if (s < 0 || s > t.children.length) throw new Error("Invalid tree location");

      for (var _e73 = 0; _e73 < s; _e73++) {
        i += t.children[_e73].renderNodeCount;
      }

      return o = o && !t.collapsed, n = n && t.visible, 0 === r.length ? {
        parentNode: t,
        listIndex: i,
        revealed: o,
        visible: n
      } : this.getParentNodeWithListIndex(r, t.children[s], i + 1, o, n);
    }
  }, {
    key: "getNode",
    value: function getNode() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.getTreeNode(e);
    }
  }, {
    key: "getNodeLocation",
    value: function getNodeLocation(e) {
      var t = [];

      for (; e.parent;) {
        t.push(e.parent.children.indexOf(e)), e = e.parent;
      }

      return t.reverse();
    }
  }, {
    key: "getParentNodeLocation",
    value: function getParentNodeLocation(e) {
      return e.length <= 1 ? [] : function (e) {
        if (0 === e.length) throw new Error("Invalid tail call");
        return [e.slice(0, e.length - 1), e[e.length - 1]];
      }(e)[0];
    }
  }, {
    key: "getParentElement",
    value: function getParentElement(e) {
      var t = this.getParentNodeLocation(e);
      return this.getTreeNode(t).element;
    }
  }, {
    key: "getFirstElementChild",
    value: function getFirstElementChild(e) {
      var t = this.getTreeNode(e);
      if (0 !== t.children.length) return t.children[0].element;
    }
  }, {
    key: "getLastElementAncestor",
    value: function getLastElementAncestor() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var t = this.getTreeNode(e);
      if (0 !== t.children.length) return this._getLastElementAncestor(t);
    }
  }, {
    key: "_getLastElementAncestor",
    value: function _getLastElementAncestor(e) {
      return 0 === e.children.length ? e.element : this._getLastElementAncestor(e.children[e.children.length - 1]);
    }
  }]);

  return Bo;
}();

function bo(e) {
  if (e instanceof Ki) {
    var _t53 = e.elements;
    return new Ki(_t53.map(function (e) {
      return e.element;
    }));
  }

  return e;
}

var Fo =
/*#__PURE__*/
function () {
  function Fo(e, t) {
    _classCallCheck(this, Fo);

    this.modelProvider = e, this.dnd = t, this.autoExpandDisposable = f.None;
  }

  _createClass(Fo, [{
    key: "getDragURI",
    value: function getDragURI(e) {
      return this.dnd.getDragURI(e.element);
    }
  }, {
    key: "getDragLabel",
    value: function getDragLabel(e) {
      if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map(function (e) {
        return e.element;
      }));
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e, t) {
      this.dnd.onDragStart && this.dnd.onDragStart(bo(e), t);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e, t, i, o) {
      var _this83 = this;

      var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      var s = this.dnd.onDragOver(bo(e), t && t.element, i, o),
          r = this.autoExpandNode !== t;
      if (r && (this.autoExpandDisposable.dispose(), this.autoExpandNode = t), void 0 === t) return s;

      if (r && "boolean" != typeof s && s.autoExpand && (this.autoExpandDisposable = At(function () {
        var e = _this83.modelProvider(),
            i = e.getNodeLocation(t);

        e.isCollapsed(i) && e.setCollapsed(i, !1), _this83.autoExpandNode = void 0;
      }, 500)), "boolean" == typeof s || !s.accept || void 0 === s.bubble) {
        if (!n) {
          return {
            accept: "boolean" == typeof s ? s : s.accept,
            effect: "boolean" == typeof s ? void 0 : s.effect,
            feedback: [i]
          };
        }

        return s;
      }

      if (1 === s.bubble) {
        var _i43 = t.parent,
            _n25 = this.modelProvider(),
            _s18 = _i43 && _n25.getListIndex(_n25.getNodeLocation(_i43));

        return this.onDragOver(e, _i43, _s18, o, !1);
      }

      var l = this.modelProvider(),
          a = l.getNodeLocation(t),
          A = l.getListIndex(a),
          h = l.getListRenderCount(a);
      return Object.assign({}, s, {
        feedback: mt(A, A + h)
      });
    }
  }, {
    key: "drop",
    value: function drop(e, t, i, o) {
      this.autoExpandDisposable.dispose(), this.autoExpandNode = void 0, this.dnd.drop(bo(e), t && t.element, i, o);
    }
  }]);

  return Fo;
}();

var Ho =
/*#__PURE__*/
function () {
  function Ho(e) {
    _classCallCheck(this, Ho);

    this.delegate = e;
  }

  _createClass(Ho, [{
    key: "getHeight",
    value: function getHeight(e) {
      return this.delegate.getHeight(e.element);
    }
  }, {
    key: "getTemplateId",
    value: function getTemplateId(e) {
      return this.delegate.getTemplateId(e.element);
    }
  }, {
    key: "hasDynamicHeight",
    value: function hasDynamicHeight(e) {
      return !!this.delegate.hasDynamicHeight && this.delegate.hasDynamicHeight(e.element);
    }
  }]);

  return Ho;
}();

var So =
/*#__PURE__*/
function () {
  function So(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, So);

    this.renderer = e, this.renderedElements = new Map(), this.renderedNodes = new Map(), this.indent = So.DefaultIndent, this.disposables = [], this.templateId = e.templateId, this.updateOptions(i), v.map(t, function (e) {
      return e.node;
    })(this.onDidChangeNodeTwistieState, this, this.disposables), e.onDidChangeTwistieState && e.onDidChangeTwistieState(this.onDidChangeTwistieState, this, this.disposables);
  }

  _createClass(So, [{
    key: "updateOptions",
    value: function updateOptions() {
      var _this84 = this;

      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      void 0 !== e.indent && (this.indent = $i(e.indent, 0, 40)), this.renderedNodes.forEach(function (e, t) {
        e.twistie.style.marginLeft = "".concat(t.depth * _this84.indent, "px");
      });
    }
  }, {
    key: "renderTemplate",
    value: function renderTemplate(e) {
      var t = kt(e, Ut(".monaco-tl-row")),
          i = kt(t, Ut(".monaco-tl-twistie")),
          o = kt(t, Ut(".monaco-tl-contents"));
      return {
        container: e,
        twistie: i,
        templateData: this.renderer.renderTemplate(o)
      };
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i, o) {
      o || (this.renderedNodes.set(e, i), this.renderedElements.set(e.element, e));
      var n = So.DefaultIndent + (e.depth - 1) * this.indent;
      i.twistie.style.marginLeft = "".concat(n, "px"), this.update(e, i), this.renderer.renderElement(e, t, i.templateData, o);
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(e, t, i, o) {
      this.renderer.disposeElement && this.renderer.disposeElement(e, t, i.templateData, o), o || (this.renderedNodes.delete(e), this.renderedElements.delete(e.element));
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {
      this.renderer.disposeTemplate(e.templateData);
    }
  }, {
    key: "onDidChangeTwistieState",
    value: function onDidChangeTwistieState(e) {
      var t = this.renderedElements.get(e);
      t && this.onDidChangeNodeTwistieState(t);
    }
  }, {
    key: "onDidChangeNodeTwistieState",
    value: function onDidChangeNodeTwistieState(e) {
      var t = this.renderedNodes.get(e);
      t && this.update(e, t);
    }
  }, {
    key: "update",
    value: function update(e, t) {
      this.renderer.renderTwistie && this.renderer.renderTwistie(e.element, t.twistie), Mt(t.twistie, "collapsible", e.collapsible), Mt(t.twistie, "collapsed", e.collapsible && e.collapsed), e.collapsible ? t.container.setAttribute("aria-expanded", String(!e.collapsed)) : t.container.removeAttribute("aria-expanded");
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.renderedNodes.clear(), this.renderedElements.clear(), this.disposables = C(this.disposables);
    }
  }]);

  return So;
}();

function zo(e) {
  return "INPUT" === e.tagName || "TEXTAREA" === e.tagName;
}

function xo(e) {
  return {
    elements: e.elements.map(function (e) {
      return e.element;
    }),
    browserEvent: e.browserEvent
  };
}

function Vo(e) {
  return {
    browserEvent: e.browserEvent,
    element: e.element ? e.element.element : null
  };
}

function Io(e) {
  return {
    element: e.element ? e.element.element : null,
    browserEvent: e.browserEvent,
    anchor: e.anchor
  };
}

function _o(e, t) {
  t(e), e.children.forEach(function (e) {
    return _o(e, t);
  });
}

So.DefaultIndent = 8;

var No =
/*#__PURE__*/
function () {
  function No(e) {
    _classCallCheck(this, No);

    this.identityProvider = e, this.nodes = [], this._onDidChange = new b(), this.onDidChange = this._onDidChange.event;
  }

  _createClass(No, [{
    key: "set",
    value: function set(e, t) {
      if (ut(this.nodes, e)) return;
      this.nodes = _toConsumableArray(e), this.elements = void 0, this._nodeSet = void 0;
      var i = this;

      this._onDidChange.fire({
        get elements() {
          return i.get();
        },

        browserEvent: t
      });
    }
  }, {
    key: "get",
    value: function get() {
      return this.elements || (this.elements = this.nodes.map(function (e) {
        return e.element;
      })), _toConsumableArray(this.elements);
    }
  }, {
    key: "has",
    value: function has(e) {
      return this.nodeSet.has(e);
    }
  }, {
    key: "onDidModelSplice",
    value: function onDidModelSplice(_ref14) {
      var e = _ref14.insertedNodes,
          t = _ref14.deletedNodes;

      if (!this.identityProvider) {
        var _e74 = this.createNodeSet(),
            _i44 = function _i44(t) {
          return _e74.delete(t);
        };

        return t.forEach(function (e) {
          return _o(e, _i44);
        }), void this.set(se(_e74));
      }

      var i = this.identityProvider,
          o = new Map();
      this.nodes.forEach(function (e) {
        return o.set(i.getId(e.element).toString(), e);
      });

      var n = new Map(),
          s = function s(e) {
        return n.set(i.getId(e.element).toString(), e);
      },
          r = function r(e) {
        return n.delete(i.getId(e.element).toString());
      };

      t.forEach(function (e) {
        return _o(e, s);
      }), e.forEach(function (e) {
        return _o(e, r);
      }), n.forEach(function (e, t) {
        return o.delete(t);
      }), this.set(se(o));
    }
  }, {
    key: "createNodeSet",
    value: function createNodeSet() {
      var e = new Set();
      var _iteratorNormalCompletion36 = true;
      var _didIteratorError36 = false;
      var _iteratorError36 = undefined;

      try {
        for (var _iterator36 = this.nodes[Symbol.iterator](), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
          var _t54 = _step36.value;
          e.add(_t54);
        }
      } catch (err) {
        _didIteratorError36 = true;
        _iteratorError36 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion36 && _iterator36.return != null) {
            _iterator36.return();
          }
        } finally {
          if (_didIteratorError36) {
            throw _iteratorError36;
          }
        }
      }

      return e;
    }
  }, {
    key: "nodeSet",
    get: function get() {
      return this._nodeSet || (this._nodeSet = this.createNodeSet()), this._nodeSet;
    }
  }]);

  return No;
}();

var Lo =
/*#__PURE__*/
function (_uo) {
  _inherits(Lo, _uo);

  function Lo(e, t) {
    var _this85;

    _classCallCheck(this, Lo);

    _this85 = _possibleConstructorReturn(this, _getPrototypeOf(Lo).call(this, e)), _this85.tree = t;
    return _this85;
  }

  _createClass(Lo, [{
    key: "onPointer",
    value: function onPointer(e) {
      if (zo(e.browserEvent.target)) return;
      var t = e.element;
      if (!t) return _get(_getPrototypeOf(Lo.prototype), "onPointer", this).call(this, e);
      if (this.isSelectionRangeChangeEvent(e) || this.isSelectionSingleChangeEvent(e)) return _get(_getPrototypeOf(Lo.prototype), "onPointer", this).call(this, e);
      var i = vt(e.browserEvent.target, "monaco-tl-twistie");
      if (!this.tree.openOnSingleClick && 2 !== e.browserEvent.detail && !i) return _get(_getPrototypeOf(Lo.prototype), "onPointer", this).call(this, e);
      var o = !1;
      if ((o = "function" == typeof this.tree.expandOnlyOnTwistieClick ? this.tree.expandOnlyOnTwistieClick(t.element) : !!this.tree.expandOnlyOnTwistieClick) && !i) return _get(_getPrototypeOf(Lo.prototype), "onPointer", this).call(this, e);
      var n = this.tree.model,
          s = n.getNodeLocation(t),
          r = e.browserEvent.altKey;
      n.setCollapsed(s, void 0, r), o && i || _get(_getPrototypeOf(Lo.prototype), "onPointer", this).call(this, e);
    }
  }]);

  return Lo;
}(uo);

var Po =
/*#__PURE__*/
function (_Eo) {
  _inherits(Po, _Eo);

  function Po(e, t, i, o, n, s) {
    var _this86;

    _classCallCheck(this, Po);

    _this86 = _possibleConstructorReturn(this, _getPrototypeOf(Po).call(this, e, t, i, s)), _this86.focusTrait = o, _this86.selectionTrait = n;
    return _this86;
  }

  _createClass(Po, [{
    key: "createMouseController",
    value: function createMouseController(e) {
      return new Lo(this, e.tree);
    }
  }, {
    key: "splice",
    value: function splice(e, t) {
      var _this87 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (_get(_getPrototypeOf(Po.prototype), "splice", this).call(this, e, t, i), 0 === i.length) return;
      var o = [],
          n = [];
      i.forEach(function (t, i) {
        _this87.selectionTrait.has(t) && o.push(e + i), _this87.selectionTrait.has(t) && n.push(e + i);
      }), o.length > 0 && _get(_getPrototypeOf(Po.prototype), "setFocus", this).call(this, [].concat(_toConsumableArray(_get(_getPrototypeOf(Po.prototype), "getFocus", this).call(this)), o)), n.length > 0 && _get(_getPrototypeOf(Po.prototype), "setSelection", this).call(this, [].concat(_toConsumableArray(_get(_getPrototypeOf(Po.prototype), "getSelection", this).call(this)), n));
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      var _this88 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      _get(_getPrototypeOf(Po.prototype), "setFocus", this).call(this, e, t), i || this.focusTrait.set(e.map(function (e) {
        return _this88.element(e);
      }), t);
    }
  }, {
    key: "setSelection",
    value: function setSelection(e, t) {
      var _this89 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      _get(_getPrototypeOf(Po.prototype), "setSelection", this).call(this, e, t), i || this.selectionTrait.set(e.map(function (e) {
        return _this89.element(e);
      }), t);
    }
  }]);

  return Po;
}(Eo);

var Qo =
/*#__PURE__*/
function () {
  function Qo(e, t, i) {
    var _this$disposables,
        _this90 = this;

    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Qo);

    this._options = o, this.eventBufferer = new F(), this.disposables = [], this._onWillRefilter = new b(), this.onWillRefilter = this._onWillRefilter.event, this._onDidUpdateOptions = new b(), this.onDidUpdateOptions = this._onDidUpdateOptions.event;
    var n = new Ho(t),
        s = new H();
    var r, l;

    if (this.renderers = i.map(function (e) {
      return new So(e, s.event, o);
    }), (_this$disposables = this.disposables).push.apply(_this$disposables, _toConsumableArray(this.renderers)), this.focus = new No(o.identityProvider), this.selection = new No(o.identityProvider), this.view = new Po(e, n, this.renderers, this.focus, this.selection, Object.assign({}, (r = function r() {
      return _this90.model;
    }, (l = o) && Object.assign({}, l, {
      identityProvider: l.identityProvider && {
        getId: function getId(e) {
          return l.identityProvider.getId(e.element);
        }
      },
      dnd: l.dnd && new Fo(r, l.dnd),
      multipleSelectionController: l.multipleSelectionController && {
        isSelectionSingleChangeEvent: function isSelectionSingleChangeEvent(e) {
          return l.multipleSelectionController.isSelectionSingleChangeEvent(Object.assign({}, e, {
            element: e.element
          }));
        },
        isSelectionRangeChangeEvent: function isSelectionRangeChangeEvent(e) {
          return l.multipleSelectionController.isSelectionRangeChangeEvent(Object.assign({}, e, {
            element: e.element
          }));
        }
      },
      accessibilityProvider: l.accessibilityProvider && {
        getAriaLabel: function getAriaLabel(e) {
          return l.accessibilityProvider.getAriaLabel(e.element);
        },
        getAriaLevel: function getAriaLevel(e) {
          return e.depth;
        }
      },
      keyboardNavigationLabelProvider: l.keyboardNavigationLabelProvider && Object.assign({}, l.keyboardNavigationLabelProvider, {
        getKeyboardNavigationLabel: function getKeyboardNavigationLabel(e) {
          return l.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(e.element);
        }
      }),
      enableKeyboardNavigation: l.simpleKeyboardNavigation,
      ariaSetProvider: {
        getSetSize: function getSetSize(e) {
          return e.parent.visibleChildrenCount;
        },
        getPosInSet: function getPosInSet(e) {
          return e.visibleChildIndex + 1;
        }
      }
    })), {
      tree: this
    })), this.model = this.createModel(this.view, o), s.input = this.model.onDidChangeCollapseState, this.model.onDidSplice(function (e) {
      _this90.focus.onDidModelSplice(e), _this90.selection.onDidModelSplice(e);
    }, null, this.disposables), !1 !== o.keyboardSupport) {
      var _e75 = v.chain(this.view.onKeyDown).filter(function (e) {
        return !zo(e.target);
      }).map(function (e) {
        return new We(e);
      });

      _e75.filter(function (e) {
        return 15 === e.keyCode;
      }).on(this.onLeftArrow, this, this.disposables), _e75.filter(function (e) {
        return 17 === e.keyCode;
      }).on(this.onRightArrow, this, this.disposables), _e75.filter(function (e) {
        return 10 === e.keyCode;
      }).on(this.onSpace, this, this.disposables);
    }
  }

  _createClass(Qo, [{
    key: "updateOptions",
    value: function updateOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._options = Object.assign({}, this._options, e);
      var _iteratorNormalCompletion37 = true;
      var _didIteratorError37 = false;
      var _iteratorError37 = undefined;

      try {
        for (var _iterator37 = this.renderers[Symbol.iterator](), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
          var _t55 = _step37.value;

          _t55.updateOptions(e);
        }
      } catch (err) {
        _didIteratorError37 = true;
        _iteratorError37 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion37 && _iterator37.return != null) {
            _iterator37.return();
          }
        } finally {
          if (_didIteratorError37) {
            throw _iteratorError37;
          }
        }
      }

      this.view.updateOptions({
        enableKeyboardNavigation: this._options.simpleKeyboardNavigation,
        automaticKeyboardNavigation: this._options.automaticKeyboardNavigation
      }), this.typeFilterController && this.typeFilterController.updateOptions(this._options), this._onDidUpdateOptions.fire(this._options);
    }
  }, {
    key: "updateWidth",
    value: function updateWidth(e) {
      var t = this.model.getListIndex(e);
      -1 !== t && this.view.updateWidth(t);
    }
  }, {
    key: "getHTMLElement",
    value: function getHTMLElement() {
      return this.view.getHTMLElement();
    }
  }, {
    key: "domFocus",
    value: function domFocus() {
      this.view.domFocus();
    }
  }, {
    key: "isDOMFocused",
    value: function isDOMFocused() {
      return this.getHTMLElement() === document.activeElement;
    }
  }, {
    key: "layout",
    value: function layout(e, t) {
      this.view.layout(e, t);
    }
  }, {
    key: "style",
    value: function style(e) {
      this.view.style(e);
    }
  }, {
    key: "getParentElement",
    value: function getParentElement(e) {
      return this.model.getParentElement(e);
    }
  }, {
    key: "getFirstElementChild",
    value: function getFirstElementChild(e) {
      return this.model.getFirstElementChild(e);
    }
  }, {
    key: "getNode",
    value: function getNode(e) {
      return this.model.getNode(e);
    }
  }, {
    key: "collapse",
    value: function collapse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.model.setCollapsed(e, !0, t);
    }
  }, {
    key: "expand",
    value: function expand(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.model.setCollapsed(e, !1, t);
    }
  }, {
    key: "toggleCollapsed",
    value: function toggleCollapsed(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.model.setCollapsed(e, void 0, t);
    }
  }, {
    key: "expandAll",
    value: function expandAll() {
      this.model.setCollapsed(this.model.rootRef, !1, !0);
    }
  }, {
    key: "collapseAll",
    value: function collapseAll() {
      this.model.setCollapsed(this.model.rootRef, !0, !0);
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(e) {
      return this.model.isCollapsible(e);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(e) {
      return this.model.isCollapsed(e);
    }
  }, {
    key: "toggleKeyboardNavigation",
    value: function toggleKeyboardNavigation() {
      this.view.toggleKeyboardNavigation(), this.typeFilterController && this.typeFilterController.toggle();
    }
  }, {
    key: "refilter",
    value: function refilter() {
      this._onWillRefilter.fire(void 0), this.model.refilter();
    }
  }, {
    key: "setSelection",
    value: function setSelection(e, t) {
      var _this91 = this;

      var i = e.map(function (e) {
        return _this91.model.getNode(e);
      });
      this.selection.set(i, t);
      var o = e.map(function (e) {
        return _this91.model.getListIndex(e);
      }).filter(function (e) {
        return e > -1;
      });
      this.view.setSelection(o, t, !0);
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      return this.selection.get();
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      var _this92 = this;

      var i = e.map(function (e) {
        return _this92.model.getNode(e);
      });
      this.focus.set(i, t);
      var o = e.map(function (e) {
        return _this92.model.getListIndex(e);
      }).filter(function (e) {
        return e > -1;
      });
      this.view.setFocus(o, t, !0);
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.focusNavigationFilter;
      this.view.focusNext(e, t, i, o);
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.focusNavigationFilter;
      this.view.focusPrevious(e, t, i, o);
    }
  }, {
    key: "focusNextPage",
    value: function focusNextPage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.focusNavigationFilter;
      this.view.focusNextPage(e, t);
    }
  }, {
    key: "focusPreviousPage",
    value: function focusPreviousPage(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.focusNavigationFilter;
      this.view.focusPreviousPage(e, t);
    }
  }, {
    key: "focusLast",
    value: function focusLast(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.focusNavigationFilter;
      this.view.focusLast(e, t);
    }
  }, {
    key: "focusFirst",
    value: function focusFirst(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.focusNavigationFilter;
      this.view.focusFirst(e, t);
    }
  }, {
    key: "getFocus",
    value: function getFocus() {
      return this.focus.get();
    }
  }, {
    key: "open",
    value: function open(e, t) {
      var _this93 = this;

      var i = e.map(function (e) {
        return _this93.model.getListIndex(e);
      });
      this.view.open(i, t);
    }
  }, {
    key: "reveal",
    value: function reveal(e, t) {
      this.model.expandTo(e);
      var i = this.model.getListIndex(e);
      -1 !== i && this.view.reveal(i, t);
    }
  }, {
    key: "getRelativeTop",
    value: function getRelativeTop(e) {
      var t = this.model.getListIndex(e);
      return -1 === t ? null : this.view.getRelativeTop(t);
    }
  }, {
    key: "onLeftArrow",
    value: function onLeftArrow(e) {
      e.preventDefault(), e.stopPropagation();
      var t = this.view.getFocusedElements();
      if (0 === t.length) return;
      var i = t[0],
          o = this.model.getNodeLocation(i);

      if (!this.model.setCollapsed(o, !0)) {
        var _e76 = this.model.getParentNodeLocation(o);

        if (null === _e76) return;

        var _t56 = this.model.getListIndex(_e76);

        this.view.reveal(_t56), this.view.setFocus([_t56]);
      }
    }
  }, {
    key: "onRightArrow",
    value: function onRightArrow(e) {
      e.preventDefault(), e.stopPropagation();
      var t = this.view.getFocusedElements();
      if (0 === t.length) return;
      var i = t[0],
          o = this.model.getNodeLocation(i);

      if (!this.model.setCollapsed(o, !1)) {
        if (!i.children.some(function (e) {
          return e.visible;
        })) return;

        var _this$view$getFocus = this.view.getFocus(),
            _this$view$getFocus2 = _slicedToArray(_this$view$getFocus, 1),
            _e77 = _this$view$getFocus2[0],
            _t57 = _e77 + 1;

        this.view.reveal(_t57), this.view.setFocus([_t57]);
      }
    }
  }, {
    key: "onSpace",
    value: function onSpace(e) {
      e.preventDefault(), e.stopPropagation();
      var t = this.view.getFocusedElements();
      if (0 === t.length) return;
      var i = t[0],
          o = this.model.getNodeLocation(i),
          n = e.browserEvent.altKey;
      this.model.setCollapsed(o, void 0, n);
    }
  }, {
    key: "navigate",
    value: function navigate(e) {
      return new Ro(this.view, this.model, e);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.disposables = C(this.disposables), this.view.dispose();
    }
  }, {
    key: "onDidScroll",
    get: function get() {
      return this.view.onDidScroll;
    }
  }, {
    key: "onDidChangeFocus",
    get: function get() {
      return this.eventBufferer.wrapEvent(this.focus.onDidChange);
    }
  }, {
    key: "onDidChangeSelection",
    get: function get() {
      return this.eventBufferer.wrapEvent(this.selection.onDidChange);
    }
  }, {
    key: "onDidOpen",
    get: function get() {
      return v.map(this.view.onDidOpen, xo);
    }
  }, {
    key: "onMouseClick",
    get: function get() {
      return v.map(this.view.onMouseClick, Vo);
    }
  }, {
    key: "onMouseDblClick",
    get: function get() {
      return v.map(this.view.onMouseDblClick, Vo);
    }
  }, {
    key: "onContextMenu",
    get: function get() {
      return v.map(this.view.onContextMenu, Io);
    }
  }, {
    key: "onKeyDown",
    get: function get() {
      return this.view.onKeyDown;
    }
  }, {
    key: "onKeyUp",
    get: function get() {
      return this.view.onKeyUp;
    }
  }, {
    key: "onKeyPress",
    get: function get() {
      return this.view.onKeyPress;
    }
  }, {
    key: "onDidFocus",
    get: function get() {
      return this.view.onDidFocus;
    }
  }, {
    key: "onDidBlur",
    get: function get() {
      return this.view.onDidBlur;
    }
  }, {
    key: "onDidChangeCollapseState",
    get: function get() {
      return this.model.onDidChangeCollapseState;
    }
  }, {
    key: "onDidChangeRenderNodeCount",
    get: function get() {
      return this.model.onDidChangeRenderNodeCount;
    }
  }, {
    key: "filterOnType",
    get: function get() {
      return !!this._options.filterOnType;
    }
  }, {
    key: "onDidChangeTypeFilterPattern",
    get: function get() {
      return this.typeFilterController ? this.typeFilterController.onDidChangePattern : v.None;
    }
  }, {
    key: "openOnSingleClick",
    get: function get() {
      return void 0 === this._options.openOnSingleClick || this._options.openOnSingleClick;
    }
  }, {
    key: "expandOnlyOnTwistieClick",
    get: function get() {
      return void 0 !== this._options.expandOnlyOnTwistieClick && this._options.expandOnlyOnTwistieClick;
    }
  }, {
    key: "onDidDispose",
    get: function get() {
      return this.view.onDidDispose;
    }
  }, {
    key: "options",
    get: function get() {
      return this._options;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.typeFilterController && this.typeFilterController.filterOnType && this.typeFilterController.empty ? 100 : this.view.contentHeight;
    }
  }, {
    key: "onDidChangeContentHeight",
    get: function get() {
      var _this94 = this;

      var e = this.view.onDidChangeContentHeight;
      return this.typeFilterController && (e = v.any(e, v.map(this.typeFilterController.onDidChangeEmptyState, function () {
        return _this94.contentHeight;
      }))), e;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.view.scrollTop;
    },
    set: function set(e) {
      this.view.scrollTop = e;
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.view.scrollHeight;
    }
  }, {
    key: "renderHeight",
    get: function get() {
      return this.view.renderHeight;
    }
  }, {
    key: "firstVisibleElement",
    get: function get() {
      var e = this.view.firstVisibleIndex;
      return this.view.element(e).element;
    }
  }, {
    key: "lastVisibleElement",
    get: function get() {
      var e = this.view.lastVisibleIndex;
      return this.view.element(e).element;
    }
  }]);

  return Qo;
}();

var Ro =
/*#__PURE__*/
function () {
  function Ro(e, t, i) {
    _classCallCheck(this, Ro);

    this.view = e, this.model = t, this.index = i ? this.model.getListIndex(i) : -1;
  }

  _createClass(Ro, [{
    key: "current",
    value: function current() {
      return this.index < 0 || this.index >= this.view.length ? null : this.view.element(this.index).element;
    }
  }, {
    key: "previous",
    value: function previous() {
      return this.index--, this.current();
    }
  }, {
    key: "next",
    value: function next() {
      return this.index++, this.current();
    }
  }, {
    key: "parent",
    value: function parent() {
      if (this.index < 0 || this.index >= this.view.length) return null;
      var e = this.view.element(this.index);
      return e.parent ? (this.index = this.model.getListIndex(this.model.getNodeLocation(e.parent)), this.current()) : (this.index = -1, this.current());
    }
  }, {
    key: "first",
    value: function first() {
      return this.index = 0, this.current();
    }
  }, {
    key: "last",
    value: function last() {
      return this.index = this.view.length - 1, this.current();
    }
  }]);

  return Ro;
}();

var To =
/*#__PURE__*/
function () {
  function To(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, To);

    this.rootRef = null, this.nodes = new Map(), this.model = new Bo(e, null, t), this.onDidSplice = this.model.onDidSplice, this.onDidChangeCollapseState = this.model.onDidChangeCollapseState, this.onDidChangeRenderNodeCount = this.model.onDidChangeRenderNodeCount, t.sorter && (this.sorter = {
      compare: function compare(e, i) {
        return t.sorter.compare(e.element, i.element);
      }
    });
  }

  _createClass(To, [{
    key: "setChildren",
    value: function setChildren(e, t, i, o) {
      var n = this.getElementLocation(e);
      return this._setChildren(n, this.preserveCollapseState(t), i, o);
    }
  }, {
    key: "_setChildren",
    value: function _setChildren(e, t, i, o) {
      var _this95 = this;

      var n = new Set();
      return this.model.splice([].concat(_toConsumableArray(e), [0]), Number.MAX_VALUE, t, function (e) {
        n.add(e.element), _this95.nodes.set(e.element, e), i && i(e);
      }, function (e) {
        n.has(e.element) || _this95.nodes.delete(e.element), o && o(e);
      });
    }
  }, {
    key: "preserveCollapseState",
    value: function preserveCollapseState(e) {
      var _this96 = this;

      var t = e ? (i = e, Array.isArray(i) ? w.fromArray(i) : i) : w.empty();
      var i;
      return this.sorter && (t = w.fromArray(w.collect(t).sort(this.sorter.compare.bind(this.sorter)))), w.map(t, function (e) {
        var t = _this96.nodes.get(e.element);

        if (!t) return Object.assign({}, e, {
          children: _this96.preserveCollapseState(e.children)
        });
        var i = "boolean" == typeof e.collapsible ? e.collapsible : t.collapsible,
            o = void 0 !== e.collapsed ? e.collapsed : t.collapsed;
        return Object.assign({}, e, {
          collapsible: i,
          collapsed: o,
          children: _this96.preserveCollapseState(e.children)
        });
      });
    }
  }, {
    key: "rerender",
    value: function rerender(e) {
      var t = this.getElementLocation(e);
      this.model.rerender(t);
    }
  }, {
    key: "resort",
    value: function resort() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      if (!this.sorter) return;
      var i = this.getElementLocation(e),
          o = this.model.getNode(i);

      this._setChildren(i, this.resortChildren(o, t));
    }
  }, {
    key: "resortChildren",
    value: function resortChildren(e, t) {
      var _this97 = this;

      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !0;
      var o = w.fromArray(e.children);
      return (t || i) && (o = w.fromArray(w.collect(o).sort(this.sorter.compare.bind(this.sorter)))), w.map(o, function (e) {
        return {
          element: e.element,
          collapsible: e.collapsible,
          collapsed: e.collapsed,
          children: _this97.resortChildren(e, t, !1)
        };
      });
    }
  }, {
    key: "getParentElement",
    value: function getParentElement() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = this.getElementLocation(e);
      return this.model.getParentElement(t);
    }
  }, {
    key: "getFirstElementChild",
    value: function getFirstElementChild() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = this.getElementLocation(e);
      return this.model.getFirstElementChild(t);
    }
  }, {
    key: "getLastElementAncestor",
    value: function getLastElementAncestor() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = this.getElementLocation(e);
      return this.model.getLastElementAncestor(t);
    }
  }, {
    key: "getListIndex",
    value: function getListIndex(e) {
      var t = this.getElementLocation(e);
      return this.model.getListIndex(t);
    }
  }, {
    key: "getListRenderCount",
    value: function getListRenderCount(e) {
      var t = this.getElementLocation(e);
      return this.model.getListRenderCount(t);
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(e) {
      var t = this.getElementLocation(e);
      return this.model.isCollapsible(t);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(e) {
      var t = this.getElementLocation(e);
      return this.model.isCollapsed(t);
    }
  }, {
    key: "setCollapsed",
    value: function setCollapsed(e, t, i) {
      var o = this.getElementLocation(e);
      return this.model.setCollapsed(o, t, i);
    }
  }, {
    key: "expandTo",
    value: function expandTo(e) {
      var t = this.getElementLocation(e);
      this.model.expandTo(t);
    }
  }, {
    key: "refilter",
    value: function refilter() {
      this.model.refilter();
    }
  }, {
    key: "getNode",
    value: function getNode() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var t = this.getElementLocation(e);
      return this.model.getNode(t);
    }
  }, {
    key: "getNodeLocation",
    value: function getNodeLocation(e) {
      return e.element;
    }
  }, {
    key: "getParentNodeLocation",
    value: function getParentNodeLocation(e) {
      var t = this.nodes.get(e);
      if (!t) throw new Error("Tree element not found: ".concat(e));
      return t.parent.element;
    }
  }, {
    key: "getElementLocation",
    value: function getElementLocation(e) {
      if (null === e) return [];
      var t = this.nodes.get(e);
      if (!t) throw new Error("Tree element not found: ".concat(e));
      return this.model.getNodeLocation(t);
    }
  }, {
    key: "size",
    get: function get() {
      return this.nodes.size;
    }
  }]);

  return To;
}();

var ko =
/*#__PURE__*/
function (_Qo) {
  _inherits(ko, _Qo);

  function ko(e, t, i) {
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, ko);

    return _possibleConstructorReturn(this, _getPrototypeOf(ko).call(this, e, t, i, o));
  }

  _createClass(ko, [{
    key: "setChildren",
    value: function setChildren(e, t, i, o) {
      return this.model.setChildren(e, t, i, o);
    }
  }, {
    key: "rerender",
    value: function rerender(e) {
      void 0 !== e ? this.model.rerender(e) : this.view.rerender();
    }
  }, {
    key: "resort",
    value: function resort(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this.model.resort(e, t);
    }
  }, {
    key: "createModel",
    value: function createModel(e, t) {
      return new To(e, t);
    }
  }]);

  return ko;
}(Qo);

function Yo(e, t) {
  return !!t.parent && (t.parent === e || Yo(e, t.parent));
}

var Uo =
/*#__PURE__*/
function () {
  function Uo(e) {
    _classCallCheck(this, Uo);

    this.node = e;
  }

  _createClass(Uo, [{
    key: "element",
    get: function get() {
      return this.node.element.element;
    }
  }, {
    key: "parent",
    get: function get() {
      return this.node.parent && new Uo(this.node.parent);
    }
  }, {
    key: "children",
    get: function get() {
      return this.node.children.map(function (e) {
        return new Uo(e);
      });
    }
  }, {
    key: "depth",
    get: function get() {
      return this.node.depth;
    }
  }, {
    key: "visibleChildrenCount",
    get: function get() {
      return this.node.visibleChildrenCount;
    }
  }, {
    key: "visibleChildIndex",
    get: function get() {
      return this.node.visibleChildIndex;
    }
  }, {
    key: "collapsible",
    get: function get() {
      return this.node.collapsible;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this.node.collapsed;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.node.visible;
    }
  }, {
    key: "filterData",
    get: function get() {
      return this.node.filterData;
    }
  }]);

  return Uo;
}();

var Jo =
/*#__PURE__*/
function () {
  function Jo(e, t) {
    _classCallCheck(this, Jo);

    this.renderer = e, this.onDidChangeTwistieState = t, this.renderedNodes = new Map(), this.disposables = [], this.templateId = e.templateId;
  }

  _createClass(Jo, [{
    key: "renderTemplate",
    value: function renderTemplate(e) {
      return {
        templateData: this.renderer.renderTemplate(e)
      };
    }
  }, {
    key: "renderElement",
    value: function renderElement(e, t, i, o) {
      this.renderer.renderElement(new Uo(e), t, i.templateData, o);
    }
  }, {
    key: "renderTwistie",
    value: function renderTwistie(e, t) {
      return Mt(t, "loading", e.slow), !1;
    }
  }, {
    key: "disposeElement",
    value: function disposeElement(e, t, i, o) {
      this.renderer.disposeElement && this.renderer.disposeElement(new Uo(e), t, i.templateData, o);
    }
  }, {
    key: "disposeTemplate",
    value: function disposeTemplate(e) {
      this.renderer.disposeTemplate(e.templateData);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this.renderedNodes.clear(), this.disposables = C(this.disposables);
    }
  }]);

  return Jo;
}();

function jo(e) {
  return {
    browserEvent: e.browserEvent,
    elements: e.elements.map(function (e) {
      return e.element;
    })
  };
}

function Go(e) {
  return {
    browserEvent: e.browserEvent,
    element: e.element && e.element.element
  };
}

function Oo(e) {
  return {
    browserEvent: e.browserEvent,
    element: e.element && e.element.element,
    anchor: e.anchor
  };
}

var Ko;

function Wo(e) {
  if (e instanceof Ki) {
    var _t58 = e.elements;
    return new Ki(_t58.map(function (e) {
      return e.element;
    }));
  }

  return e;
}

!function (e) {
  e[e.Refresh = 0] = "Refresh", e[e.Expand = 1] = "Expand";
}(Ko || (Ko = {}));

var Xo =
/*#__PURE__*/
function () {
  function Xo(e) {
    _classCallCheck(this, Xo);

    this.dnd = e;
  }

  _createClass(Xo, [{
    key: "getDragURI",
    value: function getDragURI(e) {
      return this.dnd.getDragURI(e.element);
    }
  }, {
    key: "getDragLabel",
    value: function getDragLabel(e) {
      if (this.dnd.getDragLabel) return this.dnd.getDragLabel(e.map(function (e) {
        return e.element;
      }));
    }
  }, {
    key: "onDragStart",
    value: function onDragStart(e, t) {
      this.dnd.onDragStart && this.dnd.onDragStart(Wo(e), t);
    }
  }, {
    key: "onDragOver",
    value: function onDragOver(e, t, i, o) {
      var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : !0;
      return this.dnd.onDragOver(Wo(e), t && t.element, i, o);
    }
  }, {
    key: "drop",
    value: function drop(e, t, i, o) {
      this.dnd.drop(Wo(e), t && t.element, i, o);
    }
  }]);

  return Xo;
}();

var Zo =
/*#__PURE__*/
function () {
  function Zo() {
    _classCallCheck(this, Zo);
  }

  _createClass(Zo, null, [{
    key: "has",
    value: function has(e) {
      return new $o(e);
    }
  }, {
    key: "equals",
    value: function equals(e, t) {
      return new en(e, t);
    }
  }, {
    key: "notEquals",
    value: function notEquals(e, t) {
      return new tn(e, t);
    }
  }, {
    key: "regex",
    value: function regex(e, t) {
      return new nn(e, t);
    }
  }, {
    key: "not",
    value: function not(e) {
      return new on(e);
    }
  }, {
    key: "and",
    value: function and() {
      for (var _len13 = arguments.length, e = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        e[_key13] = arguments[_key13];
      }

      return new sn(e);
    }
  }, {
    key: "deserialize",
    value: function deserialize(e) {
      var _this98 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (!e) return null;
      var i = e.split("&&");
      return new sn(i.map(function (e) {
        return _this98._deserializeOne(e, t);
      })).normalize();
    }
  }, {
    key: "_deserializeOne",
    value: function _deserializeOne(e, t) {
      if ((e = e.trim()).indexOf("!=") >= 0) {
        var _i45 = e.split("!=");

        return new tn(_i45[0].trim(), this._deserializeValue(_i45[1], t));
      }

      if (e.indexOf("==") >= 0) {
        var _i46 = e.split("==");

        return new en(_i46[0].trim(), this._deserializeValue(_i46[1], t));
      }

      if (e.indexOf("=~") >= 0) {
        var _i47 = e.split("=~");

        return new nn(_i47[0].trim(), this._deserializeRegexValue(_i47[1], t));
      }

      return /^\!\s*/.test(e) ? new on(e.substr(1).trim()) : new $o(e);
    }
  }, {
    key: "_deserializeValue",
    value: function _deserializeValue(e, t) {
      if ("true" === (e = e.trim())) return !0;
      if ("false" === e) return !1;
      var i = /^'([^']*)'$/.exec(e);
      return i ? i[1].trim() : e;
    }
  }, {
    key: "_deserializeRegexValue",
    value: function _deserializeRegexValue(e, t) {
      if (!(i = e) || "string" != typeof i || 0 === i.trim().length) {
        if (t) throw new Error("missing regexp-value for =~-expression");
        return console.warn("missing regexp-value for =~-expression"), null;
      }

      var i;
      var o = e.indexOf("/"),
          n = e.lastIndexOf("/");

      if (o === n || o < 0) {
        if (t) throw new Error("bad regexp-value '".concat(e, "', missing /-enclosure"));
        return console.warn("bad regexp-value '".concat(e, "', missing /-enclosure")), null;
      }

      var s = e.slice(o + 1, n),
          r = "i" === e[n + 1] ? "i" : "";

      try {
        return new RegExp(s, r);
      } catch (i) {
        if (t) throw new Error("bad regexp-value '".concat(e, "', parse error: ").concat(i));
        return console.warn("bad regexp-value '".concat(e, "', parse error: ").concat(i)), null;
      }
    }
  }]);

  return Zo;
}();

function qo(e, t) {
  var i = e.getType(),
      o = t.getType();
  if (i !== o) return i - o;

  switch (i) {
    case 1:
    case 2:
    case 3:
    case 4:
    case 6:
      return e.cmp(t);

    default:
      throw new Error("Unknown ContextKeyExpr!");
  }
}

var $o =
/*#__PURE__*/
function () {
  function $o(e) {
    _classCallCheck(this, $o);

    this.key = e;
  }

  _createClass($o, [{
    key: "getType",
    value: function getType() {
      return 1;
    }
  }, {
    key: "cmp",
    value: function cmp(e) {
      return this.key < e.key ? -1 : this.key > e.key ? 1 : 0;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return e instanceof $o && this.key === e.key;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      return !!e.getValue(this.key);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return this.key;
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }]);

  return $o;
}();

var en =
/*#__PURE__*/
function () {
  function en(e, t) {
    _classCallCheck(this, en);

    this.key = e, this.value = t;
  }

  _createClass(en, [{
    key: "getType",
    value: function getType() {
      return 3;
    }
  }, {
    key: "cmp",
    value: function cmp(e) {
      return this.key < e.key ? -1 : this.key > e.key ? 1 : this.value < e.value ? -1 : this.value > e.value ? 1 : 0;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return e instanceof en && this.key === e.key && this.value === e.value;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      return e.getValue(this.key) == this.value;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return "boolean" == typeof this.value ? this.value ? new $o(this.key) : new on(this.key) : this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return "boolean" == typeof this.value ? this.normalize().serialize() : this.key + " == '" + this.value + "'";
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }]);

  return en;
}();

var tn =
/*#__PURE__*/
function () {
  function tn(e, t) {
    _classCallCheck(this, tn);

    this.key = e, this.value = t;
  }

  _createClass(tn, [{
    key: "getType",
    value: function getType() {
      return 4;
    }
  }, {
    key: "cmp",
    value: function cmp(e) {
      return this.key < e.key ? -1 : this.key > e.key ? 1 : this.value < e.value ? -1 : this.value > e.value ? 1 : 0;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return e instanceof tn && this.key === e.key && this.value === e.value;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      return e.getValue(this.key) != this.value;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return "boolean" == typeof this.value ? this.value ? new on(this.key) : new $o(this.key) : this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return "boolean" == typeof this.value ? this.normalize().serialize() : this.key + " != '" + this.value + "'";
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }]);

  return tn;
}();

var on =
/*#__PURE__*/
function () {
  function on(e) {
    _classCallCheck(this, on);

    this.key = e;
  }

  _createClass(on, [{
    key: "getType",
    value: function getType() {
      return 2;
    }
  }, {
    key: "cmp",
    value: function cmp(e) {
      return this.key < e.key ? -1 : this.key > e.key ? 1 : 0;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      return e instanceof on && this.key === e.key;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      return !e.getValue(this.key);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return "!" + this.key;
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }]);

  return on;
}();

var nn =
/*#__PURE__*/
function () {
  function nn(e, t) {
    _classCallCheck(this, nn);

    this.key = e, this.regexp = t;
  }

  _createClass(nn, [{
    key: "getType",
    value: function getType() {
      return 6;
    }
  }, {
    key: "cmp",
    value: function cmp(e) {
      if (this.key < e.key) return -1;
      if (this.key > e.key) return 1;
      var t = this.regexp ? this.regexp.source : "",
          i = e.regexp ? e.regexp.source : "";
      return t < i ? -1 : t > i ? 1 : 0;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      if (e instanceof nn) {
        var _t59 = this.regexp ? this.regexp.source : "",
            _i48 = e.regexp ? e.regexp.source : "";

        return this.key === e.key && _t59 === _i48;
      }

      return !1;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      var t = e.getValue(this.key);
      return !!this.regexp && this.regexp.test(t);
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      var e = this.regexp ? "/".concat(this.regexp.source, "/").concat(this.regexp.ignoreCase ? "i" : "") : "/invalid/";
      return "".concat(this.key, " =~ ").concat(e);
    }
  }, {
    key: "keys",
    value: function keys() {
      return [this.key];
    }
  }]);

  return nn;
}();

var sn =
/*#__PURE__*/
function () {
  function sn(e) {
    _classCallCheck(this, sn);

    this.expr = sn._normalizeArr(e);
  }

  _createClass(sn, [{
    key: "getType",
    value: function getType() {
      return 5;
    }
  }, {
    key: "equals",
    value: function equals(e) {
      if (e instanceof sn) {
        if (this.expr.length !== e.expr.length) return !1;

        for (var _t60 = 0, _i49 = this.expr.length; _t60 < _i49; _t60++) {
          if (!this.expr[_t60].equals(e.expr[_t60])) return !1;
        }

        return !0;
      }

      return !1;
    }
  }, {
    key: "evaluate",
    value: function evaluate(e) {
      for (var _t61 = 0, _i50 = this.expr.length; _t61 < _i50; _t61++) {
        if (!this.expr[_t61].evaluate(e)) return !1;
      }

      return !0;
    }
  }, {
    key: "normalize",
    value: function normalize() {
      return 0 === this.expr.length ? null : 1 === this.expr.length ? this.expr[0] : this;
    }
  }, {
    key: "serialize",
    value: function serialize() {
      if (0 === this.expr.length) return "";

      if (1 === this.expr.length) {
        var _e78 = this.normalize();

        return _e78 ? _e78.serialize() : "";
      }

      return this.expr.map(function (e) {
        return e.serialize();
      }).join(" && ");
    }
  }, {
    key: "keys",
    value: function keys() {
      var e = [];
      var _iteratorNormalCompletion38 = true;
      var _didIteratorError38 = false;
      var _iteratorError38 = undefined;

      try {
        for (var _iterator38 = this.expr[Symbol.iterator](), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
          var _t62 = _step38.value;
          e.push.apply(e, _toConsumableArray(_t62.keys()));
        }
      } catch (err) {
        _didIteratorError38 = true;
        _iteratorError38 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion38 && _iterator38.return != null) {
            _iterator38.return();
          }
        } finally {
          if (_didIteratorError38) {
            throw _iteratorError38;
          }
        }
      }

      return e;
    }
  }], [{
    key: "_normalizeArr",
    value: function _normalizeArr(e) {
      var t = [];

      if (e) {
        for (var _i51 = 0, _o29 = e.length; _i51 < _o29; _i51++) {
          var _o30 = e[_i51];
          _o30 && (_o30 = _o30.normalize()) && (_o30 instanceof sn ? t = t.concat(_o30.expr) : t.push(_o30));
        }

        t.sort(qo);
      }

      return t;
    }
  }]);

  return sn;
}();

var rn =
/*#__PURE__*/
function (_$o) {
  _inherits(rn, _$o);

  function rn(e, t) {
    var _this99;

    _classCallCheck(this, rn);

    _this99 = _possibleConstructorReturn(this, _getPrototypeOf(rn).call(this, e)), _this99._defaultValue = t;
    return _this99;
  }

  _createClass(rn, [{
    key: "bindTo",
    value: function bindTo(e) {
      return e.createKey(this.key, this._defaultValue);
    }
  }, {
    key: "getValue",
    value: function getValue(e) {
      return e.getContextKeyValue(this.key);
    }
  }, {
    key: "toNegated",
    value: function toNegated() {
      return Zo.not(this.key);
    }
  }, {
    key: "isEqualTo",
    value: function isEqualTo(e) {
      return Zo.equals(this.key, e);
    }
  }, {
    key: "notEqualsTo",
    value: function notEqualsTo(e) {
      return Zo.notEquals(this.key, e);
    }
  }]);

  return rn;
}($o);

var ln = n("contextKeyService"),
    an = new rn("treeViewFocus", !0);

var An =
/*#__PURE__*/
function (_ref15) {
  _inherits(An, _ref15);

  function An(e, t, i, o, n) {
    var _this100;

    _classCallCheck(this, An);

    _this100 = _possibleConstructorReturn(this, _getPrototypeOf(An).call(this, e, new De(), [t], i, Object.assign({
      accessibilityProvider: new we(),
      ariaLabel: "Files Explorer",
      identityProvider: {
        getId: function getId(e) {
          return e.id;
        }
      },
      keyboardNavigationLabelProvider: {
        getKeyboardNavigationLabel: function getKeyboardNavigationLabel(e) {
          return e.id;
        }
      },
      multipleSelectionSupport: !0,
      autoExpandSingleChildren: !0
    }, o))), console.log("TreeViewVSCode.created"), _this100._contextkeyService = n.createScoped(e), an.bindTo(_this100._contextkeyService);
    return _this100;
  }

  _createClass(An, [{
    key: "refreshAndFocusNode",
    value: function refreshAndFocusNode(e, t) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var i, o, _iteratorNormalCompletion39, _didIteratorError39, _iteratorError39, _iterator39, _step39, n;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("refreshAndFocusNode", e, t);
                _context.next = 3;
                return this.expand(t);

              case 3:
                _context.next = 5;
                return this.updateChildren(t, !1);

              case 5:
                if (!(e instanceof Promise)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return e;

              case 8:
                _context.t0 = _context.sent;
                _context.next = 12;
                break;

              case 11:
                _context.t0 = e;

              case 12:
                i = _context.t0;

                if (!(console.log("IsPromise", e instanceof Promise, "value:", i), void 0 === i)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                o = this.nodes;

                if (o.has(i)) {
                  _context.next = 44;
                  break;
                }

                _iteratorNormalCompletion39 = true;
                _didIteratorError39 = false;
                _iteratorError39 = undefined;
                _context.prev = 20;
                _iterator39 = o.keys()[Symbol.iterator]();

              case 22:
                if (_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done) {
                  _context.next = 30;
                  break;
                }

                n = _step39.value;

                if (!(n && n.id === i.id)) {
                  _context.next = 27;
                  break;
                }

                console.log("id", n), i = n;
                return _context.abrupt("break", 30);

              case 27:
                _iteratorNormalCompletion39 = true;
                _context.next = 22;
                break;

              case 30:
                _context.next = 36;
                break;

              case 32:
                _context.prev = 32;
                _context.t1 = _context["catch"](20);
                _didIteratorError39 = true;
                _iteratorError39 = _context.t1;

              case 36:
                _context.prev = 36;
                _context.prev = 37;

                if (!_iteratorNormalCompletion39 && _iterator39.return != null) {
                  _iterator39.return();
                }

              case 39:
                _context.prev = 39;

                if (!_didIteratorError39) {
                  _context.next = 42;
                  break;
                }

                throw _iteratorError39;

              case 42:
                return _context.finish(39);

              case 43:
                return _context.finish(36);

              case 44:
                this.reveal(i), this.setFocus([]), this.setSelection([i]), this.domFocus();

              case 45:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[20, 32, 36, 44], [37,, 39, 43]]);
      }));
    }
  }, {
    key: "contextkeyService",
    get: function get() {
      return this._contextkeyService;
    }
  }]);

  return An;
}(
/*#__PURE__*/
function () {
  function _class6(e, t, i, o) {
    var _this101 = this;

    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    _classCallCheck(this, _class6);

    this.dataSource = o, this.nodes = new Map(), this.subTreeRefreshPromises = new Map(), this.refreshPromises = new Map(), this._onDidRender = new b(), this._onDidChangeNodeSlowState = new b(), this.disposables = [], this.identityProvider = n.identityProvider, this.autoExpandSingleChildren = void 0 !== n.autoExpandSingleChildren && n.autoExpandSingleChildren, this.sorter = n.sorter;

    var s = new Ho(t),
        r = i.map(function (e) {
      return new Jo(e, _this101._onDidChangeNodeSlowState.event);
    }),
        l = function (e) {
      return e && Object.assign({}, e, {
        collapseByDefault: !0,
        identityProvider: e.identityProvider && {
          getId: function getId(t) {
            return e.identityProvider.getId(t.element);
          }
        },
        dnd: e.dnd && new Xo(e.dnd),
        multipleSelectionController: e.multipleSelectionController && {
          isSelectionSingleChangeEvent: function isSelectionSingleChangeEvent(t) {
            return e.multipleSelectionController.isSelectionSingleChangeEvent(Object.assign({}, t, {
              element: t.element
            }));
          },
          isSelectionRangeChangeEvent: function isSelectionRangeChangeEvent(t) {
            return e.multipleSelectionController.isSelectionRangeChangeEvent(Object.assign({}, t, {
              element: t.element
            }));
          }
        },
        accessibilityProvider: e.accessibilityProvider && {
          getAriaLabel: function getAriaLabel(t) {
            return e.accessibilityProvider.getAriaLabel(t.element);
          }
        },
        filter: e.filter && {
          filter: function filter(t, i) {
            return e.filter.filter(t.element, i);
          }
        },
        keyboardNavigationLabelProvider: e.keyboardNavigationLabelProvider && {
          getKeyboardNavigationLabel: function getKeyboardNavigationLabel(t) {
            return e.keyboardNavigationLabelProvider.getKeyboardNavigationLabel(t.element);
          }
        },
        sorter: void 0,
        expandOnlyOnTwistieClick: void 0 === e.expandOnlyOnTwistieClick ? void 0 : "function" != typeof e.expandOnlyOnTwistieClick ? e.expandOnlyOnTwistieClick : function (t) {
          return e.expandOnlyOnTwistieClick(t.element);
        },
        ariaSetProvider: void 0
      });
    }(n) || {};

    this.tree = new ko(e, s, r, l), this.root = {
      element: void 0,
      parent: null,
      children: [],
      state: "uninitialized",
      hasChildren: !0,
      needsRefresh: !1,
      disposed: !1,
      slow: !1
    }, this.identityProvider && (this.root = Object.assign({}, this.root, {
      id: null
    })), this.nodes.set(null, this.root), this.tree.onDidChangeCollapseState(this._onDidChangeCollapseState, this, this.disposables);
  }

  _createClass(_class6, [{
    key: "updateOptions",
    value: function updateOptions() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.tree.updateOptions(e);
    }
  }, {
    key: "getHTMLElement",
    value: function getHTMLElement() {
      return this.tree.getHTMLElement();
    }
  }, {
    key: "domFocus",
    value: function domFocus() {
      this.tree.domFocus();
    }
  }, {
    key: "layout",
    value: function layout(e, t) {
      this.tree.layout(e, t);
    }
  }, {
    key: "style",
    value: function style(e) {
      this.tree.style(e);
    }
  }, {
    key: "getInput",
    value: function getInput() {
      return this.root.element;
    }
  }, {
    key: "setInput",
    value: function setInput(e, t) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var i;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.refreshPromises.forEach(function (e) {
                  return e.cancel();
                }), this.refreshPromises.clear(), this.root.element = e;
                i = t && {
                  viewState: t,
                  focus: [],
                  selection: []
                };
                _context2.next = 4;
                return this.updateChildren(e, !0, i);

              case 4:
                i && (this.tree.setFocus(i.focus), this.tree.setSelection(i.selection));
                t && "number" == typeof t.scrollTop && (this.scrollTop = t.scrollTop);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "updateChildren",
    value: function updateChildren() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root.element;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(void 0 === this.root.element)) {
                  _context3.next = 2;
                  break;
                }

                throw new Error("Tree input not set");

              case 2:
                _context3.t0 = "loading" === this.root.state;

                if (!_context3.t0) {
                  _context3.next = 8;
                  break;
                }

                _context3.next = 6;
                return this.subTreeRefreshPromises.get(this.root);

              case 6:
                _context3.next = 8;
                return v.toPromise(this._onDidRender.event);

              case 8:
                _context3.next = 10;
                return this.refreshAndRenderNode(this.getDataNode(e), t, Ko.Refresh, i);

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "resort",
    value: function resort() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root.element;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this.tree.resort(this.getDataNode(e), t);
    }
  }, {
    key: "hasNode",
    value: function hasNode(e) {
      return e === this.root.element || this.nodes.has(e);
    }
  }, {
    key: "rerender",
    value: function rerender(e) {
      if (void 0 === e) return void this.tree.rerender();
      var t = this.getDataNode(e);
      this.tree.rerender(t);
    }
  }, {
    key: "updateWidth",
    value: function updateWidth(e) {
      var t = this.getDataNode(e);
      this.tree.updateWidth(t);
    }
  }, {
    key: "getNode",
    value: function getNode() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root.element;
      var t = this.getDataNode(e),
          i = this.tree.getNode(t === this.root ? null : t);
      return new Uo(i);
    }
  }, {
    key: "collapse",
    value: function collapse(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = this.getDataNode(e);
      return this.tree.collapse(i === this.root ? null : i, t);
    }
  }, {
    key: "expand",
    value: function expand(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var i, o;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(void 0 === this.root.element)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error("Tree input not set");

              case 2:
                _context4.t0 = "loading" === this.root.state;

                if (!_context4.t0) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 6;
                return this.subTreeRefreshPromises.get(this.root);

              case 6:
                _context4.next = 8;
                return v.toPromise(this._onDidRender.event);

              case 8:
                i = this.getDataNode(e);

                if (!(i !== this.root && "loading" !== i.state && !this.tree.isCollapsed(i))) {
                  _context4.next = 11;
                  break;
                }

                return _context4.abrupt("return", !1);

              case 11:
                o = this.tree.expand(i === this.root ? null : i, t);
                _context4.t1 = "loading" === i.state;

                if (!_context4.t1) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 16;
                return this.subTreeRefreshPromises.get(i);

              case 16:
                _context4.next = 18;
                return v.toPromise(this._onDidRender.event);

              case 18:
                return _context4.abrupt("return", o);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "toggleCollapsed",
    value: function toggleCollapsed(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return this.tree.toggleCollapsed(this.getDataNode(e), t);
    }
  }, {
    key: "expandAll",
    value: function expandAll() {
      this.tree.expandAll();
    }
  }, {
    key: "collapseAll",
    value: function collapseAll() {
      this.tree.collapseAll();
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(e) {
      return this.tree.isCollapsible(this.getDataNode(e));
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(e) {
      return this.tree.isCollapsed(this.getDataNode(e));
    }
  }, {
    key: "toggleKeyboardNavigation",
    value: function toggleKeyboardNavigation() {
      this.tree.toggleKeyboardNavigation();
    }
  }, {
    key: "refilter",
    value: function refilter() {
      this.tree.refilter();
    }
  }, {
    key: "setSelection",
    value: function setSelection(e, t) {
      var _this102 = this;

      var i = e.map(function (e) {
        return _this102.getDataNode(e);
      });
      this.tree.setSelection(i, t);
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      return this.tree.getSelection().map(function (e) {
        return e.element;
      });
    }
  }, {
    key: "setFocus",
    value: function setFocus(e, t) {
      var _this103 = this;

      var i = e.map(function (e) {
        return _this103.getDataNode(e);
      });
      this.tree.setFocus(i, t);
    }
  }, {
    key: "focusNext",
    value: function focusNext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      this.tree.focusNext(e, t, i);
    }
  }, {
    key: "focusPrevious",
    value: function focusPrevious() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      this.tree.focusPrevious(e, t, i);
    }
  }, {
    key: "focusNextPage",
    value: function focusNextPage(e) {
      this.tree.focusNextPage(e);
    }
  }, {
    key: "focusPreviousPage",
    value: function focusPreviousPage(e) {
      this.tree.focusPreviousPage(e);
    }
  }, {
    key: "focusLast",
    value: function focusLast(e) {
      this.tree.focusLast(e);
    }
  }, {
    key: "focusFirst",
    value: function focusFirst(e) {
      this.tree.focusFirst(e);
    }
  }, {
    key: "getFocus",
    value: function getFocus() {
      return this.tree.getFocus().map(function (e) {
        return e.element;
      });
    }
  }, {
    key: "open",
    value: function open(e) {
      var _this104 = this;

      var t = e.map(function (e) {
        return _this104.getDataNode(e);
      });
      this.tree.open(t);
    }
  }, {
    key: "reveal",
    value: function reveal(e, t) {
      this.tree.reveal(this.getDataNode(e), t);
    }
  }, {
    key: "getRelativeTop",
    value: function getRelativeTop(e) {
      return this.tree.getRelativeTop(this.getDataNode(e));
    }
  }, {
    key: "getParentElement",
    value: function getParentElement(e) {
      var t = this.tree.getParentElement(this.getDataNode(e));
      return t && t.element;
    }
  }, {
    key: "getFirstElementChild",
    value: function getFirstElementChild() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.root.element;
      var t = this.getDataNode(e),
          i = this.tree.getFirstElementChild(t === this.root ? null : t);
      return i && i.element;
    }
  }, {
    key: "getDataNode",
    value: function getDataNode(e) {
      var t = this.nodes.get(e === this.root.element ? null : e);
      if (!t) throw new Error("Data tree node not found: ".concat(e));
      return t;
    }
  }, {
    key: "refreshAndRenderNode",
    value: function refreshAndRenderNode(e, t, i, o) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        var _t63;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.refreshNode(e, t, o);

              case 2:
                this.render(e, o);

                if (!(e !== this.root && this.autoExpandSingleChildren && i === Ko.Expand)) {
                  _context5.next = 9;
                  break;
                }

                _t63 = this.tree.getNode(e).children.filter(function (e) {
                  return e.visible;
                });
                _context5.t0 = 1 === _t63.length;

                if (!_context5.t0) {
                  _context5.next = 9;
                  break;
                }

                _context5.next = 9;
                return this.tree.expand(_t63[0].element, !1);

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "refreshNode",
    value: function refreshNode(e, t, i) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6() {
        var _this105 = this;

        var o;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!e.disposed) {
                  _context6.next = 2;
                  break;
                }

                return _context6.abrupt("return", void console.error("Async data tree node is disposed"));

              case 2:
                if (!(this.subTreeRefreshPromises.forEach(function (n, s) {
                  !o && function (e, t) {
                    return e === t || Yo(e, t) || Yo(t, e);
                  }(s, e) && (o = n.then(function () {
                    return _this105.refreshNode(e, t, i);
                  }));
                }), o)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt("return", o);

              case 4:
                o = this.doRefreshSubTree(e, t, i), this.subTreeRefreshPromises.set(e, o);
                _context6.prev = 5;
                _context6.next = 8;
                return o;

              case 8:
                _context6.prev = 8;
                this.subTreeRefreshPromises.delete(e);
                return _context6.finish(8);

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5,, 8, 11]]);
      }));
    }
  }, {
    key: "doRefreshSubTree",
    value: function doRefreshSubTree(e, t, i) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7() {
        var _this106 = this;

        var o;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                e.state = "loading";
                _context7.prev = 1;
                _context7.next = 4;
                return this.doRefreshNode(e, t, i);

              case 4:
                if (!t) {
                  _context7.next = 8;
                  break;
                }

                o = e.children.filter(function (e) {
                  return e.needsRefresh ? (e.needsRefresh = !1, !0) : !(!e.hasChildren || "loaded" !== e.state) || !!(i && i.viewState.expanded && e.id) && i.viewState.expanded.indexOf(e.id) > -1;
                });
                _context7.next = 8;
                return Promise.all(o.map(function (e) {
                  return _this106.doRefreshSubTree(e, t, i);
                }));

              case 8:
                _context7.prev = 8;
                e.state = "loaded";
                return _context7.finish(8);

              case 11:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1,, 8, 11]]);
      }));
    }
  }, {
    key: "doRefreshNode",
    value: function doRefreshNode(e, t, i) {
      return a(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this107 = this;

        var o, _t64, _n26;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (e.hasChildren = !!this.dataSource.hasChildren(e.element), e.hasChildren) {
                  _t64 = function e(t, i) {
                    return i ? new Promise(function (e, o) {
                      var n = setTimeout(e, t);
                      i.onCancellationRequested(function () {
                        clearTimeout(n), o(u());
                      });
                    }) : lt(function (i) {
                      return e(t, i);
                    });
                  }(800);

                  _t64.then(function () {
                    e.slow = !0, _this107._onDidChangeNodeSlowState.fire(e);
                  }, function (e) {
                    return null;
                  }), o = this.doGetChildren(e).finally(function () {
                    return _t64.cancel();
                  });
                } else o = Promise.resolve([]);

                _context8.prev = 1;
                _context8.next = 4;
                return o;

              case 4:
                _n26 = _context8.sent;
                this.setChildren(e, _n26, t, i);
                _context8.next = 13;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](1);

                if (!(e.needsRefresh = !0, e !== this.root && this.tree.collapse(e === this.root ? null : e), d(_context8.t0))) {
                  _context8.next = 12;
                  break;
                }

                return _context8.abrupt("return");

              case 12:
                throw _context8.t0;

              case 13:
                _context8.prev = 13;
                e.slow && (e.slow = !1, this._onDidChangeNodeSlowState.fire(e));
                return _context8.finish(13);

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[1, 8, 13, 16]]);
      }));
    }
  }, {
    key: "doGetChildren",
    value: function doGetChildren(e) {
      var _this108 = this;

      var t = this.refreshPromises.get(e);
      return t || (t = lt(function () {
        return a(_this108, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee9() {
          var t;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return this.dataSource.getChildren(e.element);

                case 2:
                  t = _context9.sent;
                  return _context9.abrupt("return", (this.sorter && t.sort(this.sorter.compare.bind(this.sorter)), t));

                case 4:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));
      }), this.refreshPromises.set(e, t), t.finally(function () {
        return _this108.refreshPromises.delete(e);
      }));
    }
  }, {
    key: "_onDidChangeCollapseState",
    value: function _onDidChangeCollapseState(_ref16) {
      var e = _ref16.node,
          t = _ref16.deep;
      e.collapsed || "uninitialized" !== e.element.state && !e.element.needsRefresh || (t ? this.collapse(e.element.element) : this.refreshAndRenderNode(e.element, !1, Ko.Expand).catch(h));
    }
  }, {
    key: "setChildren",
    value: function setChildren(e, t, i, o) {
      var _this109 = this,
          _e$children;

      var n;

      if (this.identityProvider) {
        n = new Map();
        var _iteratorNormalCompletion40 = true;
        var _didIteratorError40 = false;
        var _iteratorError40 = undefined;

        try {
          for (var _iterator40 = e.children[Symbol.iterator](), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
            var _t65 = _step40.value;
            n.set(_t65.id, _t65);
          }
        } catch (err) {
          _didIteratorError40 = true;
          _iteratorError40 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion40 && _iterator40.return != null) {
              _iterator40.return();
            }
          } finally {
            if (_didIteratorError40) {
              throw _iteratorError40;
            }
          }
        }
      }

      var s = t.map(function (t) {
        if (!_this109.identityProvider) {
          var _i52 = !!_this109.dataSource.hasChildren(t);

          return {
            element: t,
            parent: e,
            children: [],
            state: "uninitialized",
            hasChildren: _i52,
            needsRefresh: !1,
            disposed: !1,
            slow: !1
          };
        }

        var i = _this109.identityProvider.getId(t).toString(),
            s = n.get(i);

        if (!s) {
          var _n27 = {
            element: t,
            parent: e,
            children: [],
            id: i,
            state: "uninitialized",
            hasChildren: !!_this109.dataSource.hasChildren(t),
            needsRefresh: !1,
            disposed: !1,
            slow: !1
          };
          return o && o.viewState.focus && o.viewState.focus.indexOf(i) > -1 && o.focus.push(_n27), o && o.viewState.selection && o.viewState.selection.indexOf(i) > -1 && o.selection.push(_n27), _n27;
        }

        s.element = t;

        var r = _this109.dataSource.hasChildren(s.element);

        return ("loaded" === s.state || "uninitialized" !== s.state && s.hasChildren !== !!r) && (s.needsRefresh = !0), s.hasChildren = r, s;
      });
      0 === e.children.length && 0 === t.length || (_e$children = e.children).splice.apply(_e$children, [0, e.children.length].concat(_toConsumableArray(s)));
    }
  }, {
    key: "render",
    value: function render(e, t) {
      var _this110 = this;

      var i = new Set(),
          o = e.children.map(function (e) {
        return function e(t, i) {
          var o;
          return i && i.viewState.expanded && t.id && (o = -1 === i.viewState.expanded.indexOf(t.id)), {
            element: t,
            children: w.map(w.fromArray(t.children), function (t) {
              return e(t, i);
            }),
            collapsible: t.hasChildren,
            collapsed: o
          };
        }(e, t);
      });
      this.tree.setChildren(e === this.root ? null : e, o, function (e) {
        e.element.element && (i.add(e.element.element), _this110.nodes.set(e.element.element, e.element));
      }, function (e) {
        e.element.element && (i.has(e.element.element) || (e.element.disposed = !0, _this110.nodes.delete(e.element.element)));
      }), this._onDidRender.fire();
    }
  }, {
    key: "getViewState",
    value: function getViewState() {
      var _this111 = this;

      if (!this.identityProvider) throw new Error("Can't get tree view state without an identity provider");

      var e = function e(_e79) {
        return _this111.identityProvider.getId(_e79).toString();
      },
          t = this.getFocus().map(e),
          i = this.getSelection().map(e),
          o = [],
          n = this.tree.getNode(),
          s = [n];

      for (; s.length > 0;) {
        var _t66 = s.shift();

        _t66 !== n && _t66.collapsible && !_t66.collapsed && o.push(e(_t66.element.element)), s.push.apply(s, _toConsumableArray(_t66.children));
      }

      return {
        focus: t,
        selection: i,
        expanded: o,
        scrollTop: this.scrollTop
      };
    }
  }, {
    key: "dispose",
    value: function dispose() {
      C(this.disposables);
    }
  }, {
    key: "onDidScroll",
    get: function get() {
      return this.tree.onDidScroll;
    }
  }, {
    key: "onDidChangeFocus",
    get: function get() {
      return v.map(this.tree.onDidChangeFocus, jo);
    }
  }, {
    key: "onDidChangeSelection",
    get: function get() {
      return v.map(this.tree.onDidChangeSelection, jo);
    }
  }, {
    key: "onDidOpen",
    get: function get() {
      return v.map(this.tree.onDidOpen, jo);
    }
  }, {
    key: "onMouseClick",
    get: function get() {
      return v.map(this.tree.onMouseClick, Go);
    }
  }, {
    key: "onMouseDblClick",
    get: function get() {
      return v.map(this.tree.onMouseDblClick, Go);
    }
  }, {
    key: "onContextMenu",
    get: function get() {
      return v.map(this.tree.onContextMenu, Oo);
    }
  }, {
    key: "onDidFocus",
    get: function get() {
      return this.tree.onDidFocus;
    }
  }, {
    key: "onDidBlur",
    get: function get() {
      return this.tree.onDidBlur;
    }
  }, {
    key: "onDidUpdateOptions",
    get: function get() {
      return this.tree.onDidUpdateOptions;
    }
  }, {
    key: "filterOnType",
    get: function get() {
      return this.tree.filterOnType;
    }
  }, {
    key: "openOnSingleClick",
    get: function get() {
      return this.tree.openOnSingleClick;
    }
  }, {
    key: "onDidDispose",
    get: function get() {
      return this.tree.onDidDispose;
    }
  }, {
    key: "contentHeight",
    get: function get() {
      return this.tree.contentHeight;
    }
  }, {
    key: "onDidChangeContentHeight",
    get: function get() {
      return this.tree.onDidChangeContentHeight;
    }
  }, {
    key: "scrollTop",
    get: function get() {
      return this.tree.scrollTop;
    },
    set: function set(e) {
      this.tree.scrollTop = e;
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      return this.tree.scrollHeight;
    }
  }, {
    key: "renderHeight",
    get: function get() {
      return this.tree.renderHeight;
    }
  }, {
    key: "firstVisibleElement",
    get: function get() {
      return this.tree.firstVisibleElement.element;
    }
  }, {
    key: "lastVisibleElement",
    get: function get() {
      return this.tree.lastVisibleElement.element;
    }
  }]);

  return _class6;
}());

function hn(e, t) {
  return t;
}

An = r([l(4, ln)], An);
var cn;
!function (e) {
  e[e.Ignore = 0] = "Ignore", e[e.Info = 1] = "Info", e[e.Warning = 2] = "Warning", e[e.Error = 3] = "Error";
}(cn || (cn = {})), function (e) {
  var t = "error",
      i = "warning",
      o = "warn",
      n = "info",
      s = Object.create(null);
  s[e.Error] = hn(0, "Error"), s[e.Warning] = hn(0, "Warning"), s[e.Info] = hn(0, "Info"), e.fromValue = function (s) {
    return s ? de(t, s) ? e.Error : de(i, s) || de(o, s) ? e.Warning : de(n, s) ? e.Info : e.Ignore : e.Ignore;
  };
}(cn || (cn = {}));
var dn = cn;
var un = n("commandService"),
    gn = new (
/*#__PURE__*/
function () {
  function _class7() {
    _classCallCheck(this, _class7);

    this._commands = new Map(), this._onDidRegisterCommand = new b(), this.onDidRegisterCommand = this._onDidRegisterCommand.event;
  }

  _createClass(_class7, [{
    key: "registerCommand",
    value: function registerCommand(e, t) {
      var _this112 = this;

      if (!e) throw new Error("invalid command");

      if ("string" == typeof e) {
        if (!t) throw new Error("invalid command");
        return this.registerCommand({
          id: e,
          handler: t
        });
      }

      if (e.description) {
        var _t67 = [];
        var _iteratorNormalCompletion41 = true;
        var _didIteratorError41 = false;
        var _iteratorError41 = undefined;

        try {
          for (var _iterator41 = e.description.args[Symbol.iterator](), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
            var _i54 = _step41.value;

            _t67.push(_i54.constraint);
          }
        } catch (err) {
          _didIteratorError41 = true;
          _iteratorError41 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion41 && _iterator41.return != null) {
              _iterator41.return();
            }
          } finally {
            if (_didIteratorError41) {
              throw _iteratorError41;
            }
          }
        }

        var _i53 = e.handler;

        e.handler = function (e) {
          for (var _len14 = arguments.length, o = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
            o[_key14 - 1] = arguments[_key14];
          }

          return function (e, t) {
            var i = Math.min(e.length, t.length);

            for (var _o31 = 0; _o31 < i; _o31++) {
              Xt(e[_o31], t[_o31]);
            }
          }(o, _t67), _i53.apply(void 0, [e].concat(o));
        };
      }

      var i = e.id;

      var o = this._commands.get(i);

      o || (o = new y(), this._commands.set(i, o));
      var n = o.unshift(e),
          s = m(function () {
        n();

        var e = _this112._commands.get(i);

        e && e.isEmpty() && _this112._commands.delete(i);
      });
      return this._onDidRegisterCommand.fire(i), s;
    }
  }, {
    key: "registerCommandAlias",
    value: function registerCommandAlias(e, t) {
      return gn.registerCommand(e, function (e) {
        var _e$get;

        for (var _len15 = arguments.length, i = new Array(_len15 > 1 ? _len15 - 1 : 0), _key15 = 1; _key15 < _len15; _key15++) {
          i[_key15 - 1] = arguments[_key15];
        }

        return (_e$get = e.get(un)).executeCommand.apply(_e$get, [t].concat(i));
      });
    }
  }, {
    key: "getCommand",
    value: function getCommand(e) {
      var t = this._commands.get(e);

      if (t && !t.isEmpty()) return t.iterator().next().value;
    }
  }, {
    key: "getCommands",
    value: function getCommands() {
      var _this113 = this;

      var e = Object.create(null);
      return this._commands.forEach(function (t, i) {
        e[i] = _this113.getCommand(i);
      }), e;
    }
  }]);

  return _class7;
}())();
var Cn;

function pn(e, t) {
  if (!e) throw new Error(t ? "Assertion failed (" + t + ")" : "Assertion Failed");
}

!function (e) {
  e.DEFAULT = {
    allowTrailingComma: !0
  };
}(Cn || (Cn = {}));
var mn = new (
/*#__PURE__*/
function () {
  function _class8() {
    _classCallCheck(this, _class8);

    this.data = {};
  }

  _createClass(_class8, [{
    key: "add",
    value: function add(e, t) {
      pn(jt(e)), pn(Gt(t)), pn(!this.data.hasOwnProperty(e), "There is already an extension with this id"), this.data[e] = t;
    }
  }, {
    key: "knows",
    value: function knows(e) {
      return this.data.hasOwnProperty(e);
    }
  }, {
    key: "as",
    value: function as(e) {
      return this.data[e] || null;
    }
  }]);

  return _class8;
}())(),
    fn = "base.contributions.json";
var Dn = new (
/*#__PURE__*/
function () {
  function _class9() {
    _classCallCheck(this, _class9);

    this._onDidChangeSchema = new b(), this.onDidChangeSchema = this._onDidChangeSchema.event, this.schemasById = {};
  }

  _createClass(_class9, [{
    key: "registerSchema",
    value: function registerSchema(e, t) {
      var i;
      this.schemasById[(i = e, i.length > 0 && "#" === i.charAt(i.length - 1) ? i.substring(0, i.length - 1) : i)] = t, this._onDidChangeSchema.fire(e);
    }
  }, {
    key: "notifySchemaChanged",
    value: function notifySchemaChanged(e) {
      this._onDidChangeSchema.fire(e);
    }
  }, {
    key: "getSchemaContributions",
    value: function getSchemaContributions() {
      return {
        schemas: this.schemasById
      };
    }
  }]);

  return _class9;
}())();
mn.add(fn, Dn);
var wn = {
  Configuration: "base.contributions.configuration"
},
    vn = {
  properties: {},
  patternProperties: {}
},
    En = {
  properties: {},
  patternProperties: {}
},
    yn = {
  properties: {},
  patternProperties: {}
},
    Mn = {
  properties: {},
  patternProperties: {}
},
    Bn = "vscode://schemas/settings/editor",
    bn = mn.as(fn);
var Fn = "override",
    Hn = "\\[.*\\]$",
    Sn = "\\[(${0})\\]$",
    zn = new RegExp(Hn);

function xn(e) {
  switch (Array.isArray(e) ? e[0] : e) {
    case "boolean":
      return !1;

    case "integer":
    case "number":
      return 0;

    case "string":
      return "";

    case "array":
      return [];

    case "object":
      return {};

    default:
      return null;
  }
}

var Vn = new (
/*#__PURE__*/
function () {
  function _class10() {
    _classCallCheck(this, _class10);

    this.overrideIdentifiers = [], this._onDidSchemaChange = new b(), this.onDidSchemaChange = this._onDidSchemaChange.event, this._onDidUpdateConfiguration = new b(), this.onDidUpdateConfiguration = this._onDidUpdateConfiguration.event, this.defaultOverridesConfigurationNode = {
      id: "defaultOverrides",
      title: hn(0, "Default Configuration Overrides"),
      properties: {}
    }, this.configurationContributors = [this.defaultOverridesConfigurationNode], this.editorConfigurationSchema = {
      properties: {},
      patternProperties: {},
      additionalProperties: !1,
      errorMessage: "Unknown editor configuration setting"
    }, this.configurationProperties = {}, this.excludedConfigurationProperties = {}, this.computeOverridePropertyPattern(), bn.registerSchema(Bn, this.editorConfigurationSchema);
  }

  _createClass(_class10, [{
    key: "registerConfiguration",
    value: function registerConfiguration(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      this.registerConfigurations([e], t);
    }
  }, {
    key: "registerConfigurations",
    value: function registerConfigurations(e) {
      var _this114 = this;

      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = [];
      e.forEach(function (e) {
        i.push.apply(i, _toConsumableArray(_this114.validateAndRegisterProperties(e, t))), _this114.configurationContributors.push(e), _this114.registerJSONConfiguration(e), _this114.updateSchemaForOverrideSettingsConfiguration(e);
      }), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire(i);
    }
  }, {
    key: "deregisterConfigurations",
    value: function deregisterConfigurations(e) {
      var _this115 = this;

      var t = [],
          i = function i(e) {
        if (e.properties) for (var _i55 in e.properties) {
          switch (t.push(_i55), delete _this115.configurationProperties[_i55], delete _this115.editorConfigurationSchema.properties[_i55], delete vn.properties[_i55], e.properties[_i55].scope) {
            case 1:
              delete En.properties[_i55];
              break;

            case 2:
              delete yn.properties[_i55];
              break;

            case 3:
              delete Mn.properties[_i55];
          }
        }
        e.allOf && e.allOf.forEach(function (e) {
          return i(e);
        });
      };

      var _iteratorNormalCompletion42 = true;
      var _didIteratorError42 = false;
      var _iteratorError42 = undefined;

      try {
        for (var _iterator42 = e[Symbol.iterator](), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
          var _t68 = _step42.value;
          i(_t68);

          var _e80 = this.configurationContributors.indexOf(_t68);

          -1 !== _e80 && this.configurationContributors.splice(_e80, 1);
        }
      } catch (err) {
        _didIteratorError42 = true;
        _iteratorError42 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion42 && _iterator42.return != null) {
            _iterator42.return();
          }
        } finally {
          if (_didIteratorError42) {
            throw _iteratorError42;
          }
        }
      }

      bn.registerSchema(Bn, this.editorConfigurationSchema), this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire(t);
    }
  }, {
    key: "registerDefaultConfigurations",
    value: function registerDefaultConfigurations(e) {
      var t = [];
      var _iteratorNormalCompletion43 = true;
      var _didIteratorError43 = false;
      var _iteratorError43 = undefined;

      try {
        for (var _iterator43 = e[Symbol.iterator](), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
          var _i56 = _step43.value;

          for (var _e81 in _i56.defaults) {
            var o = _i56.defaults[_e81];

            if (zn.test(_e81) && "object" == typeof o) {
              var _i57 = {
                type: "object",
                default: o,
                description: hn(0, "Configure editor settings to be overridden for {0} language."),
                $ref: Bn
              };
              vn.properties[_e81] = _i57, this.defaultOverridesConfigurationNode.properties[_e81] = _i57, this.configurationProperties[_e81] = _i57, t.push(_e81);
            }
          }
        }
      } catch (err) {
        _didIteratorError43 = true;
        _iteratorError43 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion43 && _iterator43.return != null) {
            _iterator43.return();
          }
        } finally {
          if (_didIteratorError43) {
            throw _iteratorError43;
          }
        }
      }

      this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire(t);
    }
  }, {
    key: "deregisterDefaultConfigurations",
    value: function deregisterDefaultConfigurations(e) {
      var t = [];
      var _iteratorNormalCompletion44 = true;
      var _didIteratorError44 = false;
      var _iteratorError44 = undefined;

      try {
        for (var _iterator44 = e[Symbol.iterator](), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
          var _i58 = _step44.value;

          for (var _e82 in _i58.defaults) {
            t.push(_e82), delete vn.properties[_e82], delete this.defaultOverridesConfigurationNode.properties[_e82], delete this.configurationProperties[_e82];
          }
        }
      } catch (err) {
        _didIteratorError44 = true;
        _iteratorError44 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion44 && _iterator44.return != null) {
            _iterator44.return();
          }
        } finally {
          if (_didIteratorError44) {
            throw _iteratorError44;
          }
        }
      }

      this._onDidSchemaChange.fire(), this._onDidUpdateConfiguration.fire(t);
    }
  }, {
    key: "notifyConfigurationSchemaUpdated",
    value: function notifyConfigurationSchemaUpdated() {
      this._onDidSchemaChange.fire();
    }
  }, {
    key: "registerOverrideIdentifiers",
    value: function registerOverrideIdentifiers(e) {
      var _this$overrideIdentif;

      (_this$overrideIdentif = this.overrideIdentifiers).push.apply(_this$overrideIdentif, _toConsumableArray(e)), this.updateOverridePropertyPatternKey();
    }
  }, {
    key: "validateAndRegisterProperties",
    value: function validateAndRegisterProperties(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
      var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !1;
      i = Kt(e.scope) ? i : e.scope, o = e.overridable || o;
      var n = [],
          s = e.properties;
      if (s) for (var _e83 in s) {
        var _r10 = void 0;

        if (t && (_r10 = In(_e83))) {
          console.warn(_r10), delete s[_e83];
          continue;
        }

        var _l4 = s[_e83];
        Ot(_l4.default) && (_l4.default = xn(_l4.type)), o && (_l4.overridable = !0), zn.test(_e83) ? _l4.scope = void 0 : _l4.scope = Kt(_l4.scope) ? i : _l4.scope, !s[_e83].hasOwnProperty("included") || s[_e83].included ? (this.configurationProperties[_e83] = s[_e83], n.push(_e83)) : (this.excludedConfigurationProperties[_e83] = s[_e83], delete s[_e83]);
      }
      var r = e.allOf;

      if (r) {
        var _iteratorNormalCompletion45 = true;
        var _didIteratorError45 = false;
        var _iteratorError45 = undefined;

        try {
          for (var _iterator45 = r[Symbol.iterator](), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
            var _e84 = _step45.value;
            n.push.apply(n, _toConsumableArray(this.validateAndRegisterProperties(_e84, t, i, o)));
          }
        } catch (err) {
          _didIteratorError45 = true;
          _iteratorError45 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion45 && _iterator45.return != null) {
              _iterator45.return();
            }
          } finally {
            if (_didIteratorError45) {
              throw _iteratorError45;
            }
          }
        }
      }

      return n;
    }
  }, {
    key: "getConfigurations",
    value: function getConfigurations() {
      return this.configurationContributors;
    }
  }, {
    key: "getConfigurationProperties",
    value: function getConfigurationProperties() {
      return this.configurationProperties;
    }
  }, {
    key: "getExcludedConfigurationProperties",
    value: function getExcludedConfigurationProperties() {
      return this.excludedConfigurationProperties;
    }
  }, {
    key: "registerJSONConfiguration",
    value: function registerJSONConfiguration(e) {
      !function e(t) {
        var i = t.properties;
        if (i) for (var _e85 in i) {
          switch (vn.properties[_e85] = i[_e85], i[_e85].scope) {
            case 1:
              En.properties[_e85] = i[_e85];
              break;

            case 2:
              yn.properties[_e85] = i[_e85];
              break;

            case 3:
              Mn.properties[_e85] = i[_e85];
          }
        }
        var o = t.allOf;
        o && o.forEach(e);
      }(e);
    }
  }, {
    key: "updateSchemaForOverrideSettingsConfiguration",
    value: function updateSchemaForOverrideSettingsConfiguration(e) {
      e.id !== Fn && (this.update(e), bn.registerSchema(Bn, this.editorConfigurationSchema));
    }
  }, {
    key: "updateOverridePropertyPatternKey",
    value: function updateOverridePropertyPatternKey() {
      var e = vn.patternProperties[this.overridePropertyPattern];
      e || (e = {
        type: "object",
        description: hn(0, "Configure editor settings to be overridden for a language."),
        errorMessage: "Unknown Identifier. Use language identifiers",
        $ref: Bn
      }), delete vn.patternProperties[this.overridePropertyPattern], delete En.patternProperties[this.overridePropertyPattern], delete yn.patternProperties[this.overridePropertyPattern], delete Mn.patternProperties[this.overridePropertyPattern], this.computeOverridePropertyPattern(), vn.patternProperties[this.overridePropertyPattern] = e, En.patternProperties[this.overridePropertyPattern] = e, yn.patternProperties[this.overridePropertyPattern] = e, Mn.patternProperties[this.overridePropertyPattern] = e, this._onDidSchemaChange.fire();
    }
  }, {
    key: "update",
    value: function update(e) {
      var _this116 = this;

      var t = e.properties;
      if (t) for (var _e86 in t) {
        t[_e86].overridable && (this.editorConfigurationSchema.properties[_e86] = this.getConfigurationProperties()[_e86]);
      }
      var i = e.allOf;
      i && i.forEach(function (e) {
        return _this116.update(e);
      });
    }
  }, {
    key: "computeOverridePropertyPattern",
    value: function computeOverridePropertyPattern() {
      this.overridePropertyPattern = this.overrideIdentifiers.length ? Sn.replace("${0}", this.overrideIdentifiers.map(function (e) {
        return function (e, t) {
          var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
          if (!e) throw new Error("Cannot create regex from empty string");
          t || (e = e.replace(/[\-\\\{\}\*\+\?\|\^\$\.\[\]\(\)\#]/g, "\\$&")), i.wholeWord && (/\B/.test(e.charAt(0)) || (e = "\\b" + e), /\B/.test(e.charAt(e.length - 1)) || (e += "\\b"));
          var o = "";
          return i.global && (o += "g"), i.matchCase || (o += "i"), i.multiline && (o += "m"), i.unicode && (o += "u"), new RegExp(e, o);
        }(e, !1).source;
      }).join("|")) : Hn;
    }
  }]);

  return _class10;
}())();

function In(e) {
  return zn.test(e) ? hn(0, "Cannot register '{0}'. This matches property pattern '\\\\[.*\\\\]$' for describing language specific editor settings. Use 'configurationDefaults' contribution.") : void 0 !== Vn.getConfigurationProperties()[e] ? hn(0, "Cannot register '{0}'. This property is already registered.") : null;
}

mn.add(wn.Configuration, Vn);

var _n = n("configurationService");

function Nn(e, t) {
  var i = Object.create(null);

  for (var o in e) {
    Ln(i, o, e[o], t);
  }

  return i;
}

function Ln(e, t, i, o) {
  var n = t.split("."),
      s = n.pop();
  var r = e;

  for (var _e87 = 0; _e87 < n.length; _e87++) {
    var _i59 = n[_e87],
        _s19 = r[_i59];

    switch (typeof _s19) {
      case "undefined":
        _s19 = r[_i59] = Object.create(null);
        break;

      case "object":
        break;

      default:
        return void o("Ignoring ".concat(t, " as ").concat(n.slice(0, _e87 + 1).join("."), " is ").concat(JSON.stringify(_s19)));
    }

    r = _s19;
  }

  "object" == typeof r ? r[s] = i : o("Ignoring ".concat(t, " as ").concat(n.join("."), " is ").concat(JSON.stringify(r)));
}

function Pn(e, t) {
  !function e(t, i) {
    var o = i.shift();
    if (0 === i.length) return void delete t[o];

    if (-1 !== Object.keys(t).indexOf(o)) {
      var _n28 = t[o];
      "object" != typeof _n28 || Array.isArray(_n28) || (e(_n28, i), 0 === Object.keys(_n28).length && delete t[o]);
    }
  }(e, t.split("."));
}

function Qn(e) {
  return e.substring(1, e.length - 1);
}

var Rn =
/*#__PURE__*/
function () {
  function Rn() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, Rn);

    this._contents = e, this._keys = t, this._overrides = i, this.isFrozen = !1;
  }

  _createClass(Rn, [{
    key: "getValue",
    value: function getValue(e) {
      return e ? function (e, t, i) {
        var o = function (e, t) {
          var i = e;
          var _iteratorNormalCompletion46 = true;
          var _didIteratorError46 = false;
          var _iteratorError46 = undefined;

          try {
            for (var _iterator46 = t[Symbol.iterator](), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
              var _e88 = _step46.value;
              if ("object" != typeof i || null === i) return;
              i = i[_e88];
            }
          } catch (err) {
            _didIteratorError46 = true;
            _iteratorError46 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion46 && _iterator46.return != null) {
                _iterator46.return();
              }
            } finally {
              if (_didIteratorError46) {
                throw _iteratorError46;
              }
            }
          }

          return i;
        }(e, t.split("."));

        return void 0 === o ? i : o;
      }(this.contents, e) : this.contents;
    }
  }, {
    key: "override",
    value: function override(e) {
      var t = this.getContentsForOverrideIdentifer(e);
      if (!t || "object" != typeof t || !Object.keys(t).length) return this;
      var i = {};
      var _iteratorNormalCompletion47 = true;
      var _didIteratorError47 = false;
      var _iteratorError47 = undefined;

      try {
        for (var _iterator47 = Ct([].concat(_toConsumableArray(Object.keys(this.contents)), _toConsumableArray(Object.keys(t))))[Symbol.iterator](), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
          var _e89 = _step47.value;
          var o = this.contents[_e89],
              _n29 = t[_e89];
          _n29 && ("object" == typeof o && "object" == typeof _n29 ? (o = Zt(o), this.mergeContents(o, _n29)) : o = _n29), i[_e89] = o;
        }
      } catch (err) {
        _didIteratorError47 = true;
        _iteratorError47 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion47 && _iterator47.return != null) {
            _iterator47.return();
          }
        } finally {
          if (_didIteratorError47) {
            throw _iteratorError47;
          }
        }
      }

      return new Rn(i);
    }
  }, {
    key: "merge",
    value: function merge() {
      var _this117 = this;

      var t = Zt(this.contents),
          i = Zt(this.overrides),
          o = _toConsumableArray(this.keys);

      for (var _len16 = arguments.length, e = new Array(_len16), _key16 = 0; _key16 < _len16; _key16++) {
        e[_key16] = arguments[_key16];
      }

      for (var _i60 = 0, _e90 = e; _i60 < _e90.length; _i60++) {
        var _n30 = _e90[_i60];
        this.mergeContents(t, _n30.contents);
        var _iteratorNormalCompletion48 = true;
        var _didIteratorError48 = false;
        var _iteratorError48 = undefined;

        try {
          var _loop2 = function _loop2() {
            var e = _step48.value;

            var _i$filter = i.filter(function (t) {
              return ut(t.identifiers, e.identifiers);
            }),
                _i$filter2 = _slicedToArray(_i$filter, 1),
                t = _i$filter2[0];

            t ? _this117.mergeContents(t.contents, e.contents) : i.push(Zt(e));
          };

          for (var _iterator48 = _n30.overrides[Symbol.iterator](), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
            _loop2();
          }
        } catch (err) {
          _didIteratorError48 = true;
          _iteratorError48 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion48 && _iterator48.return != null) {
              _iterator48.return();
            }
          } finally {
            if (_didIteratorError48) {
              throw _iteratorError48;
            }
          }
        }

        var _iteratorNormalCompletion49 = true;
        var _didIteratorError49 = false;
        var _iteratorError49 = undefined;

        try {
          for (var _iterator49 = _n30.keys[Symbol.iterator](), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
            var _e91 = _step49.value;
            -1 === o.indexOf(_e91) && o.push(_e91);
          }
        } catch (err) {
          _didIteratorError49 = true;
          _iteratorError49 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion49 && _iterator49.return != null) {
              _iterator49.return();
            }
          } finally {
            if (_didIteratorError49) {
              throw _iteratorError49;
            }
          }
        }
      }

      return new Rn(t, o, i);
    }
  }, {
    key: "freeze",
    value: function freeze() {
      return this.isFrozen = !0, this;
    }
  }, {
    key: "mergeContents",
    value: function mergeContents(e, t) {
      for (var _i61 = 0, _Object$keys = Object.keys(t); _i61 < _Object$keys.length; _i61++) {
        var _i62 = _Object$keys[_i61];
        _i62 in e && Gt(e[_i62]) && Gt(t[_i62]) ? this.mergeContents(e[_i62], t[_i62]) : e[_i62] = Zt(t[_i62]);
      }
    }
  }, {
    key: "checkAndFreeze",
    value: function checkAndFreeze(e) {
      return this.isFrozen && !Object.isFrozen(e) ? function (e) {
        if (!e || "object" != typeof e) return e;
        var t = [e];

        for (; t.length > 0;) {
          var _e92 = t.shift();

          Object.freeze(_e92);

          for (var _i63 in _e92) {
            if (qt.call(_e92, _i63)) {
              var o = _e92[_i63];
              "object" != typeof o || Object.isFrozen(o) || t.push(o);
            }
          }
        }

        return e;
      }(e) : e;
    }
  }, {
    key: "getContentsForOverrideIdentifer",
    value: function getContentsForOverrideIdentifer(e) {
      var _iteratorNormalCompletion50 = true;
      var _didIteratorError50 = false;
      var _iteratorError50 = undefined;

      try {
        for (var _iterator50 = this.overrides[Symbol.iterator](), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
          var _t69 = _step50.value;
          if (-1 !== _t69.identifiers.indexOf(e)) return _t69.contents;
        }
      } catch (err) {
        _didIteratorError50 = true;
        _iteratorError50 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion50 && _iterator50.return != null) {
            _iterator50.return();
          }
        } finally {
          if (_didIteratorError50) {
            throw _iteratorError50;
          }
        }
      }

      return null;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        contents: this.contents,
        overrides: this.overrides,
        keys: this.keys
      };
    }
  }, {
    key: "setValue",
    value: function setValue(e, t) {
      this.addKey(e), Ln(this.contents, e, t, function (e) {
        throw new Error(e);
      });
    }
  }, {
    key: "removeValue",
    value: function removeValue(e) {
      this.removeKey(e) && Pn(this.contents, e);
    }
  }, {
    key: "addKey",
    value: function addKey(e) {
      var t = this.keys.length;

      for (var _i64 = 0; _i64 < t; _i64++) {
        0 === e.indexOf(this.keys[_i64]) && (t = _i64);
      }

      this.keys.splice(t, 1, e);
    }
  }, {
    key: "removeKey",
    value: function removeKey(e) {
      var t = this.keys.indexOf(e);
      return -1 !== t && (this.keys.splice(t, 1), !0);
    }
  }, {
    key: "contents",
    get: function get() {
      return this.checkAndFreeze(this._contents);
    }
  }, {
    key: "overrides",
    get: function get() {
      return this.checkAndFreeze(this._overrides);
    }
  }, {
    key: "keys",
    get: function get() {
      return this.checkAndFreeze(this._keys);
    }
  }]);

  return Rn;
}();

var Tn =
/*#__PURE__*/
function (_Rn) {
  _inherits(Tn, _Rn);

  function Tn() {
    _classCallCheck(this, Tn);

    var e = function () {
      var e = Object.create(null),
          t = mn.as(wn.Configuration).getConfigurationProperties();

      for (var _i65 in t) {
        Ln(e, _i65, t[_i65].default, function (e) {
          return console.error("Conflict in default settings: ".concat(e));
        });
      }

      return e;
    }(),
        t = function () {
      var e = mn.as(wn.Configuration).getConfigurationProperties();
      return Object.keys(e);
    }(),
        i = [];

    for (var _i66 = 0, _Object$keys2 = Object.keys(e); _i66 < _Object$keys2.length; _i66++) {
      var _t70 = _Object$keys2[_i66];
      zn.test(_t70) && i.push({
        identifiers: [Qn(_t70).trim()],
        contents: Nn(e[_t70], function (e) {
          return console.error("Conflict in default settings file: ".concat(e));
        })
      });
    }

    return _possibleConstructorReturn(this, _getPrototypeOf(Tn).call(this, e, t, i));
  }

  return Tn;
}(Rn);

var kn =
/*#__PURE__*/
function () {
  function kn(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new Rn();
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new le();
    var n = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : new Rn();
    var s = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : new le();
    var r = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : !0;

    _classCallCheck(this, kn);

    this._defaultConfiguration = e, this._userConfiguration = t, this._workspaceConfiguration = i, this._folderConfigurations = o, this._memoryConfiguration = n, this._memoryConfigurationByResource = s, this._freeze = r, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations = new le();
  }

  _createClass(kn, [{
    key: "getValue",
    value: function getValue(e, t) {
      return this.getConsolidateConfigurationModel(t).getValue(e);
    }
  }, {
    key: "updateValue",
    value: function updateValue(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var o;
      i.resource ? (o = this._memoryConfigurationByResource.get(i.resource)) || (o = new Rn(), this._memoryConfigurationByResource.set(i.resource, o)) : o = this._memoryConfiguration, void 0 === t ? o.removeValue(e) : o.setValue(e, t), i.resource || (this._workspaceConsolidatedConfiguration = null);
    }
  }, {
    key: "inspect",
    value: function inspect(e, t) {
      var i = this.getConsolidateConfigurationModel(t),
          o = this.getFolderConfigurationModelForResource(t.resource),
          n = t.resource && this._memoryConfigurationByResource.get(t.resource) || this._memoryConfiguration;

      return {
        default: t.overrideIdentifier ? this._defaultConfiguration.freeze().override(t.overrideIdentifier).getValue(e) : this._defaultConfiguration.freeze().getValue(e),
        user: t.overrideIdentifier ? this._userConfiguration.freeze().override(t.overrideIdentifier).getValue(e) : this._userConfiguration.freeze().getValue(e),
        workspace: void 0,
        workspaceFolder: o ? t.overrideIdentifier ? o.freeze().override(t.overrideIdentifier).getValue(e) : o.freeze().getValue(e) : void 0,
        memory: t.overrideIdentifier ? n.override(t.overrideIdentifier).getValue(e) : n.getValue(e),
        value: i.getValue(e)
      };
    }
  }, {
    key: "keys",
    value: function keys(e) {
      var t = this.getFolderConfigurationModelForResource(void 0);
      return {
        default: this._defaultConfiguration.freeze().keys,
        user: this._userConfiguration.freeze().keys,
        workspace: this._workspaceConfiguration.freeze().keys,
        workspaceFolder: t ? t.freeze().keys : []
      };
    }
  }, {
    key: "updateDefaultConfiguration",
    value: function updateDefaultConfiguration(e) {
      this._defaultConfiguration = e, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations.clear();
    }
  }, {
    key: "updateUserConfiguration",
    value: function updateUserConfiguration(e) {
      this._userConfiguration = e, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations.clear();
    }
  }, {
    key: "updateWorkspaceConfiguration",
    value: function updateWorkspaceConfiguration(e) {
      this._workspaceConfiguration = e, this._workspaceConsolidatedConfiguration = null, this._foldersConsolidatedConfigurations.clear();
    }
  }, {
    key: "updateFolderConfiguration",
    value: function updateFolderConfiguration(e, t) {
      this._folderConfigurations.set(e, t), this._foldersConsolidatedConfigurations.delete(e);
    }
  }, {
    key: "deleteFolderConfiguration",
    value: function deleteFolderConfiguration(e) {
      this.folders.delete(e), this._foldersConsolidatedConfigurations.delete(e);
    }
  }, {
    key: "getConsolidateConfigurationModel",
    value: function getConsolidateConfigurationModel(e) {
      var t = this.getConsolidatedConfigurationModelForResource(e);
      return e.overrideIdentifier ? t.override(e.overrideIdentifier) : t;
    }
  }, {
    key: "getConsolidatedConfigurationModelForResource",
    value: function getConsolidatedConfigurationModelForResource(_ref17) {
      var e = _ref17.resource;
      return this.getWorkspaceConsolidatedConfiguration();
    }
  }, {
    key: "getWorkspaceConsolidatedConfiguration",
    value: function getWorkspaceConsolidatedConfiguration() {
      return this._workspaceConsolidatedConfiguration || (this._workspaceConsolidatedConfiguration = this._defaultConfiguration.merge(this._userConfiguration, this._workspaceConfiguration, this._memoryConfiguration), this._freeze && (this._workspaceConfiguration = this._workspaceConfiguration.freeze())), this._workspaceConsolidatedConfiguration;
    }
  }, {
    key: "getFolderConsolidatedConfiguration",
    value: function getFolderConsolidatedConfiguration(e) {
      var t = this._foldersConsolidatedConfigurations.get(e);

      if (!t) {
        var _i67 = this.getWorkspaceConsolidatedConfiguration(),
            o = this._folderConfigurations.get(e);

        o ? (t = _i67.merge(o), this._freeze && (t = t.freeze()), this._foldersConsolidatedConfigurations.set(e, t)) : t = _i67;
      }

      return t;
    }
  }, {
    key: "getFolderConfigurationModelForResource",
    value: function getFolderConfigurationModelForResource(e) {
      return null;
    }
  }, {
    key: "toData",
    value: function toData() {
      var _this118 = this;

      return {
        defaults: {
          contents: this._defaultConfiguration.contents,
          overrides: this._defaultConfiguration.overrides,
          keys: this._defaultConfiguration.keys
        },
        user: {
          contents: this._userConfiguration.contents,
          overrides: this._userConfiguration.overrides,
          keys: this._userConfiguration.keys
        },
        workspace: {
          contents: this._workspaceConfiguration.contents,
          overrides: this._workspaceConfiguration.overrides,
          keys: this._workspaceConfiguration.keys
        },
        folders: this._folderConfigurations.keys().reduce(function (e, t) {
          var _this118$_folderConfi = _this118._folderConfigurations.get(t),
              i = _this118$_folderConfi.contents,
              o = _this118$_folderConfi.overrides,
              n = _this118$_folderConfi.keys;

          return e[t.toString()] = {
            contents: i,
            overrides: o,
            keys: n
          }, e;
        }, Object.create({})),
        isComplete: !0
      };
    }
  }, {
    key: "defaults",
    get: function get() {
      return this._defaultConfiguration;
    }
  }, {
    key: "user",
    get: function get() {
      return this._userConfiguration;
    }
  }, {
    key: "workspace",
    get: function get() {
      return this._workspaceConfiguration;
    }
  }, {
    key: "folders",
    get: function get() {
      return this._folderConfigurations;
    }
  }]);

  return kn;
}();

var Yn =
/*#__PURE__*/
function (_f11) {
  _inherits(Yn, _f11);

  function Yn(e, t, i, o) {
    var _this119;

    _classCallCheck(this, Yn);

    _this119 = _possibleConstructorReturn(this, _getPrototypeOf(Yn).call(this)), _this119._contextKeyService = e, _this119._commandService = t, _this119._telemetryService = i, _this119._notificationService = o, _this119._currentChord = null, _this119._currentChordChecker = new ct(), _this119._currentChordStatusMessage = null, _this119._onDidUpdateKeybindings = _this119._register(new b());
    return _this119;
  }

  _createClass(Yn, [{
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(Yn.prototype), "dispose", this).call(this);
    }
  }, {
    key: "getDefaultKeybindingsContent",
    value: function getDefaultKeybindingsContent() {
      return "";
    }
  }, {
    key: "getDefaultKeybindings",
    value: function getDefaultKeybindings() {
      return this._getResolver().getDefaultKeybindings();
    }
  }, {
    key: "getKeybindings",
    value: function getKeybindings() {
      return this._getResolver().getKeybindings();
    }
  }, {
    key: "customKeybindingsCount",
    value: function customKeybindingsCount() {
      return 0;
    }
  }, {
    key: "lookupKeybindings",
    value: function lookupKeybindings(e) {
      return gt(this._getResolver().lookupKeybindings(e).map(function (e) {
        return e.resolvedKeybinding;
      }));
    }
  }, {
    key: "lookupKeybinding",
    value: function lookupKeybinding(e) {
      var t = this._getResolver().lookupPrimaryKeybinding(e);

      if (t) return t.resolvedKeybinding || void 0;
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(e, t) {
      return this._dispatch(e, t);
    }
  }, {
    key: "softDispatch",
    value: function softDispatch(e, t) {
      var i = this.resolveKeyboardEvent(e);
      if (i.isChord()) return console.warn("Unexpected keyboard event mapped to a chord"), null;

      var _i$getDispatchParts = i.getDispatchParts(),
          _i$getDispatchParts2 = _slicedToArray(_i$getDispatchParts, 1),
          o = _i$getDispatchParts2[0];

      if (null === o) return null;

      var n = this._contextKeyService.getContext(t),
          s = this._currentChord ? this._currentChord.keypress : null;

      return this._getResolver().resolve(n, s, o);
    }
  }, {
    key: "_enterChordMode",
    value: function _enterChordMode(e, t) {
      var _this120 = this;

      this._currentChord = {
        keypress: e,
        label: t
      };
      var i = Date.now();

      this._currentChordChecker.cancelAndSet(function () {
        _this120._documentHasFocus() ? Date.now() - i > 5e3 && _this120._leaveChordMode() : _this120._leaveChordMode();
      }, 500);
    }
  }, {
    key: "_leaveChordMode",
    value: function _leaveChordMode() {
      this._currentChordStatusMessage && (this._currentChordStatusMessage.dispose(), this._currentChordStatusMessage = null), this._currentChordChecker.cancel(), this._currentChord = null;
    }
  }, {
    key: "dispatchByUserSettingsLabel",
    value: function dispatchByUserSettingsLabel(e, t) {
      var i = this.resolveUserBinding(e);
      i.length >= 1 && this._doDispatch(i[0], t);
    }
  }, {
    key: "_dispatch",
    value: function _dispatch(e, t) {
      return this._doDispatch(this.resolveKeyboardEvent(e), t);
    }
  }, {
    key: "_doDispatch",
    value: function _doDispatch(e, t) {
      var _this121 = this;

      var i = !1;
      if (e.isChord()) return console.warn("Unexpected keyboard event mapped to a chord"), !1;

      var _e$getDispatchParts = e.getDispatchParts(),
          _e$getDispatchParts2 = _slicedToArray(_e$getDispatchParts, 1),
          o = _e$getDispatchParts2[0];

      if (null === o) return i;

      var n = this._contextKeyService.getContext(t),
          s = this._currentChord ? this._currentChord.keypress : null,
          r = e.getLabel(),
          l = this._getResolver().resolve(n, s, o);

      return l && l.enterChord ? (i = !0, this._enterChordMode(o, r), i) : (this._leaveChordMode(), l && l.commandId && (l.bubble || (i = !0), void 0 === l.commandArgs ? this._commandService.executeCommand(l.commandId).then(void 0, function (e) {
        return _this121._notificationService.warn(e);
      }) : this._commandService.executeCommand(l.commandId, l.commandArgs).then(void 0, function (e) {
        return _this121._notificationService.warn(e);
      }), this._telemetryService.publicLog("workbenchActionExecuted", {
        id: l.commandId,
        from: "keybinding"
      })), i);
    }
  }, {
    key: "mightProducePrintableCharacter",
    value: function mightProducePrintableCharacter(e) {
      return !e.ctrlKey && !e.metaKey && (e.keyCode >= 31 && e.keyCode <= 56 || e.keyCode >= 21 && e.keyCode <= 30);
    }
  }, {
    key: "onDidUpdateKeybindings",
    get: function get() {
      return this._onDidUpdateKeybindings ? this._onDidUpdateKeybindings.event : v.None;
    }
  }]);

  return Yn;
}(f);

var Un =
/*#__PURE__*/
function () {
  function Un(e) {
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : !0;
    var n = arguments.length > 4 ? arguments[4] : undefined;

    _classCallCheck(this, Un);

    this._onDidChange = new b(), this.onDidChange = this._onDidChange.event, this._id = e, this._label = t, this._cssClass = i, this._enabled = o, this._actionCallback = n;
  }

  _createClass(Un, [{
    key: "_setLabel",
    value: function _setLabel(e) {
      this._label !== e && (this._label = e, this._onDidChange.fire({
        label: e
      }));
    }
  }, {
    key: "_setTooltip",
    value: function _setTooltip(e) {
      this._tooltip !== e && (this._tooltip = e, this._onDidChange.fire({
        tooltip: e
      }));
    }
  }, {
    key: "_setClass",
    value: function _setClass(e) {
      this._cssClass !== e && (this._cssClass = e, this._onDidChange.fire({
        class: e
      }));
    }
  }, {
    key: "_setEnabled",
    value: function _setEnabled(e) {
      this._enabled !== e && (this._enabled = e, this._onDidChange.fire({
        enabled: e
      }));
    }
  }, {
    key: "_setChecked",
    value: function _setChecked(e) {
      this._checked !== e && (this._checked = e, this._onDidChange.fire({
        checked: e
      }));
    }
  }, {
    key: "_setRadio",
    value: function _setRadio(e) {
      this._radio !== e && (this._radio = e, this._onDidChange.fire({
        radio: e
      }));
    }
  }, {
    key: "run",
    value: function run(e, t) {
      return this._actionCallback ? this._actionCallback(e) : Promise.resolve(!0);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      this._onDidChange.dispose();
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(e) {
      this._setLabel(e);
    }
  }, {
    key: "tooltip",
    get: function get() {
      return this._tooltip;
    },
    set: function set(e) {
      this._setTooltip(e);
    }
  }, {
    key: "class",
    get: function get() {
      return this._cssClass;
    },
    set: function set(e) {
      this._setClass(e);
    }
  }, {
    key: "enabled",
    get: function get() {
      return this._enabled;
    },
    set: function set(e) {
      this._setEnabled(e);
    }
  }, {
    key: "checked",
    get: function get() {
      return this._checked;
    },
    set: function set(e) {
      this._setChecked(e);
    }
  }, {
    key: "radio",
    get: function get() {
      return this._radio;
    },
    set: function set(e) {
      this._setRadio(e);
    }
  }]);

  return Un;
}();

var Jn =
/*#__PURE__*/
function () {
  function Jn() {
    _classCallCheck(this, Jn);

    this._coreKeybindings = [], this._extensionKeybindings = [], this._cachedMergedKeybindings = null;
  }

  _createClass(Jn, [{
    key: "registerKeybindingRule",
    value: function registerKeybindingRule(e) {
      var t = Jn.bindToCurrentPlatform(e);

      if (t && t.primary) {
        var _i68 = Pe(t.primary, J);

        _i68 && this._registerDefaultKeybinding(_i68, e.id, void 0, e.weight, 0, e.when);
      }

      if (t && Array.isArray(t.secondary)) for (var _i69 = 0, o = t.secondary.length; _i69 < o; _i69++) {
        var _o32 = Pe(t.secondary[_i69], J);

        _o32 && this._registerDefaultKeybinding(_o32, e.id, void 0, e.weight, -_i69 - 1, e.when);
      }
    }
  }, {
    key: "setExtensionKeybindings",
    value: function setExtensionKeybindings(e) {
      var t = [],
          i = 0;

      for (var o = 0, _n31 = e.length; o < _n31; o++) {
        var _n32 = e[o];

        var _s20 = Jn.bindToCurrentPlatform2(_n32);

        _s20 && _s20.primary && (t[i++] = {
          keybinding: _s20.primary,
          command: _n32.id,
          commandArgs: _n32.args,
          when: _n32.when,
          weight1: _n32.weight,
          weight2: 0
        });
      }

      this._extensionKeybindings = t, this._cachedMergedKeybindings = null;
    }
  }, {
    key: "registerCommandAndKeybindingRule",
    value: function registerCommandAndKeybindingRule(e) {
      this.registerKeybindingRule(e), gn.registerCommand(e);
    }
  }, {
    key: "_assertNoCtrlAlt",
    value: function _assertNoCtrlAlt(e, t) {
      e.ctrlKey && e.altKey && !e.metaKey && Jn._mightProduceChar(e.keyCode) && console.warn("Ctrl+Alt+ keybindings should not be used by default under Windows. Offender: ", e, " for ", t);
    }
  }, {
    key: "_registerDefaultKeybinding",
    value: function _registerDefaultKeybinding(e, t, i, o, n, s) {
      1 === J && this._assertNoCtrlAlt(e.parts[0], t), this._coreKeybindings.push({
        keybinding: e,
        command: t,
        commandArgs: i,
        when: s,
        weight1: o,
        weight2: n
      }), this._cachedMergedKeybindings = null;
    }
  }, {
    key: "getDefaultKeybindings",
    value: function getDefaultKeybindings() {
      return this._cachedMergedKeybindings || (this._cachedMergedKeybindings = [].concat(this._coreKeybindings).concat(this._extensionKeybindings), this._cachedMergedKeybindings.sort(Gn)), this._cachedMergedKeybindings.slice(0);
    }
  }], [{
    key: "bindToCurrentPlatform",
    value: function bindToCurrentPlatform(e) {
      if (1 === J) {
        if (e && e.win) return e.win;
      } else if (2 === J) {
        if (e && e.mac) return e.mac;
      } else if (e && e.linux) return e.linux;

      return e;
    }
  }, {
    key: "bindToCurrentPlatform2",
    value: function bindToCurrentPlatform2(e) {
      if (1 === J) {
        if (e && e.win) return e.win;
      } else if (2 === J) {
        if (e && e.mac) return e.mac;
      } else if (e && e.linux) return e.linux;

      return e;
    }
  }, {
    key: "_mightProduceChar",
    value: function _mightProduceChar(e) {
      return e >= 21 && e <= 30 || e >= 31 && e <= 56 || 80 === e || 81 === e || 82 === e || 83 === e || 84 === e || 85 === e || 86 === e || 110 === e || 111 === e || 87 === e || 88 === e || 89 === e || 90 === e || 91 === e || 92 === e;
    }
  }]);

  return Jn;
}();

var jn = new Jn();

function Gn(e, t) {
  return e.weight1 !== t.weight1 ? e.weight1 - t.weight1 : e.command < t.command ? -1 : e.command > t.command ? 1 : e.weight2 - t.weight2;
}

function On(e) {
  return void 0 !== e.command;
}

var Kn = n("menuService"),
    Wn = new (
/*#__PURE__*/
function () {
  function _class11() {
    _classCallCheck(this, _class11);

    this._commands = Object.create(null), this._menuItems = Object.create(null), this._onDidChangeMenu = new b(), this.onDidChangeMenu = this._onDidChangeMenu.event;
  }

  _createClass(_class11, [{
    key: "addCommand",
    value: function addCommand(e) {
      var _this122 = this;

      return this._commands[e.id] = e, this._onDidChangeMenu.fire(0), {
        dispose: function dispose() {
          delete _this122._commands[e.id] && _this122._onDidChangeMenu.fire(0);
        }
      };
    }
  }, {
    key: "getCommand",
    value: function getCommand(e) {
      return this._commands[e];
    }
  }, {
    key: "getCommands",
    value: function getCommands() {
      var e = Object.create(null);

      for (var _t71 in this._commands) {
        e[_t71] = this.getCommand(_t71);
      }

      return e;
    }
  }, {
    key: "appendMenuItem",
    value: function appendMenuItem(e, t) {
      var _this123 = this;

      var i = this._menuItems[e];
      return i ? i.push(t) : this._menuItems[e] = i = [t], this._onDidChangeMenu.fire(e), {
        dispose: function dispose() {
          var o = i.indexOf(t);
          o >= 0 && (i.splice(o, 1), _this123._onDidChangeMenu.fire(e));
        }
      };
    }
  }, {
    key: "getMenuItems",
    value: function getMenuItems(e) {
      var t = (this._menuItems[e] || []).slice(0);
      return 0 === e && this._appendImplicitItems(t), t;
    }
  }, {
    key: "_appendImplicitItems",
    value: function _appendImplicitItems(e) {
      var t = new Set(),
          i = e.filter(function (e) {
        return On(e);
      });
      var _iteratorNormalCompletion51 = true;
      var _didIteratorError51 = false;
      var _iteratorError51 = undefined;

      try {
        for (var _iterator51 = i[Symbol.iterator](), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
          var _ref19 = _step51.value;
          var _e93 = _ref19.command;
          var o = _ref19.alt;
          t.add(_e93.id), o && t.add(o.id);
        }
      } catch (err) {
        _didIteratorError51 = true;
        _iteratorError51 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion51 && _iterator51.return != null) {
            _iterator51.return();
          }
        } finally {
          if (_didIteratorError51) {
            throw _iteratorError51;
          }
        }
      }

      for (var _i70 in this._commands) {
        t.has(_i70) || e.push({
          command: this._commands[_i70]
        });
      }
    }
  }]);

  return _class11;
}())();

var Xn =
/*#__PURE__*/
function (_Un) {
  _inherits(Xn, _Un);

  function Xn(e, t, i) {
    var _this124;

    _classCallCheck(this, Xn);

    _this124 = _possibleConstructorReturn(this, _getPrototypeOf(Xn).call(this, e, t)), _this124._commandService = i;
    return _this124;
  }

  _createClass(Xn, [{
    key: "run",
    value: function run() {
      var _this$_commandService;

      for (var _len17 = arguments.length, e = new Array(_len17), _key17 = 0; _key17 < _len17; _key17++) {
        e[_key17] = arguments[_key17];
      }

      return (_this$_commandService = this._commandService).executeCommand.apply(_this$_commandService, [this.id].concat(e));
    }
  }]);

  return Xn;
}(Un);

Xn = r([l(2, un)], Xn);

var Zn =
/*#__PURE__*/
function (_Un2) {
  _inherits(Zn, _Un2);

  function Zn(e) {
    var _this125;

    _classCallCheck(this, Zn);

    "string" == typeof e.title ? _this125 = _possibleConstructorReturn(this, _getPrototypeOf(Zn).call(this, "", e.title, "submenu")) : _this125 = _possibleConstructorReturn(this, _getPrototypeOf(Zn).call(this, "", e.title.value, "submenu")), _this125.item = e;
    return _possibleConstructorReturn(_this125);
  }

  return Zn;
}(Un);

var qn =
/*#__PURE__*/
function (_Xn) {
  _inherits(e, _Xn);

  function e(t, i, o, n, s) {
    var _this126;

    _classCallCheck(this, e);

    "string" == typeof t.title ? _this126 = _possibleConstructorReturn(this, _getPrototypeOf(e).call(this, t.id, t.title, s)) : _this126 = _possibleConstructorReturn(this, _getPrototypeOf(e).call(this, t.id, t.title.value, s)), _this126._cssClass = void 0, _this126._enabled = !t.precondition || n.contextMatchesRules(t.precondition), _this126._checked = Boolean(t.toggled && n.contextMatchesRules(t.toggled)), _this126._options = o || {}, _this126.item = t, _this126.alt = i ? new e(i, void 0, _this126._options, n, s) : void 0;
    return _possibleConstructorReturn(_this126);
  }

  _createClass(e, [{
    key: "run",
    value: function run() {
      var _get2;

      var t = [];

      for (var _len18 = arguments.length, e = new Array(_len18), _key18 = 0; _key18 < _len18; _key18++) {
        e[_key18] = arguments[_key18];
      }

      return this._options.arg && (t = [].concat(_toConsumableArray(t), [this._options.arg])), this._options.shouldForwardArgs && (t = [].concat(_toConsumableArray(t), e)), (_get2 = _get(_getPrototypeOf(e.prototype), "run", this)).call.apply(_get2, [this].concat(_toConsumableArray(t)));
    }
  }]);

  return e;
}(Xn);

function $n(e) {
  var t = e.id,
      i = e.handler,
      o = e.title,
      n = e.category,
      s = e.menu,
      r = e.keybinding,
      l = e.precondition,
      a = [];

  if (a.push(gn.registerCommand(t, i)), s && o) {
    var _e94 = {
      id: t,
      title: o,
      category: n,
      precondition: l
    },
        _i71 = s.menuId,
        _r11 = s.when,
        _A = s.group;
    a.push(Wn.appendMenuItem(_i71, {
      command: _e94,
      when: _r11,
      group: _A
    }));
  }

  if (r) {
    var _e95 = r.when,
        _i72 = r.weight,
        _o33 = r.keys;
    jn.registerKeybindingRule({
      id: t,
      when: _e95,
      weight: _i72 || 0,
      primary: _o33.primary,
      secondary: _o33.secondary,
      linux: _o33.linux,
      mac: _o33.mac,
      win: _o33.win
    });
  }

  return {
    dispose: function dispose() {
      C(a);
    }
  };
}

qn = r([l(3, ln), l(4, un)], qn);

var es =
/*#__PURE__*/
function () {
  function es(e, t) {
    _classCallCheck(this, es);

    this._defaultKeybindings = e, this._defaultBoundCommands = new Map();

    for (var _t72 = 0, _i73 = e.length; _t72 < _i73; _t72++) {
      var _i74 = e[_t72].command;
      _i74 && this._defaultBoundCommands.set(_i74, !0);
    }

    this._map = new Map(), this._lookupMap = new Map(), this._keybindings = es.combine(e, t);

    for (var _e96 = 0, _t73 = this._keybindings.length; _e96 < _t73; _e96++) {
      var _t74 = this._keybindings[_e96];
      0 !== _t74.keypressParts.length && this._addKeyPress(_t74.keypressParts[0], _t74);
    }
  }

  _createClass(es, [{
    key: "_addKeyPress",
    value: function _addKeyPress(e, t) {
      var i = this._map.get(e);

      if (void 0 === i) return this._map.set(e, [t]), void this._addToLookupMap(t);

      for (var _e97 = i.length - 1; _e97 >= 0; _e97--) {
        var o = i[_e97];
        if (o.command === t.command) continue;

        var _n33 = o.keypressParts.length > 1,
            _s21 = t.keypressParts.length > 1;

        _n33 && _s21 && o.keypressParts[1] !== t.keypressParts[1] || es.whenIsEntirelyIncluded(o.when, t.when) && this._removeFromLookupMap(o);
      }

      i.push(t), this._addToLookupMap(t);
    }
  }, {
    key: "_addToLookupMap",
    value: function _addToLookupMap(e) {
      if (!e.command) return;

      var t = this._lookupMap.get(e.command);

      void 0 === t ? (t = [e], this._lookupMap.set(e.command, t)) : t.push(e);
    }
  }, {
    key: "_removeFromLookupMap",
    value: function _removeFromLookupMap(e) {
      if (!e.command) return;

      var t = this._lookupMap.get(e.command);

      if (void 0 !== t) for (var _i75 = 0, o = t.length; _i75 < o; _i75++) {
        if (t[_i75] === e) return void t.splice(_i75, 1);
      }
    }
  }, {
    key: "getDefaultBoundCommands",
    value: function getDefaultBoundCommands() {
      return this._defaultBoundCommands;
    }
  }, {
    key: "getDefaultKeybindings",
    value: function getDefaultKeybindings() {
      return this._defaultKeybindings;
    }
  }, {
    key: "getKeybindings",
    value: function getKeybindings() {
      return this._keybindings;
    }
  }, {
    key: "lookupKeybindings",
    value: function lookupKeybindings(e) {
      var t = this._lookupMap.get(e);

      if (void 0 === t || 0 === t.length) return [];
      var i = [],
          o = 0;

      for (var _e98 = t.length - 1; _e98 >= 0; _e98--) {
        i[o++] = t[_e98];
      }

      return i;
    }
  }, {
    key: "lookupPrimaryKeybinding",
    value: function lookupPrimaryKeybinding(e) {
      var t = this._lookupMap.get(e);

      return void 0 === t || 0 === t.length ? null : t[t.length - 1];
    }
  }, {
    key: "resolve",
    value: function resolve(e, t, i) {
      var o = null;

      if (null !== t) {
        var _e99 = this._map.get(t);

        if (void 0 === _e99) return null;
        o = [];

        for (var _t75 = 0, _n34 = _e99.length; _t75 < _n34; _t75++) {
          var _n35 = _e99[_t75];
          _n35.keypressParts[1] === i && o.push(_n35);
        }
      } else {
        var _e100 = this._map.get(i);

        if (void 0 === _e100) return null;
        o = _e100;
      }

      var n = this._findCommand(e, o);

      return n ? null === t && n.keypressParts.length > 1 && null !== n.keypressParts[1] ? {
        enterChord: !0,
        commandId: null,
        commandArgs: null,
        bubble: !1
      } : {
        enterChord: !1,
        commandId: n.command,
        commandArgs: n.commandArgs,
        bubble: n.bubble
      } : null;
    }
  }, {
    key: "_findCommand",
    value: function _findCommand(e, t) {
      for (var _i76 = t.length - 1; _i76 >= 0; _i76--) {
        var o = t[_i76];
        if (es.contextMatchesRules(e, o.when)) return o;
      }

      return null;
    }
  }], [{
    key: "_isTargetedForRemoval",
    value: function _isTargetedForRemoval(e, t, i, o, n) {
      if (e.command !== o) return !1;
      if (t && e.keypressParts[0] !== t) return !1;
      if (i && e.keypressParts[1] !== i) return !1;

      if (n) {
        if (!e.when) return !1;
        if (!n.equals(e.when)) return !1;
      }

      return !0;
    }
  }, {
    key: "combine",
    value: function combine(e, t) {
      e = e.slice(0);
      var i = [];
      var _iteratorNormalCompletion52 = true;
      var _didIteratorError52 = false;
      var _iteratorError52 = undefined;

      try {
        for (var _iterator52 = t[Symbol.iterator](), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
          var o = _step52.value;

          if (!o.command || 0 === o.command.length || "-" !== o.command.charAt(0)) {
            i.push(o);
            continue;
          }

          var _t76 = o.command.substr(1),
              _n36 = o.keypressParts[0],
              _s22 = o.keypressParts[1],
              _r12 = o.when;

          for (var _i77 = e.length - 1; _i77 >= 0; _i77--) {
            this._isTargetedForRemoval(e[_i77], _n36, _s22, _t76, _r12) && e.splice(_i77, 1);
          }
        }
      } catch (err) {
        _didIteratorError52 = true;
        _iteratorError52 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion52 && _iterator52.return != null) {
            _iterator52.return();
          }
        } finally {
          if (_didIteratorError52) {
            throw _iteratorError52;
          }
        }
      }

      return e.concat(i);
    }
  }, {
    key: "whenIsEntirelyIncluded",
    value: function whenIsEntirelyIncluded(e, t) {
      if (!t) return !0;
      if (!e) return !1;
      var i = e instanceof sn ? e.expr : [e],
          o = t instanceof sn ? t.expr : [t];
      var n = 0;
      var _iteratorNormalCompletion53 = true;
      var _didIteratorError53 = false;
      var _iteratorError53 = undefined;

      try {
        for (var _iterator53 = o[Symbol.iterator](), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
          var _e101 = _step53.value;

          var _t77 = !1;

          for (; !_t77 && n < i.length;) {
            i[n].equals(_e101) && (_t77 = !0), n++;
          }

          if (!_t77) return !1;
        }
      } catch (err) {
        _didIteratorError53 = true;
        _iteratorError53 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion53 && _iterator53.return != null) {
            _iterator53.return();
          }
        } finally {
          if (_didIteratorError53) {
            throw _iteratorError53;
          }
        }
      }

      return !0;
    }
  }, {
    key: "contextMatchesRules",
    value: function contextMatchesRules(e, t) {
      return !t || t.evaluate(e);
    }
  }, {
    key: "getAllUnboundCommands",
    value: function getAllUnboundCommands(e) {
      var t = [],
          i = new Map(),
          o = function o(_o34) {
        if (i.has(_o34)) return;
        if (i.set(_o34, !0), "_" === _o34[0] || 0 === _o34.indexOf("vscode.")) return;
        if (!0 === e.get(_o34)) return;
        var n = gn.getCommand(_o34);
        n && "object" == typeof n.description && function (e) {
          return Array.isArray(e) && e.length > 0;
        }(n.description.args) || t.push(_o34);
      };

      for (var _e102 in Wn.getCommands()) {
        o(_e102);
      }

      for (var _e103 in gn.getCommands()) {
        o(_e103);
      }

      return t;
    }
  }]);

  return es;
}();

var ts =
/*#__PURE__*/
function () {
  function ts(e, t) {
    var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : t;

    _classCallCheck(this, ts);

    this.modifierLabels = [null], this.modifierLabels[2] = e, this.modifierLabels[1] = t, this.modifierLabels[3] = i;
  }

  _createClass(ts, [{
    key: "toLabel",
    value: function toLabel(e, t, i) {
      if (0 === t.length) return null;
      var o = [];

      for (var _n37 = 0, _s23 = t.length; _n37 < _s23; _n37++) {
        var _s24 = t[_n37],
            _r13 = i(_s24);

        if (null === _r13) return null;
        o[_n37] = rs(_s24, _r13, this.modifierLabels[e]);
      }

      return o.join(" ");
    }
  }]);

  return ts;
}();

var is = new ts({
  ctrlKey: "⌃",
  shiftKey: "⇧",
  altKey: "⌥",
  metaKey: "⌘",
  separator: ""
}, {
  ctrlKey: hn(0, "Ctrl"),
  shiftKey: hn(0, "Shift"),
  altKey: hn(0, "Alt"),
  metaKey: hn(0, "Windows"),
  separator: "+"
}, {
  ctrlKey: hn(0, "Ctrl"),
  shiftKey: hn(0, "Shift"),
  altKey: hn(0, "Alt"),
  metaKey: hn(0, "Super"),
  separator: "+"
}),
    os = new ts({
  ctrlKey: hn(0, "Control"),
  shiftKey: hn(0, "Shift"),
  altKey: hn(0, "Alt"),
  metaKey: hn(0, "Command"),
  separator: "+"
}, {
  ctrlKey: hn(0, "Control"),
  shiftKey: hn(0, "Shift"),
  altKey: hn(0, "Alt"),
  metaKey: hn(0, "Windows"),
  separator: "+"
}, {
  ctrlKey: hn(0, "Control"),
  shiftKey: hn(0, "Shift"),
  altKey: hn(0, "Alt"),
  metaKey: hn(0, "Super"),
  separator: "+"
}),
    ns = new ts({
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Cmd",
  separator: "+"
}, {
  ctrlKey: "Ctrl",
  shiftKey: "Shift",
  altKey: "Alt",
  metaKey: "Super",
  separator: "+"
}),
    ss = new ts({
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "cmd",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "win",
  separator: "+"
}, {
  ctrlKey: "ctrl",
  shiftKey: "shift",
  altKey: "alt",
  metaKey: "meta",
  separator: "+"
});

function rs(e, t, i) {
  if (null === t) return "";
  var o = [];
  return e.ctrlKey && o.push(i.ctrlKey), e.shiftKey && o.push(i.shiftKey), e.altKey && o.push(i.altKey), e.metaKey && o.push(i.metaKey), o.push(t), o.join(i.separator);
}

var ls = function ls(e, t, i, o, n) {
  _classCallCheck(this, ls);

  this.resolvedKeybinding = e, this.keypressParts = e ? function (e) {
    var t = [];

    for (var _i78 = 0, _o35 = e.length; _i78 < _o35; _i78++) {
      var _o36 = e[_i78];
      if (!_o36) return t;
      t.push(_o36);
    }

    return t;
  }(e.getDispatchParts()) : [], this.bubble = !!t && 94 === t.charCodeAt(0), this.command = this.bubble ? t.substr(1) : t, this.commandArgs = i, this.when = o, this.isDefault = n;
};

var as =
/*#__PURE__*/
function (_Ye) {
  _inherits(as, _Ye);

  function as(e, t) {
    var _this127;

    _classCallCheck(this, as);

    if (_this127 = _possibleConstructorReturn(this, _getPrototypeOf(as).call(this)), 0 === t.length) throw g("parts");
    _this127._os = e, _this127._parts = t;
    return _possibleConstructorReturn(_this127);
  }

  _createClass(as, [{
    key: "getLabel",
    value: function getLabel() {
      var _this128 = this;

      return is.toLabel(this._os, this._parts, function (e) {
        return _this128._getLabel(e);
      });
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel() {
      var _this129 = this;

      return os.toLabel(this._os, this._parts, function (e) {
        return _this129._getAriaLabel(e);
      });
    }
  }, {
    key: "getElectronAccelerator",
    value: function getElectronAccelerator() {
      var _this130 = this;

      return this._parts.length > 1 ? null : ns.toLabel(this._os, this._parts, function (e) {
        return _this130._getElectronAccelerator(e);
      });
    }
  }, {
    key: "getUserSettingsLabel",
    value: function getUserSettingsLabel() {
      var _this131 = this;

      return ss.toLabel(this._os, this._parts, function (e) {
        return _this131._getUserSettingsLabel(e);
      });
    }
  }, {
    key: "isWYSIWYG",
    value: function isWYSIWYG() {
      var _this132 = this;

      return this._parts.every(function (e) {
        return _this132._isWYSIWYG(e);
      });
    }
  }, {
    key: "isChord",
    value: function isChord() {
      return this._parts.length > 1;
    }
  }, {
    key: "getParts",
    value: function getParts() {
      var _this133 = this;

      return this._parts.map(function (e) {
        return _this133._getPart(e);
      });
    }
  }, {
    key: "_getPart",
    value: function _getPart(e) {
      return new ke(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, this._getLabel(e), this._getAriaLabel(e));
    }
  }, {
    key: "getDispatchParts",
    value: function getDispatchParts() {
      var _this134 = this;

      return this._parts.map(function (e) {
        return _this134._getDispatchPart(e);
      });
    }
  }]);

  return as;
}(Ye);

var As =
/*#__PURE__*/
function (_as) {
  _inherits(As, _as);

  function As(e, t) {
    _classCallCheck(this, As);

    return _possibleConstructorReturn(this, _getPrototypeOf(As).call(this, t, e.parts));
  }

  _createClass(As, [{
    key: "_keyCodeToUILabel",
    value: function _keyCodeToUILabel(e) {
      if (2 === this._os) switch (e) {
        case 15:
          return "←";

        case 16:
          return "↑";

        case 17:
          return "→";

        case 18:
          return "↓";
      }
      return Le.toString(e);
    }
  }, {
    key: "_getLabel",
    value: function _getLabel(e) {
      return e.isDuplicateModifierCase() ? "" : this._keyCodeToUILabel(e.keyCode);
    }
  }, {
    key: "_getAriaLabel",
    value: function _getAriaLabel(e) {
      return e.isDuplicateModifierCase() ? "" : Le.toString(e.keyCode);
    }
  }, {
    key: "_keyCodeToElectronAccelerator",
    value: function _keyCodeToElectronAccelerator(e) {
      if (e >= 93 && e <= 108) return null;

      switch (e) {
        case 16:
          return "Up";

        case 18:
          return "Down";

        case 15:
          return "Left";

        case 17:
          return "Right";
      }

      return Le.toString(e);
    }
  }, {
    key: "_getElectronAccelerator",
    value: function _getElectronAccelerator(e) {
      return e.isDuplicateModifierCase() ? null : this._keyCodeToElectronAccelerator(e.keyCode);
    }
  }, {
    key: "_getUserSettingsLabel",
    value: function _getUserSettingsLabel(e) {
      if (e.isDuplicateModifierCase()) return "";
      var t = Le.toUserSettingsUS(e.keyCode);
      return t ? t.toLowerCase() : t;
    }
  }, {
    key: "_isWYSIWYG",
    value: function _isWYSIWYG() {
      return !0;
    }
  }, {
    key: "_getDispatchPart",
    value: function _getDispatchPart(e) {
      return As.getDispatchStr(e);
    }
  }], [{
    key: "getDispatchStr",
    value: function getDispatchStr(e) {
      if (e.isModifierKey()) return null;
      var t = "";
      return e.ctrlKey && (t += "ctrl+"), e.shiftKey && (t += "shift+"), e.altKey && (t += "alt+"), e.metaKey && (t += "meta+"), t += Le.toString(e.keyCode);
    }
  }]);

  return As;
}(as);

var hs = n("notificationService");

var cs =
/*#__PURE__*/
function () {
  function cs() {
    _classCallCheck(this, cs);
  }

  _createClass(cs, [{
    key: "infinite",
    value: function infinite() {}
  }, {
    key: "done",
    value: function done() {}
  }, {
    key: "total",
    value: function total(e) {}
  }, {
    key: "worked",
    value: function worked(e) {}
  }]);

  return cs;
}();

var ds = n("telemetryService");

var us =
/*#__PURE__*/
function () {
  function us() {
    _classCallCheck(this, us);
  }

  _createClass(us, [{
    key: "confirm",
    value: function confirm(e) {
      return this.doConfirm(e).then(function (e) {
        return {
          confirmed: e,
          checkboxChecked: !1
        };
      });
    }
  }, {
    key: "doConfirm",
    value: function doConfirm(e) {
      var t = e.message;
      return e.detail && (t = t + "\n\n" + e.detail), Promise.resolve(window.confirm(t));
    }
  }, {
    key: "show",
    value: function show(e, t, i, o) {
      return Promise.resolve(0);
    }
  }]);

  return us;
}();

var gs =
/*#__PURE__*/
function () {
  function gs() {
    _classCallCheck(this, gs);
  }

  _createClass(gs, [{
    key: "info",
    value: function info(e) {
      return this.notify({
        severity: dn.Info,
        message: e
      });
    }
  }, {
    key: "warn",
    value: function warn(e) {
      return this.notify({
        severity: dn.Warning,
        message: e
      });
    }
  }, {
    key: "error",
    value: function error(e) {
      return this.notify({
        severity: dn.Error,
        message: e
      });
    }
  }, {
    key: "notify",
    value: function notify(e) {
      switch (e.severity) {
        case dn.Error:
          console.error(e.message);
          break;

        case dn.Warning:
          console.warn(e.message);
          break;

        default:
          console.log(e.message);
      }

      return gs.NO_OP;
    }
  }, {
    key: "prompt",
    value: function prompt(e, t, i, o) {
      return gs.NO_OP;
    }
  }]);

  return gs;
}();

gs.NO_OP = new (
/*#__PURE__*/
function () {
  function _class12() {
    _classCallCheck(this, _class12);

    this.progress = new cs(), this._onDidClose = new b();
  }

  _createClass(_class12, [{
    key: "updateSeverity",
    value: function updateSeverity(e) {}
  }, {
    key: "updateMessage",
    value: function updateMessage(e) {}
  }, {
    key: "updateActions",
    value: function updateActions(e) {}
  }, {
    key: "close",
    value: function close() {
      this._onDidClose.dispose();
    }
  }, {
    key: "onDidClose",
    get: function get() {
      return this._onDidClose.event;
    }
  }]);

  return _class12;
}())();

var Cs =
/*#__PURE__*/
function () {
  function Cs(e) {
    _classCallCheck(this, Cs);

    this._onWillExecuteCommand = new b(), this.onWillExecuteCommand = this._onWillExecuteCommand.event, this._instantiationService = e, this._dynamicCommands = Object.create(null);
  }

  _createClass(Cs, [{
    key: "addCommand",
    value: function addCommand(e) {
      var _this135 = this;

      var t = e.id;
      return this._dynamicCommands[t] = e, m(function () {
        delete _this135._dynamicCommands[t];
      });
    }
  }, {
    key: "executeCommand",
    value: function executeCommand(e) {
      var i = gn.getCommand(e) || this._dynamicCommands[e];

      if (!i) return Promise.reject(new Error("command '".concat(e, "' not found")));

      try {
        this._onWillExecuteCommand.fire({
          commandId: e
        });

        for (var _len19 = arguments.length, t = new Array(_len19 > 1 ? _len19 - 1 : 0), _key19 = 1; _key19 < _len19; _key19++) {
          t[_key19 - 1] = arguments[_key19];
        }

        var o = this._instantiationService.invokeFunction.apply(this._instantiationService, [i.handler].concat(t));

        return Promise.resolve(o);
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);

  return Cs;
}();

var ps =
/*#__PURE__*/
function (_Yn) {
  _inherits(ps, _Yn);

  function ps(e, t, i, o, n) {
    var _this136;

    _classCallCheck(this, ps);

    _this136 = _possibleConstructorReturn(this, _getPrototypeOf(ps).call(this, t, i, o, n)), _this136._cachedResolver = null, _this136._dynamicKeybindings = [], _this136._register(bt(e, Tt.KEY_DOWN, function (e) {
      var t = new We(e);
      _this136._dispatch(t, t.target) && t.preventDefault();
    }));
    return _this136;
  }

  _createClass(ps, [{
    key: "addDynamicKeybinding",
    value: function addDynamicKeybinding(e, t, i, o) {
      var _this137 = this;

      var n = Pe(t, J);
      if (!n) throw new Error("Invalid keybinding");
      var s = [];
      this._dynamicKeybindings.push({
        keybinding: n,
        command: e,
        when: o,
        weight1: 1e3,
        weight2: 0
      }), s.push(m(function () {
        for (var _t78 = 0; _t78 < _this137._dynamicKeybindings.length; _t78++) {
          if (_this137._dynamicKeybindings[_t78].command === e) return _this137._dynamicKeybindings.splice(_t78, 1), void _this137.updateResolver({
            source: 1
          });
        }
      }));
      var r = this._commandService;
      if (!(r instanceof Cs)) throw new Error("Unknown command service!");
      return s.push(r.addCommand({
        id: e,
        handler: i
      })), this.updateResolver({
        source: 1
      }), p(s);
    }
  }, {
    key: "updateResolver",
    value: function updateResolver(e) {
      this._cachedResolver = null, this._onDidUpdateKeybindings.fire(e);
    }
  }, {
    key: "_getResolver",
    value: function _getResolver() {
      if (!this._cachedResolver) {
        var _e104 = this._toNormalizedKeybindingItems(jn.getDefaultKeybindings(), !0),
            _t79 = this._toNormalizedKeybindingItems(this._dynamicKeybindings, !1);

        this._cachedResolver = new es(_e104, _t79);
      }

      return this._cachedResolver;
    }
  }, {
    key: "_documentHasFocus",
    value: function _documentHasFocus() {
      return document.hasFocus();
    }
  }, {
    key: "_toNormalizedKeybindingItems",
    value: function _toNormalizedKeybindingItems(e, t) {
      var i = [],
          o = 0;
      var _iteratorNormalCompletion54 = true;
      var _didIteratorError54 = false;
      var _iteratorError54 = undefined;

      try {
        for (var _iterator54 = e[Symbol.iterator](), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
          var _n38 = _step54.value;

          var _e105 = _n38.when ? _n38.when.normalize() : null,
              _s25 = _n38.keybinding;

          if (_s25) {
            var _r14 = this.resolveKeybinding(_s25);

            var _iteratorNormalCompletion55 = true;
            var _didIteratorError55 = false;
            var _iteratorError55 = undefined;

            try {
              for (var _iterator55 = _r14[Symbol.iterator](), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
                var _s26 = _step55.value;
                i[o++] = new ls(_s26, _n38.command, _n38.commandArgs, _e105, t);
              }
            } catch (err) {
              _didIteratorError55 = true;
              _iteratorError55 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion55 && _iterator55.return != null) {
                  _iterator55.return();
                }
              } finally {
                if (_didIteratorError55) {
                  throw _iteratorError55;
                }
              }
            }
          } else i[o++] = new ls(null, _n38.command, _n38.commandArgs, _e105, t);
        }
      } catch (err) {
        _didIteratorError54 = true;
        _iteratorError54 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion54 && _iterator54.return != null) {
            _iterator54.return();
          }
        } finally {
          if (_didIteratorError54) {
            throw _iteratorError54;
          }
        }
      }

      return i;
    }
  }, {
    key: "resolveKeybinding",
    value: function resolveKeybinding(e) {
      return [new As(e, J)];
    }
  }, {
    key: "resolveKeyboardEvent",
    value: function resolveKeyboardEvent(e) {
      var t = new Re(e.ctrlKey, e.shiftKey, e.altKey, e.metaKey, e.keyCode).toChord();
      return new As(t, J);
    }
  }, {
    key: "resolveUserBinding",
    value: function resolveUserBinding(e) {
      return [];
    }
  }, {
    key: "_dumpDebugInfo",
    value: function _dumpDebugInfo() {
      return "";
    }
  }]);

  return ps;
}(Yn);

function ms(e) {
  return e && "object" == typeof e && (!e.overrideIdentifier || "string" == typeof e.overrideIdentifier) && (!e.resource || e.resource instanceof q);
}

ps = r([l(1, ln), l(2, un), l(3, ds), l(4, hs)], ps);

var fs =
/*#__PURE__*/
function () {
  function fs() {
    _classCallCheck(this, fs);

    this.isOptedIn = !1;
  }

  _createClass(fs, [{
    key: "publicLog",
    value: function publicLog(e, t) {
      return Promise.resolve(void 0);
    }
  }, {
    key: "getTelemetryInfo",
    value: function getTelemetryInfo() {
      throw new Error("Not available");
    }
  }]);

  return fs;
}();

var Ds =
/*#__PURE__*/
function () {
  function Ds() {
    _classCallCheck(this, Ds);

    this._onDidChangeConfiguration = new b(), this.onDidChangeConfiguration = this._onDidChangeConfiguration.event, this._configuration = new kn(new Tn(), new Rn());
  }

  _createClass(Ds, [{
    key: "configuration",
    value: function configuration() {
      return this._configuration;
    }
  }, {
    key: "getValue",
    value: function getValue(e, t) {
      var i = "string" == typeof e ? e : void 0,
          o = ms(e) ? e : ms(t) ? t : {};
      return this.configuration().getValue(i, o);
    }
  }, {
    key: "updateValue",
    value: function updateValue(e, t, i, o) {
      return this.configuration().updateValue(e, t), Promise.resolve();
    }
  }, {
    key: "inspect",
    value: function inspect(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.configuration().inspect(e, t);
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.configuration().keys(void 0);
    }
  }, {
    key: "reloadConfiguration",
    value: function reloadConfiguration() {
      return Promise.resolve(void 0);
    }
  }, {
    key: "getConfigurationData",
    value: function getConfigurationData() {
      return null;
    }
  }]);

  return Ds;
}();

var ws = 65,
    vs = 97,
    Es = 90,
    ys = 122,
    Ms = 46,
    Bs = 47,
    bs = 92;

var Fs =
/*#__PURE__*/
function (_Error) {
  _inherits(Fs, _Error);

  function Fs(e, t, i) {
    var _this138;

    _classCallCheck(this, Fs);

    var o, n;
    "string" == typeof t && 0 === t.indexOf("not ") ? (o = "must not be", t = t.replace(/^not /, "")) : o = "must be";
    var s = -1 !== e.indexOf(".") ? "property" : "argument";
    n = "The \"".concat(e, "\" ").concat(s, " ").concat(o, " of type ").concat(t), _this138 = _possibleConstructorReturn(this, _getPrototypeOf(Fs).call(this, n += ". Received type ".concat(typeof i)));
    return _this138;
  }

  return Fs;
}(_wrapNativeSuper(Error));

function Hs(e, t) {
  if ("string" != typeof e) throw new Fs(t, "string", e);
}

function Ss(e) {
  return e === Bs || e === bs;
}

function zs(e) {
  return e === Bs;
}

function xs(e) {
  return e >= ws && e <= Es || e >= vs && e <= ys;
}

function Vs(e, t, i, o) {
  var n,
      s = "",
      r = 0,
      l = -1,
      a = 0;

  for (var _A2 = 0; _A2 <= e.length; ++_A2) {
    if (_A2 < e.length) n = e.charCodeAt(_A2);else {
      if (o(n)) break;
      n = Bs;
    }

    if (o(n)) {
      if (l === _A2 - 1 || 1 === a) ;else if (l !== _A2 - 1 && 2 === a) {
        if (s.length < 2 || 2 !== r || s.charCodeAt(s.length - 1) !== Ms || s.charCodeAt(s.length - 2) !== Ms) {
          if (s.length > 2) {
            var _e106 = s.lastIndexOf(i);

            -1 === _e106 ? (s = "", r = 0) : r = (s = s.slice(0, _e106)).length - 1 - s.lastIndexOf(i), l = _A2, a = 0;
            continue;
          }

          if (2 === s.length || 1 === s.length) {
            s = "", r = 0, l = _A2, a = 0;
            continue;
          }
        }

        t && (s.length > 0 ? s += "".concat(i, "..") : s = "..", r = 2);
      } else s.length > 0 ? s += i + e.slice(l + 1, _A2) : s = e.slice(l + 1, _A2), r = _A2 - l - 1;
      l = _A2, a = 0;
    } else n === Ms && -1 !== a ? ++a : a = -1;
  }

  return s;
}

function Is(e, t) {
  var i = t.dir || t.root,
      o = t.base || (t.name || "") + (t.ext || "");
  return i ? i === t.root ? i + o : i + e + o : o;
}

var _s = {
  resolve: function resolve() {
    var t = "",
        i = "",
        o = !1;

    for (var _n39 = arguments.length - 1; _n39 >= -1; _n39--) {
      var _s27 = void 0;

      if (_n39 >= 0 ? _s27 = _n39 < 0 || arguments.length <= _n39 ? undefined : arguments[_n39] : t ? void 0 !== (_s27 = process.env["=" + t] || process.cwd()) && _s27.slice(0, 3).toLowerCase() === t.toLowerCase() + "\\" || (_s27 = t + "\\") : _s27 = process.cwd(), Hs(_s27, "path"), 0 === _s27.length) continue;

      var _r15 = _s27.length,
          _l5 = 0,
          _a = "",
          _A3 = !1;

      var _h = _s27.charCodeAt(0);

      if (_r15 > 1) {
        if (Ss(_h)) {
          if (_A3 = !0, Ss(_s27.charCodeAt(1))) {
            var _e107 = 2,
                _t80 = _e107;

            for (; _e107 < _r15 && !Ss(_s27.charCodeAt(_e107)); ++_e107) {
              ;
            }

            if (_e107 < _r15 && _e107 !== _t80) {
              var _i79 = _s27.slice(_t80, _e107);

              for (_t80 = _e107; _e107 < _r15 && Ss(_s27.charCodeAt(_e107)); ++_e107) {
                ;
              }

              if (_e107 < _r15 && _e107 !== _t80) {
                for (_t80 = _e107; _e107 < _r15 && !Ss(_s27.charCodeAt(_e107)); ++_e107) {
                  ;
                }

                _e107 === _r15 ? (_a = "\\\\" + _i79 + "\\" + _s27.slice(_t80), _l5 = _e107) : _e107 !== _t80 && (_a = "\\\\" + _i79 + "\\" + _s27.slice(_t80, _e107), _l5 = _e107);
              }
            }
          } else _l5 = 1;
        } else xs(_h) && 58 === _s27.charCodeAt(1) && (_a = _s27.slice(0, 2), _l5 = 2, _r15 > 2 && Ss(_s27.charCodeAt(2)) && (_A3 = !0, _l5 = 3));
      } else Ss(_h) && (_l5 = 1, _A3 = !0);
      if (!(_a.length > 0 && t.length > 0 && _a.toLowerCase() !== t.toLowerCase()) && (0 === t.length && _a.length > 0 && (t = _a), o || (i = _s27.slice(_l5) + "\\" + i, o = _A3), t.length > 0 && o)) break;
    }

    return t + (o ? "\\" : "") + (i = Vs(i, !o, "\\", Ss)) || ".";
  },
  normalize: function normalize(e) {
    Hs(e, "path");
    var t = e.length;
    if (0 === t) return ".";
    var i,
        o = 0,
        n = !1;
    var s = e.charCodeAt(0);
    if (t > 1) {
      if (Ss(s)) {
        if (n = !0, Ss(e.charCodeAt(1))) {
          var _n40 = 2,
              _s28 = _n40;

          for (; _n40 < t && !Ss(e.charCodeAt(_n40)); ++_n40) {
            ;
          }

          if (_n40 < t && _n40 !== _s28) {
            var _r16 = e.slice(_s28, _n40);

            for (_s28 = _n40; _n40 < t && Ss(e.charCodeAt(_n40)); ++_n40) {
              ;
            }

            if (_n40 < t && _n40 !== _s28) {
              for (_s28 = _n40; _n40 < t && !Ss(e.charCodeAt(_n40)); ++_n40) {
                ;
              }

              if (_n40 === t) return "\\\\" + _r16 + "\\" + e.slice(_s28) + "\\";
              _n40 !== _s28 && (i = "\\\\" + _r16 + "\\" + e.slice(_s28, _n40), o = _n40);
            }
          }
        } else o = 1;
      } else xs(s) && 58 === e.charCodeAt(1) && (i = e.slice(0, 2), o = 2, t > 2 && Ss(e.charCodeAt(2)) && (n = !0, o = 3));
    } else if (Ss(s)) return "\\";
    var r;
    return 0 !== (r = o < t ? Vs(e.slice(o), !n, "\\", Ss) : "").length || n || (r = "."), r.length > 0 && Ss(e.charCodeAt(t - 1)) && (r += "\\"), void 0 === i ? n ? r.length > 0 ? "\\" + r : "\\" : r.length > 0 ? r : "" : n ? r.length > 0 ? i + "\\" + r : i + "\\" : r.length > 0 ? i + r : i;
  },
  isAbsolute: function isAbsolute(e) {
    Hs(e, "path");
    var t = e.length;
    if (0 === t) return !1;
    var i = e.charCodeAt(0);
    return !!Ss(i) || !!(xs(i) && t > 2 && 58 === e.charCodeAt(1) && Ss(e.charCodeAt(2)));
  },
  join: function join() {
    if (0 === arguments.length) return ".";
    var t, i;

    for (var _o37 = 0; _o37 < arguments.length; ++_o37) {
      var _n41 = _o37 < 0 || arguments.length <= _o37 ? undefined : arguments[_o37];

      Hs(_n41, "path"), _n41.length > 0 && (void 0 === t ? t = i = _n41 : t += "\\" + _n41);
    }

    if (void 0 === t) return ".";
    var o = !0,
        n = 0;

    if (Ss(i.charCodeAt(0))) {
      ++n;
      var _e108 = i.length;
      _e108 > 1 && Ss(i.charCodeAt(1)) && (++n, _e108 > 2 && (Ss(i.charCodeAt(2)) ? ++n : o = !1));
    }

    if (o) {
      for (; n < t.length && Ss(t.charCodeAt(n)); ++n) {
        ;
      }

      n >= 2 && (t = "\\" + t.slice(n));
    }

    return _s.normalize(t);
  },
  relative: function relative(e, t) {
    if (Hs(e, "from"), Hs(t, "to"), e === t) return "";

    var i = _s.resolve(e),
        o = _s.resolve(t);

    if (i === o) return "";
    if ((e = i.toLowerCase()) === (t = o.toLowerCase())) return "";
    var n = 0;

    for (; n < e.length && e.charCodeAt(n) === bs; ++n) {
      ;
    }

    var s = e.length;

    for (; s - 1 > n && e.charCodeAt(s - 1) === bs; --s) {
      ;
    }

    var r = s - n,
        l = 0;

    for (; l < t.length && t.charCodeAt(l) === bs; ++l) {
      ;
    }

    var a = t.length;

    for (; a - 1 > l && t.charCodeAt(a - 1) === bs; --a) {
      ;
    }

    var A = a - l,
        h = r < A ? r : A,
        c = -1,
        d = 0;

    for (; d <= h; ++d) {
      if (d === h) {
        if (A > h) {
          if (t.charCodeAt(l + d) === bs) return o.slice(l + d + 1);
          if (2 === d) return o.slice(l + d);
        }

        r > h && (e.charCodeAt(n + d) === bs ? c = d : 2 === d && (c = 3));
        break;
      }

      var _i80 = e.charCodeAt(n + d);

      if (_i80 !== t.charCodeAt(l + d)) break;
      _i80 === bs && (c = d);
    }

    if (d !== h && -1 === c) return o;
    var u = "";

    for (-1 === c && (c = 0), d = n + c + 1; d <= s; ++d) {
      d !== s && e.charCodeAt(d) !== bs || (0 === u.length ? u += ".." : u += "\\..");
    }

    return u.length > 0 ? u + o.slice(l + c, a) : (l += c, o.charCodeAt(l) === bs && ++l, o.slice(l, a));
  },
  toNamespacedPath: function toNamespacedPath(e) {
    if ("string" != typeof e) return e;
    if (0 === e.length) return "";

    var t = _s.resolve(e);

    if (t.length >= 3) if (t.charCodeAt(0) === bs) {
      if (t.charCodeAt(1) === bs) {
        var _e109 = t.charCodeAt(2);

        if (63 !== _e109 && _e109 !== Ms) return "\\\\?\\UNC\\" + t.slice(2);
      }
    } else if (xs(t.charCodeAt(0)) && 58 === t.charCodeAt(1) && t.charCodeAt(2) === bs) return "\\\\?\\" + t;
    return e;
  },
  dirname: function dirname(e) {
    Hs(e, "path");
    var t = e.length;
    if (0 === t) return ".";
    var i = -1,
        o = -1,
        n = !0,
        s = 0;
    var r = e.charCodeAt(0);
    if (t > 1) {
      if (Ss(r)) {
        if (i = s = 1, Ss(e.charCodeAt(1))) {
          var _o38 = 2,
              _n42 = _o38;

          for (; _o38 < t && !Ss(e.charCodeAt(_o38)); ++_o38) {
            ;
          }

          if (_o38 < t && _o38 !== _n42) {
            for (_n42 = _o38; _o38 < t && Ss(e.charCodeAt(_o38)); ++_o38) {
              ;
            }

            if (_o38 < t && _o38 !== _n42) {
              for (_n42 = _o38; _o38 < t && !Ss(e.charCodeAt(_o38)); ++_o38) {
                ;
              }

              if (_o38 === t) return e;
              _o38 !== _n42 && (i = s = _o38 + 1);
            }
          }
        }
      } else xs(r) && 58 === e.charCodeAt(1) && (i = s = 2, t > 2 && Ss(e.charCodeAt(2)) && (i = s = 3));
    } else if (Ss(r)) return e;

    for (var _i81 = t - 1; _i81 >= s; --_i81) {
      if (Ss(e.charCodeAt(_i81))) {
        if (!n) {
          o = _i81;
          break;
        }
      } else n = !1;
    }

    if (-1 === o) {
      if (-1 === i) return ".";
      o = i;
    }

    return e.slice(0, o);
  },
  basename: function basename(e, t) {
    void 0 !== t && Hs(t, "ext"), Hs(e, "path");
    var i,
        o = 0,
        n = -1,
        s = !0;

    if (e.length >= 2) {
      xs(e.charCodeAt(0)) && 58 === e.charCodeAt(1) && (o = 2);
    }

    if (void 0 !== t && t.length > 0 && t.length <= e.length) {
      if (t.length === e.length && t === e) return "";

      var _r17 = t.length - 1,
          _l6 = -1;

      for (i = e.length - 1; i >= o; --i) {
        var _a2 = e.charCodeAt(i);

        if (Ss(_a2)) {
          if (!s) {
            o = i + 1;
            break;
          }
        } else -1 === _l6 && (s = !1, _l6 = i + 1), _r17 >= 0 && (_a2 === t.charCodeAt(_r17) ? -1 == --_r17 && (n = i) : (_r17 = -1, n = _l6));
      }

      return o === n ? n = _l6 : -1 === n && (n = e.length), e.slice(o, n);
    }

    for (i = e.length - 1; i >= o; --i) {
      if (Ss(e.charCodeAt(i))) {
        if (!s) {
          o = i + 1;
          break;
        }
      } else -1 === n && (s = !1, n = i + 1);
    }

    return -1 === n ? "" : e.slice(o, n);
  },
  extname: function extname(e) {
    Hs(e, "path");
    var t = 0,
        i = -1,
        o = 0,
        n = -1,
        s = !0,
        r = 0;
    e.length >= 2 && 58 === e.charCodeAt(1) && xs(e.charCodeAt(0)) && (t = o = 2);

    for (var _l7 = e.length - 1; _l7 >= t; --_l7) {
      var _t81 = e.charCodeAt(_l7);

      if (Ss(_t81)) {
        if (!s) {
          o = _l7 + 1;
          break;
        }
      } else -1 === n && (s = !1, n = _l7 + 1), _t81 === Ms ? -1 === i ? i = _l7 : 1 !== r && (r = 1) : -1 !== i && (r = -1);
    }

    return -1 === i || -1 === n || 0 === r || 1 === r && i === n - 1 && i === o + 1 ? "" : e.slice(i, n);
  },
  format: function format(e) {
    if (null === e || "object" != typeof e) throw new Fs("pathObject", "Object", e);
    return Is("\\", e);
  },
  parse: function parse(e) {
    Hs(e, "path");
    var t = {
      root: "",
      dir: "",
      base: "",
      ext: "",
      name: ""
    };
    if (0 === e.length) return t;
    var i = e.length,
        o = 0,
        n = e.charCodeAt(0);

    if (i > 1) {
      if (Ss(n)) {
        if (o = 1, Ss(e.charCodeAt(1))) {
          var _t82 = 2,
              _n43 = _t82;

          for (; _t82 < i && !Ss(e.charCodeAt(_t82)); ++_t82) {
            ;
          }

          if (_t82 < i && _t82 !== _n43) {
            for (_n43 = _t82; _t82 < i && Ss(e.charCodeAt(_t82)); ++_t82) {
              ;
            }

            if (_t82 < i && _t82 !== _n43) {
              for (_n43 = _t82; _t82 < i && !Ss(e.charCodeAt(_t82)); ++_t82) {
                ;
              }

              _t82 === i ? o = _t82 : _t82 !== _n43 && (o = _t82 + 1);
            }
          }
        }
      } else if (xs(n) && 58 === e.charCodeAt(1)) {
        if (o = 2, !(i > 2)) return t.root = t.dir = e, t;

        if (Ss(e.charCodeAt(2))) {
          if (3 === i) return t.root = t.dir = e, t;
          o = 3;
        }
      }
    } else if (Ss(n)) return t.root = t.dir = e, t;

    o > 0 && (t.root = e.slice(0, o));
    var s = -1,
        r = o,
        l = -1,
        a = !0,
        A = e.length - 1,
        h = 0;

    for (; A >= o; --A) {
      if (Ss(n = e.charCodeAt(A))) {
        if (!a) {
          r = A + 1;
          break;
        }
      } else -1 === l && (a = !1, l = A + 1), n === Ms ? -1 === s ? s = A : 1 !== h && (h = 1) : -1 !== s && (h = -1);
    }

    return -1 === s || -1 === l || 0 === h || 1 === h && s === l - 1 && s === r + 1 ? -1 !== l && (t.base = t.name = e.slice(r, l)) : (t.name = e.slice(r, s), t.base = e.slice(r, l), t.ext = e.slice(s, l)), t.dir = r > 0 && r !== o ? e.slice(0, r - 1) : t.root, t;
  },
  sep: "\\",
  delimiter: ";",
  win32: null,
  posix: null
},
    Ns = {
  resolve: function resolve() {
    var t = "",
        i = !1;

    for (var o = arguments.length - 1; o >= -1 && !i; o--) {
      var _n44 = void 0;

      Hs(_n44 = o >= 0 ? o < 0 || arguments.length <= o ? undefined : arguments[o] : process.cwd(), "path"), 0 !== _n44.length && (t = _n44 + "/" + t, i = _n44.charCodeAt(0) === Bs);
    }

    return t = Vs(t, !i, "/", zs), i ? t.length > 0 ? "/" + t : "/" : t.length > 0 ? t : ".";
  },
  normalize: function normalize(e) {
    if (Hs(e, "path"), 0 === e.length) return ".";
    var t = e.charCodeAt(0) === Bs,
        i = e.charCodeAt(e.length - 1) === Bs;
    return 0 !== (e = Vs(e, !t, "/", zs)).length || t || (e = "."), e.length > 0 && i && (e += "/"), t ? "/" + e : e;
  },
  isAbsolute: function isAbsolute(e) {
    return Hs(e, "path"), e.length > 0 && e.charCodeAt(0) === Bs;
  },
  join: function join() {
    if (0 === arguments.length) return ".";
    var t;

    for (var _i82 = 0; _i82 < arguments.length; ++_i82) {
      var _e110 = arguments[_i82];
      Hs(_e110, "path"), _e110.length > 0 && (void 0 === t ? t = _e110 : t += "/" + _e110);
    }

    return void 0 === t ? "." : Ns.normalize(t);
  },
  relative: function relative(e, t) {
    if (Hs(e, "from"), Hs(t, "to"), e === t) return "";
    if ((e = Ns.resolve(e)) === (t = Ns.resolve(t))) return "";
    var i = 1;

    for (; i < e.length && e.charCodeAt(i) === Bs; ++i) {
      ;
    }

    var o = e.length,
        n = o - i,
        s = 1;

    for (; s < t.length && t.charCodeAt(s) === Bs; ++s) {
      ;
    }

    var r = t.length - s,
        l = n < r ? n : r,
        a = -1,
        A = 0;

    for (; A <= l; ++A) {
      if (A === l) {
        if (r > l) {
          if (t.charCodeAt(s + A) === Bs) return t.slice(s + A + 1);
          if (0 === A) return t.slice(s + A);
        } else n > l && (e.charCodeAt(i + A) === Bs ? a = A : 0 === A && (a = 0));

        break;
      }

      var _o39 = e.charCodeAt(i + A);

      if (_o39 !== t.charCodeAt(s + A)) break;
      _o39 === Bs && (a = A);
    }

    var h = "";

    for (A = i + a + 1; A <= o; ++A) {
      A !== o && e.charCodeAt(A) !== Bs || (0 === h.length ? h += ".." : h += "/..");
    }

    return h.length > 0 ? h + t.slice(s + a) : (s += a, t.charCodeAt(s) === Bs && ++s, t.slice(s));
  },
  toNamespacedPath: function toNamespacedPath(e) {
    return e;
  },
  dirname: function dirname(e) {
    if (Hs(e, "path"), 0 === e.length) return ".";
    var t = e.charCodeAt(0) === Bs;
    var i = -1,
        o = !0;

    for (var _t83 = e.length - 1; _t83 >= 1; --_t83) {
      if (e.charCodeAt(_t83) === Bs) {
        if (!o) {
          i = _t83;
          break;
        }
      } else o = !1;
    }

    return -1 === i ? t ? "/" : "." : t && 1 === i ? "//" : e.slice(0, i);
  },
  basename: function basename(e, t) {
    void 0 !== t && Hs(t, "ext"), Hs(e, "path");
    var i,
        o = 0,
        n = -1,
        s = !0;

    if (void 0 !== t && t.length > 0 && t.length <= e.length) {
      if (t.length === e.length && t === e) return "";

      var _r18 = t.length - 1,
          _l8 = -1;

      for (i = e.length - 1; i >= 0; --i) {
        var _a3 = e.charCodeAt(i);

        if (_a3 === Bs) {
          if (!s) {
            o = i + 1;
            break;
          }
        } else -1 === _l8 && (s = !1, _l8 = i + 1), _r18 >= 0 && (_a3 === t.charCodeAt(_r18) ? -1 == --_r18 && (n = i) : (_r18 = -1, n = _l8));
      }

      return o === n ? n = _l8 : -1 === n && (n = e.length), e.slice(o, n);
    }

    for (i = e.length - 1; i >= 0; --i) {
      if (e.charCodeAt(i) === Bs) {
        if (!s) {
          o = i + 1;
          break;
        }
      } else -1 === n && (s = !1, n = i + 1);
    }

    return -1 === n ? "" : e.slice(o, n);
  },
  extname: function extname(e) {
    Hs(e, "path");
    var t = -1,
        i = 0,
        o = -1,
        n = !0,
        s = 0;

    for (var _r19 = e.length - 1; _r19 >= 0; --_r19) {
      var _l9 = e.charCodeAt(_r19);

      if (_l9 !== Bs) -1 === o && (n = !1, o = _r19 + 1), _l9 === Ms ? -1 === t ? t = _r19 : 1 !== s && (s = 1) : -1 !== t && (s = -1);else if (!n) {
        i = _r19 + 1;
        break;
      }
    }

    return -1 === t || -1 === o || 0 === s || 1 === s && t === o - 1 && t === i + 1 ? "" : e.slice(t, o);
  },
  format: function format(e) {
    if (null === e || "object" != typeof e) throw new Fs("pathObject", "Object", e);
    return Is("/", e);
  },
  parse: function parse(e) {
    Hs(e, "path");
    var t = {
      root: "",
      dir: "",
      base: "",
      ext: "",
      name: ""
    };
    if (0 === e.length) return t;
    var i,
        o = e.charCodeAt(0) === Bs;
    o ? (t.root = "/", i = 1) : i = 0;
    var n = -1,
        s = 0,
        r = -1,
        l = !0,
        a = e.length - 1,
        A = 0;

    for (; a >= i; --a) {
      var _t84 = e.charCodeAt(a);

      if (_t84 !== Bs) -1 === r && (l = !1, r = a + 1), _t84 === Ms ? -1 === n ? n = a : 1 !== A && (A = 1) : -1 !== n && (A = -1);else if (!l) {
        s = a + 1;
        break;
      }
    }

    return -1 === n || -1 === r || 0 === A || 1 === A && n === r - 1 && n === s + 1 ? -1 !== r && (t.base = t.name = 0 === s && o ? e.slice(1, r) : e.slice(s, r)) : (0 === s && o ? (t.name = e.slice(1, n), t.base = e.slice(1, r)) : (t.name = e.slice(s, n), t.base = e.slice(s, r)), t.ext = e.slice(n, r)), s > 0 ? t.dir = e.slice(0, s - 1) : o && (t.dir = "/"), t;
  },
  sep: "/",
  delimiter: ":",
  win32: null,
  posix: null
};
Ns.win32 = _s.win32 = _s, Ns.posix = _s.posix = Ns;
"win32" === process.platform ? _s.normalize : Ns.normalize, "win32" === process.platform ? _s.isAbsolute : Ns.isAbsolute, "win32" === process.platform ? _s.join : Ns.join, "win32" === process.platform ? _s.resolve : Ns.resolve, "win32" === process.platform ? _s.relative : Ns.relative, "win32" === process.platform ? _s.dirname : Ns.dirname, "win32" === process.platform ? _s.basename : Ns.basename, "win32" === process.platform ? _s.extname : Ns.extname, "win32" === process.platform ? _s.format : Ns.format, "win32" === process.platform ? _s.parse : Ns.parse, "win32" === process.platform ? _s.toNamespacedPath : Ns.toNamespacedPath, "win32" === process.platform ? _s.sep : Ns.sep, "win32" === process.platform ? _s.delimiter : Ns.delimiter;
var Ls = "undefined" == typeof process ? {
  cwd: function cwd() {
    return "/";
  },
  env: Object.create(null),

  get platform() {
    return T ? "win32" : k ? "darwin" : "linux";
  },

  nextTick: function nextTick(e) {
    return function (e) {
      return null === U && (U = Y.setImmediate ? Y.setImmediate.bind(Y) : "undefined" != typeof process && "function" == typeof process.nextTick ? process.nextTick.bind(process) : Y.setTimeout.bind(Y)), U(e);
    }(e);
  }
} : process;
Ls.cwd, Ls.env, Ls.platform, Ls.nextTick;
var Ps;
!function (e) {
  e.inMemory = "inmemory", e.vscode = "vscode", e.internal = "private", e.walkThrough = "walkThrough", e.walkThroughSnippet = "walkThroughSnippet", e.http = "http", e.https = "https", e.file = "file", e.mailto = "mailto", e.untitled = "untitled", e.data = "data", e.command = "command";
}(Ps || (Ps = {}));
new Ae(1e4);
var Qs;
!function (e) {
  e.META_DATA_LABEL = "label", e.META_DATA_DESCRIPTION = "description", e.META_DATA_SIZE = "size", e.META_DATA_MIME = "mime", e.parseMetaData = function (t) {
    var i = new Map();
    t.path.substring(t.path.indexOf(";") + 1, t.path.lastIndexOf(";")).split(";").forEach(function (e) {
      var _e$split = e.split(":"),
          _e$split2 = _slicedToArray(_e$split, 2),
          t = _e$split2[0],
          o = _e$split2[1];

      t && o && i.set(t, o);
    });
    var o = t.path.substring(0, t.path.indexOf(";"));
    return o && i.set(e.META_DATA_MIME, o), i;
  };
}(Qs || (Qs = {}));
var Rs = n("dialogService"),
    Ts = (n("fileDialogService"), Object.prototype.hasOwnProperty);

function ks(e, t) {
  var _loop3 = function _loop3(_i83) {
    if (Ts.call(e, _i83)) {
      if (!1 === t({
        key: _i83,
        value: e[_i83]
      }, function () {
        delete e[_i83];
      })) return {
        v: void 0
      };
    }
  };

  for (var _i83 in e) {
    var _ret2 = _loop3(_i83);

    if (typeof _ret2 === "object") return _ret2.v;
  }
}

var Ys =
/*#__PURE__*/
function () {
  function Ys(e) {
    _classCallCheck(this, Ys);

    this._hashFn = e, this._nodes = Object.create(null);
  }

  _createClass(Ys, [{
    key: "roots",
    value: function roots() {
      var e = [];
      return ks(this._nodes, function (t) {
        (function (e) {
          if (!Gt(e)) return !1;

          for (var _t85 in e) {
            if (Wt.call(e, _t85)) return !1;
          }

          return !0;
        })(t.value.outgoing) && e.push(t.value);
      }), e;
    }
  }, {
    key: "insertEdge",
    value: function insertEdge(e, t) {
      var i = this.lookupOrInsertNode(e),
          o = this.lookupOrInsertNode(t);
      i.outgoing[this._hashFn(t)] = o, o.incoming[this._hashFn(e)] = i;
    }
  }, {
    key: "removeNode",
    value: function removeNode(e) {
      var t = this._hashFn(e);

      delete this._nodes[t], ks(this._nodes, function (e) {
        delete e.value.outgoing[t], delete e.value.incoming[t];
      });
    }
  }, {
    key: "lookupOrInsertNode",
    value: function lookupOrInsertNode(e) {
      var t = this._hashFn(e);

      var i = this._nodes[t];
      return i || (i = function (e) {
        return {
          data: e,
          incoming: Object.create(null),
          outgoing: Object.create(null)
        };
      }(e), this._nodes[t] = i), i;
    }
  }, {
    key: "lookup",
    value: function lookup(e) {
      return this._nodes[this._hashFn(e)];
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      for (var _e111 in this._nodes) {
        return !1;
      }

      return !0;
    }
  }, {
    key: "toString",
    value: function toString() {
      var e = [];
      return ks(this._nodes, function (t) {
        e.push("".concat(t.key, ", (incoming)[").concat(Object.keys(t.value.incoming).join(", "), "], (outgoing)[").concat(Object.keys(t.value.outgoing).join(","), "]"));
      }), e.join("\n");
    }
  }]);

  return Ys;
}();

var Us =
/*#__PURE__*/
function () {
  function Us() {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new s();
    var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
    var o = arguments.length > 2 ? arguments[2] : undefined;

    _classCallCheck(this, Us);

    this._services = e, this._strict = t, this._parent = o, this._services.set(i, this);
  }

  _createClass(Us, [{
    key: "createChild",
    value: function createChild(e) {
      return new Us(e, this._strict, this);
    }
  }, {
    key: "invokeFunction",
    value: function invokeFunction(e) {
      var _this139 = this;

      for (var _len20 = arguments.length, t = new Array(_len20 > 1 ? _len20 - 1 : 0), _key20 = 1; _key20 < _len20; _key20++) {
        t[_key20 - 1] = arguments[_key20];
      }

      var i = Js.traceInvocation(e),
          n = !1;

      try {
        var _s29 = {
          get: function get(e, t) {
            if (n) throw function (e) {
              return e ? new Error("Illegal state: ".concat(e)) : new Error("Illegal state");
            }("service accessor is only valid during the invocation of its target method");

            var s = _this139._getOrCreateServiceInstance(e, i);

            if (!s && t !== function (e) {
              return function (t, i, n) {
                if (3 !== arguments.length) throw new Error("@optional-decorator can only be used to decorate a parameter");
                o(e, t, n, !0);
              };
            }) throw new Error("[invokeFunction] unknown service '".concat(e, "'"));
            return s;
          }
        };
        return e.apply(void 0, [_s29].concat(t));
      } finally {
        n = !0, i.stop();
      }
    }
  }, {
    key: "createInstance",
    value: function createInstance(t) {
      var o, n;

      for (var _len21 = arguments.length, i = new Array(_len21 > 1 ? _len21 - 1 : 0), _key21 = 1; _key21 < _len21; _key21++) {
        i[_key21 - 1] = arguments[_key21];
      }

      return t instanceof e ? (o = Js.traceCreation(t.ctor), n = this._createInstance(t.ctor, t.staticArguments.concat(i), o)) : (o = Js.traceCreation(t), n = this._createInstance(t, i, o)), o.stop(), n;
    }
  }, {
    key: "_createInstance",
    value: function _createInstance(e) {
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var o = arguments.length > 2 ? arguments[2] : undefined;
      var n = t.getServiceDependencies(e).sort(function (e, t) {
        return e.index - t.index;
      }),
          s = [];
      var _iteratorNormalCompletion56 = true;
      var _didIteratorError56 = false;
      var _iteratorError56 = undefined;

      try {
        for (var _iterator56 = n[Symbol.iterator](), _step56; !(_iteratorNormalCompletion56 = (_step56 = _iterator56.next()).done); _iteratorNormalCompletion56 = true) {
          var _t87 = _step56.value;

          var _i85 = this._getOrCreateServiceInstance(_t87.id, o);

          if (!_i85 && this._strict && !_t87.optional) throw new Error("[createInstance] ".concat(e.name, " depends on UNKNOWN service ").concat(_t87.id, "."));
          s.push(_i85);
        }
      } catch (err) {
        _didIteratorError56 = true;
        _iteratorError56 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion56 && _iterator56.return != null) {
            _iterator56.return();
          }
        } finally {
          if (_didIteratorError56) {
            throw _iteratorError56;
          }
        }
      }

      var r = n.length > 0 ? n[0].index : i.length;

      if (i.length !== r) {
        console.warn("[createInstance] First service dependency of ".concat(e.name, " at position ").concat(r + 1, " conflicts with ").concat(i.length, " static arguments"));

        var _t86 = r - i.length;

        i = _t86 > 0 ? i.concat(new Array(_t86)) : i.slice(0, r);
      }

      return function (e) {
        for (var _len22 = arguments.length, t = new Array(_len22 > 1 ? _len22 - 1 : 0), _key22 = 1; _key22 < _len22; _key22++) {
          t[_key22 - 1] = arguments[_key22];
        }

        if ("function" == typeof (i = e) && i.hasOwnProperty("prototype") && !i.hasOwnProperty("arguments")) return _construct(e, t);
        {
          var _i84 = Object.create(e.prototype);

          return e.apply(_i84, t), _i84;
        }
        var i;
      }.apply(null, [e].concat(i, s));
    }
  }, {
    key: "_setServiceInstance",
    value: function _setServiceInstance(t, i) {
      if (this._services.get(t) instanceof e) this._services.set(t, i);else {
        if (!this._parent) throw new Error("illegalState - setting UNKNOWN service instance");

        this._parent._setServiceInstance(t, i);
      }
    }
  }, {
    key: "_getServiceInstanceOrDescriptor",
    value: function _getServiceInstanceOrDescriptor(e) {
      var t = this._services.get(e);

      return !t && this._parent ? this._parent._getServiceInstanceOrDescriptor(e) : t;
    }
  }, {
    key: "_getOrCreateServiceInstance",
    value: function _getOrCreateServiceInstance(t, i) {
      var o = this._getServiceInstanceOrDescriptor(t);

      return o instanceof e ? this._createAndCacheServiceInstance(t, o, i.branch(t, !0)) : (i.branch(t, !1), o);
    }
  }, {
    key: "_createAndCacheServiceInstance",
    value: function _createAndCacheServiceInstance(i, o, n) {
      var s = new Ys(function (e) {
        return e.id.toString();
      });

      function r() {
        var e = new Error("[createInstance] cyclic dependency between services");
        throw e.message = s.toString(), e;
      }

      var l = 0;
      var a = [{
        id: i,
        desc: o,
        _trace: n
      }];

      for (; a.length;) {
        var _o40 = a.pop();

        s.lookupOrInsertNode(_o40), l++ > 100 && r();

        var _n45 = t.getServiceDependencies(_o40.desc.ctor);

        var _iteratorNormalCompletion57 = true;
        var _didIteratorError57 = false;
        var _iteratorError57 = undefined;

        try {
          for (var _iterator57 = _n45[Symbol.iterator](), _step57; !(_iteratorNormalCompletion57 = (_step57 = _iterator57.next()).done); _iteratorNormalCompletion57 = true) {
            var _t88 = _step57.value;

            var _n46 = this._getServiceInstanceOrDescriptor(_t88.id);

            if (_n46 || _t88.optional || console.warn("[createInstance] ".concat(i, " depends on ").concat(_t88.id, " which is NOT registered.")), _n46 instanceof e) {
              var _e112 = {
                id: _t88.id,
                desc: _n46,
                _trace: _o40._trace.branch(_t88.id, !0)
              };
              s.insertEdge(_o40, _e112), a.push(_e112);
            }
          }
        } catch (err) {
          _didIteratorError57 = true;
          _iteratorError57 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion57 && _iterator57.return != null) {
              _iterator57.return();
            }
          } finally {
            if (_didIteratorError57) {
              throw _iteratorError57;
            }
          }
        }
      }

      for (;;) {
        var _e113 = s.roots();

        if (0 === _e113.length) {
          s.isEmpty() || r();
          break;
        }

        var _iteratorNormalCompletion58 = true;
        var _didIteratorError58 = false;
        var _iteratorError58 = undefined;

        try {
          for (var _iterator58 = _e113[Symbol.iterator](), _step58; !(_iteratorNormalCompletion58 = (_step58 = _iterator58.next()).done); _iteratorNormalCompletion58 = true) {
            var _ref21 = _step58.value;
            var _t89 = _ref21.data;

            var _e114 = this._createServiceInstanceWithOwner(_t89.id, _t89.desc.ctor, _t89.desc.staticArguments, _t89.desc.supportsDelayedInstantiation, _t89._trace);

            this._setServiceInstance(_t89.id, _e114), s.removeNode(_t89);
          }
        } catch (err) {
          _didIteratorError58 = true;
          _iteratorError58 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion58 && _iterator58.return != null) {
              _iterator58.return();
            }
          } finally {
            if (_didIteratorError58) {
              throw _iteratorError58;
            }
          }
        }
      }

      return this._getServiceInstanceOrDescriptor(i);
    }
  }, {
    key: "_createServiceInstanceWithOwner",
    value: function _createServiceInstanceWithOwner(t, i) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var n = arguments.length > 3 ? arguments[3] : undefined;
      var s = arguments.length > 4 ? arguments[4] : undefined;
      if (this._services.get(t) instanceof e) return this._createServiceInstance(i, o, n, s);
      if (this._parent) return this._parent._createServiceInstanceWithOwner(t, i, o, n, s);
      throw new Error("illegalState - creating UNKNOWN service instance");
    }
  }, {
    key: "_createServiceInstance",
    value: function _createServiceInstance(e) {
      var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var i = arguments.length > 2 ? arguments[2] : undefined;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      return this._createInstance(e, t, o);
    }
  }]);

  return Us;
}();

var Js =
/*#__PURE__*/
function () {
  function Js(e, t) {
    _classCallCheck(this, Js);

    this.type = e, this.name = t, this._start = Date.now(), this._dep = [];
  }

  _createClass(Js, [{
    key: "branch",
    value: function branch(e, t) {
      var i = new Js(2, e.toString());
      return this._dep.push([e, t, i]), i;
    }
  }, {
    key: "stop",
    value: function stop() {
      var e = Date.now() - this._start;

      Js._totals += e;
      var t = !1;
      var i = ["".concat(0 === this.type ? "CREATE" : "CALL", " ").concat(this.name), "".concat(function e(i, o) {
        var n = [],
            s = new Array(i + 1).join("\t");
        var _iteratorNormalCompletion59 = true;
        var _didIteratorError59 = false;
        var _iteratorError59 = undefined;

        try {
          for (var _iterator59 = o._dep[Symbol.iterator](), _step59; !(_iteratorNormalCompletion59 = (_step59 = _iterator59.next()).done); _iteratorNormalCompletion59 = true) {
            var _ref24 = _step59.value;

            var _ref23 = _slicedToArray(_ref24, 3);

            var _r20 = _ref23[0];
            var _l10 = _ref23[1];
            var _a4 = _ref23[2];

            if (_l10 && _a4) {
              t = !0, n.push("".concat(s, "CREATES -> ").concat(_r20));

              var _o41 = e(i + 1, _a4);

              _o41 && n.push(_o41);
            } else n.push("".concat(s, "uses -> ").concat(_r20));
          }
        } catch (err) {
          _didIteratorError59 = true;
          _iteratorError59 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion59 && _iterator59.return != null) {
              _iterator59.return();
            }
          } finally {
            if (_didIteratorError59) {
              throw _iteratorError59;
            }
          }
        }

        return n.join("\n");
      }(1, this)), "DONE, took ".concat(e.toFixed(2), "ms (grand total ").concat(Js._totals.toFixed(2), "ms)")];
      (e > 2 || t) && console.log(i.join("\n"));
    }
  }], [{
    key: "traceInvocation",
    value: function traceInvocation(e) {
      return Js._None;
    }
  }, {
    key: "traceCreation",
    value: function traceCreation(e) {
      return Js._None;
    }
  }]);

  return Js;
}();

Js._None = new (
/*#__PURE__*/
function (_Js) {
  _inherits(_class13, _Js);

  function _class13() {
    _classCallCheck(this, _class13);

    return _possibleConstructorReturn(this, _getPrototypeOf(_class13).call(this, -1, null));
  }

  _createClass(_class13, [{
    key: "stop",
    value: function stop() {}
  }, {
    key: "branch",
    value: function branch() {
      return this;
    }
  }]);

  return _class13;
}(Js))(), Js._totals = 0;
var js = n("logService");
var Gs;
!function (e) {
  e[e.Trace = 0] = "Trace", e[e.Debug = 1] = "Debug", e[e.Info = 2] = "Info", e[e.Warning = 3] = "Warning", e[e.Error = 4] = "Error", e[e.Critical = 5] = "Critical", e[e.Off = 6] = "Off";
}(Gs || (Gs = {}));
Gs.Info;

var Os =
/*#__PURE__*/
function () {
  function Os() {
    _classCallCheck(this, Os);

    this.onDidChangeLogLevel = new b().event;
  }

  _createClass(Os, [{
    key: "setLevel",
    value: function setLevel(e) {}
  }, {
    key: "getLevel",
    value: function getLevel() {
      return Gs.Info;
    }
  }, {
    key: "trace",
    value: function trace(e) {}
  }, {
    key: "debug",
    value: function debug(e) {}
  }, {
    key: "info",
    value: function info(e) {}
  }, {
    key: "warn",
    value: function warn(e) {}
  }, {
    key: "error",
    value: function error(e) {}
  }, {
    key: "critical",
    value: function critical(e) {}
  }, {
    key: "dispose",
    value: function dispose() {}
  }]);

  return Os;
}();

var Ks =
/*#__PURE__*/
function () {
  function Ks(e) {
    _classCallCheck(this, Ks);

    this._commandService = e;
  }

  _createClass(Ks, [{
    key: "createMenu",
    value: function createMenu(e, t) {
      return new Ws(e, this._commandService, t);
    }
  }]);

  return Ks;
}();

Ks = r([l(0, un)], Ks);

var Ws =
/*#__PURE__*/
function () {
  function e(_e115, t, i) {
    var _this140 = this;

    _classCallCheck(this, e);

    this._id = _e115, this._commandService = t, this._contextKeyService = i, this._onDidChange = new b(), this._disposables = [], this._build(), v.debounce(v.filter(Wn.onDidChangeMenu, function (e) {
      return e === _this140._id;
    }), function () {}, 50)(this._build, this, this._disposables), v.debounce(this._contextKeyService.onDidChangeContext, function (e, t) {
      return e || t.affectsSome(_this140._contextKeys);
    }, 50)(function (e) {
      return e && _this140._onDidChange.fire(void 0);
    }, this, this._disposables);
  }

  _createClass(e, [{
    key: "_build",
    value: function _build() {
      this._menuGroups = [], this._contextKeys = new Set();
      var t = Wn.getMenuItems(this._id);
      var i;
      t.sort(e._compareMenuItems);
      var _iteratorNormalCompletion60 = true;
      var _didIteratorError60 = false;
      var _iteratorError60 = undefined;

      try {
        for (var _iterator60 = t[Symbol.iterator](), _step60; !(_iteratorNormalCompletion60 = (_step60 = _iterator60.next()).done); _iteratorNormalCompletion60 = true) {
          var _o42 = _step60.value;

          var _t90 = _o42.group || "";

          i && i[0] === _t90 || (i = [_t90, []], this._menuGroups.push(i)), i[1].push(_o42), e._fillInKbExprKeys(_o42.when, this._contextKeys), On(_o42) && _o42.command.precondition && e._fillInKbExprKeys(_o42.command.precondition, this._contextKeys), On(_o42) && _o42.command.toggled && e._fillInKbExprKeys(_o42.command.toggled, this._contextKeys);
        }
      } catch (err) {
        _didIteratorError60 = true;
        _iteratorError60 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion60 && _iterator60.return != null) {
            _iterator60.return();
          }
        } finally {
          if (_didIteratorError60) {
            throw _iteratorError60;
          }
        }
      }

      this._onDidChange.fire(this);
    }
  }, {
    key: "dispose",
    value: function dispose() {
      C(this._disposables), this._onDidChange.dispose();
    }
  }, {
    key: "getActions",
    value: function getActions(e) {
      var t = [];
      var _iteratorNormalCompletion61 = true;
      var _didIteratorError61 = false;
      var _iteratorError61 = undefined;

      try {
        for (var _iterator61 = this._menuGroups[Symbol.iterator](), _step61; !(_iteratorNormalCompletion61 = (_step61 = _iterator61.next()).done); _iteratorNormalCompletion61 = true) {
          var _i86 = _step61.value;

          var _i87 = _slicedToArray(_i86, 2),
              _o43 = _i87[0],
              _n47 = _i87[1],
              _s30 = [];

          var _iteratorNormalCompletion62 = true;
          var _didIteratorError62 = false;
          var _iteratorError62 = undefined;

          try {
            for (var _iterator62 = _n47[Symbol.iterator](), _step62; !(_iteratorNormalCompletion62 = (_step62 = _iterator62.next()).done); _iteratorNormalCompletion62 = true) {
              var _t91 = _step62.value;

              if (this._contextKeyService.contextMatchesRules(_t91.when || null)) {
                var _i88 = On(_t91) ? new qn(_t91.command, _t91.alt, e, this._contextKeyService, this._commandService) : new Zn(_t91);

                _s30.push(_i88);
              }
            }
          } catch (err) {
            _didIteratorError62 = true;
            _iteratorError62 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion62 && _iterator62.return != null) {
                _iterator62.return();
              }
            } finally {
              if (_didIteratorError62) {
                throw _iteratorError62;
              }
            }
          }

          _s30.length > 0 && t.push([_o43, _s30]);
        }
      } catch (err) {
        _didIteratorError61 = true;
        _iteratorError61 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion61 && _iterator61.return != null) {
            _iterator61.return();
          }
        } finally {
          if (_didIteratorError61) {
            throw _iteratorError61;
          }
        }
      }

      return t;
    }
  }, {
    key: "onDidChange",
    get: function get() {
      return this._onDidChange.event;
    }
  }], [{
    key: "_fillInKbExprKeys",
    value: function _fillInKbExprKeys(e, t) {
      if (e) {
        var _iteratorNormalCompletion63 = true;
        var _didIteratorError63 = false;
        var _iteratorError63 = undefined;

        try {
          for (var _iterator63 = e.keys()[Symbol.iterator](), _step63; !(_iteratorNormalCompletion63 = (_step63 = _iterator63.next()).done); _iteratorNormalCompletion63 = true) {
            var _i89 = _step63.value;
            t.add(_i89);
          }
        } catch (err) {
          _didIteratorError63 = true;
          _iteratorError63 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion63 && _iterator63.return != null) {
              _iterator63.return();
            }
          } finally {
            if (_didIteratorError63) {
              throw _iteratorError63;
            }
          }
        }
      }
    }
  }, {
    key: "_compareMenuItems",
    value: function _compareMenuItems(e, t) {
      var i = e.group,
          o = t.group;

      if (i !== o) {
        if (!i) return 1;
        if (!o) return -1;
        if ("navigation" === i) return -1;
        if ("navigation" === o) return 1;

        var _e116 = i.localeCompare(o);

        if (0 !== _e116) return _e116;
      }

      var n = e.order || 0,
          s = t.order || 0;
      if (n < s) return -1;
      if (n > s) return 1;
      var r = "string" == typeof e.command.title ? e.command.title : e.command.title.value,
          l = "string" == typeof t.command.title ? t.command.title : t.command.title.value;
      return r.localeCompare(l);
    }
  }]);

  return e;
}();

var Xs;
Ws = r([l(1, un), l(2, ln)], Ws), function (e) {
  var t = new s();

  var o =
  /*#__PURE__*/
  function () {
    function o(e, t) {
      _classCallCheck(this, o);

      this._serviceId = e, this._factory = t, this._value = null;
    }

    _createClass(o, [{
      key: "get",
      value: function get(e) {
        if (!this._value) {
          if (e && (this._value = e[this._serviceId.toString()]), this._value || (this._value = this._factory(e)), !this._value) throw new Error("Service " + this._serviceId + " is missing!");
          t.set(this._serviceId, this._value);
        }

        return this._value;
      }
    }, {
      key: "id",
      get: function get() {
        return this._serviceId;
      }
    }]);

    return o;
  }();

  e.LazyStaticService = o;
  var r = [];

  function l(e, t) {
    var i = new o(e, t);
    return r.push(i), i;
  }

  e.init = function (e) {
    var t = new s();

    for (var _i90 in e) {
      e.hasOwnProperty(_i90) && t.set(n(_i90), e[_i90]);
    }

    r.forEach(function (i) {
      return t.set(i.id, i.get(e));
    });
    var o = new Us(t, !0);
    return t.set(i, o), [t, o];
  }, e.instantiationService = l(i, function () {
    return new Us(t, !0);
  });
  var a = new Ds();
  e.configurationService = l(_n, function () {
    return a;
  }), e.telemetryService = l(ds, function () {
    return new fs();
  }), e.dialogService = l(Rs, function () {
    return new us();
  }), e.notificationService = l(hs, function () {
    return new gs();
  }), e.logService = l(js, function () {
    return new Os();
  });
}(Xs || (Xs = {}));

var Zs =
/*#__PURE__*/
function (_f12) {
  _inherits(Zs, _f12);

  function Zs(e, t) {
    var _this141;

    _classCallCheck(this, Zs);

    _this141 = _possibleConstructorReturn(this, _getPrototypeOf(Zs).call(this));

    var _Xs$init = Xs.init(t),
        _Xs$init2 = _slicedToArray(_Xs$init, 2),
        i = _Xs$init2[0],
        o = _Xs$init2[1];

    _this141._serviceCollection = i, _this141._instantiationService = o;
    _this141.get(_n), _this141.get(hs), _this141.get(ds);

    var n = function n(e, i) {
      var o = null;
      return t && (o = t[e.toString()]), o || (o = i()), _this141._serviceCollection.set(e, o), o;
    },
        s = n(un, function () {
      return new Cs(_this141._instantiationService);
    });

    n(Kn, function () {
      return new Ks(s);
    });
    return _this141;
  }

  _createClass(Zs, [{
    key: "get",
    value: function get(e) {
      var t = this._serviceCollection.get(e);

      if (!t) throw new Error("Missing service " + e);
      return t;
    }
  }, {
    key: "set",
    value: function set(e, t) {
      this._serviceCollection.set(e, t);
    }
  }, {
    key: "has",
    value: function has(e) {
      return this._serviceCollection.has(e);
    }
  }]);

  return Zs;
}(f);

var qs =
/*#__PURE__*/
function (_Zs) {
  _inherits(qs, _Zs);

  function qs(e, t) {
    var _this142;

    _classCallCheck(this, qs);

    _this142 = _possibleConstructorReturn(this, _getPrototypeOf(qs).call(this, e, t)), _this142.domElement = e;
    return _this142;
  }

  _createClass(qs, [{
    key: "createTree",
    value: function createTree(e, t) {
      var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this._instantiationService;
      var o = arguments.length > 3 ? arguments[3] : undefined;
      var n = arguments.length > 4 ? arguments[4] : undefined;
      return function (e, t, i) {
        var o = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Ee;
        var n = arguments.length > 4 ? arguments[4] : undefined;
        var s = i.createInstance(ri, si),
            r = i.createInstance(ve, s, function (e) {}, n),
            l = i.createInstance(t.ctor);
        return i.createInstance(An, e, r, l, o);
      }(e, t, i, o, n);
    }
  }, {
    key: "registerService",
    value: function registerService(t, i) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var n = o ? new s() : this._serviceCollection;
      return "function" == typeof i ? n.set(t, new e(i)) : n.set(t, i), o ? this._instantiationService.createChild(n) : this._instantiationService;
    }
  }, {
    key: "dispose",
    value: function dispose() {
      _get(_getPrototypeOf(qs.prototype), "dispose", this).call(this), this._serviceCollection.forEach(function (e, t) {
        t.dispose && t.dispose();
      });
    }
  }, {
    key: "InstantiationService",
    get: function get() {
      return this._instantiationService;
    }
  }]);

  return qs;
}(Zs);

var $s = n("treeViewService");

var er =
/*#__PURE__*/
function (_f13) {
  _inherits(er, _f13);

  function er(e) {
    var _this143;

    _classCallCheck(this, er);

    _this143 = _possibleConstructorReturn(this, _getPrototypeOf(er).call(this)), _this143._instantiationService = e, _this143._extensionHostIsReady = !1, _this143._onWillExecuteCommand = _this143._register(new b()), _this143.onWillExecuteCommand = _this143._onWillExecuteCommand.event;
    return _this143;
  }

  _createClass(er, [{
    key: "executeCommand",
    value: function executeCommand(e) {
      var i = !!gn.getCommand(e);

      for (var _len23 = arguments.length, t = new Array(_len23 > 1 ? _len23 - 1 : 0), _key23 = 1; _key23 < _len23; _key23++) {
        t[_key23 - 1] = arguments[_key23];
      }

      if (!this._extensionHostIsReady && i) return this._tryExecuteCommand(e, t);
      throw new Error("!commandIsRegistered");
    }
  }, {
    key: "_tryExecuteCommand",
    value: function _tryExecuteCommand(e, t) {
      var i = gn.getCommand(e);
      if (!i) return Promise.reject(new Error("command '".concat(e, "' not found")));

      try {
        this._onWillExecuteCommand.fire({
          commandId: e
        });

        var _o44 = this._instantiationService.invokeFunction.apply(this._instantiationService, [i.handler].concat(_toConsumableArray(t)));

        return Promise.resolve(_o44);
      } catch (e) {
        return Promise.reject(e);
      }
    }
  }]);

  return er;
}(f);

er = r([l(0, i)], er);
var tr = "data-keybinding-context";

var ir =
/*#__PURE__*/
function () {
  function ir(e, t) {
    _classCallCheck(this, ir);

    this._id = e, this._parent = t, this._value = Object.create(null), this._value._contextId = e;
  }

  _createClass(ir, [{
    key: "setValue",
    value: function setValue(e, t) {
      return this._value[e] !== t && (this._value[e] = t, !0);
    }
  }, {
    key: "removeValue",
    value: function removeValue(e) {
      return e in this._value && (delete this._value[e], !0);
    }
  }, {
    key: "getValue",
    value: function getValue(e) {
      var t = this._value[e];
      return void 0 === t && this._parent ? this._parent.getValue(e) : t;
    }
  }, {
    key: "collectAllValues",
    value: function collectAllValues() {
      var e = this._parent ? this._parent.collectAllValues() : Object.create(null);
      return delete (e = Object.assign({}, e, this._value))._contextId, e;
    }
  }]);

  return ir;
}();

var or =
/*#__PURE__*/
function (_ir) {
  _inherits(or, _ir);

  function or() {
    _classCallCheck(this, or);

    return _possibleConstructorReturn(this, _getPrototypeOf(or).call(this, -1, null));
  }

  _createClass(or, [{
    key: "setValue",
    value: function setValue(e, t) {
      return !1;
    }
  }, {
    key: "removeValue",
    value: function removeValue(e) {
      return !1;
    }
  }, {
    key: "getValue",
    value: function getValue(e) {}
  }, {
    key: "collectAllValues",
    value: function collectAllValues() {
      return Object.create(null);
    }
  }]);

  return or;
}(ir);

or.INSTANCE = new or();

var nr =
/*#__PURE__*/
function (_ir2) {
  _inherits(nr, _ir2);

  function nr(e, t, i) {
    var _this144;

    _classCallCheck(this, nr);

    _this144 = _possibleConstructorReturn(this, _getPrototypeOf(nr).call(this, e, null)), _this144._configurationService = t, _this144._values = new Map(), _this144._listener = _this144._configurationService.onDidChangeConfiguration(function (e) {
      if (4 === e.source) {
        var _e117 = re(_this144._values);

        _this144._values.clear(), i.fire(_e117);
      } else {
        var _t92 = [];
        var _iteratorNormalCompletion64 = true;
        var _didIteratorError64 = false;
        var _iteratorError64 = undefined;

        try {
          for (var _iterator64 = e.affectedKeys[Symbol.iterator](), _step64; !(_iteratorNormalCompletion64 = (_step64 = _iterator64.next()).done); _iteratorNormalCompletion64 = true) {
            var _i91 = _step64.value;

            var _e118 = "config.".concat(_i91);

            _this144._values.has(_e118) && (_this144._values.delete(_e118), _t92.push(_e118));
          }
        } catch (err) {
          _didIteratorError64 = true;
          _iteratorError64 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion64 && _iterator64.return != null) {
              _iterator64.return();
            }
          } finally {
            if (_didIteratorError64) {
              throw _iteratorError64;
            }
          }
        }

        i.fire(_t92);
      }
    });
    return _this144;
  }

  _createClass(nr, [{
    key: "dispose",
    value: function dispose() {
      this._listener.dispose();
    }
  }, {
    key: "getValue",
    value: function getValue(e) {
      if (0 !== e.indexOf(nr._keyPrefix)) return _get(_getPrototypeOf(nr.prototype), "getValue", this).call(this, e);
      if (this._values.has(e)) return this._values.get(e);

      var t = e.substr(nr._keyPrefix.length),
          i = this._configurationService.getValue(t);

      var o = void 0;

      switch (typeof i) {
        case "number":
        case "boolean":
        case "string":
          o = i;
      }

      return this._values.set(e, o), o;
    }
  }, {
    key: "setValue",
    value: function setValue(e, t) {
      return _get(_getPrototypeOf(nr.prototype), "setValue", this).call(this, e, t);
    }
  }, {
    key: "removeValue",
    value: function removeValue(e) {
      return _get(_getPrototypeOf(nr.prototype), "removeValue", this).call(this, e);
    }
  }, {
    key: "collectAllValues",
    value: function collectAllValues() {
      var e = Object.create(null);
      return this._values.forEach(function (t, i) {
        return e[i] = t;
      }), Object.assign({}, e, _get(_getPrototypeOf(nr.prototype), "collectAllValues", this).call(this));
    }
  }]);

  return nr;
}(ir);

nr._keyPrefix = "config.";

var sr =
/*#__PURE__*/
function () {
  function sr(e, t, i) {
    _classCallCheck(this, sr);

    this._parent = e, this._key = t, this._defaultValue = i, this.reset();
  }

  _createClass(sr, [{
    key: "set",
    value: function set(e) {
      this._parent.setContext(this._key, e);
    }
  }, {
    key: "reset",
    value: function reset() {
      void 0 === this._defaultValue ? this._parent.removeContext(this._key) : this._parent.setContext(this._key, this._defaultValue);
    }
  }, {
    key: "get",
    value: function get() {
      return this._parent.getContextKeyValue(this._key);
    }
  }]);

  return sr;
}();

var rr =
/*#__PURE__*/
function () {
  function rr(e) {
    _classCallCheck(this, rr);

    this._key = e;
  }

  _createClass(rr, [{
    key: "affectsSome",
    value: function affectsSome(e) {
      return e.has(this._key);
    }
  }]);

  return rr;
}();

var lr =
/*#__PURE__*/
function () {
  function lr(e) {
    _classCallCheck(this, lr);

    this._keys = e;
  }

  _createClass(lr, [{
    key: "affectsSome",
    value: function affectsSome(e) {
      var _iteratorNormalCompletion65 = true;
      var _didIteratorError65 = false;
      var _iteratorError65 = undefined;

      try {
        for (var _iterator65 = this._keys[Symbol.iterator](), _step65; !(_iteratorNormalCompletion65 = (_step65 = _iterator65.next()).done); _iteratorNormalCompletion65 = true) {
          var _t93 = _step65.value;
          if (e.has(_t93)) return !0;
        }
      } catch (err) {
        _didIteratorError65 = true;
        _iteratorError65 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion65 && _iterator65.return != null) {
            _iterator65.return();
          }
        } finally {
          if (_didIteratorError65) {
            throw _iteratorError65;
          }
        }
      }

      return !1;
    }
  }]);

  return lr;
}();

var ar =
/*#__PURE__*/
function () {
  function ar(e) {
    _classCallCheck(this, ar);

    this._isDisposed = !1, this._myContextId = e, this._onDidChangeContextKey = new b();
  }

  _createClass(ar, [{
    key: "createKey",
    value: function createKey(e, t) {
      if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
      return new sr(this, e, t);
    }
  }, {
    key: "createScoped",
    value: function createScoped(e) {
      if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
      return new hr(this, this._onDidChangeContextKey, e);
    }
  }, {
    key: "contextMatchesRules",
    value: function contextMatchesRules(e) {
      if (this._isDisposed) throw new Error("AbstractContextKeyService has been disposed");
      var t = this.getContextValuesContainer(this._myContextId);
      return es.contextMatchesRules(t, e);
    }
  }, {
    key: "getContextKeyValue",
    value: function getContextKeyValue(e) {
      if (!this._isDisposed) return this.getContextValuesContainer(this._myContextId).getValue(e);
    }
  }, {
    key: "setContext",
    value: function setContext(e, t) {
      if (this._isDisposed) return;
      var i = this.getContextValuesContainer(this._myContextId);
      i && i.setValue(e, t) && this._onDidChangeContextKey.fire(e);
    }
  }, {
    key: "removeContext",
    value: function removeContext(e) {
      this._isDisposed || this.getContextValuesContainer(this._myContextId).removeValue(e) && this._onDidChangeContextKey.fire(e);
    }
  }, {
    key: "getContext",
    value: function getContext(e) {
      return this._isDisposed ? or.INSTANCE : this.getContextValuesContainer(function (e) {
        for (; e;) {
          if (e.hasAttribute(tr)) {
            var _t94 = e.getAttribute(tr);

            return _t94 ? parseInt(_t94, 10) : NaN;
          }

          e = e.parentElement;
        }

        return 0;
      }(e));
    }
  }, {
    key: "onDidChangeContext",
    get: function get() {
      return this._onDidChangeContext || (this._onDidChangeContext = v.map(this._onDidChangeContextKey.event, function (e) {
        return "string" == typeof e ? new rr(e) : new lr(e);
      })), this._onDidChangeContext;
    }
  }]);

  return ar;
}();

var Ar =
/*#__PURE__*/
function (_ar) {
  _inherits(Ar, _ar);

  function Ar(e) {
    var _this145;

    _classCallCheck(this, Ar);

    _this145 = _possibleConstructorReturn(this, _getPrototypeOf(Ar).call(this, 0)), _this145._toDispose = [], _this145._lastContextId = 0, _this145._contexts = Object.create(null);
    var t = new nr(_this145._myContextId, e, _this145._onDidChangeContextKey);
    _this145._contexts[String(_this145._myContextId)] = t, _this145._toDispose.push(t);
    return _this145;
  }

  _createClass(Ar, [{
    key: "dispose",
    value: function dispose() {
      this._isDisposed = !0, this._toDispose = C(this._toDispose);
    }
  }, {
    key: "getContextValuesContainer",
    value: function getContextValuesContainer(e) {
      return this._isDisposed ? or.INSTANCE : this._contexts[String(e)];
    }
  }, {
    key: "createChildContext",
    value: function createChildContext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._myContextId;
      if (this._isDisposed) throw new Error("ContextKeyService has been disposed");
      var t = ++this._lastContextId;
      return this._contexts[String(t)] = new ir(t, this.getContextValuesContainer(e)), t;
    }
  }, {
    key: "disposeContext",
    value: function disposeContext(e) {
      this._isDisposed || delete this._contexts[String(e)];
    }
  }]);

  return Ar;
}(ar);

Ar = r([l(0, _n)], Ar);

var hr =
/*#__PURE__*/
function (_ar2) {
  _inherits(hr, _ar2);

  function hr(e, t, i) {
    var _this146;

    _classCallCheck(this, hr);

    _this146 = _possibleConstructorReturn(this, _getPrototypeOf(hr).call(this, e.createChildContext())), _this146._parent = e, _this146._onDidChangeContextKey = t, i && (_this146._domNode = i, _this146._domNode.setAttribute(tr, String(_this146._myContextId)));
    return _this146;
  }

  _createClass(hr, [{
    key: "dispose",
    value: function dispose() {
      this._isDisposed = !0, this._parent.disposeContext(this._myContextId), this._domNode && (this._domNode.removeAttribute(tr), this._domNode = void 0);
    }
  }, {
    key: "getContextValuesContainer",
    value: function getContextValuesContainer(e) {
      return this._isDisposed ? or.INSTANCE : this._parent.getContextValuesContainer(e);
    }
  }, {
    key: "createChildContext",
    value: function createChildContext() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._myContextId;
      if (this._isDisposed) throw new Error("ScopedContextKeyService has been disposed");
      return this._parent.createChildContext(e);
    }
  }, {
    key: "disposeContext",
    value: function disposeContext(e) {
      this._isDisposed || this._parent.disposeContext(e);
    }
  }, {
    key: "onDidChangeContext",
    get: function get() {
      return this._parent.onDidChangeContext;
    }
  }]);

  return hr;
}(ar);

gn.registerCommand("setContext", function (e, t, i) {
  e.get(ln).createKey(String(t), i);
});

var cr = n("keybindingService"),
    dr = function dr(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new qs(e, t);
};

export { I as Color, er as CommandService, Zo as ContextKeyExpr, Ar as ContextKeyService, b as Emitter, v as Event, un as ICommandService, _n as IConfigurationService, ln as IContextKeyService, i as IInstantiationService, cr as IKeybindingService, Kn as IMenuService, hs as INotificationService, $s as ITreeViewService, qn as MenuItemAction, Wn as MenuRegistry, Ks as MenuService, rn as RawContextKey, s as ServiceCollection, dn as Severity, ps as StandaloneKeybindingService, e as SyncDescriptor, an as TreeViewFocusContextKey, An as TreeViewVSCode, n as createDecorator, dr as createWorkbenchVsCode, C as dispose, A as errorHandler, $n as registerAction };